
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireca4e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireca4e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cKY7h", function(module, exports) {

$parcel$export(module.exports, "spotByPath", function () { return spotByPath; });
$parcel$export(module.exports, "lookup", function () { return lookup; });
$parcel$export(module.exports, "lookdown", function () { return lookdown; });
$parcel$export(module.exports, "lookdownAll", function () { return lookdownAll; });
$parcel$export(module.exports, "setNodeStyles", function () { return setNodeStyles; });
$parcel$export(module.exports, "remove", function () { return remove; });
$parcel$export(module.exports, "setProps", function () { return setProps; });
$parcel$export(module.exports, "getRef", function () { return getRef; });
$parcel$export(module.exports, "getPath", function () { return getPath; });
$parcel$export(module.exports, "keys", function () { return keys; });
$parcel$export(module.exports, "parse", function () { return parse; });
$parcel$export(module.exports, "parseDeep", function () { return parseDeep; });
$parcel$export(module.exports, "verbose", function () { return verbose; });
$parcel$export(module.exports, "log", function () { return log; });
$parcel$export(module.exports, "warn", function () { return warn; });
$parcel$export(module.exports, "error", function () { return error; });
$parcel$export(module.exports, "nextElement", function () { return nextElement; });
$parcel$export(module.exports, "previousElement", function () { return previousElement; });
$parcel$export(module.exports, "variables", function () { return variables; });
$parcel$export(module.exports, "call", function () { return call; });
$parcel$export(module.exports, "isMethod", function () { return isMethod; });
parcelRequire("QRTe9");
var $dKo7X = parcelRequire("dKo7X");
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
var $kitvZ = parcelRequire("kitvZ");
var $1cJu7 = parcelRequire("1cJu7");

var $hmiUX = parcelRequire("hmiUX");
parcelRequire("6cTIH");
var $6l4Vl = parcelRequire("6l4Vl");
'use strict';
function spotByPath(path) {
    const element = this;
    const arr = [].concat(path);
    let active = (0, $hmiUX.TREE)[arr[0]];
    if (!arr || !arr.length) return console.log(arr, 'on', element.key, 'is undefined');
    while(active.key === arr[0]){
        arr.shift();
        if (!arr.length) break;
        active = active[arr[0]];
        if (!active) return;
    }
    return active;
}
function lookup(param) {
    const el = this;
    let { parent } = el;
    if ((0, $amNJ8.isFunction)(param)) {
        if (parent.state && param(parent, parent.state, parent.context)) return parent;
        else if (parent.parent) return parent.lookup(param);
        else return;
    }
    if (el[param]) return el[param];
    while(parent.param !== param){
        if (parent[param]) return parent[param];
        parent = parent.parent;
        if (!parent) return;
    }
    return parent;
}
function lookdown(param) {
    const el = this;
    const { __ref: ref } = el;
    const children = ref?.__children;
    if (!children) return;
    for(let i = 0; i < children.length; i++){
        const v = children[i];
        const childElem = el[v];
        if (v === param) return childElem;
        else if ((0, $amNJ8.isFunction)(param)) {
            const exec = param(childElem, childElem.state, childElem.context);
            if (childElem.state && exec) return childElem;
        }
        const lookdown = childElem?.lookdown?.(param);
        if (lookdown) return lookdown;
    }
}
function lookdownAll(param, results = []) {
    const el = this;
    const { __ref: ref } = el;
    const children = ref?.__children;
    if (!children) return;
    for(let i = 0; i < children.length; i++){
        const v = children[i];
        const childElem = el[v];
        if (v === param) results.push(childElem);
        else if ((0, $amNJ8.isFunction)(param)) {
            const exec = param(childElem, childElem.state, childElem.context);
            if (childElem.state && exec) results.push(childElem);
        }
        childElem?.lookdownAll?.(param, results);
    }
    return results.length ? results : undefined;
}
function setNodeStyles(params = {}) {
    const el = this;
    if (!el.node?.style) return;
    for(const param in params){
        const value = params[param];
        const childElem = el[param];
        if ((0, $amNJ8.isObject)(value) && childElem) setNodeStyles.call(childElem, value);
        else el.node.style[param] = value;
    }
    return el;
}
async function remove(opts) {
    const element = this;
    const beforeRemoveReturns = (0, $dKo7X.triggerEventOn)('beforeRemove', element, opts);
    if (beforeRemoveReturns === false) return element;
    if ((0, $amNJ8.isFunction)(element.node.remove)) element.node.remove();
    else if (!(0, $kitvZ.isProduction)()) {
        console.warn('This item cant be removed');
        element.log();
    }
    delete element.parent[element.key];
    if (element.parent.__ref) element.parent.__ref.__children = (0, $1cJu7.removeValueFromArray)(element.parent.__ref.__children, element.key);
    await (0, $dKo7X.triggerEventOn)('remove', element, opts);
}
function get(param) {
    const element = this;
    return element[param];
}
function setProps(param, options) {
    const element = this;
    if (!param || !element.props) return;
    element.update({
        props: param
    }, options);
    return element;
}
function getRef(key) {
    if (key) return this.__ref && this.__ref[key];
    return this.__ref;
}
function getChildren() {
    const __children = this.getRef('__children');
    return __children.map((k)=>this[k]);
}
function getPath() {
    return this.getRef().path;
}
const defineSetter = (element, key, get, set)=>Object.defineProperty(element, key, {
        get: get,
        set: set
    });
function keys() {
    const element = this;
    const keys = [];
    for(const param in element){
        if ((0, $6l4Vl.REGISTRY)[param] && !(0, $6l4Vl.parseFilters).elementKeys.includes(param) || !Object.hasOwnProperty.call(element, param)) continue;
        keys.push(param);
    }
    return keys;
}
function parse(excl = []) {
    const element = this;
    const obj = {};
    const keyList = keys.call(element);
    keyList.forEach((v)=>{
        if (excl.includes(v)) return;
        const val = element[v];
        if (v === 'state') {
            if (element.__ref && !element.__ref.__hasRootState) return;
            const parsedVal = (0, $amNJ8.isFunction)(val && val.parse) ? val.parse() : val;
            obj[v] = (0, $amNJ8.isFunction)(parsedVal) ? parsedVal : JSON.parse(JSON.stringify(parsedVal || {}));
        } else if (v === 'scope') {
            if (element.__ref && !element.__ref.__hasRootScope) return;
            obj[v] = JSON.parse(JSON.stringify(val || {}));
        } else if (v === 'props') {
            const { __element, update, ...props } = element[v];
            obj[v] = props;
        } else if ((0, $amNJ8.isDefined)(val) && Object.hasOwnProperty.call(element, v)) obj[v] = val;
    });
    return obj;
}
function parseDeep(excl = []) {
    const element = this;
    const obj = parse.call(element, excl);
    for(const v in obj){
        if (excl.includes(v)) return;
        if ((0, $amNJ8.isObjectLike)(obj[v])) obj[v] = parseDeep.call(obj[v], excl);
    }
    return obj;
}
function verbose(element, ...args) {
    if ((0, $kitvZ.isProduction)()) return;
    const parent = this;
    const { __ref: ref } = parent;
    console.groupCollapsed(parent.key);
    if (args.length) args.forEach((v)=>console.log(`%c${v}:\n`, 'font-weight: bold', parent[v]));
    else {
        console.log(ref.path);
        const keys = parent.keys();
        keys.forEach((v)=>console.log(`%c${v}:`, 'font-weight: bold', parent[v]));
    }
    console.log(parent);
    console.groupEnd(parent.key);
    return parent;
}
function log(...params) {
    if ((0, $kitvZ.isNotProduction)()) console.log(...params);
}
function warn(...params) {
    if ((0, $kitvZ.isNotProduction)()) console.warn(...params);
}
function error(...params) {
    if ((0, $kitvZ.isNotProduction)()) {
        if (params[params.length - 1]?.debugger) debugger; // eslint-disable-line
        if (params[params.length - 1]?.verbose) verbose.call(this, ...params);
        console.error(...params, this);
    }
}
function nextElement() {
    const element = this;
    const { key, parent } = element;
    const { __children } = parent.__ref;
    const currentIndex = __children.indexOf(key);
    const nextChild = __children[currentIndex + 1];
    return parent[nextChild];
}
function previousElement(el) {
    const element = el || this;
    const { key, parent } = element;
    const { __children } = parent.__ref;
    if (!__children) return;
    const currentIndex = __children.indexOf(key);
    return parent[__children[currentIndex - 1]];
}
function variables(obj = {}) {
    const element = this;
    if (!element.data) element.data = {};
    if (!element.data.varCaches) element.data.varCaches = {};
    const varCaches = element.data.varCaches;
    const changes = {};
    let changed;
    for(const key in obj)if (obj[key] !== varCaches[key]) {
        changed = true;
        changes[key] = obj[key];
    }
    return {
        changed: (cb)=>{
            if (!changed || !varCaches) return;
            const returns = cb(changes, (0, $jm0BQ.deepClone)(varCaches));
            for(const key in changes)varCaches[key] = changes[key];
            return returns;
        },
        timeout: (cb, timeout)=>{
            if (!changed) return;
            const t = setTimeout(()=>{
                cb(changes);
                clearTimeout(t);
            }, timeout);
        }
    };
}
function call(fnKey, ...args) {
    const fn = this.context.utils?.[fnKey] || this.context.functions?.[fnKey] || this.context.methods?.[fnKey] || this.context.snippets?.[fnKey];
    if (!fn) return undefined;
    try {
        // Call the function
        const result = fn.call(this, ...args);
        // Handle promises
        if (result && typeof result.then === 'function') // This magic allows the function to be awaited if called with await
        // but still work reasonably when called without await
        return result;
        // Return synchronous results directly
        return result;
    } catch (error) {
        console.error(`Error calling '${fnKey}':`, error);
        throw error;
    }
}
const METHODS = [
    'set',
    'reset',
    'update',
    'remove',
    'updateContent',
    'removeContent',
    'lookup',
    'lookdown',
    'lookdownAll',
    'getRef',
    'getChildren',
    'getPath',
    'setNodeStyles',
    'spotByPath',
    'keys',
    'parse',
    'setProps',
    'parseDeep',
    'variables',
    'if',
    'log',
    'verbose',
    'warn',
    'error',
    'call',
    'nextElement',
    'previousElement'
];
function isMethod(param, element) {
    return METHODS.includes(param) || element?.context?.methods?.[param];
}

});
parcelRegister("QRTe9", function(module, exports) {
$parcel$export(module.exports, "applyEvent", function () { return (parcelRequire("dKo7X")).applyEvent; });
$parcel$export(module.exports, "applyEventsOnNode", function () { return (parcelRequire("dKo7X")).applyEventsOnNode; });
$parcel$export(module.exports, "triggerEventOn", function () { return (parcelRequire("dKo7X")).triggerEventOn; });
$parcel$export(module.exports, "triggerEventOnUpdate", function () { return (parcelRequire("dKo7X")).triggerEventOnUpdate; });
$parcel$export(module.exports, "canRenderTag", function () { return (parcelRequire("3o7U3")).canRenderTag; });
$parcel$export(module.exports, "applyAnimationFrame", function () { return (parcelRequire("bnF2s")).applyAnimationFrame; });
$parcel$export(module.exports, "initAnimationFrame", function () { return (parcelRequire("bnF2s")).initAnimationFrame; });
parcelRequire("dKo7X");
parcelRequire("3o7U3");
parcelRequire("bnF2s");
'use strict';

});
parcelRegister("dKo7X", function(module, exports) {

$parcel$export(module.exports, "applyEvent", function () { return $a02249681f4528de$export$27ca81ea148fa005; });
$parcel$export(module.exports, "triggerEventOn", function () { return $a02249681f4528de$export$1bc010482b845252; });
$parcel$export(module.exports, "triggerEventOnUpdate", function () { return $a02249681f4528de$export$8fe90418b8a0fc1e; });
$parcel$export(module.exports, "applyEventsOnNode", function () { return $a02249681f4528de$export$1f7cb486ba1f8a10; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $a02249681f4528de$var$getOnOrPropsEvent = (param, element)=>{
    const onEvent = element.on?.[param];
    const onPropEvent = element.props?.['on' + param.slice(0, 1).toUpperCase() + param.slice(1)];
    return onEvent || onPropEvent;
};
const $a02249681f4528de$export$27ca81ea148fa005 = (param, element, state, context, options)=>{
    return param.call(element, element, state || element.state, context || element.context, options);
};
const $a02249681f4528de$export$1bc010482b845252 = async (param, element, options)=>{
    const appliedFunction = $a02249681f4528de$var$getOnOrPropsEvent(param, element);
    if (appliedFunction) {
        const { state: state, context: context } = element;
        return await $a02249681f4528de$export$27ca81ea148fa005(appliedFunction, element, state, context, options);
    }
};
const $a02249681f4528de$export$906113ec468a9c43 = (param, updatedObj, element, state, context, options)=>{
    return param.call(element, updatedObj, element, state || element.state, context || element.context, options);
};
const $a02249681f4528de$export$8fe90418b8a0fc1e = async (param, updatedObj, element, options)=>{
    const appliedFunction = $a02249681f4528de$var$getOnOrPropsEvent(param, element);
    if (appliedFunction) {
        const { state: state, context: context } = element;
        return await $a02249681f4528de$export$906113ec468a9c43(appliedFunction, updatedObj, element, state, context, options);
    }
};
const $a02249681f4528de$export$1f7cb486ba1f8a10 = (element, options)=>{
    const { node: node, on: on } = element;
    for(const param in on){
        if (param === 'init' || param === 'beforeClassAssign' || param === 'render' || param === 'renderRouter' || param === 'attachNode' || param === 'stateInit' || param === 'stateCreated' || param === 'beforeStateUpdate' || param === 'stateUpdate' || param === 'beforeUpdate' || param === 'done' || param === 'create' || param === 'complete' || param === 'frame' || param === 'update') continue;
        const appliedFunction = $a02249681f4528de$var$getOnOrPropsEvent(param, element);
        if ((0, $amNJ8.isFunction)(appliedFunction)) node.addEventListener(param, async (event)=>{
            const { state: state, context: context } = element;
            await appliedFunction.call(element, event, element, state, context, options);
        });
    }
};

});
parcelRegister("imR0C", function(module, exports) {

var $7Ionn = parcelRequire("7Ionn");

var $kitvZ = parcelRequire("kitvZ");

var $amNJ8 = parcelRequire("amNJ8");

var $jm0BQ = parcelRequire("jm0BQ");

var $7033D = parcelRequire("7033D");

var $1cJu7 = parcelRequire("1cJu7");

var $2Jg1F = parcelRequire("2Jg1F");

var $4A0KM = parcelRequire("4A0KM");

var $l2qXs = parcelRequire("l2qXs");

var $aLXZy = parcelRequire("aLXZy");

var $aQLXm = parcelRequire("aQLXm");

var $8Y0fc = parcelRequire("8Y0fc");

var $3Kzng = parcelRequire("3Kzng");
'use strict';
$parcel$exportWildcard(module.exports, $7Ionn);
$parcel$exportWildcard(module.exports, $kitvZ);
$parcel$exportWildcard(module.exports, $amNJ8);
$parcel$exportWildcard(module.exports, $jm0BQ);
$parcel$exportWildcard(module.exports, $7033D);
$parcel$exportWildcard(module.exports, $1cJu7);
$parcel$exportWildcard(module.exports, $2Jg1F);
$parcel$exportWildcard(module.exports, $4A0KM);
$parcel$exportWildcard(module.exports, $l2qXs);
$parcel$exportWildcard(module.exports, $aLXZy);
$parcel$exportWildcard(module.exports, $aQLXm);
$parcel$exportWildcard(module.exports, $8Y0fc);
$parcel$exportWildcard(module.exports, $3Kzng);

});
parcelRegister("7Ionn", function(module, exports) {

$parcel$export(module.exports, "generateKey", function () { return $59df8d0bae969c53$export$3a7728e868aa3ebd; });
$parcel$export(module.exports, "createSnapshotId", function () { return $59df8d0bae969c53$export$6f8fb29fbb5b5b63; });
'use strict';
const $59df8d0bae969c53$export$3a7728e868aa3ebd = function() {
    let index = 0;
    function newId() {
        index++;
        return index;
    }
    return newId;
}();
const $59df8d0bae969c53$export$6f8fb29fbb5b5b63 = $59df8d0bae969c53$export$3a7728e868aa3ebd;

});

parcelRegister("kitvZ", function(module, exports) {

$parcel$export(module.exports, "NODE_ENV", function () { return $03d03321b4d92837$export$dd8826725fa2a3d4; });
$parcel$export(module.exports, "ENV", function () { return $03d03321b4d92837$export$83401e34d5e11bf4; });
$parcel$export(module.exports, "isProduction", function () { return $03d03321b4d92837$export$f15d00aa73aafac4; });
$parcel$export(module.exports, "isTest", function () { return $03d03321b4d92837$export$410cbc2864fa25b5; });
$parcel$export(module.exports, "isTesting", function () { return $03d03321b4d92837$export$9592e006a670b581; });
$parcel$export(module.exports, "isStaging", function () { return $03d03321b4d92837$export$23da1d24a38b0bde; });
$parcel$export(module.exports, "isLocal", function () { return $03d03321b4d92837$export$6dd1bbd39f571125; });
$parcel$export(module.exports, "isDevelopment", function () { return $03d03321b4d92837$export$df77466336fe5355; });
$parcel$export(module.exports, "getNev", function () { return $03d03321b4d92837$export$d84272657cb7c466; });
$parcel$export(module.exports, "isNotProduction", function () { return $03d03321b4d92837$export$eda5083784a7e709; });
'use strict';
const $03d03321b4d92837$export$dd8826725fa2a3d4 = "production";
const $03d03321b4d92837$export$83401e34d5e11bf4 = $03d03321b4d92837$export$dd8826725fa2a3d4;
const $03d03321b4d92837$export$f15d00aa73aafac4 = (env = $03d03321b4d92837$export$dd8826725fa2a3d4)=>env === 'production';
const $03d03321b4d92837$export$410cbc2864fa25b5 = (env = $03d03321b4d92837$export$dd8826725fa2a3d4)=>env === 'testing' || env === 'test';
const $03d03321b4d92837$export$9592e006a670b581 = $03d03321b4d92837$export$410cbc2864fa25b5;
const $03d03321b4d92837$export$23da1d24a38b0bde = (env = $03d03321b4d92837$export$dd8826725fa2a3d4)=>env === 'staging';
const $03d03321b4d92837$export$6dd1bbd39f571125 = (env = $03d03321b4d92837$export$dd8826725fa2a3d4)=>env === 'local';
const $03d03321b4d92837$export$df77466336fe5355 = (env = $03d03321b4d92837$export$dd8826725fa2a3d4)=>env === 'development' || env === 'dev' || env === 'local';
const $03d03321b4d92837$export$d84272657cb7c466 = (key, env = $03d03321b4d92837$export$dd8826725fa2a3d4)=>env[key];
const $03d03321b4d92837$export$eda5083784a7e709 = (env = $03d03321b4d92837$export$dd8826725fa2a3d4)=>!$03d03321b4d92837$export$f15d00aa73aafac4(env);

});

parcelRegister("amNJ8", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $78c2882dd354e8db$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isString", function () { return $78c2882dd354e8db$export$844ec244b1367d54; });
$parcel$export(module.exports, "isNumber", function () { return $78c2882dd354e8db$export$7e4aa119212bc614; });
$parcel$export(module.exports, "isFunction", function () { return $78c2882dd354e8db$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isBoolean", function () { return $78c2882dd354e8db$export$f9ce7b637dfbe238; });
$parcel$export(module.exports, "isNull", function () { return $78c2882dd354e8db$export$630801d484da15df; });
$parcel$export(module.exports, "isArray", function () { return $78c2882dd354e8db$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isDate", function () { return $78c2882dd354e8db$export$871608497c498473; });
$parcel$export(module.exports, "isObjectLike", function () { return $78c2882dd354e8db$export$c10d0b04eaa80a43; });
$parcel$export(module.exports, "isDefined", function () { return $78c2882dd354e8db$export$4e62c701997796c1; });
$parcel$export(module.exports, "isUndefined", function () { return $78c2882dd354e8db$export$fce6876652108ab; });
$parcel$export(module.exports, "TYPES", function () { return $78c2882dd354e8db$export$426db7a6155b7a80; });
$parcel$export(module.exports, "is", function () { return $78c2882dd354e8db$export$226b3eccf92c9ed9; });
$parcel$export(module.exports, "isNot", function () { return $78c2882dd354e8db$export$612ae635ef713eeb; });

var $2Jg1F = parcelRequire("2Jg1F");
'use strict';
const $78c2882dd354e8db$export$a6cdc56e425d0d0a = (arg)=>{
    if (arg === null) return false;
    return typeof arg === 'object' && arg.constructor === Object;
};
const $78c2882dd354e8db$export$844ec244b1367d54 = (arg)=>typeof arg === 'string';
const $78c2882dd354e8db$export$7e4aa119212bc614 = (arg)=>typeof arg === 'number';
const $78c2882dd354e8db$export$f6e2535fb5126e54 = (arg)=>typeof arg === 'function';
const $78c2882dd354e8db$export$f9ce7b637dfbe238 = (arg)=>arg === true || arg === false;
const $78c2882dd354e8db$export$630801d484da15df = (arg)=>arg === null;
const $78c2882dd354e8db$export$43bee75e5e14138e = (arg)=>Array.isArray(arg);
const $78c2882dd354e8db$export$871608497c498473 = (d)=>d instanceof Date;
const $78c2882dd354e8db$export$c10d0b04eaa80a43 = (arg)=>{
    if (arg === null) return false;
    // if (isArray(arg)) return false
    return typeof arg === 'object';
};
const $78c2882dd354e8db$export$4e62c701997796c1 = (arg)=>{
    return $78c2882dd354e8db$export$a6cdc56e425d0d0a(arg) || $78c2882dd354e8db$export$c10d0b04eaa80a43(arg) || $78c2882dd354e8db$export$844ec244b1367d54(arg) || $78c2882dd354e8db$export$7e4aa119212bc614(arg) || $78c2882dd354e8db$export$f6e2535fb5126e54(arg) || $78c2882dd354e8db$export$43bee75e5e14138e(arg) || $78c2882dd354e8db$export$c10d0b04eaa80a43(arg) || $78c2882dd354e8db$export$f9ce7b637dfbe238(arg) || $78c2882dd354e8db$export$871608497c498473(arg) || $78c2882dd354e8db$export$630801d484da15df(arg);
};
const $78c2882dd354e8db$export$fce6876652108ab = (arg)=>{
    return arg === undefined;
};
const $78c2882dd354e8db$export$426db7a6155b7a80 = {
    boolean: $78c2882dd354e8db$export$f9ce7b637dfbe238,
    array: $78c2882dd354e8db$export$43bee75e5e14138e,
    object: $78c2882dd354e8db$export$a6cdc56e425d0d0a,
    string: $78c2882dd354e8db$export$844ec244b1367d54,
    date: $78c2882dd354e8db$export$871608497c498473,
    number: $78c2882dd354e8db$export$7e4aa119212bc614,
    null: $78c2882dd354e8db$export$630801d484da15df,
    function: $78c2882dd354e8db$export$f6e2535fb5126e54,
    objectLike: $78c2882dd354e8db$export$c10d0b04eaa80a43,
    node: (0, $2Jg1F.isNode),
    htmlElement: (0, $2Jg1F.isHtmlElement),
    defined: $78c2882dd354e8db$export$4e62c701997796c1
};
const $78c2882dd354e8db$export$226b3eccf92c9ed9 = (arg)=>{
    return (...args)=>{
        return args.map((val)=>$78c2882dd354e8db$export$426db7a6155b7a80[val](arg)).filter((v)=>v).length > 0;
    };
};
const $78c2882dd354e8db$export$612ae635ef713eeb = (arg)=>{
    return (...args)=>{
        return args.map((val)=>$78c2882dd354e8db$export$426db7a6155b7a80[val](arg)).filter((v)=>v).length === 0;
    };
};

});
parcelRegister("2Jg1F", function(module, exports) {

$parcel$export(module.exports, "isNode", function () { return $1fcc37296bb660a2$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "isHtmlElement", function () { return $1fcc37296bb660a2$export$211442cb55fb93; });
$parcel$export(module.exports, "isDOMNode", function () { return $1fcc37296bb660a2$export$b8eb4d3b76e486c2; });

var $aLXZy = parcelRequire("aLXZy");
'use strict';
const $1fcc37296bb660a2$export$8ee0fc9ee280b4ee = (obj)=>{
    return (typeof Node === 'object' ? obj instanceof (0, $aLXZy.window).Node : obj && typeof obj === 'object' && typeof obj.nodeType === 'number' && typeof obj.nodeName === 'string') || false;
};
const $1fcc37296bb660a2$export$211442cb55fb93 = (obj)=>{
    return (typeof HTMLElement === 'object' ? obj instanceof (0, $aLXZy.window).HTMLElement // DOM2
     : obj && typeof obj === 'object' && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === 'string') || false;
};
const $1fcc37296bb660a2$export$b8eb4d3b76e486c2 = (obj)=>{
    return typeof (0, $aLXZy.window) !== 'undefined' && (obj instanceof (0, $aLXZy.window).Node || obj instanceof (0, $aLXZy.window).Window || obj === (0, $aLXZy.window) || obj === document);
};

});
parcelRegister("aLXZy", function(module, exports) {

$parcel$export(module.exports, "global", function () { return $7d7cd44f0bac7f98$export$90b4d2ff6acb88af; });
$parcel$export(module.exports, "self", function () { return $7d7cd44f0bac7f98$export$82c2e460fb230c2a; });
$parcel$export(module.exports, "window", function () { return $7d7cd44f0bac7f98$export$8291e5b88f90ce4; });
$parcel$export(module.exports, "document", function () { return $7d7cd44f0bac7f98$export$5a7bfc01df82fcd1; });
'use strict';
const $7d7cd44f0bac7f98$export$90b4d2ff6acb88af = globalThis;
const $7d7cd44f0bac7f98$export$82c2e460fb230c2a = globalThis;
const $7d7cd44f0bac7f98$export$8291e5b88f90ce4 = globalThis;
const $7d7cd44f0bac7f98$export$5a7bfc01df82fcd1 = (undefined || $7d7cd44f0bac7f98$export$8291e5b88f90ce4).document // eslint-disable-line
;

});



parcelRegister("jm0BQ", function(module, exports) {

$parcel$export(module.exports, "exec", function () { return $e1708b64fd8f3355$export$78e3044358792147; });
$parcel$export(module.exports, "map", function () { return $e1708b64fd8f3355$export$871de8747c9eaa88; });
$parcel$export(module.exports, "merge", function () { return $e1708b64fd8f3355$export$4950aa0f605343fb; });
$parcel$export(module.exports, "deepMerge", function () { return $e1708b64fd8f3355$export$6969335ea1e4e77c; });
$parcel$export(module.exports, "clone", function () { return $e1708b64fd8f3355$export$9cd59f9826255e47; });
$parcel$export(module.exports, "mergeArrayExclude", function () { return $e1708b64fd8f3355$export$1c8d6f44648a0c27; });
$parcel$export(module.exports, "deepClone", function () { return $e1708b64fd8f3355$export$b7d58db314e0ac27; });
$parcel$export(module.exports, "deepStringify", function () { return $e1708b64fd8f3355$export$7885cbf849c4488d; });
$parcel$export(module.exports, "deepStringifyWithMaxDepth", function () { return $e1708b64fd8f3355$export$46c0f1e710234ddf; });
$parcel$export(module.exports, "objectToString", function () { return $e1708b64fd8f3355$export$830c053460e5ddf6; });
$parcel$export(module.exports, "detachFunctionsFromObject", function () { return $e1708b64fd8f3355$export$43ffbb9d42fee1c4; });
$parcel$export(module.exports, "hasFunction", function () { return $e1708b64fd8f3355$export$6b15be743c368efa; });
$parcel$export(module.exports, "deepDestringify", function () { return $e1708b64fd8f3355$export$87659e1dc59ed8a3; });
$parcel$export(module.exports, "stringToObject", function () { return $e1708b64fd8f3355$export$a6c9a3ccba61521e; });
$parcel$export(module.exports, "diffObjects", function () { return $e1708b64fd8f3355$export$fcd7b39b3d1c2c1; });
$parcel$export(module.exports, "diff", function () { return $e1708b64fd8f3355$export$a37e3c603d7117e5; });
$parcel$export(module.exports, "diffArrays", function () { return $e1708b64fd8f3355$export$f1c08b3bfc8443c4; });
$parcel$export(module.exports, "hasOwnProperty", function () { return $e1708b64fd8f3355$export$5a15a386532a5ea4; });
$parcel$export(module.exports, "isEmpty", function () { return $e1708b64fd8f3355$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "isEmptyObject", function () { return $e1708b64fd8f3355$export$83b788b1a3698c03; });
$parcel$export(module.exports, "makeObjectWithoutPrototype", function () { return $e1708b64fd8f3355$export$d6d64087a1bd2d; });
$parcel$export(module.exports, "deepDiff", function () { return $e1708b64fd8f3355$export$f00d38dfe38936c3; });
$parcel$export(module.exports, "overwrite", function () { return $e1708b64fd8f3355$export$d3305692eb3e9a81; });
$parcel$export(module.exports, "overwriteShallow", function () { return $e1708b64fd8f3355$export$1c07155dfdd98f41; });
$parcel$export(module.exports, "overwriteDeep", function () { return $e1708b64fd8f3355$export$f0b277b530b4fffd; });
$parcel$export(module.exports, "mergeIfExisted", function () { return $e1708b64fd8f3355$export$7bde6dffa6d2dd59; });
$parcel$export(module.exports, "flattenRecursive", function () { return $e1708b64fd8f3355$export$d53c2c5b09d0676f; });
$parcel$export(module.exports, "isEqualDeep", function () { return $e1708b64fd8f3355$export$683c7d6569f339f4; });
$parcel$export(module.exports, "deepContains", function () { return $e1708b64fd8f3355$export$273cb3019e2f952c; });
$parcel$export(module.exports, "removeFromObject", function () { return $e1708b64fd8f3355$export$bdd7fc6cf95d63b; });
$parcel$export(module.exports, "createObjectWithoutPrototype", function () { return $e1708b64fd8f3355$export$c2a75c92f46bb782; });
$parcel$export(module.exports, "createNestedObject", function () { return $e1708b64fd8f3355$export$a9706fb8026b394a; });
$parcel$export(module.exports, "removeNestedKeyByPath", function () { return $e1708b64fd8f3355$export$33f72cab96f733af; });
$parcel$export(module.exports, "setInObjectByPath", function () { return $e1708b64fd8f3355$export$9c3074cc3d55a00f; });
$parcel$export(module.exports, "getInObjectByPath", function () { return $e1708b64fd8f3355$export$12bc5d09cd221028; });
$parcel$export(module.exports, "detectInfiniteLoop", function () { return $e1708b64fd8f3355$export$ad59efee0c629be2; });
$parcel$export(module.exports, "isCyclic", function () { return $e1708b64fd8f3355$export$831fcc412582ee80; });
$parcel$export(module.exports, "excludeKeysFromObject", function () { return $e1708b64fd8f3355$export$efc42697dda340d9; });

var $aLXZy = parcelRequire("aLXZy");

var $amNJ8 = parcelRequire("amNJ8");

var $1cJu7 = parcelRequire("1cJu7");

var $l2qXs = parcelRequire("l2qXs");

var $2Jg1F = parcelRequire("2Jg1F");

var $kitvZ = parcelRequire("kitvZ");
'use strict';
function $e1708b64fd8f3355$export$78e3044358792147(param, element, state, context) {
    if (!element) element = this;
    if ((0, $amNJ8.isFunction)(param)) try {
        // Call the function with the specified context and parameters
        const result = param.call(element, element, state || element.state, context || element.context);
        // Handle promises
        if (result && typeof result.then === 'function') // This magic allows the function to be awaited if called with await
        // but still work reasonably when called without await
        return result;
        return result;
    } catch (e) {
        if ((0, $kitvZ.isNotProduction)()) {
            console.log(param);
            console.warn('Error executing function', e);
        }
    }
    return param;
}
const $e1708b64fd8f3355$export$871de8747c9eaa88 = (obj, extention, element)=>{
    for(const e in extention)obj[e] = $e1708b64fd8f3355$export$78e3044358792147(extention[e], element);
};
const $e1708b64fd8f3355$export$4950aa0f605343fb = (element, obj, excludeFrom = [])=>{
    for(const e in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, e);
        if (!hasOwnProperty || excludeFrom.includes(e) || e.startsWith('__')) continue;
        const elementProp = element[e];
        const objProp = obj[e];
        if (elementProp === undefined) element[e] = objProp;
    }
    return element;
};
const $e1708b64fd8f3355$export$6969335ea1e4e77c = (element, extend, excludeFrom = [])=>{
    for(const e in extend){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(extend, e);
        if (!hasOwnProperty || excludeFrom.includes(e) || e.startsWith('__')) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if ((0, $amNJ8.isObjectLike)(elementProp) && (0, $amNJ8.isObjectLike)(extendProp)) $e1708b64fd8f3355$export$6969335ea1e4e77c(elementProp, extendProp, excludeFrom);
        else if (elementProp === undefined) element[e] = extendProp;
    }
    return element;
};
const $e1708b64fd8f3355$export$9cd59f9826255e47 = (obj, excludeFrom = [])=>{
    const o = {};
    for(const prop in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, prop);
        if (!hasOwnProperty || excludeFrom.includes(prop) || prop.startsWith('__')) continue;
        o[prop] = obj[prop];
    }
    return o;
};
const $e1708b64fd8f3355$export$1c8d6f44648a0c27 = (arr, exclude = [])=>{
    return arr.reduce((acc, curr)=>$e1708b64fd8f3355$export$6969335ea1e4e77c(acc, $e1708b64fd8f3355$export$b7d58db314e0ac27(curr, {
            exclude: exclude
        })), {});
};
const $e1708b64fd8f3355$export$b7d58db314e0ac27 = (obj, options = {})=>{
    const { exclude: exclude = [], cleanUndefined: cleanUndefined = false, cleanNull: cleanNull = false, window: targetWindow, visited: visited = new WeakMap(), handleExtend: handleExtend = false } = options;
    // Handle non-object types and special cases
    if (!(0, $amNJ8.isObjectLike)(obj) || (0, $2Jg1F.isDOMNode)(obj)) return obj;
    // Handle circular references
    if (visited.has(obj)) return visited.get(obj);
    // Create appropriate container based on type and window context
    const clone = targetWindow ? (0, $amNJ8.isArray)(obj) ? new targetWindow.Array() : new targetWindow.Object() : (0, $amNJ8.isArray)(obj) ? [] : {};
    // Store the clone to handle circular references
    visited.set(obj, clone);
    // Clone properties
    for(const key in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
        // Skip excluded properties
        if (exclude.includes(key) || key.startsWith('__') || key === '__proto__') continue;
        const value = obj[key];
        // Skip based on cleanup options
        if (cleanUndefined && (0, $amNJ8.isUndefined)(value) || cleanNull && (0, $amNJ8.isNull)(value)) continue;
        // Handle special cases
        if ((0, $2Jg1F.isDOMNode)(value)) {
            clone[key] = value;
            continue;
        }
        // Handle 'extend' array if enabled
        if (handleExtend && key === 'extend' && (0, $amNJ8.isArray)(value)) {
            clone[key] = (0, $1cJu7.mergeArray)(value, exclude);
            continue;
        }
        // Handle functions in cross-frame scenario
        if ((0, $amNJ8.isFunction)(value) && targetWindow) {
            clone[key] = targetWindow.eval('(' + value.toString() + ')');
            continue;
        }
        // Recursively clone objects
        if ((0, $amNJ8.isObjectLike)(value)) clone[key] = $e1708b64fd8f3355$export$b7d58db314e0ac27(value, {
            ...options,
            visited: visited
        });
        else clone[key] = value;
    }
    return clone;
};
const $e1708b64fd8f3355$export$7885cbf849c4488d = (obj, stringified = {})=>{
    if (obj.node || obj.__ref || obj.parent || obj.__element || obj.parse) {
        (obj.__element || obj.parent?.__element).warn('Trying to clone element or state at', obj);
        obj = obj.parse?.();
    }
    for(const prop in obj){
        const objProp = obj[prop];
        if ((0, $amNJ8.isFunction)(objProp)) stringified[prop] = objProp.toString();
        else if ((0, $amNJ8.isObject)(objProp)) {
            stringified[prop] = {};
            $e1708b64fd8f3355$export$7885cbf849c4488d(objProp, stringified[prop]);
        } else if ((0, $amNJ8.isArray)(objProp)) {
            stringified[prop] = [];
            objProp.forEach((v, i)=>{
                if ((0, $amNJ8.isObject)(v)) {
                    stringified[prop][i] = {};
                    $e1708b64fd8f3355$export$7885cbf849c4488d(v, stringified[prop][i]);
                } else if ((0, $amNJ8.isFunction)(v)) stringified[prop][i] = v.toString();
                else stringified[prop][i] = v;
            });
        } else stringified[prop] = objProp;
    }
    return stringified;
};
const $e1708b64fd8f3355$var$MAX_DEPTH = 100 // Adjust this value as needed
;
const $e1708b64fd8f3355$export$46c0f1e710234ddf = (obj, stringified = {}, depth = 0, path = '')=>{
    if (depth > $e1708b64fd8f3355$var$MAX_DEPTH) {
        console.warn(`Maximum depth exceeded at path: ${path}. Possible circular reference.`);
        return '[MAX_DEPTH_EXCEEDED]';
    }
    for(const prop in obj){
        const currentPath = path ? `${path}.${prop}` : prop;
        const objProp = obj[prop];
        if ((0, $amNJ8.isFunction)(objProp)) stringified[prop] = objProp.toString();
        else if ((0, $amNJ8.isObject)(objProp)) {
            stringified[prop] = {};
            $e1708b64fd8f3355$export$46c0f1e710234ddf(objProp, stringified[prop], depth + 1, currentPath);
        } else if ((0, $amNJ8.isArray)(objProp)) {
            stringified[prop] = [];
            objProp.forEach((v, i)=>{
                const itemPath = `${currentPath}[${i}]`;
                if ((0, $amNJ8.isObject)(v)) {
                    stringified[prop][i] = {};
                    $e1708b64fd8f3355$export$46c0f1e710234ddf(v, stringified[prop][i], depth + 1, itemPath);
                } else if ((0, $amNJ8.isFunction)(v)) stringified[prop][i] = v.toString();
                else stringified[prop][i] = v;
            });
        } else stringified[prop] = objProp;
    }
    return stringified;
};
const $e1708b64fd8f3355$export$830c053460e5ddf6 = (obj = {}, indent = 0)=>{
    // Handle empty object case
    if (obj === null || typeof obj !== 'object') return String(obj);
    // Handle empty object case
    if (Object.keys(obj).length === 0) return '{}';
    const spaces = '  '.repeat(indent);
    let str = '{\n';
    for (const [key, value] of Object.entries(obj)){
        const keyNotAllowdChars = (0, $l2qXs.stringIncludesAny)(key, [
            '&',
            '*',
            '-',
            ':',
            '%',
            '{',
            '}',
            '>',
            '<',
            '@',
            '.',
            '/',
            '!',
            ' '
        ]);
        const stringedKey = keyNotAllowdChars ? `'${key}'` : key;
        str += `${spaces}  ${stringedKey}: `;
        if ((0, $amNJ8.isArray)(value)) {
            str += '[\n';
            for (const element of value){
                if ((0, $amNJ8.isObjectLike)(element) && element !== null) str += `${spaces}    ${$e1708b64fd8f3355$export$830c053460e5ddf6(element, indent + 2)},\n`;
                else if ((0, $amNJ8.isString)(element)) str += `${spaces}    '${element}',\n`;
                else str += `${spaces}    ${element},\n`;
            }
            str += `${spaces}  ]`;
        } else if ((0, $amNJ8.isObjectLike)(value)) str += $e1708b64fd8f3355$export$830c053460e5ddf6(value, indent + 1);
        else if ((0, $amNJ8.isString)(value)) str += (0, $l2qXs.stringIncludesAny)(value, [
            '\n',
            "'"
        ]) ? `\`${value}\`` : `'${value}'`;
        else str += value;
        str += ',\n';
    }
    str += `${spaces}}`;
    return str;
};
const $e1708b64fd8f3355$export$43ffbb9d42fee1c4 = (obj, detached = {})=>{
    for(const prop in obj){
        const objProp = obj[prop];
        if ((0, $amNJ8.isFunction)(objProp)) continue;
        else if ((0, $amNJ8.isObject)(objProp)) {
            detached[prop] = {};
            $e1708b64fd8f3355$export$7885cbf849c4488d(objProp, detached[prop]);
        } else if ((0, $amNJ8.isArray)(objProp)) {
            detached[prop] = [];
            objProp.forEach((v, i)=>{
                if ((0, $amNJ8.isFunction)(v)) return;
                if ((0, $amNJ8.isObject)(v)) {
                    detached[prop][i] = {};
                    $e1708b64fd8f3355$export$43ffbb9d42fee1c4(v, detached[prop][i]);
                } else detached[prop][i] = v;
            });
        } else detached[prop] = objProp;
    }
    return detached;
};
const $e1708b64fd8f3355$export$6b15be743c368efa = (str)=>{
    if (!str) return false;
    const trimmed = str.trim().replace(/\n\s*/g, ' ').trim();
    if (trimmed === '') return false;
    if (trimmed === '{}') return false;
    if (trimmed === '[]') return false;
    const patterns = [
        /^\(\s*\{[^}]*\}\s*\)\s*=>/,
        /^(\([^)]*\)|[^=]*)\s*=>/,
        /^function[\s(]/,
        /^async\s+/,
        /^\(\s*function/,
        /^[a-zA-Z_$][a-zA-Z0-9_$]*\s*=>/
    ];
    const isFunction = patterns.some((pattern)=>pattern.test(trimmed));
    const isObjectLiteral = trimmed.startsWith('{') && !trimmed.includes('=>');
    const isArrayLiteral = trimmed.startsWith('[');
    const isJSONLike = /^["[{]/.test(trimmed) && !trimmed.includes('=>');
    return isFunction && !isObjectLiteral && !isArrayLiteral && !isJSONLike;
};
const $e1708b64fd8f3355$export$87659e1dc59ed8a3 = (obj, destringified = {})=>{
    for(const prop in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, prop);
        if (!hasOwnProperty) continue;
        const objProp = obj[prop];
        if ((0, $amNJ8.isString)(objProp)) {
            if ($e1708b64fd8f3355$export$6b15be743c368efa(objProp)) try {
                const evalProp = (0, $aLXZy.window).eval(`(${objProp})`);
                destringified[prop] = evalProp;
            } catch (e) {
                if (e) destringified[prop] = objProp;
            }
            else destringified[prop] = objProp;
        } else if ((0, $amNJ8.isArray)(objProp)) {
            destringified[prop] = [];
            objProp.forEach((arrProp)=>{
                if ((0, $amNJ8.isString)(arrProp)) {
                    if ($e1708b64fd8f3355$export$6b15be743c368efa(arrProp)) try {
                        const evalProp = (0, $aLXZy.window).eval(`(${arrProp})`);
                        destringified[prop].push(evalProp);
                    } catch (e) {
                        if (e) destringified[prop].push(arrProp);
                    }
                    else destringified[prop].push(arrProp);
                } else if ((0, $amNJ8.isObject)(arrProp)) destringified[prop].push($e1708b64fd8f3355$export$87659e1dc59ed8a3(arrProp));
                else destringified[prop].push(arrProp);
            });
        } else if ((0, $amNJ8.isObject)(objProp)) destringified[prop] = $e1708b64fd8f3355$export$87659e1dc59ed8a3(objProp, destringified[prop]);
        else destringified[prop] = objProp;
    }
    return destringified;
};
const $e1708b64fd8f3355$export$a6c9a3ccba61521e = (str, opts = {
    verbose: true
})=>{
    try {
        return str ? (0, $aLXZy.window).eval('(' + str + ')') : {} // eslint-disable-line
        ;
    } catch (e) {
        if (opts.verbose) console.warn(e);
    }
};
const $e1708b64fd8f3355$export$fcd7b39b3d1c2c1 = (original, objToDiff, cache)=>{
    for(const e in objToDiff){
        if (e === 'ref') continue;
        const originalProp = original[e];
        const objToDiffProp = objToDiff[e];
        if ((0, $amNJ8.isObject)(originalProp) && (0, $amNJ8.isObject)(objToDiffProp)) {
            cache[e] = {};
            $e1708b64fd8f3355$export$a37e3c603d7117e5(originalProp, objToDiffProp, cache[e]);
        } else if (objToDiffProp !== undefined) cache[e] = objToDiffProp;
    }
    return cache;
};
const $e1708b64fd8f3355$export$f1c08b3bfc8443c4 = (original, objToDiff, cache)=>{
    if (original.length !== objToDiff.length) cache = objToDiff;
    else {
        const diffArr = [];
        for(let i = 0; i < original.length; i++){
            const diffObj = $e1708b64fd8f3355$export$a37e3c603d7117e5(original[i], objToDiff[i]);
            if (Object.keys(diffObj).length > 0) diffArr.push(diffObj);
        }
        if (diffArr.length > 0) cache = diffArr;
    }
    return cache;
};
const $e1708b64fd8f3355$export$a37e3c603d7117e5 = (original, objToDiff, cache = {})=>{
    if ((0, $amNJ8.isArray)(original) && (0, $amNJ8.isArray)(objToDiff)) {
        cache = [];
        $e1708b64fd8f3355$export$f1c08b3bfc8443c4(original, objToDiff, cache);
    } else $e1708b64fd8f3355$export$fcd7b39b3d1c2c1(original, objToDiff, cache);
    return cache;
};
const $e1708b64fd8f3355$export$5a15a386532a5ea4 = (o, ...args)=>Object.prototype.hasOwnProperty.call(o, ...args);
const $e1708b64fd8f3355$export$dd1bc94b04021eeb = (o)=>Object.keys(o).length === 0;
const $e1708b64fd8f3355$export$83b788b1a3698c03 = (o)=>(0, $amNJ8.isObject)(o) && $e1708b64fd8f3355$export$dd1bc94b04021eeb(o);
const $e1708b64fd8f3355$export$d6d64087a1bd2d = ()=>Object.create(null);
const $e1708b64fd8f3355$export$f00d38dfe38936c3 = (lhs, rhs)=>{
    if (lhs === rhs) return {};
    if (!(0, $amNJ8.isObjectLike)(lhs) || !(0, $amNJ8.isObjectLike)(rhs)) return rhs;
    const deletedValues = Object.keys(lhs).reduce((acc, key)=>{
        if (!$e1708b64fd8f3355$export$5a15a386532a5ea4(rhs, key)) acc[key] = undefined;
        return acc;
    }, $e1708b64fd8f3355$export$d6d64087a1bd2d());
    if ((0, $amNJ8.isDate)(lhs) || (0, $amNJ8.isDate)(rhs)) {
        if (lhs.valueOf() === rhs.valueOf()) return {};
        return rhs;
    }
    return Object.keys(rhs).reduce((acc, key)=>{
        if (!$e1708b64fd8f3355$export$5a15a386532a5ea4(lhs, key)) {
            acc[key] = rhs[key];
            return acc;
        }
        const difference = $e1708b64fd8f3355$export$a37e3c603d7117e5(lhs[key], rhs[key]);
        if ($e1708b64fd8f3355$export$83b788b1a3698c03(difference) && !(0, $amNJ8.isDate)(difference) && ($e1708b64fd8f3355$export$83b788b1a3698c03(lhs[key]) || !$e1708b64fd8f3355$export$83b788b1a3698c03(rhs[key]))) return acc;
        acc[key] = difference;
        return acc;
    }, deletedValues);
};
const $e1708b64fd8f3355$export$d3305692eb3e9a81 = (element, params, opts = {})=>{
    const { __ref: ref } = element;
    const excl = opts.exclude || [];
    const allowUnderscore = opts.preventUnderscore;
    const preventCaching = opts.preventCaching;
    for(const e in params){
        if (excl.includes(e) || !allowUnderscore && e.startsWith('__')) continue;
        const elementProp = element[e];
        const paramsProp = params[e];
        if (paramsProp !== undefined) {
            element[e] = paramsProp;
            if (ref && !preventCaching) ref.__cache[e] = elementProp;
            if ((0, $amNJ8.isObject)(opts.diff)) $e1708b64fd8f3355$export$a37e3c603d7117e5[e] = elementProp;
        }
    }
    return element;
};
const $e1708b64fd8f3355$export$1c07155dfdd98f41 = (obj, params, excludeFrom = [])=>{
    for(const e in params){
        if (excludeFrom.includes(e) || e.startsWith('__')) continue;
        obj[e] = params[e];
    }
    return obj;
};
const $e1708b64fd8f3355$export$f0b277b530b4fffd = (obj, params, opts = {}, visited = new WeakMap())=>{
    const excl = opts.exclude || [];
    const forcedExclude = opts.preventForce ? [] : [
        'node',
        'window'
    ];
    if (!(0, $amNJ8.isObjectLike)(obj) || !(0, $amNJ8.isObjectLike)(params) || (0, $2Jg1F.isDOMNode)(obj) || (0, $2Jg1F.isDOMNode)(params)) return params;
    if (visited.has(obj)) return visited.get(obj);
    visited.set(obj, obj);
    for(const e in params){
        if (!Object.hasOwnProperty.call(params, e)) continue;
        if (excl.includes(e) || forcedExclude && e.startsWith('__')) continue;
        const objProp = obj[e];
        const paramsProp = params[e];
        if ((0, $2Jg1F.isDOMNode)(paramsProp)) obj[e] = paramsProp;
        else if ((0, $amNJ8.isObjectLike)(objProp) && (0, $amNJ8.isObjectLike)(paramsProp)) obj[e] = $e1708b64fd8f3355$export$f0b277b530b4fffd(objProp, paramsProp, opts, visited);
        else if (paramsProp !== undefined) obj[e] = paramsProp;
    }
    return obj;
};
const $e1708b64fd8f3355$export$7bde6dffa6d2dd59 = (a, b)=>{
    if ((0, $amNJ8.isObjectLike)(a) && (0, $amNJ8.isObjectLike)(b)) return $e1708b64fd8f3355$export$6969335ea1e4e77c(a, b);
    return a || b;
};
const $e1708b64fd8f3355$export$d53c2c5b09d0676f = (param, prop, stack = [])=>{
    const objectized = (0, $1cJu7.mergeAndCloneIfArray)(param);
    stack.push(objectized);
    const extendOfExtend = objectized[prop];
    if (extendOfExtend) $e1708b64fd8f3355$export$d53c2c5b09d0676f(extendOfExtend, prop, stack);
    delete objectized[prop];
    return stack;
};
const $e1708b64fd8f3355$export$683c7d6569f339f4 = (param, element, visited = new Set())=>{
    // Check if both values are non-null objects
    if (typeof param !== 'object' || typeof element !== 'object' || param === null || element === null) return param === element // Compare non-object values directly
    ;
    // Check for circular references
    if (visited.has(param) || visited.has(element)) return true // Assume equality to break the circular reference
    ;
    visited.add(param);
    visited.add(element);
    const keysParam = Object.keys(param);
    const keysElement = Object.keys(element);
    // Check if both objects have the same number of properties
    if (keysParam.length !== keysElement.length) return false;
    // Check if all properties in param also exist in element
    for (const key of keysParam){
        if (!keysElement.includes(key)) return false;
        const paramProp = param[key];
        const elementProp = element[key];
        // Recursively check property values
        if (!$e1708b64fd8f3355$export$683c7d6569f339f4(paramProp, elementProp, visited)) return false;
    }
    return true;
};
const $e1708b64fd8f3355$export$273cb3019e2f952c = (obj1, obj2, ignoredKeys = [
    'node',
    '__ref'
])=>{
    if (obj1 === obj2) return true;
    if (!(0, $amNJ8.isObjectLike)(obj1) || !(0, $amNJ8.isObjectLike)(obj2)) return false;
    if ((0, $2Jg1F.isDOMNode)(obj1) || (0, $2Jg1F.isDOMNode)(obj2)) return obj1 === obj2;
    const stack = [
        [
            obj1,
            obj2
        ]
    ];
    const visited = new WeakSet();
    while(stack.length > 0){
        const [current1, current2] = stack.pop();
        if (visited.has(current1)) continue;
        visited.add(current1);
        const keys1 = Object.keys(current1).filter((key)=>!ignoredKeys.includes(key));
        const keys2 = Object.keys(current2).filter((key)=>!ignoredKeys.includes(key));
        if (keys1.length !== keys2.length) return false;
        for (const key of keys1){
            if (!Object.prototype.hasOwnProperty.call(current2, key)) return false;
            const value1 = current1[key];
            const value2 = current2[key];
            if ((0, $2Jg1F.isDOMNode)(value1) || (0, $2Jg1F.isDOMNode)(value2)) {
                if (value1 !== value2) return false;
            } else if ((0, $amNJ8.isObjectLike)(value1) && (0, $amNJ8.isObjectLike)(value2)) {
                if (value1 !== value2) stack.push([
                    value1,
                    value2
                ]);
            } else if (value1 !== value2) return false;
        }
    }
    return true;
};
const $e1708b64fd8f3355$export$bdd7fc6cf95d63b = (obj, props)=>{
    if (props === undefined || props === null) return obj;
    if ((0, $amNJ8.is)(props)('string', 'number')) delete obj[props];
    else if ((0, $amNJ8.isArray)(props)) props.forEach((prop)=>delete obj[prop]);
    else throw new Error('Invalid input: props must be a string or an array of strings');
    return obj;
};
const $e1708b64fd8f3355$export$c2a75c92f46bb782 = (obj)=>{
    if (obj === null || typeof obj !== 'object') return obj // Return the value if obj is not an object
    ;
    const newObj = Object.create(null) // Create an object without prototype
    ;
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = $e1708b64fd8f3355$export$c2a75c92f46bb782(obj[key]) // Recursively copy each property
    ;
    return newObj;
};
const $e1708b64fd8f3355$export$a9706fb8026b394a = (arr, lastValue)=>{
    const nestedObject = {};
    if (arr.length === 0) return lastValue;
    arr.reduce((obj, value, index)=>{
        if (!obj[value]) obj[value] = {};
        if (index === arr.length - 1 && lastValue !== undefined) obj[value] = lastValue;
        return obj[value];
    }, nestedObject);
    return nestedObject;
};
const $e1708b64fd8f3355$export$33f72cab96f733af = (obj, path)=>{
    if (!Array.isArray(path)) throw new Error('Path must be an array.');
    let current = obj;
    for(let i = 0; i < path.length - 1; i++){
        if (current[path[i]] === undefined) return; // Path does not exist, so nothing to remove.
        current = current[path[i]];
    }
    const lastKey = path[path.length - 1];
    if (current && Object.hasOwnProperty.call(current, lastKey)) delete current[lastKey];
};
const $e1708b64fd8f3355$export$9c3074cc3d55a00f = (obj, path, value)=>{
    if (!Array.isArray(path)) throw new Error('Path must be an array.');
    let current = obj;
    for(let i = 0; i < path.length - 1; i++){
        // If the current path segment doesn't exist or isn't an object, create it
        if (!current[path[i]] || typeof current[path[i]] !== 'object') current[path[i]] = {};
        current = current[path[i]];
    }
    const lastKey = path[path.length - 1];
    current[lastKey] = value;
    return obj;
};
const $e1708b64fd8f3355$export$12bc5d09cd221028 = (obj, path)=>{
    if (!Array.isArray(path)) throw new Error('Path must be an array.');
    let current = obj;
    for(let i = 0; i < path.length; i++){
        if (current === undefined || current === null) return undefined;
        current = current[path[i]];
    }
    return current;
};
const $e1708b64fd8f3355$export$ad59efee0c629be2 = (arr)=>{
    const maxRepeats = 10 // Maximum allowed repetitions
    ;
    let pattern = [];
    let repeatCount = 0;
    for(let i = 0; i < arr.length; i++)if (pattern.length < 2) // Build the initial pattern with two consecutive elements
    pattern.push(arr[i]);
    else {
        // Check if the current element follows the repeating pattern
        if (arr[i] === pattern[i % 2]) repeatCount++;
        else {
            // If there's a mismatch, reset the pattern and repeat counter
            pattern = [
                arr[i - 1],
                arr[i]
            ];
            repeatCount = 1 // Reset to 1 because we start a new potential pattern
            ;
        }
        // If the pattern repeats more than `maxRepeats`, throw a warning
        if (repeatCount >= maxRepeats * 2) {
            if ((0, $kitvZ.isNotProduction)()) console.warn('Warning: Potential infinite loop detected due to repeated sequence:', pattern);
            return true;
        }
    }
};
const $e1708b64fd8f3355$export$831fcc412582ee80 = (obj)=>{
    const seenObjects = [];
    function detect(obj) {
        if (obj && typeof obj === 'object') {
            if (seenObjects.indexOf(obj) !== -1) return true;
            seenObjects.push(obj);
            for(const key in obj)if (Object.hasOwnProperty.call(obj, key) && detect(obj[key])) {
                console.log(obj, 'cycle at ' + key);
                return true;
            }
        }
        return false;
    }
    return detect(obj);
};
const $e1708b64fd8f3355$export$efc42697dda340d9 = (obj, excludedKeys)=>{
    const result = {
        ...obj
    };
    excludedKeys.forEach((key)=>delete result[key]);
    return result;
};

});
parcelRegister("1cJu7", function(module, exports) {

$parcel$export(module.exports, "arrayContainsOtherArray", function () { return $0e0a31c2721a2db1$export$de875babef361e5d; });
$parcel$export(module.exports, "getFrequencyInArray", function () { return $0e0a31c2721a2db1$export$2b3f138fefbb2e97; });
$parcel$export(module.exports, "removeFromArray", function () { return $0e0a31c2721a2db1$export$8af121ae7401c4; });
$parcel$export(module.exports, "swapItemsInArray", function () { return $0e0a31c2721a2db1$export$7e6517ca043a4c76; });
$parcel$export(module.exports, "joinArrays", function () { return $0e0a31c2721a2db1$export$fc359ae9633f7296; });
$parcel$export(module.exports, "mergeArray", function () { return $0e0a31c2721a2db1$export$fd2fbaf2367ef824; });
$parcel$export(module.exports, "mergeAndCloneIfArray", function () { return $0e0a31c2721a2db1$export$803a4c6bdde5cd1d; });
$parcel$export(module.exports, "cutArrayBeforeValue", function () { return $0e0a31c2721a2db1$export$e1c90dd42d36d8f4; });
$parcel$export(module.exports, "cutArrayAfterValue", function () { return $0e0a31c2721a2db1$export$e9b4b966d876219d; });
$parcel$export(module.exports, "removeValueFromArray", function () { return $0e0a31c2721a2db1$export$7268a0a9258a5297; });
$parcel$export(module.exports, "removeValueFromArrayAll", function () { return $0e0a31c2721a2db1$export$91b305d65813a3f8; });
$parcel$export(module.exports, "addItemAfterEveryElement", function () { return $0e0a31c2721a2db1$export$aefdd0c3cb403b10; });
$parcel$export(module.exports, "reorderArrayByValues", function () { return $0e0a31c2721a2db1$export$402525ce1e0ae04f; });
$parcel$export(module.exports, "arraysEqual", function () { return $0e0a31c2721a2db1$export$234180f8206db11b; });
$parcel$export(module.exports, "filterArrays", function () { return $0e0a31c2721a2db1$export$e43a5cd3407a4eed; });
$parcel$export(module.exports, "filterArraysFast", function () { return $0e0a31c2721a2db1$export$34fca6752b16443b; });
$parcel$export(module.exports, "checkIfStringIsInArray", function () { return $0e0a31c2721a2db1$export$8a158988a0fbe64f; });

var $jm0BQ = parcelRequire("jm0BQ");

var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $0e0a31c2721a2db1$export$de875babef361e5d = (arr1, arr2)=>{
    return arr2.every((val)=>arr1.includes(val));
};
const $0e0a31c2721a2db1$export$2b3f138fefbb2e97 = (arr, value)=>{
    return arr.reduce((count, currentValue)=>{
        return currentValue === value ? count + 1 : count;
    }, 0);
};
const $0e0a31c2721a2db1$export$8af121ae7401c4 = (arr, index)=>{
    if ((0, $amNJ8.isString)(index)) index = parseInt(index);
    if ((0, $amNJ8.isNumber)(index)) {
        if (index < 0 || index >= arr.length || isNaN(index)) throw new Error('Invalid index');
        arr.splice(index, 1);
    } else if ((0, $amNJ8.isArray)(index)) index.forEach((idx)=>$0e0a31c2721a2db1$export$8af121ae7401c4(arr, idx));
    else throw new Error('Invalid index');
    return arr;
};
const $0e0a31c2721a2db1$export$7e6517ca043a4c76 = (arr, i, j)=>{
    [arr[i], arr[j]] = [
        arr[j],
        arr[i]
    ];
};
const $0e0a31c2721a2db1$export$fc359ae9633f7296 = (...arrays)=>{
    return [].concat(...arrays);
};
const $0e0a31c2721a2db1$export$fd2fbaf2367ef824 = (arr, exclude = [])=>{
    return arr.reduce((a, c)=>(0, $jm0BQ.deepMerge)(a, (0, $jm0BQ.deepClone)(c, {
            exclude: exclude
        }), exclude), {});
};
const $0e0a31c2721a2db1$export$803a4c6bdde5cd1d = (obj)=>{
    return (0, $amNJ8.isArray)(obj) ? $0e0a31c2721a2db1$export$fd2fbaf2367ef824(obj) : (0, $jm0BQ.deepClone)(obj);
};
const $0e0a31c2721a2db1$export$e1c90dd42d36d8f4 = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index !== -1) return arr.slice(0, index);
    return arr;
};
const $0e0a31c2721a2db1$export$e9b4b966d876219d = (arr, value)=>{
    if (!(0, $amNJ8.isArray)(arr)) return;
    const index = arr.indexOf(value);
    if (index !== -1) return arr.slice(index + 1);
    return arr;
};
const $0e0a31c2721a2db1$export$7268a0a9258a5297 = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index > -1) {
        const newArray = [
            ...arr
        ];
        newArray.splice(index, 1);
        return newArray;
    }
    return arr;
};
const $0e0a31c2721a2db1$export$91b305d65813a3f8 = (arr, value)=>{
    return arr.filter((item)=>item !== value);
};
const $0e0a31c2721a2db1$export$aefdd0c3cb403b10 = (array, item)=>{
    // Create a new array to hold the result
    const result = [];
    // Loop through the input array
    for(let i = 0; i < array.length; i++){
        // Add the current element to the result array
        result.push(array[i]);
        // If it's not the last element, add the item
        if (i < array.length - 1) result.push(item);
    }
    return result;
};
const $0e0a31c2721a2db1$export$402525ce1e0ae04f = (array, valueToMove, insertBeforeValue)=>{
    const newArray = [
        ...array
    ] // Create a copy of the original array
    ;
    const indexToMove = newArray.indexOf(valueToMove) // Find the index of the value to move
    ;
    const indexToInsertBefore = newArray.indexOf(insertBeforeValue) // Find the index to insert before
    ;
    if (indexToMove !== -1 && indexToInsertBefore !== -1) {
        const removedItem = newArray.splice(indexToMove, 1)[0] // Remove the item to move
        ;
        const insertIndex = indexToInsertBefore < indexToMove ? indexToInsertBefore : indexToInsertBefore + 1 // Adjust insert index
        ;
        newArray.splice(insertIndex, 0, removedItem) // Insert the removed item before the specified value
        ;
    }
    return newArray;
};
const $0e0a31c2721a2db1$export$234180f8206db11b = (arr1, arr2)=>{
    if (arr1.length !== arr2.length) return false;
    for(let i = 0; i < arr1.length; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
};
const $0e0a31c2721a2db1$export$e43a5cd3407a4eed = (sourceArr, excludeArr)=>{
    return sourceArr.filter((item)=>!excludeArr.includes(item));
};
const $0e0a31c2721a2db1$export$34fca6752b16443b = (sourceArr, excludeArr)=>{
    const excludeSet = new Set(excludeArr);
    return sourceArr.filter((item)=>!excludeSet.has(item));
};
const $0e0a31c2721a2db1$export$8a158988a0fbe64f = (string, arr)=>{
    if (!string) return;
    return arr.filter((v)=>string.includes(v)).length;
};

});

parcelRegister("l2qXs", function(module, exports) {

$parcel$export(module.exports, "stringIncludesAny", function () { return $f50eb22ebe41488a$export$5e62532c096c05e0; });
$parcel$export(module.exports, "trimStringFromSymbols", function () { return $f50eb22ebe41488a$export$4cb168a4c77839cc; });
$parcel$export(module.exports, "replaceLiteralsWithObjectFields", function () { return $f50eb22ebe41488a$export$7cb52b7decbd2220; });
$parcel$export(module.exports, "lowercaseFirstLetter", function () { return $f50eb22ebe41488a$export$f08459d87829d2ee; });
$parcel$export(module.exports, "findKeyPosition", function () { return $f50eb22ebe41488a$export$e03c69ff1d8102d5; });
$parcel$export(module.exports, "replaceOctalEscapeSequences", function () { return $f50eb22ebe41488a$export$ed5844ba7edb0ac0; });
$parcel$export(module.exports, "encodeNewlines", function () { return $f50eb22ebe41488a$export$56079d9b77cc851c; });
$parcel$export(module.exports, "decodeNewlines", function () { return $f50eb22ebe41488a$export$d5a58d286266e59c; });
$parcel$export(module.exports, "customEncodeURIComponent", function () { return $f50eb22ebe41488a$export$afdf0655b23d957b; });
$parcel$export(module.exports, "customDecodeURIComponent", function () { return $f50eb22ebe41488a$export$f0dfcf6020c0b258; });
'use strict';
const $f50eb22ebe41488a$export$5e62532c096c05e0 = (str, characters)=>{
    for (const char of characters){
        if (str.includes(char)) return true;
    }
    return false;
};
const $f50eb22ebe41488a$export$4cb168a4c77839cc = (str, characters)=>{
    // Create a regular expression pattern to match the specified symbols
    const pattern = new RegExp(`[${characters.join('\\')}]`, 'g');
    // Replace matched symbols with an empty string
    return str.replace(pattern, '');
};
/**
 * Replaces placeholders in a string with corresponding {{ }} values from an object.
 *
 * @param {string} str - The string containing placeholders to replace.
 * @param {object} state - The object containing the values to substitute.
 * @returns {string} The modified string with placeholders replaced by values from the object.
 */ const $f50eb22ebe41488a$var$brackRegex = {
    2: /\{\{\s*((?:\.\.\/)+)?([^}\s]+)\s*\}\}/g,
    3: /\{\{\{\s*((?:\.\.\/)+)?([^}\s]+)\s*\}\}\}/g
};
function $f50eb22ebe41488a$export$7cb52b7decbd2220(str, options = {}, forcedState) {
    if (!str.includes(options.bracketsLength === 3 ? '{{{' : '{{')) return str;
    const reg = $f50eb22ebe41488a$var$brackRegex[options.bracketsLength || 2];
    const obj = forcedState || this?.state || {};
    return str.replace(reg, (_, parentPath, variable)=>{
        if (parentPath) {
            const parentLevels = parentPath.match(options.bracketsLength === 3 ? /\.\.\.\//g : /\.\.\//g).length;
            let parentState = obj;
            for(let i = 0; i < parentLevels; i++){
                parentState = parentState.parent;
                if (!parentState) return '' // Return an empty string if the parent level doesn't exist
                ;
            }
            const value = parentState[variable.trim()];
            return value !== undefined ? `${value}` : '';
        } else {
            const value = obj[variable.trim()];
            return value !== undefined ? `${value}` : '';
        }
    });
}
const $f50eb22ebe41488a$export$f08459d87829d2ee = (inputString)=>{
    return `${inputString.charAt(0).toLowerCase()}${inputString.slice(1)}`;
};
const $f50eb22ebe41488a$export$e03c69ff1d8102d5 = (str, key)=>{
    const lines = str.split('\n');
    let startLineNumber = -1;
    let endLineNumber = -1;
    let startColumn = -1;
    let endColumn = -1;
    const keyPattern = new RegExp(`\\b${key}\\b\\s*:\\s*`);
    let braceCount = 0;
    let foundKey = false;
    for(let i = 0; i < lines.length; i++){
        if (keyPattern.test(lines[i]) && !foundKey) {
            foundKey = true;
            startLineNumber = i + 1;
            startColumn = lines[i].indexOf(key) + 1;
            // Check if the value is an empty object
            if (lines[i].includes('{}')) {
                endLineNumber = startLineNumber;
                endColumn = lines[i].indexOf('{}') + 3;
                break;
            }
            // Check if the value starts with '{' (object) or '[' (array)
            const line = lines[i].slice(startColumn + key.length);
            if (line.includes('{') || line.includes('[')) braceCount = 1;
            else {
                endLineNumber = i + 1;
                endColumn = lines[i].length + 1;
                break;
            }
        } else if (foundKey) {
            braceCount += (lines[i].match(/{/g) || []).length;
            braceCount += (lines[i].match(/\[/g) || []).length;
            braceCount -= (lines[i].match(/}/g) || []).length;
            braceCount -= (lines[i].match(/]/g) || []).length;
            // If braceCount is 0 and we find the end of the object/array
            if (braceCount === 0) {
                endLineNumber = i + 1;
                endColumn = lines[i].lastIndexOf('}') !== -1 ? lines[i].lastIndexOf('}') + 2 : lines[i].length + 1;
                break;
            }
        }
    }
    return {
        startColumn: startColumn,
        endColumn: endColumn,
        startLineNumber: startLineNumber,
        endLineNumber: endLineNumber
    };
};
const $f50eb22ebe41488a$export$ed5844ba7edb0ac0 = (str)=>{
    // Regex to match octal escape sequences
    const octalRegex = /\\([0-7]{1,3})/g;
    // Replace each match with the corresponding character
    return str.replace(octalRegex, (match, p1)=>{
        // Convert the octal value to a decimal integer
        const octalValue = parseInt(p1, 8);
        // Convert the decimal value to the corresponding character
        const char = String.fromCharCode(octalValue);
        return char;
    });
};
const $f50eb22ebe41488a$export$56079d9b77cc851c = (str)=>{
    return str.split('\n').join('/////n').split('`').join('/////tilde').split('$').join('/////dlrsgn');
};
const $f50eb22ebe41488a$export$d5a58d286266e59c = (encodedStr)=>{
    return encodedStr.split('/////n').join('\n').split('/////tilde').join('`').split('/////dlrsgn').join('$');
};
const $f50eb22ebe41488a$export$afdf0655b23d957b = (str)=>{
    return str.split('').map((char)=>{
        if (/[^a-zA-Z0-9\s]/.test(char)) return '%' + char.charCodeAt(0).toString(16).toUpperCase();
        return char;
    }).join('');
};
const $f50eb22ebe41488a$export$f0dfcf6020c0b258 = (encodedStr)=>{
    return encodedStr.replace(/%[0-9A-Fa-f]{2}/g, (match)=>String.fromCharCode(parseInt(match.slice(1), 16)));
};

});


parcelRegister("7033D", function(module, exports) {

$parcel$export(module.exports, "debounce", function () { return $518ae7af61518fb6$export$61fc7d43ac8f84b0; });
$parcel$export(module.exports, "debounceOnContext", function () { return $518ae7af61518fb6$export$d3757b91c00af798; });
$parcel$export(module.exports, "memoize", function () { return $518ae7af61518fb6$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "isStringFunction", function () { return $518ae7af61518fb6$export$6f017d9966fe4675; });
$parcel$export(module.exports, "cloneFunction", function () { return $518ae7af61518fb6$export$5c7d787bf6cea16b; });
'use strict';
function $518ae7af61518fb6$export$61fc7d43ac8f84b0(func, wait, immediate) {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
const $518ae7af61518fb6$export$d3757b91c00af798 = (element, func, timeout = 300)=>{
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(element, args);
        }, timeout);
    };
};
const $518ae7af61518fb6$export$fc10aeed3a532e2a = (fn)=>{
    const cache = {};
    return (...args)=>{
        const n = args[0];
        if (n in cache) return cache[n];
        else {
            const result = fn(n);
            cache[n] = result;
            return result;
        }
    };
};
const $518ae7af61518fb6$export$6f017d9966fe4675 = (inputString)=>{
    // Regular expression to match both regular and arrow function declarations
    const functionRegex = /^((function\s*\([^)]*\)\s*\{[^}]*\})|(\([^)]*\)\s*=>))/;
    // Use the regex to test if the inputString matches the function pattern
    return functionRegex.test(inputString);
};
function $518ae7af61518fb6$export$5c7d787bf6cea16b(fn, win = window) {
    const temp = function() {
        return fn.apply(win, arguments);
    };
    // Copy properties from original function
    for(const key in fn)if (Object.hasOwnProperty.call(fn, key)) temp[key] = fn[key];
    return temp;
}

});

parcelRegister("4A0KM", function(module, exports) {

$parcel$export(module.exports, "logIf", function () { return $355b1bdd7d674182$export$f3730dd3d285b7c6; });
$parcel$export(module.exports, "logGroupIf", function () { return $355b1bdd7d674182$export$7cea94b68a0c230b; });
'use strict';
const $355b1bdd7d674182$export$f3730dd3d285b7c6 = (bool, ...arg)=>{
    if (bool) arg.map((v)=>console.log(v));
};
const $355b1bdd7d674182$export$7cea94b68a0c230b = (bool, key, ...arg)=>{
    if (bool) {
        console.group(key);
        arg.map((v)=>console.log(v));
        console.groupEnd(key);
    }
};

});

parcelRegister("aQLXm", function(module, exports) {

$parcel$export(module.exports, "isMobile", function () { return $7e63f5d63ade968d$export$d0a8044dce8ff2fc; });
$parcel$export(module.exports, "setCookie", function () { return $7e63f5d63ade968d$export$110700823644f4a6; });
$parcel$export(module.exports, "getCookie", function () { return $7e63f5d63ade968d$export$4be65e66cfa2648a; });
$parcel$export(module.exports, "removeCookie", function () { return $7e63f5d63ade968d$export$6a874b7a74007875; });
$parcel$export(module.exports, "getLocalStorage", function () { return $7e63f5d63ade968d$export$d3720feff416e85b; });
$parcel$export(module.exports, "setLocalStorage", function () { return $7e63f5d63ade968d$export$1f73f60bdb811cb1; });

var $amNJ8 = parcelRequire("amNJ8");

var $aLXZy = parcelRequire("aLXZy");
'use strict';
const $7e63f5d63ade968d$export$d0a8044dce8ff2fc = (()=>typeof navigator === 'undefined' ? false : /Mobi/.test(navigator.userAgent))();
const $7e63f5d63ade968d$export$110700823644f4a6 = (cname, cvalue, exdays = 365)=>{
    if ((0, $amNJ8.isUndefined)((0, $aLXZy.document)) || (0, $amNJ8.isUndefined)((0, $aLXZy.document).cookie)) return;
    const d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    const expires = `expires=${d.toUTCString()}`;
    (0, $aLXZy.document).cookie = `${cname}=${cvalue};${expires};path=/`;
};
const $7e63f5d63ade968d$export$4be65e66cfa2648a = (cname)=>{
    if ((0, $amNJ8.isUndefined)((0, $aLXZy.document)) || (0, $amNJ8.isUndefined)((0, $aLXZy.document).cookie)) return;
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent((0, $aLXZy.document).cookie);
    const ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) === ' ')c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return '';
};
const $7e63f5d63ade968d$export$6a874b7a74007875 = (cname)=>{
    if ((0, $amNJ8.isUndefined)((0, $aLXZy.document)) || (0, $amNJ8.isUndefined)((0, $aLXZy.document).cookie)) return;
    (0, $aLXZy.document).cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};
function $7e63f5d63ade968d$export$d3720feff416e85b(key) {
    let savedJSON;
    if (window.localStorage) try {
        savedJSON = JSON.parse(window.localStorage.getItem(key));
    } catch (e) {}
    if (typeof savedJSON !== 'undefined') return savedJSON;
}
function $7e63f5d63ade968d$export$1f73f60bdb811cb1(key, data) {
    if (data && window.localStorage) {
        if (typeof data === 'object') window.localStorage.setItem(key, JSON.stringify(data));
        else window.localStorage.setItem(key, data);
    }
}

});

parcelRegister("8Y0fc", function(module, exports) {

$parcel$export(module.exports, "HTML_TAGS", function () { return $68741dd14364602d$export$4c3fa92ca590c71f; });
$parcel$export(module.exports, "isValidHtmlTag", function () { return $68741dd14364602d$export$52675ca41d41c093; });
'use strict';
const $68741dd14364602d$export$4c3fa92ca590c71f = {
    root: [
        'body',
        'html'
    ],
    head: [
        'title',
        'base',
        'meta',
        'style',
        'noscript',
        'script'
    ],
    body: [
        'string',
        'style',
        'fragment',
        'a',
        'abbr',
        'acronym',
        'address',
        'applet',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'basefont',
        'bdi',
        'bdo',
        'big',
        'blockquote',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'search',
        'col',
        'colgroup',
        'data',
        'datalist',
        'dd',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'em',
        'embed',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'frame',
        'frameset',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hr',
        'i',
        'iframe',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'link',
        'main',
        'map',
        'mark',
        'meter',
        'nav',
        'noframes',
        'noscript',
        'object',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'param',
        'picture',
        'pre',
        'progress',
        'hgroup',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'script',
        'section',
        'select',
        'small',
        'source',
        'span',
        'strike',
        'strong',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'hgroup',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr',
        // SVG
        'svg',
        'path'
    ]
};
const $68741dd14364602d$export$52675ca41d41c093 = (arg)=>$68741dd14364602d$export$4c3fa92ca590c71f.body.includes(arg);

});

parcelRegister("3Kzng", function(module, exports) {

$parcel$export(module.exports, "checkIfKeyIsComponent", function () { return $2bb11b91e2512710$export$b791484194c5fc38; });
$parcel$export(module.exports, "checkIfKeyIsProperty", function () { return $2bb11b91e2512710$export$69dfe88127d1d0de; });
$parcel$export(module.exports, "addAdditionalExtend", function () { return $2bb11b91e2512710$export$356ecc5e07374be5; });
$parcel$export(module.exports, "checkIfSugar", function () { return $2bb11b91e2512710$export$998af2411f6c25b6; });
$parcel$export(module.exports, "extractComponentKeyFromKey", function () { return $2bb11b91e2512710$export$4683a1d5b4c03da1; });
$parcel$export(module.exports, "extendizeByKey", function () { return $2bb11b91e2512710$export$c786485ace8eb69b; });
$parcel$export(module.exports, "getCapitalCaseKeys", function () { return $2bb11b91e2512710$export$ef62ecae187000fa; });
$parcel$export(module.exports, "addChildrenIfNotInOriginal", function () { return $2bb11b91e2512710$export$5f700329e3bf6352; });
$parcel$export(module.exports, "applyKeyComponentAsExtend", function () { return $2bb11b91e2512710$export$2279e5e6b0817ddc; });
$parcel$export(module.exports, "applyComponentFromContext", function () { return $2bb11b91e2512710$export$fd6b2f481ffc7974; });
$parcel$export(module.exports, "isVariant", function () { return $2bb11b91e2512710$export$53cd1a145c393044; });
$parcel$export(module.exports, "hasVariantProp", function () { return $2bb11b91e2512710$export$c66af1c05bf7bb06; });
$parcel$export(module.exports, "getChildrenComponentsByKey", function () { return $2bb11b91e2512710$export$ca8981c294eb4d67; });
$parcel$export(module.exports, "getExtendsInElement", function () { return $2bb11b91e2512710$export$a23334bdec459c3a; });
$parcel$export(module.exports, "setContentKey", function () { return $2bb11b91e2512710$export$c99c504ad1135f20; });

var $kitvZ = parcelRequire("kitvZ");

var $1cJu7 = parcelRequire("1cJu7");

var $jm0BQ = parcelRequire("jm0BQ");

var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $2bb11b91e2512710$export$b791484194c5fc38 = (key)=>{
    const isFirstKeyString = (0, $amNJ8.isString)(key);
    if (!isFirstKeyString) return;
    const firstCharKey = key.slice(0, 1);
    return /^[A-Z]*$/.test(firstCharKey);
};
const $2bb11b91e2512710$export$69dfe88127d1d0de = (key)=>{
    const isFirstKeyString = (0, $amNJ8.isString)(key);
    if (!isFirstKeyString) return;
    const firstCharKey = key.slice(0, 1);
    return /^[a-z]*$/.test(firstCharKey);
};
const $2bb11b91e2512710$export$356ecc5e07374be5 = (newExtend, element)=>{
    if (!newExtend) return element;
    const { extend: elementExtend } = element;
    const originalArray = (0, $amNJ8.isArray)(elementExtend) ? elementExtend : [
        elementExtend
    ];
    const receivedArray = (0, $amNJ8.isArray)(newExtend) ? newExtend : [
        newExtend
    ];
    const extend = (0, $1cJu7.joinArrays)(receivedArray, originalArray);
    return {
        ...element,
        extend: extend
    };
};
const $2bb11b91e2512710$export$998af2411f6c25b6 = (element, parent, key)=>{
    const { extend: extend, props: props, childExtend: childExtend, extends: extendProps, childExtends: childExtends, childProps: childProps, children: children, on: on, $collection: $collection, $stateCollection: $stateCollection, $propsCollection: $propsCollection } = element;
    const hasComponentAttrs = extend || childExtend || props || on || $collection || $stateCollection || $propsCollection;
    if (hasComponentAttrs && (childProps || extendProps || children || childExtends)) {
        const logErr = (parent || element)?.error;
        if (logErr) logErr.call(parent, element, 'Sugar component includes params for builtin components', {
            verbose: true
        });
    }
    return !hasComponentAttrs || childProps || extendProps || children || childExtends;
};
const $2bb11b91e2512710$export$4683a1d5b4c03da1 = (key)=>{
    return key.includes('+') ? key.split('+') // get array of componentKeys
     : key.includes('_') ? [
        key.split('_')[0]
    ] // get component key split _
     : key.includes('.') && !$2bb11b91e2512710$export$b791484194c5fc38(key.split('.')[1]) ? [
        key.split('.')[0]
    ] // get component key split .
     : [
        key
    ];
};
const $2bb11b91e2512710$export$c786485ace8eb69b = (element, parent, key)=>{
    const { context: context } = parent;
    const { tag: tag, extend: extend, childExtends: childExtends } = element;
    const isSugar = $2bb11b91e2512710$export$998af2411f6c25b6(element, parent, key);
    const extendFromKey = $2bb11b91e2512710$export$4683a1d5b4c03da1(key);
    const isExtendKeyComponent = context && context.components[extendFromKey];
    if (element === isExtendKeyComponent) return element;
    else if (isSugar) {
        const newElem = $2bb11b91e2512710$export$356ecc5e07374be5(element.extends, {
            extend: extendFromKey,
            tag: tag,
            props: {
                ...element
            }
        });
        if (newElem.props.data) {
            newElem.data = newElem.props.data;
            delete newElem.props.data;
        }
        if (newElem.props.state) {
            newElem.state = newElem.props.state;
            delete newElem.props.state;
        }
        if (newElem.props.attr) {
            newElem.attr = newElem.props.attr;
            delete newElem.props.attr;
        }
        if (newElem.props.if) {
            newElem.if = newElem.props.if;
            delete newElem.props.if;
        }
        if (childExtends) newElem.childExtend = childExtends;
        return newElem;
    } else if (!extend || extend === true) return {
        ...element,
        tag: tag,
        extend: extendFromKey
    };
    else if (extend) return $2bb11b91e2512710$export$356ecc5e07374be5(extendFromKey, element);
    else if ((0, $amNJ8.isFunction)(element)) return {
        extend: extendFromKey,
        tag: tag,
        props: {
            ...(0, $jm0BQ.exec)(element, parent)
        }
    };
};
function $2bb11b91e2512710$export$ef62ecae187000fa(obj) {
    return Object.keys(obj).filter((key)=>/^[A-Z]/.test(key));
}
const $2bb11b91e2512710$export$5f700329e3bf6352 = (element, parent, key)=>{
    const childElems = $2bb11b91e2512710$export$ef62ecae187000fa(element.props);
    if (!childElems.length) return element;
    for(const i in childElems){
        const childKey = childElems[i];
        const childElem = element[childKey];
        const newChild = element.props[childKey];
        const assignChild = (val)=>{
            element[childKey] = val;
            delete element.props[childKey];
        };
        if (newChild?.ignoreExtend) continue;
        if (newChild === null) assignChild(null);
        else if (!childElem) assignChild((0, $jm0BQ.deepClone)(newChild));
        else {
            const isSugarChildElem = $2bb11b91e2512710$export$998af2411f6c25b6(childElem, parent, key);
            if (isSugarChildElem) continue;
            assignChild({
                extend: element[childKey],
                props: newChild
            });
        }
    }
};
const $2bb11b91e2512710$export$2279e5e6b0817ddc = (element, parent, key)=>{
    return $2bb11b91e2512710$export$c786485ace8eb69b(element, parent, key) || element;
};
const $2bb11b91e2512710$export$fd6b2f481ffc7974 = (element, parent, options)=>{
    const { context: context } = element;
    if (!context || !context.components) return;
    const { components: components } = context;
    const { extend: extend } = element;
    const execExtend = (0, $jm0BQ.exec)(extend, element);
    if ((0, $amNJ8.isString)(execExtend)) {
        const componentExists = components[execExtend] || components['smbls.' + execExtend];
        if (componentExists) element.extend = componentExists;
        else {
            if ((0, $kitvZ.isNotProduction)() && options.verbose) {
                console.warn(execExtend, 'is not in library', components, element);
                console.warn('replacing with ', {});
            }
            element.extend = {};
        }
    }
};
const $2bb11b91e2512710$export$53cd1a145c393044 = (param)=>{
    if (!(0, $amNJ8.isString)(param)) return;
    const firstCharKey = param.slice(0, 1);
    // return (firstCharKey === '.' || firstCharKey === '$')
    return firstCharKey === '.';
};
const $2bb11b91e2512710$export$c66af1c05bf7bb06 = (element)=>{
    const { props: props } = element;
    if ((0, $amNJ8.isObject)(props) && (0, $amNJ8.isString)(props.variant)) return true;
};
const $2bb11b91e2512710$export$ca8981c294eb4d67 = (key, el)=>{
    if (key === el.key || el.__ref.__componentKey === key) return el;
    // Check if the prop is "extend" and it's either a string or an array
    if (el.extend) {
        // Add the value of the extend key to the result array
        const foundString = (0, $amNJ8.isString)(el.extend) && el.extend === key;
        const foundInArray = (0, $amNJ8.isArray)(el.extend) && el.extend.filter((v)=>v === key).length;
        if (foundString || foundInArray) return el;
    }
    if (el.parent && el.parent.childExtend) {
        // Add the value of the extend key to the result array
        const foundString = (0, $amNJ8.isString)(el.parent.childExtend) && el.parent.childExtend === key;
        const foundInArray = (0, $amNJ8.isArray)(el.parent.childExtend) && el.parent.childExtend.filter((v)=>v === key).length;
        if (foundString || foundInArray) return el;
    }
};
const $2bb11b91e2512710$export$a23334bdec459c3a = (obj)=>{
    let result = [];
    function traverse(o) {
        for(const key in o)if (Object.hasOwnProperty.call(o, key)) {
            // Check if the key starts with a capital letter and exclude keys like @mobileL, $propsCollection
            if ($2bb11b91e2512710$export$b791484194c5fc38(key)) result.push(key);
            // Check if the key is "extend" and it's either a string or an array
            if (key === 'extend' || key === 'extends') {
                // Add the value of the extend key to the result array
                if (typeof o[key] === 'string') result.push(o[key]);
                else if (Array.isArray(o[key])) result = result.concat(o[key]);
            }
            // If the property is an object, traverse it
            if (typeof o[key] === 'object' && o[key] !== null) traverse(o[key]);
        }
    }
    traverse(obj);
    return result;
};
const $2bb11b91e2512710$export$c99c504ad1135f20 = (el, opts = {})=>{
    const { __ref: ref } = el;
    const contentElementKey = opts.contentElementKey;
    if (contentElementKey !== 'content' && contentElementKey !== ref.contentElementKey || !ref.contentElementKey) ref.contentElementKey = contentElementKey || 'content';
    else ref.contentElementKey = 'content';
    if (contentElementKey !== 'content') opts.contentElementKey = 'content';
    return ref.contentElementKey;
};

});



parcelRegister("3o7U3", function(module, exports) {

$parcel$export(module.exports, "canRenderTag", function () { return $2779be645fe0fda6$export$342a7615681b7118; });

var $7S1uT = parcelRequire("7S1uT");
parcelRequire("imR0C");
var $8Y0fc = parcelRequire("8Y0fc");
'use strict';
const $2779be645fe0fda6$export$342a7615681b7118 = (tag)=>{
    return (0, $8Y0fc.isValidHtmlTag)(tag || 'div') || (0, $7S1uT.report)('HTMLInvalidTag');
};

});
parcelRegister("7S1uT", function(module, exports) {

$parcel$export(module.exports, "ERRORS_REGISTRY", function () { return $5baebce21488f2bf$export$fc4da02de2c0bd43; });
$parcel$export(module.exports, "report", function () { return $5baebce21488f2bf$export$f18d5b0af29128b7; });
'use strict';
const $5baebce21488f2bf$export$fc4da02de2c0bd43 = {
    en: {
        DocumentNotDefined: {
            title: 'Document is undefined',
            description: 'To tweak with DOM, you should use browser.'
        },
        OverwriteToBuiltin: {
            title: 'Overwriting to builtin method',
            description: 'Overwriting a builtin method in the window define is not possible, please choose different name'
        },
        BrowserNotDefined: {
            title: "Can't recognize environment",
            description: 'Environment should be browser application, that can run Javascript'
        },
        SetQuickPreferancesIsNotObject: {
            title: 'Quick preferances object is required',
            description: 'Please pass a plain object with "lang", "culture" and "area" properties'
        },
        InvalidParams: {
            title: 'Params are invalid',
            description: 'Please pass a plain object with "lang", "culture" and "area" properties'
        },
        CantCreateWithoutNode: {
            title: 'You must provide node',
            description: "Can't create DOM element without setting node or text"
        },
        HTMLInvalidTag: {
            title: 'Element tag name (or DOM nodeName) is invalid',
            description: 'To create element, you must provide valid DOM node. See full list of them at here: http://www.w3schools.com/tags/'
        },
        HTMLInvalidAttr: {
            title: 'Attibutes object is invalid',
            description: 'Please pass a valid plain object to apply as an attributes for a DOM node'
        },
        HTMLInvalidData: {
            title: 'Data object is invalid',
            description: 'Please pass a valid plain object to apply as an dataset for a DOM node'
        },
        HTMLInvalidStyles: {
            title: 'Styles object is invalid',
            description: 'Please pass a valid plain object to apply as an style for a DOM node'
        },
        HTMLInvalidText: {
            title: 'Text string is invalid',
            description: 'Please pass a valid string to apply text to DOM node'
        },
        ElementOnStateIsNotDefined: {
            title: 'Element on state is not defined',
            description: 'Please check the element object'
        }
    }
};
const $5baebce21488f2bf$export$f18d5b0af29128b7 = (err, arg, element)=>{
    const currentLang = 'en';
    let errObj;
    if (err && typeof err === 'string') errObj = $5baebce21488f2bf$export$fc4da02de2c0bd43[currentLang][err];
    return new Error(`"${err}", "${arg}"\n\n`, `${errObj.description}`, element ? `\n\n${element}` : '');
};

});


parcelRegister("bnF2s", function(module, exports) {

$parcel$export(module.exports, "applyAnimationFrame", function () { return $8491ad1e867582f1$export$cef3c08d5491509f; });
$parcel$export(module.exports, "initAnimationFrame", function () { return $8491ad1e867582f1$export$e1d20e1514750bad; });
'use strict';
const $8491ad1e867582f1$export$a9e0446239e28a61 = (el)=>{
    const { __ref: ref } = el;
    const { frameListeners: frameListeners } = ref.root.data;
    // Check if frameListeners exists and the element is not already in the Set
    if (frameListeners && !frameListeners.has(el)) frameListeners.add(el) // Add the element to the Set
    ;
};
const $8491ad1e867582f1$export$cef3c08d5491509f = (element, options)=>{
    const { props: props, on: on, __ref: ref } = element;
    const { frameListeners: frameListeners } = ref.root.data;
    if (frameListeners && (on?.frame || props?.onFrame)) $8491ad1e867582f1$export$a9e0446239e28a61(element);
};
const $8491ad1e867582f1$export$e1d20e1514750bad = (ctx)=>{
    const frameListeners = new Set();
    function requestFrame() {
        // Iterate over frameListeners
        for (const element of frameListeners){
            if (!element.parent.node.contains(element.node)) frameListeners.delete(element) // Remove if node has no parent
            ;
            else try {
                (element.on.frame || element.props.onFrame)(element, element.state, element.context);
            } catch (e) {
                console.warn(e);
            }
        }
        window.requestAnimationFrame(requestFrame);
    }
    requestFrame();
    return frameListeners;
};

});


parcelRegister("hmiUX", function(module, exports) {

$parcel$export(module.exports, "ROOT", function () { return $ca332a63a1118bbd$export$fbea82a1c0574ef4; });
$parcel$export(module.exports, "TREE", function () { return $ca332a63a1118bbd$export$33ecaa422889cd80; });
parcelRequire("imR0C");
var $aLXZy = parcelRequire("aLXZy");

var $7S1uT = parcelRequire("7S1uT");
'use strict';
const $ca332a63a1118bbd$export$fbea82a1c0574ef4 = {
    key: ':root',
    node: (0, $aLXZy.document) ? (0, $aLXZy.document).body : (0, $7S1uT.report)('DocumentNotDefined', (0, $aLXZy.document))
};
const $ca332a63a1118bbd$export$33ecaa422889cd80 = $ca332a63a1118bbd$export$fbea82a1c0574ef4;

});

parcelRegister("6cTIH", function(module, exports) {
$parcel$export(module.exports, "parseFilters", function () { return (parcelRequire("6l4Vl")).parseFilters; });
$parcel$export(module.exports, "REGISTRY", function () { return (parcelRequire("6l4Vl")).REGISTRY; });

$parcel$export(module.exports, "registry", function () { return (parcelRequire("6l4Vl")).REGISTRY; });

var $2G8EG = parcelRequire("2G8EG");

var $alKml = parcelRequire("alKml");

var $ggGSI = parcelRequire("ggGSI");

var $jIduG = parcelRequire("jIduG");

var $3PsYR = parcelRequire("3PsYR");

var $2DT68 = parcelRequire("2DT68");

var $dgSmm = parcelRequire("dgSmm");

var $FBHcQ = parcelRequire("FBHcQ");

var $03Uv2 = parcelRequire("03Uv2");

var $6l4Vl = parcelRequire("6l4Vl");
'use strict';

});
parcelRegister("2G8EG", function(module, exports) {

$parcel$export(module.exports, "attr", function () { return $1f3637bf41c8c407$export$7aabe8b3a840d2fd; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");

var $7S1uT = parcelRequire("7S1uT");
parcelRequire("94S26");
var $iPgcK = parcelRequire("iPgcK");
'use strict';
function $1f3637bf41c8c407$export$7aabe8b3a840d2fd(params, element, node) {
    const { __ref: ref, props: props } = element;
    const { __attr: __attr } = ref;
    if ((0, $amNJ8.isNot)('object')) (0, $7S1uT.report)('HTMLInvalidAttr', params);
    if (params) {
        if (props.attr) (0, $iPgcK.deepMerge)(params, props.attr);
        for(const attr in params){
            const val = (0, $jm0BQ.exec)(params[attr], element);
            // if (__attr[attr] === val) return
            if (val !== false && !(0, $amNJ8.isUndefined)(val) && !(0, $amNJ8.isNull)(val) && node.setAttribute) node.setAttribute(attr, val);
            else if (node.removeAttribute) node.removeAttribute(attr);
            __attr[attr] = val;
        }
    }
}
var $1f3637bf41c8c407$export$2e2bcd8739ae039 = $1f3637bf41c8c407$export$7aabe8b3a840d2fd;

});
parcelRegister("94S26", function(module, exports) {
$parcel$export(module.exports, "deepMerge", function () { return (parcelRequire("iPgcK")).deepMerge; });
$parcel$export(module.exports, "METHODS_EXL", function () { return (parcelRequire("iPgcK")).METHODS_EXL; });
$parcel$export(module.exports, "overwrite", function () { return (parcelRequire("iPgcK")).overwrite; });
$parcel$export(module.exports, "cloneAndMergeArrayExtend", function () { return (parcelRequire("7riIF")).cloneAndMergeArrayExtend; });
$parcel$export(module.exports, "deepMergeExtend", function () { return (parcelRequire("7riIF")).deepMergeExtend; });
$parcel$export(module.exports, "fallbackStringExtend", function () { return (parcelRequire("7riIF")).fallbackStringExtend; });
$parcel$export(module.exports, "getExtendStack", function () { return (parcelRequire("7riIF")).getExtendStack; });
$parcel$export(module.exports, "jointStacks", function () { return (parcelRequire("7riIF")).jointStacks; });
parcelRequire("iPgcK");
parcelRequire("7riIF");
parcelRequire("fX26p");
'use strict';

});
parcelRegister("iPgcK", function(module, exports) {

$parcel$export(module.exports, "METHODS_EXL", function () { return $db498f51e58d987b$export$7f0c3d30e5984c9d; });
$parcel$export(module.exports, "deepMerge", function () { return $db498f51e58d987b$export$6969335ea1e4e77c; });
$parcel$export(module.exports, "overwrite", function () { return $db498f51e58d987b$export$d3305692eb3e9a81; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
var $1cJu7 = parcelRequire("1cJu7");
parcelRequire("5HLar");
var $fp2jj = parcelRequire("fp2jj");
'use strict';
// breaks server build
// import { IGNORE_STATE_PARAMS } from '@domql/state'
// import { METHODS } from '../methods'
const $db498f51e58d987b$var$IGNORE_STATE_PARAMS = [
    'update',
    'parse',
    'clean',
    'create',
    'destroy',
    'add',
    'toggle',
    'remove',
    'apply',
    'set',
    'reset',
    'replace',
    'quietReplace',
    'quietUpdate',
    'applyReplace',
    'applyFunction',
    'rootUpdate',
    'parentUpdate',
    'parent',
    '__element',
    '__depends',
    '__ref',
    '__children',
    'root',
    'setByPath',
    'setPathCollection',
    'removeByPath',
    'removePathCollection',
    'getByPath'
];
const $db498f51e58d987b$export$f0748ddc99f937c7 = [
    'set',
    'reset',
    'update',
    'remove',
    'updateContent',
    'removeContent',
    'lookup',
    'lookdown',
    'lookdownAll',
    'getRef',
    'getPath',
    'setNodeStyles',
    'spotByPath',
    'keys',
    'parse',
    'setProps',
    'parseDeep',
    'variables',
    'if',
    'log',
    'nextElement',
    'previousElement'
];
const $db498f51e58d987b$export$7f0c3d30e5984c9d = (0, $1cJu7.joinArrays)([
    'node',
    'state',
    'context',
    'extend',
    '__element'
], $db498f51e58d987b$export$f0748ddc99f937c7, $db498f51e58d987b$var$IGNORE_STATE_PARAMS, (0, $fp2jj.IGNORE_PROPS_PARAMS));
const $db498f51e58d987b$export$6969335ea1e4e77c = (element, extend, exclude = $db498f51e58d987b$export$7f0c3d30e5984c9d)=>{
    for(const e in extend){
        if (exclude.includes(e)) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if (elementProp === undefined) element[e] = extendProp;
        else if ((0, $amNJ8.isObjectLike)(elementProp) && (0, $amNJ8.isObject)(extendProp)) $db498f51e58d987b$export$6969335ea1e4e77c(elementProp, extendProp);
    }
    return element;
};
const $db498f51e58d987b$export$9cd59f9826255e47 = (obj, exclude = $db498f51e58d987b$export$7f0c3d30e5984c9d)=>{
    const o = {};
    for(const e in obj){
        if (exclude.includes(e)) continue;
        o[e] = obj[e];
    }
    return o;
};
const $db498f51e58d987b$export$d3305692eb3e9a81 = (element, params, options)=>{
    const changes = {};
    const { __ref: __ref } = element;
    const { __exec: __exec, __cached: __cached } = __ref;
    for(const e in params){
        if (e === 'props' || e === 'state' || e === '__ref') continue;
        const elementProp = element[e];
        const paramsProp = params[e];
        if (paramsProp !== undefined) {
            __cached[e] = changes[e] = elementProp;
            element[e] = paramsProp;
        }
        if (options.cleanExec) delete __exec[e];
    }
    return changes;
};
const $db498f51e58d987b$export$1c07155dfdd98f41 = (obj, params, exclude = $db498f51e58d987b$export$7f0c3d30e5984c9d)=>{
    for(const e in params){
        if (exclude.includes(e)) continue;
        obj[e] = params[e];
    }
    return obj;
};
const $db498f51e58d987b$export$f0b277b530b4fffd = (obj, params, exclude = $db498f51e58d987b$export$7f0c3d30e5984c9d)=>{
    for(const e in params){
        if (exclude.includes(e)) continue;
        const objProp = obj[e];
        const paramsProp = params[e];
        if ((0, $amNJ8.isObjectLike)(objProp) && (0, $amNJ8.isObjectLike)(paramsProp)) $db498f51e58d987b$export$f0b277b530b4fffd(objProp, paramsProp);
        else if (paramsProp !== undefined) obj[e] = paramsProp;
    }
    return obj;
};
const $db498f51e58d987b$export$7bde6dffa6d2dd59 = (a, b)=>{
    if ((0, $amNJ8.isObjectLike)(a) && (0, $amNJ8.isObjectLike)(b)) return $db498f51e58d987b$export$6969335ea1e4e77c(a, b);
    return a || b;
};
const $db498f51e58d987b$export$fd2fbaf2367ef824 = (arr, exclude = [
    'parent',
    'node',
    '__element',
    'state',
    'context',
    '__ref'
])=>{
    return arr.reduce((a, c)=>$db498f51e58d987b$export$6969335ea1e4e77c(a, (0, $jm0BQ.deepClone)(c, {
            exclude: exclude
        })), {});
};
const $db498f51e58d987b$export$803a4c6bdde5cd1d = (obj)=>{
    return (0, $amNJ8.isArray)(obj) ? $db498f51e58d987b$export$fd2fbaf2367ef824(obj) : (0, $jm0BQ.deepClone)(obj);
};
const $db498f51e58d987b$export$d53c2c5b09d0676f = (param, prop, stack = [])=>{
    const objectized = $db498f51e58d987b$export$803a4c6bdde5cd1d(param);
    stack.push(objectized);
    const extendOfExtend = objectized[prop];
    if (extendOfExtend) $db498f51e58d987b$export$d53c2c5b09d0676f(extendOfExtend, prop, stack);
    delete objectized[prop];
    return stack;
};

});
parcelRegister("5HLar", function(module, exports) {
$parcel$export(module.exports, "IGNORE_PROPS_PARAMS", function () { return (parcelRequire("fp2jj")).IGNORE_PROPS_PARAMS; });
$parcel$export(module.exports, "createProps", function () { return (parcelRequire("dw2Wn")).createProps; });
$parcel$export(module.exports, "updateProps", function () { return (parcelRequire("cgkQP")).updateProps; });
parcelRequire("fp2jj");
parcelRequire("dw2Wn");
parcelRequire("jnmUp");
parcelRequire("cgkQP");
'use strict';

});
parcelRegister("fp2jj", function(module, exports) {

$parcel$export(module.exports, "IGNORE_PROPS_PARAMS", function () { return $b36afba541755028$export$431871e52735632b; });
'use strict';
const $b36afba541755028$export$431871e52735632b = [
    'update',
    '__element'
];

});

parcelRegister("dw2Wn", function(module, exports) {

$parcel$export(module.exports, "syncProps", function () { return $9d708b7788d7a934$export$b23ca50362483f82; });
$parcel$export(module.exports, "createProps", function () { return $9d708b7788d7a934$export$c94ea207b45fef3a; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");

var $fp2jj = parcelRequire("fp2jj");

var $jnmUp = parcelRequire("jnmUp");
'use strict';
const $9d708b7788d7a934$var$createPropsStack = (element, parent)=>{
    const { props: props, __ref: ref } = element;
    const propsStack = ref.__props = (0, $jnmUp.inheritParentProps)(element, parent);
    if ((0, $amNJ8.isObject)(props)) propsStack.push(props);
    else if (props === 'inherit' && parent.props) propsStack.push(parent.props);
    else if (props) propsStack.push(props);
    if ((0, $amNJ8.isArray)(ref.__extend)) ref.__extend.forEach((extend)=>{
        if (extend.props && extend.props !== props) propsStack.push(extend.props);
    });
    ref.__props = propsStack;
    return propsStack;
};
const $9d708b7788d7a934$export$b23ca50362483f82 = async (props, element, opts)=>{
    element.props = {};
    const mergedProps = {};
    props.forEach((v)=>{
        if ((0, $fp2jj.IGNORE_PROPS_PARAMS).includes(v)) return;
        let execProps;
        try {
            execProps = (0, $jm0BQ.exec)(v, element);
        } catch (e) {
            element.error(e, opts);
        }
        // TODO: check if this failing the function props merge
        // if (isObject(execProps) && execProps.__element) return
        // it was causing infinite loop at early days
        element.props = (0, $jm0BQ.deepMerge)(mergedProps, (0, $jm0BQ.deepClone)(execProps, {
            ignore: (0, $fp2jj.IGNORE_PROPS_PARAMS)
        }), (0, $fp2jj.IGNORE_PROPS_PARAMS));
    });
    element.props = mergedProps;
    const methods = {
        update: await $9d708b7788d7a934$var$update.bind(element.props),
        __element: element
    };
    Object.setPrototypeOf(element.props, methods);
    return element.props;
};
const $9d708b7788d7a934$export$c94ea207b45fef3a = function(element, parent, options) {
    const { __ref: ref } = element;
    const applyProps = ()=>{
        const propsStack = options.cachedProps || $9d708b7788d7a934$var$createPropsStack(element, parent);
        if (propsStack.length) {
            ref.__props = propsStack;
            $9d708b7788d7a934$export$b23ca50362483f82(propsStack, element);
        } else {
            ref.__props = options.cachedProps || [];
            element.props = {};
        }
    };
    if (ref.__if) applyProps();
    else try {
        applyProps();
    } catch  {
        element.props = {};
        ref.__props = options.cachedProps || [];
    }
    const methods = {
        update: $9d708b7788d7a934$var$update.bind(element.props),
        __element: element
    };
    Object.setPrototypeOf(element.props, methods);
    return element;
};
async function $9d708b7788d7a934$var$update(props, options) {
    const element = this.__element;
    await element.update({
        props: props
    }, options);
}

});
parcelRegister("jnmUp", function(module, exports) {

$parcel$export(module.exports, "inheritParentProps", function () { return $e1b1ef85101d7f22$export$d25057a75c14aff7; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $e1b1ef85101d7f22$var$objectizeStringProperty = (propValue)=>{
    if ((0, $amNJ8.is)(propValue)('string', 'number')) return {
        inheritedString: propValue
    };
    return propValue;
};
const $e1b1ef85101d7f22$export$d25057a75c14aff7 = (element, parent)=>{
    let propsStack = [];
    const parentProps = (0, $jm0BQ.exec)(parent, parent.state).props;
    const matchParent = parent.props && parentProps[element.key];
    const matchParentIsString = (0, $amNJ8.isString)(matchParent);
    const matchParentChildProps = parentProps && parentProps.childProps;
    if (matchParent) {
        if (matchParentIsString) {
            const inheritedStringExists = propsStack.filter((v)=>v.inheritedString)[0];
            if (inheritedStringExists) inheritedStringExists.inheritedString = matchParent;
            else propsStack = [].concat($e1b1ef85101d7f22$var$objectizeStringProperty(matchParent), propsStack);
        } else propsStack.push($e1b1ef85101d7f22$var$objectizeStringProperty(matchParent));
    }
    if (matchParentChildProps && !element?.props?.ignoreChildProps) propsStack.push(matchParentChildProps);
    return propsStack;
};

});


parcelRegister("cgkQP", function(module, exports) {

$parcel$export(module.exports, "updateProps", function () { return $8ed72745e3b0c81a$export$c8dce3c08436e91e; });

var $dw2Wn = parcelRequire("dw2Wn");

var $jnmUp = parcelRequire("jnmUp");
'use strict';
const $8ed72745e3b0c81a$export$c8dce3c08436e91e = (newProps, element, parent)=>{
    const { __ref: __ref } = element;
    let propsStack = __ref.__props;
    const parentProps = (0, $jnmUp.inheritParentProps)(element, parent);
    if (parentProps.length) propsStack = __ref.__props = [].concat(parentProps, propsStack);
    if (newProps) propsStack = __ref.__props = [].concat(newProps, propsStack);
    if (propsStack) (0, $dw2Wn.syncProps)(propsStack, element);
    return element;
};

});



parcelRegister("7riIF", function(module, exports) {

$parcel$export(module.exports, "fallbackStringExtend", function () { return $56a9934cc91fa4b7$export$ade1aefc7d5ec315; });
$parcel$export(module.exports, "deepMergeExtend", function () { return $56a9934cc91fa4b7$export$d20ceec222df68ed; });
$parcel$export(module.exports, "cloneAndMergeArrayExtend", function () { return $56a9934cc91fa4b7$export$e2e460d82983fb19; });
$parcel$export(module.exports, "jointStacks", function () { return $56a9934cc91fa4b7$export$f9f936cf352c3af2; });
$parcel$export(module.exports, "getExtendStack", function () { return $56a9934cc91fa4b7$export$a0203ee23029af7e; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
var $kitvZ = parcelRequire("kitvZ");
'use strict';
const $56a9934cc91fa4b7$export$daf4c137c5f56404 = ()=>Math.random().toString(36).substring(2);
const $56a9934cc91fa4b7$export$476cb8ab9adcdb0d = {};
const $56a9934cc91fa4b7$export$bc442b6cc8c83971 = {};
const $56a9934cc91fa4b7$export$46ce3405574370c6 = (extend)=>{
    return $56a9934cc91fa4b7$export$476cb8ab9adcdb0d[extend.__hash];
};
const $56a9934cc91fa4b7$export$8c8f2806a2edf07f = (extend, stack)=>{
    const hash = $56a9934cc91fa4b7$export$daf4c137c5f56404();
    if (!(0, $amNJ8.isString)(extend)) extend.__hash = hash;
    $56a9934cc91fa4b7$export$476cb8ab9adcdb0d[hash] = stack;
    return stack;
};
const $56a9934cc91fa4b7$export$6ef9dd655b57622a = (extend, stack)=>{
    if (extend.__hash) return stack.concat($56a9934cc91fa4b7$export$46ce3405574370c6(extend));
    return $56a9934cc91fa4b7$export$8c8f2806a2edf07f(extend, stack) // stack .concat(hashedExtend)
    ;
};
const $56a9934cc91fa4b7$export$2c118161a655606a = (extend, stack, context)=>{
    extend.forEach((each)=>$56a9934cc91fa4b7$export$802e3e1ed5ecb3f2(each, stack, context));
    return stack;
};
const $56a9934cc91fa4b7$export$54e9fb29908872fa = (extend, stack, context)=>{
    const extendOflattenExtend = extend.extend;
    if (extendOflattenExtend) $56a9934cc91fa4b7$export$802e3e1ed5ecb3f2(extendOflattenExtend, stack, context);
    return stack;
};
const $56a9934cc91fa4b7$export$802e3e1ed5ecb3f2 = (extend, stack, context)=>{
    if (!extend) return stack;
    if ((0, $amNJ8.isArray)(extend)) return $56a9934cc91fa4b7$export$2c118161a655606a(extend, stack, context);
    if ((0, $amNJ8.isString)(extend)) extend = $56a9934cc91fa4b7$export$ade1aefc7d5ec315(extend, context);
    stack.push(extend);
    if (extend.extend) $56a9934cc91fa4b7$export$54e9fb29908872fa(extend, stack, context);
    return stack;
};
const $56a9934cc91fa4b7$export$d20ceec222df68ed = (element, extend)=>{
    for(const e in extend){
        if ([
            'parent',
            'node',
            '__element'
        ].indexOf(e) > -1) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if (elementProp === undefined) element[e] = extendProp;
        else if ((0, $amNJ8.isObject)(elementProp) && (0, $amNJ8.isObject)(extendProp)) $56a9934cc91fa4b7$export$d20ceec222df68ed(elementProp, extendProp);
        else if ((0, $amNJ8.isArray)(elementProp) && (0, $amNJ8.isArray)(extendProp)) element[e] = elementProp.concat(extendProp);
        else if ((0, $amNJ8.isArray)(elementProp) && (0, $amNJ8.isObject)(extendProp)) {
            const obj = $56a9934cc91fa4b7$export$d20ceec222df68ed({}, elementProp);
            element[e] = $56a9934cc91fa4b7$export$d20ceec222df68ed(obj, extendProp);
        } else if (elementProp === undefined && (0, $amNJ8.isFunction)(extendProp)) element[e] = extendProp;
    }
    return element;
};
const $56a9934cc91fa4b7$export$e2e460d82983fb19 = (stack)=>{
    return stack.reduce((a, c)=>{
        return $56a9934cc91fa4b7$export$d20ceec222df68ed(a, (0, $jm0BQ.deepClone)(c));
    }, {});
};
const $56a9934cc91fa4b7$export$ade1aefc7d5ec315 = (extend, context, options = {}, variant)=>{
    const COMPONENTS = context && context.components || options.components;
    const PAGES = context && context.pages || options.pages;
    if ((0, $amNJ8.isString)(extend)) {
        const componentExists = COMPONENTS && (COMPONENTS[extend + '.' + variant] || COMPONENTS[extend] || COMPONENTS['smbls.' + extend]);
        const pageExists = PAGES && extend.startsWith('/') && PAGES[extend];
        if (componentExists) return componentExists;
        else if (pageExists) return pageExists;
        else {
            if (options.verbose && (0, $kitvZ.isNotProduction)()) console.warn('Extend is string but component was not found:', extend);
            return {};
        }
    }
    return extend;
};
const $56a9934cc91fa4b7$export$f9f936cf352c3af2 = (extendStack, childExtendStack)=>{
    return [].concat(extendStack.slice(0, 1)).concat(childExtendStack.slice(0, 1)).concat(extendStack.slice(1)).concat(childExtendStack.slice(1));
};
const $56a9934cc91fa4b7$export$a0203ee23029af7e = (extend, context)=>{
    if (!extend) return [];
    if (extend.__hash) return $56a9934cc91fa4b7$export$46ce3405574370c6(extend) || [];
    const stack = $56a9934cc91fa4b7$export$802e3e1ed5ecb3f2(extend, [], context);
    return $56a9934cc91fa4b7$export$6ef9dd655b57622a(extend, stack);
};
const $56a9934cc91fa4b7$export$52f1fe7126b651a = (extend)=>{
    const stack = $56a9934cc91fa4b7$export$a0203ee23029af7e(extend);
    return $56a9934cc91fa4b7$export$e2e460d82983fb19(stack);
} // export const replaceStringsWithComponents = (stack, context, options) => {
 //   const COMPONENTS = (context && context.components) || options.components
 //   return stack.map(v => {
 //     if (isString(v)) {
 //       const component = COMPONENTS[v]
 //       return component
 //     }
 //     if (isString(v.extend)) {
 //       v.extend = getExtendMerged(COMPONENTS[v.extend])
 //     }
 //     return v
 //   })
 // }
;

});

parcelRegister("fX26p", function(module, exports) {

$parcel$export(module.exports, "createValidDomqlObjectFromSugar", function () { return $b9cdff310021518f$export$2cbc234431a4ef8; });
$parcel$export(module.exports, "applyVariant", function () { return $b9cdff310021518f$export$f1439fc936ef702f; });
parcelRequire("imR0C");
var $3Kzng = parcelRequire("3Kzng");
var $amNJ8 = parcelRequire("amNJ8");
var $jm0BQ = parcelRequire("jm0BQ");

var $9IyJY = parcelRequire("9IyJY");
parcelRequire("6cTIH");
var $6l4Vl = parcelRequire("6l4Vl");
'use strict';
const $b9cdff310021518f$export$2cbc234431a4ef8 = (el, parent, key, options)=>{
    const newElem = {
        props: {},
        define: {}
    };
    const allowedKeys = [
        'data',
        'state',
        'attr',
        'if'
    ];
    for(const k in el){
        const value = el[k];
        const isComponent = (0, $3Kzng.checkIfKeyIsComponent)(k);
        const isRegistry = (0, $6l4Vl.REGISTRY)[k];
        if (isComponent || isRegistry || allowedKeys.includes(k)) newElem[k] = value;
        else newElem.props[k] = value;
    }
    return newElem;
};
const $b9cdff310021518f$export$a9aa73f3ae416cbd = (element, variant, variantProps)=>{
    let variantElement = element[variant];
    if (!variantElement) return;
    const props = (0, $amNJ8.isObject)(variantProps) ? variantProps : {};
    if ((0, $amNJ8.isString)(variantElement)) variantElement = {
        extend: [
            {
                props: props
            },
            variantElement
        ]
    };
    else if (variantElement.extend) variantElement = (0, $3Kzng.addAdditionalExtend)({
        props: props
    }, variantElement);
    const extendedVariant = (0, $9IyJY.applyExtend)(variantElement, element.parent);
    const { parent: parent, ...rest } = extendedVariant;
    return (0, $jm0BQ.overwriteDeep)(element, rest) // TODO: check why string is not working
    ;
// return overwriteDeep(element, applyExtend(variantElement, element.parent)) // TODO: check why string is not working
};
const $b9cdff310021518f$export$f1439fc936ef702f = (element)=>{
    const { props: props } = element;
    if (!(0, $3Kzng.hasVariantProp)(element)) return element;
    const { variant: variant } = props;
    $b9cdff310021518f$export$a9aa73f3ae416cbd(element, `.${variant}`);
    const elKeys = Object.keys(element).filter((key)=>(0, $3Kzng.isVariant)(key));
    elKeys.forEach((variant)=>{
        const slicedVariantElementKey = variant.slice(1);
        const variantElementProps = props[slicedVariantElementKey];
        if (variantElementProps) $b9cdff310021518f$export$a9aa73f3ae416cbd(element, variant, variantElementProps);
    });
    return element;
};

});
parcelRegister("9IyJY", function(module, exports) {

$parcel$export(module.exports, "applyExtend", function () { return $71332bdf5670abd5$export$f20941eae6723bcc; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
parcelRequire("94S26");
var $7riIF = parcelRequire("7riIF");
'use strict';
let $71332bdf5670abd5$var$mainExtend;
const $71332bdf5670abd5$export$f20941eae6723bcc = (element, parent, options = {})=>{
    if ((0, $amNJ8.isFunction)(element)) element = (0, $jm0BQ.exec)(element, parent);
    const { props: props, __ref: __ref } = element;
    let extend = props?.extends || element.extends || element.extend;
    const variant = props?.variant;
    const context = element.context || parent.context;
    extend = (0, $7riIF.fallbackStringExtend)(extend, context, options, variant);
    const extendStack = (0, $7riIF.getExtendStack)(extend, context);
    // if (isProduction()) delete element.extend
    delete element.extend;
    let childExtendStack = [];
    if (parent) {
        element.parent = parent;
        // Assign parent attr to the element
        if (!options.ignoreChildExtend && !(props && props.ignoreChildExtend)) {
            childExtendStack = (0, $7riIF.getExtendStack)(parent.childExtend, context);
            // if (!options.ignoreChildExtend && !(props && exec(props, element).ignoreChildExtend)) {
            //   const ignoreChildExtendRecursive = props && exec(props, element).ignoreChildExtendRecursive
            const ignoreChildExtendRecursive = props && props.ignoreChildExtendRecursive;
            if (parent.childExtendRecursive && !ignoreChildExtendRecursive) {
                const canExtendRecursive = element.key !== '__text';
                if (canExtendRecursive) {
                    const childExtendRecursiveStack = (0, $7riIF.getExtendStack)(parent.childExtendRecursive, context);
                    // add error if childExtendRecursive contains element which goes to infinite loop
                    childExtendStack = childExtendStack.concat(childExtendRecursiveStack);
                    element.childExtendRecursive = parent.childExtendRecursive;
                }
            }
        }
    }
    const extendLength = extendStack.length;
    const childExtendLength = childExtendStack.length;
    let stack = [];
    if (extendLength && childExtendLength) stack = (0, $7riIF.jointStacks)(extendStack, childExtendStack);
    else if (extendLength) stack = extendStack;
    else if (childExtendLength) stack = childExtendStack;
    else if (!context.defaultExtends) return element;
    if (context.defaultExtends) {
        if (!$71332bdf5670abd5$var$mainExtend) {
            const defaultOptionsExtend = (0, $7riIF.getExtendStack)(context.defaultExtends, context);
            $71332bdf5670abd5$var$mainExtend = (0, $7riIF.cloneAndMergeArrayExtend)(defaultOptionsExtend);
            delete $71332bdf5670abd5$var$mainExtend.extend;
        }
        stack = [].concat(stack, $71332bdf5670abd5$var$mainExtend);
    }
    if (__ref) __ref.__extend = stack;
    let mergedExtend = (0, $7riIF.cloneAndMergeArrayExtend)(stack);
    const COMPONENTS = context && context.components || options.components;
    const component = (0, $jm0BQ.exec)(element.component || mergedExtend.component, element);
    if (component && COMPONENTS && COMPONENTS[component]) {
        const componentExtend = (0, $7riIF.cloneAndMergeArrayExtend)((0, $7riIF.getExtendStack)(COMPONENTS[component]));
        mergedExtend = (0, $7riIF.deepMergeExtend)(componentExtend, mergedExtend);
    }
    const merged = (0, $7riIF.deepMergeExtend)(element, mergedExtend);
    return merged;
};

});




parcelRegister("alKml", function(module, exports) {

$parcel$export(module.exports, "assignKeyAsClassname", function () { return $788fd38af9c6ae81$export$d559e9a3b71405f6; });
$parcel$export(module.exports, "classList", function () { return $788fd38af9c6ae81$export$11c615ce16f87241; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $788fd38af9c6ae81$export$d559e9a3b71405f6 = (element)=>{
    const { key: key } = element;
    if (element.class === true) element.class = key;
    else if (!element.class && typeof key === 'string' && key.charAt(0) === '_' && key.charAt(1) !== '_') element.class = key.slice(1);
};
const $788fd38af9c6ae81$export$b04d9b8d414ba5e8 = (obj, element)=>{
    let className = '';
    for(const item in obj){
        const param = obj[item];
        if (typeof param === 'boolean' && param) className += ` ${item}`;
        else if (typeof param === 'string') className += ` ${param}`;
        else if (typeof param === 'function') className += ` ${(0, $jm0BQ.exec)(param, element)}`;
    }
    return className;
};
const $788fd38af9c6ae81$export$11c615ce16f87241 = (params, element)=>{
    if (!params) return;
    const { key: key } = element;
    if (params === true) params = element.class = {
        key: key
    };
    if ((0, $amNJ8.isString)(params)) params = element.class = {
        default: params
    };
    if ((0, $amNJ8.isObject)(params)) params = $788fd38af9c6ae81$export$b04d9b8d414ba5e8(params, element);
    // TODO: fails on string
    const className = params.replace(/\s+/g, ' ').trim();
    if (element.ref) element.ref.class = className // TODO: this check is NOT needed in new DOMQL
    ;
    return className;
};
const $788fd38af9c6ae81$export$e8f750c9f10c0a7b = (params, element, node)=>{
    const className = $788fd38af9c6ae81$export$11c615ce16f87241(params, element);
    node.classList = className;
    return className;
};
function $788fd38af9c6ae81$export$f1a8a7f322d4587c(params, element, node) {
    $788fd38af9c6ae81$export$e8f750c9f10c0a7b(params, element, node);
}
var $788fd38af9c6ae81$export$2e2bcd8739ae039 = $788fd38af9c6ae81$export$f1a8a7f322d4587c;

});

parcelRegister("ggGSI", function(module, exports) {

$parcel$export(module.exports, "updateContent", function () { return $bd7f67511034d4c6$export$5143cc956eb9d8f6; });
$parcel$export(module.exports, "removeContent", function () { return $bd7f67511034d4c6$export$6e1d9b0d0e1e1def; });
$parcel$export(module.exports, "setContent", function () { return $bd7f67511034d4c6$export$431313f2afd011e2; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
var $3Kzng = parcelRequire("3Kzng");

var $48DOr = parcelRequire("48DOr");
'use strict';
const $bd7f67511034d4c6$export$5143cc956eb9d8f6 = async function(params, options) {
    const element = this;
    const ref = element.__ref;
    const contentKey = ref.contentElementKey;
    if (!element[contentKey]) return;
    if (element[contentKey].update) await element[contentKey].update(params, options);
};
const $bd7f67511034d4c6$export$6e1d9b0d0e1e1def = function(el, opts = {}) {
    const element = el || this;
    const { __ref: ref } = element;
    const contentElementKey = (0, $3Kzng.setContentKey)(element, opts);
    if (opts.contentElementKey !== 'content') opts.contentElementKey = 'content';
    if (element[contentElementKey]) {
        if (element[contentElementKey].node && element.node) {
            if (element[contentElementKey].tag === 'fragment') element.node.innerHTML = '';
            else {
                const contentNode = element[contentElementKey].node;
                if (contentNode.parentNode === element.node) element.node.removeChild(element[contentElementKey].node);
            }
        }
        const { __cached: __cached } = ref;
        if (__cached && __cached[contentElementKey]) {
            if (__cached[contentElementKey].tag === 'fragment') __cached[contentElementKey].parent.node.innerHTML = '';
            else if (__cached[contentElementKey] && (0, $amNJ8.isFunction)(__cached[contentElementKey].remove)) __cached[contentElementKey].remove();
        }
        ref.__children.splice(ref.__children.indexOf(element[contentElementKey]), 1);
        delete element[contentElementKey];
    }
};
async function $bd7f67511034d4c6$export$431313f2afd011e2(param, element, node, opts) {
    const contentElementKey = (0, $3Kzng.setContentKey)(element, opts);
    if (param && element) {
        if (element[contentElementKey].update) await element[contentElementKey].update({}, opts);
        else await (0, $48DOr.set).call(element, param, opts);
    }
}
var $bd7f67511034d4c6$export$2e2bcd8739ae039 = $bd7f67511034d4c6$export$431313f2afd011e2;

});
parcelRegister("48DOr", function(module, exports) {

$parcel$export(module.exports, "reset", function () { return $3036cabe1d0ff91c$export$aad8462122ac592b; });
$parcel$export(module.exports, "set", function () { return $3036cabe1d0ff91c$export$adaa4cf7ef1b65be; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $3Kzng = parcelRequire("3Kzng");

var $4QK8a = parcelRequire("4QK8a");

var $aWnFx = parcelRequire("aWnFx");
parcelRequire("6cTIH");
var $6l4Vl = parcelRequire("6l4Vl");

var $ggGSI = parcelRequire("ggGSI");
parcelRequire("QRTe9");
var $dKo7X = parcelRequire("dKo7X");
'use strict';
const $3036cabe1d0ff91c$export$9329d8eaaf41ac4f = async (params, element, options)=>{
    if (!options.preventRemove) (0, $ggGSI.removeContent)(element, options);
    const { __ref: ref } = element;
    if (params instanceof Promise) console.log(params, params instanceof Promise);
    await (0, $aWnFx.create)(params, element, ref.contentElementKey || 'content', {
        ignoreChildExtend: true,
        ...(0, $6l4Vl.REGISTRY).defaultOptions,
        ...(0, $4QK8a.OPTIONS).create,
        ...options
    });
};
const $3036cabe1d0ff91c$export$aad8462122ac592b = async (options)=>{
    const element = undefined;
    await (0, $aWnFx.create)(element, element.parent, undefined, {
        ignoreChildExtend: true,
        ...(0, $6l4Vl.REGISTRY).defaultOptions,
        ...(0, $4QK8a.OPTIONS).create,
        ...options
    });
};
const $3036cabe1d0ff91c$export$adaa4cf7ef1b65be = async function(params, options = {}, el) {
    const element = el || this;
    const { __ref: ref } = element;
    const content = (0, $3Kzng.setContentKey)(element, options);
    const __contentRef = content && content.__ref;
    const lazyLoad = element.props && element.props.lazyLoad;
    const hasCollection = element.$collection || element.$stateCollection || element.$propsCollection;
    if (options.preventContentUpdate === true && !hasCollection) return;
    if (ref.__noCollectionDifference || __contentRef && __contentRef.__cached && (0, $jm0BQ.deepContains)(params, content)) {
        if (!options.preventBeforeUpdateListener && !options.preventListeners) {
            const beforeUpdateReturns = await (0, $dKo7X.triggerEventOnUpdate)('beforeUpdate', params, element, options);
            if (beforeUpdateReturns === false) return element;
        }
        if (content?.update) await content.update();
        if (!options.preventUpdateListener) await (0, $dKo7X.triggerEventOn)('update', element, options);
        return;
    }
    if (params) {
        let { childExtend: childExtend, props: props } = params;
        if (!props) props = params.props = {};
        if (!childExtend && element.childExtend) {
            params.childExtend = element.childExtend;
            props.ignoreChildExtend = true;
        }
        if (!props?.childProps && element.props?.childProps) {
            props.childProps = element.props.childProps;
            props.ignoreChildProps = true;
        }
        if (lazyLoad) window.requestAnimationFrame(async ()=>{
            await $3036cabe1d0ff91c$export$9329d8eaaf41ac4f(params, element, options);
            // handle lazy load
            if (!options.preventUpdateListener) await (0, $dKo7X.triggerEventOn)('lazyLoad', element, options);
        });
        else await $3036cabe1d0ff91c$export$9329d8eaaf41ac4f(params, element, options);
    }
    return element;
};
var $3036cabe1d0ff91c$export$2e2bcd8739ae039 = $3036cabe1d0ff91c$export$adaa4cf7ef1b65be;

});
parcelRegister("4QK8a", function(module, exports) {

$parcel$export(module.exports, "OPTIONS", function () { return $387fcd5d7287c7a2$export$8eb3892b442747bd; });
'use strict';
const $387fcd5d7287c7a2$export$8eb3892b442747bd = {};
var $387fcd5d7287c7a2$export$2e2bcd8739ae039 = $387fcd5d7287c7a2$export$8eb3892b442747bd;

});

parcelRegister("aWnFx", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $7f71ae579ce368cd$export$185802fd694ee1f5; });
$parcel$export(module.exports, "default", function () { return $7f71ae579ce368cd$export$2e2bcd8739ae039; });

var $5iyU7 = parcelRequire("5iyU7");

var $hmiUX = parcelRequire("hmiUX");
parcelRequire("imR0C");
var $3Kzng = parcelRequire("3Kzng");
var $jm0BQ = parcelRequire("jm0BQ");
var $7Ionn = parcelRequire("7Ionn");
var $8Y0fc = parcelRequire("8Y0fc");
var $amNJ8 = parcelRequire("amNJ8");
var $2Jg1F = parcelRequire("2Jg1F");
parcelRequire("QRTe9");
var $bnF2s = parcelRequire("bnF2s");
var $dKo7X = parcelRequire("dKo7X");
parcelRequire("6UDue");
var $fGGtJ = parcelRequire("fGGtJ");
parcelRequire("jnoTA");
var $2KOE6 = parcelRequire("2KOE6");

var $cKY7h = parcelRequire("cKY7h");
parcelRequire("5HLar");
var $dw2Wn = parcelRequire("dw2Wn");

var $9IyJY = parcelRequire("9IyJY");
parcelRequire("6cTIH");
var $6l4Vl = parcelRequire("6l4Vl");

var $3Yday = parcelRequire("3Yday");

var $alKml = parcelRequire("alKml");

var $5uBBY = parcelRequire("5uBBY");

var $4QK8a = parcelRequire("4QK8a");

var $fX26p = parcelRequire("fX26p");

var $kitvZ = parcelRequire("kitvZ");
'use strict';
const $7f71ae579ce368cd$export$185802fd694ee1f5 = async (element, parent, key, options = (0, $4QK8a.OPTIONS).create || {}, attachOptions)=>{
    $7f71ae579ce368cd$var$cacheOptions(element, options);
    // if element is STRING
    if ($7f71ae579ce368cd$var$checkIfPrimitive(element)) element = $7f71ae579ce368cd$var$applyValueAsText(element, parent, key);
    element = $7f71ae579ce368cd$var$redefineElement(element, parent, key, options);
    parent = $7f71ae579ce368cd$var$redefineParent(element, parent, key);
    key = $7f71ae579ce368cd$var$createKey(element, parent, key);
    const ref = $7f71ae579ce368cd$var$addRef(element, parent, key);
    ref.__initialProps = (0, $jm0BQ.deepClone)(element.props);
    $7f71ae579ce368cd$var$applyContext(element, parent, options);
    (0, $3Kzng.applyComponentFromContext)(element, parent, options);
    if (!ref.__skipCreate) (0, $9IyJY.applyExtend)(element, parent, options);
    element.key = key;
    if (options.onlyResolveExtends) return await $7f71ae579ce368cd$var$onlyResolveExtends(element, parent, key, options);
    await (0, $dKo7X.triggerEventOn)('start', element, options);
    $7f71ae579ce368cd$var$switchDefaultOptions(element, parent, options);
    $7f71ae579ce368cd$var$addCaching(element, parent);
    (0, $3Yday.addMethods)(element, parent, options);
    $7f71ae579ce368cd$var$createScope(element, parent);
    await (0, $2KOE6.createState)(element, parent);
    if (element.scope === 'state') element.scope = element.state;
    $7f71ae579ce368cd$var$createIfConditionFlag(element, parent);
    // apply props settings
    (0, $dw2Wn.createProps)(element, parent, options);
    if (element.scope === 'props' || element.scope === true) element.scope = element.props;
    // recatch if it passess props again
    $7f71ae579ce368cd$var$createIfConditionFlag(element, parent);
    // if it already HAS a NODE
    if (element.node && ref.__if) return (0, $fGGtJ.assignNode)(element, parent, key, attachOptions);
    // apply variants
    (0, $fX26p.applyVariant)(element, parent);
    (0, $3Kzng.addChildrenIfNotInOriginal)(element, parent, key);
    const onInit = await (0, $dKo7X.triggerEventOn)('init', element, options);
    if (onInit === false) return element;
    await (0, $dKo7X.triggerEventOn)('beforeClassAssign', element, options);
    // generate a CLASS name
    (0, $alKml.assignKeyAsClassname)(element);
    await $7f71ae579ce368cd$var$renderElement(element, parent, options, attachOptions);
    $7f71ae579ce368cd$var$addElementIntoParentChildren(element, parent);
    await (0, $dKo7X.triggerEventOn)('complete', element, options);
    return element;
};
const $7f71ae579ce368cd$var$createBasedOnType = (element, parent, key, options)=>{
    // if ELEMENT is not given
    if (element === undefined) {
        if ((0, $kitvZ.isNotProduction)()) console.warn(key, 'element is undefined in', parent && parent.__ref && parent.__ref.path);
        return {};
    }
    if ((0, $amNJ8.isString)(key) && key.slice(0, false)) {
        if ((0, $kitvZ.isNotProduction)()) console.warn(key, 'seems like to be in __ref');
    }
    if (element === null) return;
    if (element === true) return {
        text: true
    };
    // if element is extend
    if (element.__hash) return {
        extend: element
    };
    return element;
};
const $7f71ae579ce368cd$var$redefineElement = (element, parent, key, options)=>{
    const elementWrapper = $7f71ae579ce368cd$var$createBasedOnType(element, parent, key, options);
    if (options.syntaxv3 || element.props && element.props.syntaxv3 || parent && parent.props && parent.props.syntaxv3) {
        if (element.props) element.props.syntaxv3 = true;
        else element.syntaxv3 = true;
        return (0, $fX26p.createValidDomqlObjectFromSugar)(element, parent, key, options);
    } else if ((0, $3Kzng.checkIfKeyIsComponent)(key)) return (0, $3Kzng.applyKeyComponentAsExtend)(elementWrapper, parent, key);
    // TODO: move as define plugins
    // Responsive rendering
    if ($7f71ae579ce368cd$var$checkIfMedia(key)) return $7f71ae579ce368cd$var$applyMediaProps(elementWrapper, parent, key);
    return elementWrapper;
};
const $7f71ae579ce368cd$var$redefineParent = (element, parent, key, options)=>{
    if (!parent) return 0, $hmiUX.ROOT;
    if ((0, $2Jg1F.isNode)(parent)) {
        const parentNodeWrapper = {
            key: ':root',
            node: parent
        };
        (0, $hmiUX.ROOT)[`${key}_parent`] = parentNodeWrapper;
        return parentNodeWrapper;
    }
    return parent;
};
const $7f71ae579ce368cd$var$cacheOptions = (element, options)=>{
    if (options && !(0, $4QK8a.OPTIONS).create) {
        (0, $4QK8a.OPTIONS).create = options;
        (0, $4QK8a.OPTIONS).create.context = element.context || options.context;
    }
};
const $7f71ae579ce368cd$var$createKey = (element, parent, key)=>{
    return ((0, $jm0BQ.exec)(key, element) || key || element.key || (0, $7Ionn.generateKey)()).toString();
};
const $7f71ae579ce368cd$var$addRef = (element, parent)=>{
    if (element.__ref) element.__ref.origin = element;
    else element.__ref = {
        origin: element
    };
    return element.__ref;
};
const $7f71ae579ce368cd$var$switchDefaultOptions = (element, parent, options)=>{
    if (Object.keys(options).length) {
        (0, $6l4Vl.REGISTRY).defaultOptions = options;
        if (options.ignoreChildExtend) delete options.ignoreChildExtend;
    }
};
const $7f71ae579ce368cd$var$addElementIntoParentChildren = (element, parent)=>{
    if (parent.__ref && parent.__ref.__children) parent.__ref.__children.push(element.key);
};
const $7f71ae579ce368cd$var$visitedElements = new WeakMap();
const $7f71ae579ce368cd$var$renderElement = async (element, parent, options, attachOptions)=>{
    if ($7f71ae579ce368cd$var$visitedElements.has(element)) {
        if ((0, $kitvZ.isNotProduction)()) console.warn('Cyclic rendering detected:', element.__ref.path);
    }
    $7f71ae579ce368cd$var$visitedElements.set(element, true);
    const { __ref: ref, key: key } = element;
    const createNestedChild = async ()=>{
        const isInfiniteLoopDetected = (0, $jm0BQ.detectInfiniteLoop)(ref.path);
        if (ref.__uniqId || isInfiniteLoopDetected) return;
        await (0, $5iyU7.createNode)(element, options);
        ref.__uniqId = Math.random();
    };
    // CREATE a real NODE
    if ((0, $kitvZ.isNotProduction)()) await createNestedChild();
    else try {
        await createNestedChild();
    } catch (e) {
        const path = ref.path;
        if (path.includes('ComponentsGrid')) path.splice(0, path.indexOf('ComponentsGrid') + 2);
        if (path.includes('demoComponent')) path.splice(0, path.indexOf('demoComponent') + 1);
        const isDemoComponent = element.lookup((el)=>el.state.key)?.state?.key;
        element.warn('Error happened in:', isDemoComponent ? isDemoComponent + ' ' : '' + path.join('.'));
        element.verbose();
        element.error(e, options);
        if (element.on?.error) element.on.error(e, element, element.state, element.context, options);
        if (element.props?.onError) element.props.onError(e, element, element.state, element.context, options);
    }
    if (!ref.__if) {
        parent[key || element.key] = element;
        return element;
    }
    // assign NODE
    (0, $fGGtJ.assignNode)(element, parent, key, attachOptions);
    // apply events
    (0, $bnF2s.applyAnimationFrame)(element, options);
    // run `on.render`
    await (0, $dKo7X.triggerEventOn)('render', element, options);
    // triggerEventOn('render', element, options).then(() => {})
    // run `on.renderRouter`
    await (0, $dKo7X.triggerEventOn)('renderRouter', element, options);
    // run `on.done`
    await (0, $dKo7X.triggerEventOn)('done', element, options);
    // run `on.done`
    await (0, $dKo7X.triggerEventOn)('create', element, options);
};
const $7f71ae579ce368cd$var$checkIfPrimitive = (element)=>(0, $amNJ8.is)(element)('string', 'number');
const $7f71ae579ce368cd$var$applyValueAsText = (element, parent, key)=>{
    const extendTag = element.extend && element.extend.tag;
    const childExtendTag = parent.childExtend && parent.childExtend.tag;
    const childPropsTag = parent.props.childProps && parent.props.childProps.tag;
    const isKeyValidHTMLTag = (0, $8Y0fc.HTML_TAGS).body.indexOf(key) > -1 && key;
    return {
        text: element,
        tag: extendTag || childExtendTag || childPropsTag || isKeyValidHTMLTag || 'string'
    };
};
const $7f71ae579ce368cd$var$applyContext = (element, parent, options)=>{
    const forcedOptionsContext = options.context && !(0, $hmiUX.ROOT).context && !element.context;
    if (forcedOptionsContext) (0, $hmiUX.ROOT).context = options.context;
    // inherit from parent or root
    if (!element.context) element.context = parent.context || options.context || (0, $hmiUX.ROOT).context;
};
// Create scope - shared object across the elements to the own or the nearest parent
const $7f71ae579ce368cd$var$createScope = (element, parent)=>{
    const { __ref: ref } = element;
    // If the element doesn't have a scope, initialize it using the parent's scope or the root's scope.
    if (!element.scope) element.scope = parent.scope || ref.root.scope || {};
};
const $7f71ae579ce368cd$var$createIfConditionFlag = (element, parent)=>{
    const { __ref: ref } = element;
    if ((0, $amNJ8.isFunction)(element.if) && !element.if(element, element.state, element.context)) delete ref.__if;
    else ref.__if = true;
};
const $7f71ae579ce368cd$var$addCaching = (element, parent)=>{
    const { __ref: ref, key: key } = element;
    let { __ref: parentRef } = parent;
    // enable TRANSFORM in data
    if (!element.transform) element.transform = {};
    // enable CACHING
    if (!ref.__cached) ref.__cached = {};
    if (!ref.__defineCache) ref.__defineCache = {};
    // enable EXEC
    if (!ref.__exec) ref.__exec = {};
    if (!ref.__execProps) ref.__execProps = {};
    // enable CLASS CACHING
    if (!ref.__class) ref.__class = {};
    if (!ref.__classNames) ref.__classNames = {};
    // enable CLASS CACHING
    if (!ref.__attr) ref.__attr = {};
    // enable CHANGES storing
    if (!ref.__changes) ref.__changes = [];
    // enable CHANGES storing
    if (!ref.__children) ref.__children = [];
    if ((0, $3Kzng.checkIfKeyIsComponent)(key)) ref.__componentKey = key.split('_')[0].split('.')[0].split('+')[0];
    // Add _root element property
    const hasRoot = parent && parent.key === ':root';
    if (!ref.root) ref.root = hasRoot ? element : parentRef.root;
    // set the PATH array
    // if (isNotProduction()) {
    if (!parentRef) parentRef = parent.ref = {};
    if (!parentRef.path) parentRef.path = [];
    ref.path = parentRef.path.concat(element.key);
// }
};
const $7f71ae579ce368cd$var$onlyResolveExtends = async (element, parent, key, options)=>{
    const { __ref: ref } = element;
    if (!ref.__skipCreate) {
        $7f71ae579ce368cd$var$addCaching(element, parent);
        (0, $3Yday.addMethods)(element, parent, options);
        $7f71ae579ce368cd$var$createScope(element, parent);
        (0, $2KOE6.createState)(element, parent);
        if (element.scope === 'state') element.scope = element.state;
        $7f71ae579ce368cd$var$createIfConditionFlag(element, parent);
        // apply props settings
        (0, $dw2Wn.createProps)(element, parent, options);
        if (element.scope === 'props' || element.scope === true) element.scope = element.props;
        if (element.node && ref.__if) parent[key || element.key] = element;
         // Borrowed from assignNode()
        if (!element.props) element.props = {};
        (0, $fX26p.applyVariant)(element, parent);
        $7f71ae579ce368cd$var$addElementIntoParentChildren(element, parent);
    }
    if (element.tag !== 'string' && element.tag !== 'fragment') {
        await (0, $5uBBY.throughInitialDefine)(element);
        await (0, $5uBBY.throughInitialExec)(element);
        for(const k in element){
            if ((0, $amNJ8.isUndefined)(element[k]) || (0, $cKY7h.isMethod)(k, element) || (0, $amNJ8.isObject)(((0, $6l4Vl.REGISTRY).default || (0, $6l4Vl.REGISTRY))[k]) || (0, $3Kzng.isVariant)(k)) continue;
            const hasDefine = element.define && element.define[k];
            const contextHasDefine = element.context && element.context.define && element.context.define[k];
            const optionsHasDefine = options.define && options.define[k];
            if (!ref.__skipCreate && (0, $6l4Vl.REGISTRY)[k] && !optionsHasDefine) continue;
            else if (element[k] && !hasDefine && !optionsHasDefine && !contextHasDefine) $7f71ae579ce368cd$export$185802fd694ee1f5((0, $jm0BQ.exec)(element[k], element), element, k, options);
        }
    }
    parent[key || element.key] = element // Borrowed from assignNode()
    ;
    delete element.update;
    delete element.__element;
    // added by createProps
    if (element.props) {
        delete element.props.update;
        delete element.props.__element;
    }
    return element;
};
const $7f71ae579ce368cd$var$checkIfMedia = (key)=>key.slice(0, 1) === '@';
const $7f71ae579ce368cd$var$applyMediaProps = (element, parent, key)=>{
    const { props: props } = element;
    if (props) {
        props.display = 'none';
        if (props[key]) props[key].display = props.display;
        else props[key] = {
            display: props.display || 'block'
        };
        return element;
    } else return {
        ...element,
        props: {
            display: 'none',
            [key]: {
                display: 'block'
            }
        }
    };
};
var $7f71ae579ce368cd$export$2e2bcd8739ae039 = $7f71ae579ce368cd$export$185802fd694ee1f5;

});
parcelRegister("5iyU7", function(module, exports) {

$parcel$export(module.exports, "createNode", function () { return $3db9b566e86f8f4b$export$270e7ba5936d3c48; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
var $3Kzng = parcelRequire("3Kzng");
parcelRequire("QRTe9");
var $dKo7X = parcelRequire("dKo7X");
parcelRequire("6UDue");
var $9T8r1 = parcelRequire("9T8r1");

var $cKY7h = parcelRequire("cKY7h");

var $aWnFx = parcelRequire("aWnFx");

var $5uBBY = parcelRequire("5uBBY");
parcelRequire("6cTIH");
var $6l4Vl = parcelRequire("6l4Vl");

var $fY5pv = parcelRequire("fY5pv");

var $7UeNx = parcelRequire("7UeNx");

var $kitvZ = parcelRequire("kitvZ");
'use strict';
const $3db9b566e86f8f4b$export$270e7ba5936d3c48 = async (element, options)=>{
    // create and assign a node
    let { node: node, tag: tag, __ref: ref } = element;
    let isNewNode;
    if (!node) {
        isNewNode = true;
        if (!ref.__if) return element;
        if (tag === 'shadow') node = element.node = element.parent.node.attachShadow({
            mode: 'open'
        });
        else node = element.node = (0, $9T8r1.cacheNode)(element);
        // trigger `on.attachNode`
        await (0, $dKo7X.triggerEventOn)('attachNode', element, options);
    }
    // node.dataset // .key = element.key
    if ((0, $kitvZ.isNotProduction)() || options.alowRefReference) {
        node.ref = element;
        if ((0, $amNJ8.isFunction)(node.setAttribute)) node.setAttribute('key', element.key);
    }
    // iterate through exec props
    (0, $5uBBY.throughExecProps)(element);
    // iterate through define
    await (0, $5uBBY.throughInitialDefine)(element);
    // iterate through exec
    await (0, $5uBBY.throughInitialExec)(element);
    if (element.tag !== 'string' && element.tag !== 'fragment') {
        (0, $7UeNx.propagateEventsFromProps)(element);
        if (isNewNode && (0, $amNJ8.isObject)(element.on)) (0, $dKo7X.applyEventsOnNode)(element, options);
    }
    for(const param in element){
        const value = element[param];
        if (!Object.hasOwnProperty.call(element, param)) continue;
        if ((0, $amNJ8.isUndefined)(value) || (0, $cKY7h.isMethod)(param, element) || (0, $3Kzng.isVariant)(param) || (0, $amNJ8.isObject)((0, $6l4Vl.REGISTRY)[param])) continue;
        const isElement = await (0, $fY5pv.applyParam)(param, element, options);
        if (!isElement) continue;
        const { hasDefine: hasDefine, hasContextDefine: hasContextDefine } = isElement;
        if (value && isElement && !hasDefine && !hasContextDefine) {
            const createAsync = async ()=>{
                await (0, $aWnFx.create)(await (0, $jm0BQ.exec)(value, element), element, param, options);
            };
            if (element.props && element.props.lazyLoad || options.lazyLoad) window.requestAnimationFrame(async ()=>{
                await createAsync();
                // handle lazy load
                if (!options.preventUpdateListener) await (0, $dKo7X.triggerEventOn)('lazyLoad', element, options);
            });
            else await createAsync();
        }
    }
    // node.dataset.key = key
    return element;
};
var $3db9b566e86f8f4b$export$2e2bcd8739ae039 = $3db9b566e86f8f4b$export$270e7ba5936d3c48;

});
parcelRegister("6UDue", function(module, exports) {
$parcel$export(module.exports, "cacheNode", function () { return (parcelRequire("9T8r1")).cacheNode; });
$parcel$export(module.exports, "assignNode", function () { return (parcelRequire("fGGtJ")).assignNode; });
parcelRequire("fM7lQ");
parcelRequire("9T8r1");
parcelRequire("fGGtJ");
'use strict';

});
parcelRegister("fM7lQ", function(module, exports) {
'use strict';
const $b7c10a880752b85e$export$270e7ba5936d3c48 = (element)=>{};

});

parcelRegister("9T8r1", function(module, exports) {

$parcel$export(module.exports, "cacheNode", function () { return $732fcb177dc886fe$export$257247f9c0329159; });

var $7S1uT = parcelRequire("7S1uT");
parcelRequire("QRTe9");
var $3o7U3 = parcelRequire("3o7U3");
parcelRequire("imR0C");
var $aLXZy = parcelRequire("aLXZy");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
var $8Y0fc = parcelRequire("8Y0fc");
'use strict';
const $732fcb177dc886fe$export$39fdcd81e0c5d80b = (element)=>{
    const { tag: tag, context: context } = element;
    const doc = context.document || (0, $aLXZy.document);
    if (tag) {
        if (tag === 'string') return doc.createTextNode(element.text);
        else if (tag === 'fragment') return doc.createDocumentFragment();
        else if (tag === 'svg' || tag === 'path') return doc.createElementNS('http://www.w3.org/2000/svg', tag);
        else return doc.createElement(tag) // TODO: allow strict mode to check validity
        ;
    } else return doc.createElement('div');
};
const $732fcb177dc886fe$export$5075bd4eae016d2c = (element)=>{
    let { tag: tag, key: key, props: props } = element;
    tag = (0, $jm0BQ.exec)(tag, element);
    if (tag === true) tag = key;
    if ((0, $amNJ8.isObject)(props) && (0, $amNJ8.isString)(props.tag)) {
        const tagExists = (0, $8Y0fc.isValidHtmlTag)(props.tag);
        if (tagExists) return props.tag;
    }
    if ((0, $amNJ8.isString)(tag)) {
        if ((0, $8Y0fc.isValidHtmlTag)(tag)) return tag;
    } else {
        let keyAsTag = key.toLowerCase();
        if (keyAsTag.includes('.')) keyAsTag = keyAsTag.split('.')[0];
        if (keyAsTag.includes('_')) keyAsTag = keyAsTag.split('_')[0];
        if ((0, $8Y0fc.isValidHtmlTag)(keyAsTag)) return keyAsTag;
    }
    return 'div';
};
const $732fcb177dc886fe$export$257247f9c0329159 = (element)=>{
    const { context: context } = element;
    const win = context.window || window;
    const tag = element.tag = $732fcb177dc886fe$export$5075bd4eae016d2c(element);
    if (!(0, $3o7U3.canRenderTag)(tag)) return (0, $7S1uT.report)('HTMLInvalidTag', element.tag, element);
    if (!win.nodeCaches) win.nodeCaches = {};
    let cachedTag = win.nodeCaches[tag];
    if (!cachedTag) cachedTag = win.nodeCaches[tag] = $732fcb177dc886fe$export$39fdcd81e0c5d80b(element);
    const clonedNode = cachedTag.cloneNode(true);
    if (tag === 'string') clonedNode.nodeValue = element.text;
    return clonedNode;
};

});

parcelRegister("fGGtJ", function(module, exports) {

$parcel$export(module.exports, "assignNode", function () { return $b6bbba9990506669$export$4f2a718cb234b42f; });
'use strict';
const $b6bbba9990506669$export$13970129ca912f06 = (node, parentNode, el)=>{
    try {
        if (parentNode && typeof parentNode.appendChild === 'function') {
            const win1 = el.context.window || window;
            if (parentNode instanceof win1.Node && typeof parentNode.appendChild === 'function') parentNode.appendChild(node);
            else throw new Error('Invalid parentNode: appendChild is not supported on this node type.');
        } else throw new Error('Invalid parentNode: appendChild is not supported on this node type.');
    } catch (e) {
        // Fallback for older browsers
        if (node && node.parentNode) node.parentNode.removeChild(node);
        if (node && parentNode && parentNode instanceof win.Element) parentNode.appendChild(node);
    }
    return node;
};
const $b6bbba9990506669$export$9c63b8d16fa708c5 = (node, siblingNode, parentNode)=>{
    const parent = parentNode || siblingNode.parentNode;
    if (siblingNode.nextSibling) parent && parent.insertBefore(node, siblingNode.nextSibling);
    else if (siblingNode?.insertAdjacentElement) siblingNode.insertAdjacentElement('afterend', node);
    else parent.insertBefore(node, siblingNode);
};
const $b6bbba9990506669$export$3a727f1d0007fe49 = (node, siblingNode, parentNode)=>{
    const parent = parentNode || siblingNode.parentNode;
    parent && parent.insertBefore(node, siblingNode);
};
const $b6bbba9990506669$export$4f2a718cb234b42f = (element, parent, key, attachOptions)=>{
    parent[key || element.key] = element;
    if (element.tag !== 'shadow') {
        if (attachOptions && attachOptions.position) (attachOptions.position === 'before' ? $b6bbba9990506669$export$3a727f1d0007fe49 : $b6bbba9990506669$export$9c63b8d16fa708c5)(element.node, attachOptions.node || parent.node);
        else $b6bbba9990506669$export$13970129ca912f06(element.node, parent.node, element);
    }
    return element;
};

});


parcelRegister("5uBBY", function(module, exports) {

$parcel$export(module.exports, "throughInitialExec", function () { return $3ffcedef4f7f473e$export$3223a9877c540db8; });
$parcel$export(module.exports, "throughUpdatedExec", function () { return $3ffcedef4f7f473e$export$2ad800d85590910f; });
$parcel$export(module.exports, "throughExecProps", function () { return $3ffcedef4f7f473e$export$23077649cd9ebd4b; });
$parcel$export(module.exports, "throughInitialDefine", function () { return $3ffcedef4f7f473e$export$b4c781127351659b; });
$parcel$export(module.exports, "throughUpdatedDefine", function () { return $3ffcedef4f7f473e$export$88eda8a7eb5c5eff; });
parcelRequire("imR0C");
var $3Kzng = parcelRequire("3Kzng");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
parcelRequire("94S26");
var $iPgcK = parcelRequire("iPgcK");

var $cKY7h = parcelRequire("cKY7h");
'use strict';
const $3ffcedef4f7f473e$export$3223a9877c540db8 = async (element, exclude = {})=>{
    const { __ref: ref } = element;
    for(const param in element){
        if (exclude[param]) continue;
        const prop = element[param];
        if ((0, $amNJ8.isFunction)(prop) && !(0, $cKY7h.isMethod)(param, element) && !(0, $3Kzng.isVariant)(param)) {
            ref.__exec[param] = prop;
            element[param] = await prop(element, element.state, element.context);
        // if (isComponent)
        }
    }
};
const $3ffcedef4f7f473e$export$2ad800d85590910f = async (element, options = {
    excludes: (0, $iPgcK.METHODS_EXL)
})=>{
    const { __ref: ref } = element;
    const changes = {};
    for(const param in ref.__exec){
        const prop = element[param];
        const isDefinedParam = ref.__defineCache[param];
        if (isDefinedParam) continue;
        const newExec = await ref.__exec[param](element, element.state, element.context);
        const execReturnsString = (0, $amNJ8.isString)(newExec) || (0, $amNJ8.isNumber)(newExec);
        // if (prop && prop.node && execReturnsString) {
        if (prop && prop.node && execReturnsString) (0, $iPgcK.overwrite)(prop, {
            text: newExec
        }, options);
        else if (newExec !== prop) {
            if ((0, $3Kzng.checkIfKeyIsComponent)(param)) {
                const { extend: extend, ...newElem } = (0, $3Kzng.extendizeByKey)(newExec, element, param);
                (0, $iPgcK.overwrite)(prop, newElem, options);
            // } else {
            //   overwrite(prop, newExec, options)
            } else {
                ref.__cached[param] = changes[param] = prop;
                element[param] = newExec;
            }
        }
    }
    return changes;
};
const $3ffcedef4f7f473e$export$23077649cd9ebd4b = (element)=>{
    const { __ref: ref } = element;
    const { props: props } = element;
    for(const k in props){
        const isDefine = k.startsWith('is') || k.startsWith('has') || k.startsWith('use');
        const cachedExecProp = ref.__execProps[k];
        if ((0, $amNJ8.isFunction)(cachedExecProp)) props[k] = (0, $jm0BQ.exec)(cachedExecProp, element);
        else if (isDefine && (0, $amNJ8.isFunction)(props[k])) {
            ref.__execProps[k] = props[k];
            props[k] = (0, $jm0BQ.exec)(props[k], element);
        }
    }
};
const $3ffcedef4f7f473e$export$b4c781127351659b = async (element)=>{
    const { define: define, context: context, __ref: ref } = element;
    let defineObj = {};
    const hasGlobalDefine = context && (0, $amNJ8.isObject)(context.define);
    if ((0, $amNJ8.isObject)(define)) defineObj = {
        ...define
    };
    if (hasGlobalDefine) defineObj = {
        ...defineObj,
        ...context.define
    };
    for(const param in defineObj){
        let elementProp = element[param];
        if ((0, $amNJ8.isFunction)(elementProp) && !(0, $cKY7h.isMethod)(param, element) && !(0, $3Kzng.isVariant)(param)) {
            ref.__exec[param] = elementProp;
            const execParam = elementProp = await (0, $jm0BQ.exec)(elementProp, element);
            if (execParam) {
                elementProp = element[param] = execParam.parse ? execParam.parse() : execParam;
                ref.__defineCache[param] = elementProp;
            }
        }
        const execParam = await defineObj[param](elementProp, element, element.state, element.context);
        if (execParam) element[param] = execParam;
    }
    return element;
};
const $3ffcedef4f7f473e$export$88eda8a7eb5c5eff = async (element)=>{
    const { context: context, define: define, __ref: ref } = element;
    const changes = {};
    let obj = {};
    if ((0, $amNJ8.isObject)(define)) obj = {
        ...define
    };
    if ((0, $amNJ8.isObject)(context && context.define)) obj = {
        ...obj,
        ...context.define
    };
    for(const param in obj){
        const execParam = ref.__exec[param];
        if (execParam) ref.__defineCache[param] = await execParam(element, element.state, element.context);
        const cached = await (0, $jm0BQ.exec)(ref.__defineCache[param], element);
        const newExecParam = await obj[param](cached, element, element.state, element.context);
        if (newExecParam) element[param] = newExecParam;
    }
    return changes;
};

});

parcelRegister("fY5pv", function(module, exports) {

$parcel$export(module.exports, "applyParam", function () { return $ba00a7fe12c81451$export$535107f3c159da5d; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
parcelRequire("6cTIH");
var $6l4Vl = parcelRequire("6l4Vl");
'use strict';
const $ba00a7fe12c81451$export$535107f3c159da5d = async (param, element, options)=>{
    const { node: node, context: context, __ref: ref } = element;
    const prop = await (0, $jm0BQ.exec)(element[param], element);
    const { onlyUpdate: onlyUpdate } = options;
    const DOMQLProperty = (0, $6l4Vl.REGISTRY)[param];
    const DOMQLPropertyFromContext = context && context.registry && context.registry[param];
    const isGlobalTransformer = DOMQLPropertyFromContext || DOMQLProperty;
    const hasDefine = element.define && element.define[param];
    const hasContextDefine = context && context.define && context.define[param];
    if (!ref.__if) return;
    const hasOnlyUpdate = onlyUpdate ? onlyUpdate === param || element.lookup(onlyUpdate) : true;
    if (isGlobalTransformer && !hasContextDefine && hasOnlyUpdate) {
        if ((0, $amNJ8.isFunction)(isGlobalTransformer)) await isGlobalTransformer(prop, element, node, options);
        return;
    }
    return {
        hasDefine: hasDefine,
        hasContextDefine: hasContextDefine
    };
};

});

parcelRegister("7UeNx", function(module, exports) {

$parcel$export(module.exports, "propagateEventsFromProps", function () { return $5c193dec8fea1328$export$e43138af17da316d; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
var $l2qXs = parcelRequire("l2qXs");
'use strict';
const $5c193dec8fea1328$export$e43138af17da316d = (element)=>{
    const { props: props, on: on } = element;
    const eventKeysFromProps = Object.keys(props).filter((key)=>key.startsWith('on'));
    eventKeysFromProps.forEach((v)=>{
        const eventName = (0, $l2qXs.lowercaseFirstLetter)(v.split('on')[1]);
        const origEvent = on[eventName];
        const funcFromProps = props[v];
        if ((0, $amNJ8.isFunction)(origEvent)) on[eventName] = (...args)=>{
            const originalEventRetunrs = origEvent(...args);
            if (originalEventRetunrs !== false) return funcFromProps(...args);
        };
        else on[eventName] = funcFromProps;
    });
};

});


parcelRegister("jnoTA", function(module, exports) {
$parcel$export(module.exports, "IGNORE_STATE_PARAMS", function () { return (parcelRequire("4FK1a")).IGNORE_STATE_PARAMS; });
$parcel$export(module.exports, "createState", function () { return (parcelRequire("2KOE6")).createState; });
$parcel$export(module.exports, "findInheritedState", function () { return (parcelRequire("8liBK")).findInheritedState; });
$parcel$export(module.exports, "getChildStateInKey", function () { return (parcelRequire("8liBK")).getChildStateInKey; });
$parcel$export(module.exports, "isState", function () { return (parcelRequire("8liBK")).isState; });
parcelRequire("4FK1a");
parcelRequire("2KOE6");
parcelRequire("clGOJ");
parcelRequire("2kD93");
parcelRequire("8liBK");
'use strict';

});
parcelRegister("4FK1a", function(module, exports) {

$parcel$export(module.exports, "IGNORE_STATE_PARAMS", function () { return $366eaff3202480f7$export$5100524046ce8de6; });
'use strict';
const $366eaff3202480f7$export$5100524046ce8de6 = [
    'update',
    'parse',
    'clean',
    'create',
    'destroy',
    'add',
    'toggle',
    'remove',
    'apply',
    'set',
    'reset',
    'replace',
    'quietReplace',
    'quietUpdate',
    'applyReplace',
    'applyFunction',
    'keys',
    'values',
    'ref',
    'rootUpdate',
    'parentUpdate',
    'parent',
    '__element',
    '__depends',
    '__ref',
    '__children',
    'root',
    'setByPath',
    'setPathCollection',
    'removeByPath',
    'removePathCollection',
    'getByPath'
];

});

parcelRegister("2KOE6", function(module, exports) {

$parcel$export(module.exports, "createState", function () { return $201729d82751bafd$export$e6a0daad8304de; });
parcelRequire("QRTe9");
var $dKo7X = parcelRequire("dKo7X");
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");

var $4FK1a = parcelRequire("4FK1a");

var $2kD93 = parcelRequire("2kD93");

var $clGOJ = parcelRequire("clGOJ");

var $8liBK = parcelRequire("8liBK");
'use strict';
const $201729d82751bafd$export$e6a0daad8304de = async function(element, parent, options) {
    element.state = await $201729d82751bafd$export$6e8a0938c76079c7(element, parent, options);
    return element.state;
};
const $201729d82751bafd$export$6e8a0938c76079c7 = async function(element, parent, options) {
    const objectizeState = await $201729d82751bafd$var$checkForTypes(element);
    if (objectizeState === false) return parent.state || {};
    else element.state = objectizeState;
    const whatInitReturns = await (0, $dKo7X.triggerEventOn)('stateInit', element, options);
    if (whatInitReturns === false) return element.state;
    if ((0, $8liBK.checkIfInherits)(element)) {
        const inheritedState = (0, $8liBK.createInheritedState)(element, parent);
        element.state = (0, $amNJ8.isUndefined)(inheritedState) ? {} : inheritedState;
    }
    const dependentState = $201729d82751bafd$var$applyDependentState(element, element.state || parent.state || {});
    if (dependentState) element.state = dependentState;
    $201729d82751bafd$var$applyMethods(element);
    // trigger `on.stateCreated`
    await (0, $dKo7X.triggerEventOn)('stateCreated', element);
    return element.state;
};
const $201729d82751bafd$var$applyDependentState = (element, state)=>{
    const { __ref: __ref, ref: ref, __element: __element } = state //
    ;
    const origState = (0, $jm0BQ.exec)(__ref || ref || __element?.state, element);
    if (!origState) return;
    const dependentState = (0, $jm0BQ.deepClone)(origState, (0, $4FK1a.IGNORE_STATE_PARAMS));
    const newDepends = {
        [element.key]: dependentState
    };
    const __depends = (0, $amNJ8.isObject)(origState.__depends) ? {
        ...origState.__depends,
        ...newDepends
    } : newDepends;
    if (Array.isArray(origState)) $201729d82751bafd$var$addProtoToArray(origState, {
        ...Object.getPrototypeOf(origState),
        __depends: __depends
    });
    else Object.setPrototypeOf(origState, {
        ...Object.getPrototypeOf(origState),
        __depends: __depends
    });
    return dependentState;
};
const $201729d82751bafd$var$checkForTypes = async (element)=>{
    const { state: orig, props: props, __ref: ref } = element;
    const state = props?.state || orig;
    if ((0, $amNJ8.isFunction)(state)) {
        ref.__state = state;
        return await (0, $jm0BQ.exec)(state, element);
    } else if ((0, $amNJ8.is)(state)('string', 'number')) {
        ref.__state = state;
        return {
            value: state
        };
    } else if (state === true) {
        ref.__state = element.key;
        return {};
    } else if (state) {
        ref.__hasRootState = true;
        return state;
    } else return false;
};
const $201729d82751bafd$var$addProtoToArray = (state, proto)=>{
    for(const key in proto)Object.defineProperty(state, key, {
        value: proto[key],
        enumerable: false,
        configurable: true,
        writable: true // Set this to true if you want to allow changing the function later
    });
};
const $201729d82751bafd$var$applyMethods = (element)=>{
    const state = element.state;
    const ref = element.__ref;
    const proto = {
        clean: (0, $2kD93.clean).bind(state),
        parse: (0, $2kD93.parse).bind(state),
        destroy: (0, $2kD93.destroy).bind(state),
        update: (0, $clGOJ.updateState).bind(state),
        rootUpdate: (0, $2kD93.rootUpdate).bind(state),
        parentUpdate: (0, $2kD93.parentUpdate).bind(state),
        create: $201729d82751bafd$export$e6a0daad8304de.bind(state),
        add: (0, $2kD93.add).bind(state),
        toggle: (0, $2kD93.toggle).bind(state),
        remove: (0, $2kD93.remove).bind(state),
        apply: (0, $2kD93.apply).bind(state),
        applyReplace: (0, $2kD93.applyReplace).bind(state),
        applyFunction: (0, $2kD93.applyFunction).bind(state),
        set: (0, $2kD93.set).bind(state),
        quietUpdate: (0, $2kD93.quietUpdate).bind(state),
        replace: (0, $2kD93.replace).bind(state),
        quietReplace: (0, $2kD93.quietReplace).bind(state),
        reset: (0, $2kD93.reset).bind(state),
        parent: element.parent.state || state,
        setByPath: (0, $2kD93.setByPath).bind(state),
        setPathCollection: (0, $2kD93.setPathCollection).bind(state),
        removeByPath: (0, $2kD93.removeByPath).bind(state),
        removePathCollection: (0, $2kD93.removePathCollection).bind(state),
        getByPath: (0, $2kD93.getByPath).bind(state),
        keys: (0, $2kD93.keys).bind(state),
        values: (0, $2kD93.values).bind(state),
        __element: element,
        __children: {},
        root: ref.root ? ref.root.state : state
    };
    if ((0, $amNJ8.isArray)(state)) $201729d82751bafd$var$addProtoToArray(state, proto);
    else Object.setPrototypeOf(state, proto);
    if (state.parent && state.parent.__children) state.parent.__children[element.key] = state;
};

});
parcelRegister("2kD93", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $1b2bd06cea082506$export$98e6a39c04603d36; });
$parcel$export(module.exports, "clean", function () { return $1b2bd06cea082506$export$cf0b2a6c63f9e656; });
$parcel$export(module.exports, "destroy", function () { return $1b2bd06cea082506$export$b1fb4cac938035f7; });
$parcel$export(module.exports, "parentUpdate", function () { return $1b2bd06cea082506$export$e45af8832c6abf26; });
$parcel$export(module.exports, "rootUpdate", function () { return $1b2bd06cea082506$export$c2f300c8c094e900; });
$parcel$export(module.exports, "add", function () { return $1b2bd06cea082506$export$e16d8520af44a096; });
$parcel$export(module.exports, "toggle", function () { return $1b2bd06cea082506$export$e03c1c3201ee8bb7; });
$parcel$export(module.exports, "remove", function () { return $1b2bd06cea082506$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "set", function () { return $1b2bd06cea082506$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "setByPath", function () { return $1b2bd06cea082506$export$f65a19d15516795e; });
$parcel$export(module.exports, "setPathCollection", function () { return $1b2bd06cea082506$export$d340c517393b84c7; });
$parcel$export(module.exports, "removeByPath", function () { return $1b2bd06cea082506$export$ceab6855354994b2; });
$parcel$export(module.exports, "removePathCollection", function () { return $1b2bd06cea082506$export$20d12daede3a0bb7; });
$parcel$export(module.exports, "getByPath", function () { return $1b2bd06cea082506$export$44b5bed83342a92f; });
$parcel$export(module.exports, "reset", function () { return $1b2bd06cea082506$export$aad8462122ac592b; });
$parcel$export(module.exports, "apply", function () { return $1b2bd06cea082506$export$5635d7ef4b8fee1c; });
$parcel$export(module.exports, "applyReplace", function () { return $1b2bd06cea082506$export$a820c59bcfe11369; });
$parcel$export(module.exports, "applyFunction", function () { return $1b2bd06cea082506$export$bd130d4161841808; });
$parcel$export(module.exports, "quietUpdate", function () { return $1b2bd06cea082506$export$8e1d54bd5cf63ec5; });
$parcel$export(module.exports, "replace", function () { return $1b2bd06cea082506$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "quietReplace", function () { return $1b2bd06cea082506$export$b2ed1c8afe947b7d; });
$parcel$export(module.exports, "keys", function () { return $1b2bd06cea082506$export$ed97f33186d4b816; });
$parcel$export(module.exports, "values", function () { return $1b2bd06cea082506$export$68c286be0e7e55b7; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
var $1cJu7 = parcelRequire("1cJu7");

var $4FK1a = parcelRequire("4FK1a");
'use strict';
const $1b2bd06cea082506$export$98e6a39c04603d36 = function() {
    const state = this;
    if ((0, $amNJ8.isObject)(state)) {
        const obj = {};
        for(const param in state)if (!(0, $4FK1a.IGNORE_STATE_PARAMS).includes(param)) obj[param] = state[param];
        return obj;
    } else if ((0, $amNJ8.isArray)(state)) return state.filter((item)=>!(0, $4FK1a.IGNORE_STATE_PARAMS).includes(item));
};
const $1b2bd06cea082506$export$cf0b2a6c63f9e656 = function(options = {}) {
    const state = this;
    for(const param in state)if (!(0, $4FK1a.IGNORE_STATE_PARAMS).includes(param) && Object.hasOwnProperty.call(state, param)) delete state[param];
    if (!options.preventStateUpdate) state.update(state, {
        replace: true,
        ...options
    });
    return state;
};
const $1b2bd06cea082506$export$b1fb4cac938035f7 = function(options = {}) {
    const state = this;
    const element = state.__element;
    const stateKey = element.__ref.__state;
    if ((0, $amNJ8.isString)(stateKey)) {
        element.parent.state.remove(stateKey, {
            isHoisted: true,
            ...options
        });
        return element.state;
    }
    delete element.state;
    element.state = state.parent;
    if (state.parent) delete state.parent.__children[element.key];
    if (state.__children) for(const key in state.__children){
        const child = state.__children[key];
        if (child.state) {
            if ((0, $amNJ8.isArray)(child.state)) Object.defineProperty(child.state, 'parent', {
                value: state.parent,
                enumerable: false,
                configurable: true,
                writable: true // Set this to true if you want to allow changing the function later
            });
            else Object.setPrototypeOf(child, {
                parent: state.parent
            });
        }
    }
    element.state.update({}, {
        isHoisted: true,
        ...options
    });
    return element.state;
};
const $1b2bd06cea082506$export$e45af8832c6abf26 = function(obj, options = {}) {
    const state = this;
    if (!state || !state.parent) return;
    return state.parent.update(obj, {
        isHoisted: true,
        ...options
    });
};
const $1b2bd06cea082506$export$c2f300c8c094e900 = function(obj, options = {}) {
    const state = this;
    if (!state) return;
    const rootState = state.__element.__ref.root.state;
    return rootState.update(obj, {
        isHoisted: false,
        ...options
    });
};
const $1b2bd06cea082506$export$e16d8520af44a096 = function(value, options = {}) {
    const state = this;
    if ((0, $amNJ8.isArray)(state)) {
        state.push(value);
        state.update(state.parse(), {
            overwrite: true,
            ...options
        });
    } else if ((0, $amNJ8.isObject)(state)) {
        const key = Object.keys(state).length;
        state.update({
            [key]: value
        }, options);
    }
};
const $1b2bd06cea082506$export$e03c1c3201ee8bb7 = function(key, options = {}) {
    const state = this;
    state.update({
        [key]: !state[key]
    }, options);
};
const $1b2bd06cea082506$export$cd7f480d6b8286c3 = function(key, options = {}) {
    const state = this;
    if ((0, $amNJ8.isArray)(state)) (0, $1cJu7.removeFromArray)(state, key);
    if ((0, $amNJ8.isObject)(state)) (0, $jm0BQ.removeFromObject)(state, key);
    if (options.applyReset) return state.set(state.parse(), {
        replace: true,
        ...options
    });
    return state.update();
};
const $1b2bd06cea082506$export$adaa4cf7ef1b65be = function(val, options = {}) {
    const state = this;
    const value = (0, $jm0BQ.deepClone)(val);
    return state.clean({
        preventStateUpdate: true,
        ...options
    }).update(value, {
        replace: true,
        ...options
    });
};
const $1b2bd06cea082506$export$f65a19d15516795e = function(path, val, options = {}) {
    const state = this;
    const value = (0, $jm0BQ.deepClone)(val);
    (0, $jm0BQ.setInObjectByPath)(state, path, val);
    const update = (0, $jm0BQ.createNestedObject)(path, value);
    if (options.preventStateUpdate) return update;
    return state.update(update, options);
};
const $1b2bd06cea082506$export$d340c517393b84c7 = async function(changes, options = {}) {
    const state = this;
    const update = changes.reduce((acc, change)=>{
        if (change[0] === 'update') {
            const result = $1b2bd06cea082506$export$f65a19d15516795e.call(state, change[1], change[2], {
                preventStateUpdate: true
            });
            return (0, $jm0BQ.overwriteDeep)(acc, result);
        } else if (change[0] === 'delete') $1b2bd06cea082506$export$ceab6855354994b2.call(state, change[1], options);
        return acc;
    }, {});
    return await state.update(update, options);
};
const $1b2bd06cea082506$export$ceab6855354994b2 = async function(path, options = {}) {
    const state = this;
    (0, $jm0BQ.removeNestedKeyByPath)(state, path);
    if (options.preventUpdate) return path;
    return await state.update({}, options);
};
const $1b2bd06cea082506$export$20d12daede3a0bb7 = function(changes, options = {}) {
    const state = this;
    changes.forEach((item)=>{
        $1b2bd06cea082506$export$ceab6855354994b2(item, {
            preventUpdate: true
        });
    });
    return state.update({}, options);
};
const $1b2bd06cea082506$export$44b5bed83342a92f = function(path, options = {}) {
    const state = this;
    return (0, $jm0BQ.getInObjectByPath)(state, path);
};
const $1b2bd06cea082506$export$aad8462122ac592b = function(options = {}) {
    const state = this;
    const value = (0, $jm0BQ.deepClone)(state.parse());
    return state.set(value, {
        replace: true,
        ...options
    });
};
const $1b2bd06cea082506$export$5635d7ef4b8fee1c = function(func, options = {}) {
    const state = this;
    if ((0, $amNJ8.isFunction)(func)) {
        const value = func(state);
        return state.update(value, {
            replace: true,
            ...options
        });
    }
};
const $1b2bd06cea082506$export$a820c59bcfe11369 = function(func, options = {}) {
    const state = this;
    if ((0, $amNJ8.isFunction)(func)) {
        const value = func(state);
        return state.replace(value, options);
    }
};
const $1b2bd06cea082506$export$bd130d4161841808 = function(func, options = {}) {
    const state = this;
    if ((0, $amNJ8.isFunction)(func)) {
        func(state);
        return state.update(state.parse(), {
            replace: true,
            ...options
        });
    }
};
const $1b2bd06cea082506$export$8e1d54bd5cf63ec5 = function(obj, options = {}) {
    const state = this;
    return state.update(obj, {
        preventUpdate: true,
        ...options
    });
};
const $1b2bd06cea082506$export$77ad94ebf1c2b9ed = function(obj, options = {}) {
    const state = this;
    for(const param in obj)state[param] = obj[param];
    return state.update(obj, options);
};
const $1b2bd06cea082506$export$b2ed1c8afe947b7d = function(obj, options = {}) {
    const state = this;
    return state.replace(obj, {
        preventUpdate: true,
        ...options
    });
};
const $1b2bd06cea082506$export$ed97f33186d4b816 = function(obj, options = {}) {
    const state = this;
    return Object.keys(state);
};
const $1b2bd06cea082506$export$68c286be0e7e55b7 = function(obj, options = {}) {
    const state = this;
    return Object.values(state);
};

});

parcelRegister("clGOJ", function(module, exports) {

$parcel$export(module.exports, "updateState", function () { return $8fd8a8d42eb9002f$export$4971331372cec95a; });

var $7S1uT = parcelRequire("7S1uT");
parcelRequire("QRTe9");
var $dKo7X = parcelRequire("dKo7X");

var $4FK1a = parcelRequire("4FK1a");
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");

var $8liBK = parcelRequire("8liBK");
'use strict';
const $8fd8a8d42eb9002f$var$STATE_UPDATE_OPTIONS = {
    overwrite: true,
    preventHoistElementUpdate: false,
    updateByState: true,
    isHoisted: true,
    execStateFunction: true
};
const $8fd8a8d42eb9002f$export$4971331372cec95a = async function(obj, options = $8fd8a8d42eb9002f$var$STATE_UPDATE_OPTIONS) {
    const state = this;
    const element = state.__element;
    if (options.onEach) options.onEach(element, state, element.context, options);
    if (!options.updateByState) (0, $jm0BQ.merge)(options, $8fd8a8d42eb9002f$var$STATE_UPDATE_OPTIONS);
    if (!state.__element) (0, $7S1uT.report)('ElementOnStateIsNotDefined');
    if (options.preventInheritAtCurrentState === true) options.preventInheritAtCurrentState = state;
    else if (options.preventInheritAtCurrentState) return;
    if (!options.preventBeforeStateUpdateListener) {
        const beforeStateUpdateReturns = await (0, $dKo7X.triggerEventOnUpdate)('beforeStateUpdate', obj, element, options);
        if (beforeStateUpdateReturns === false) return element;
    }
    $8fd8a8d42eb9002f$var$applyOverwrite(state, obj, options);
    const updateIsHoisted = await $8fd8a8d42eb9002f$var$hoistStateUpdate(state, obj, options);
    if (updateIsHoisted) return state;
    await $8fd8a8d42eb9002f$var$updateDependentState(state, obj, options);
    await $8fd8a8d42eb9002f$var$applyElementUpdate(state, obj, options);
    if (!options.preventStateUpdateListener) await (0, $dKo7X.triggerEventOnUpdate)('stateUpdate', obj, element, options);
    return state;
};
const $8fd8a8d42eb9002f$var$applyOverwrite = (state, obj, options)=>{
    const { overwrite: overwrite } = options;
    if (!overwrite) return;
    const shallow = overwrite === 'shallow' || overwrite === 'shallow-once';
    const merge = overwrite === 'merge';
    if (merge) {
        (0, $jm0BQ.deepMerge)(state, obj, (0, $4FK1a.IGNORE_STATE_PARAMS));
        return;
    }
    const overwriteFunc = shallow ? (0, $jm0BQ.overwriteShallow) : (0, $jm0BQ.overwriteDeep);
    if (options.overwrite === 'shallow-once') options.overwrite = true;
    overwriteFunc(state, obj, (0, $4FK1a.IGNORE_STATE_PARAMS));
};
const $8fd8a8d42eb9002f$var$hoistStateUpdate = async (state, obj, options)=>{
    const element = state.__element;
    const { parent: parent, __ref: ref } = element;
    const stateKey = ref?.__state;
    const stateType = ref?.__stateType;
    if (!stateKey) return;
    const asksForInherit = (0, $8liBK.checkIfInherits)(element);
    const inheritedState = (0, $8liBK.findInheritedState)(element, parent, {
        returnParent: true
    });
    const shouldPropagateState = asksForInherit && inheritedState && !options.stopStatePropagation;
    if (!shouldPropagateState) return;
    const isStringState = stateType === 'string' || stateType === 'number' || stateType === 'boolean';
    const value = isStringState ? state.value : state.parse();
    const passedValue = isStringState ? state.value : obj;
    const findRootState = (0, $8liBK.getRootStateInKey)(stateKey, parent.state);
    const findGrandParentState = (0, $8liBK.getParentStateInKey)(stateKey, parent.state);
    const changesValue = (0, $8liBK.createNestedObjectByKeyPath)(stateKey, passedValue);
    const targetParent = findRootState || findGrandParentState || parent.state;
    if (options.replace) (0, $jm0BQ.overwriteDeep)(targetParent, changesValue || value) // check with createNestedObjectByKeyPath
    ;
    await targetParent.update(changesValue, {
        execStateFunction: false,
        isHoisted: true,
        preventUpdate: options.preventHoistElementUpdate,
        overwrite: !options.replace,
        ...options
    });
    const hasNotUpdated = options.preventUpdate !== true || !options.preventHoistElementUpdate;
    if (!options.preventStateUpdateListener && hasNotUpdated) await (0, $dKo7X.triggerEventOnUpdate)('stateUpdate', obj, element, options);
    return true;
};
const $8fd8a8d42eb9002f$var$updateDependentState = async (state, obj, options)=>{
    if (!state.__depends) return;
    for(const el in state.__depends){
        const dependentState = state.__depends[el];
        await dependentState.clean().update(state.parse(), options);
    }
};
const $8fd8a8d42eb9002f$var$applyElementUpdate = async (state, obj, options)=>{
    const element = state.__element;
    if (options.preventUpdate !== true) await element.update({}, {
        ...options,
        updateByState: true
    });
    else if (options.preventUpdate === 'recursive') await element.update({}, {
        ...options,
        isHoisted: false,
        updateByState: true,
        preventUpdate: true
    });
};

});
parcelRegister("8liBK", function(module, exports) {

$parcel$export(module.exports, "getRootStateInKey", function () { return $612eb807482d207f$export$c138e045c9d99c0; });
$parcel$export(module.exports, "getParentStateInKey", function () { return $612eb807482d207f$export$f7dd4f6f6830b29d; });
$parcel$export(module.exports, "getChildStateInKey", function () { return $612eb807482d207f$export$e6d108f71cc7e736; });
$parcel$export(module.exports, "findInheritedState", function () { return $612eb807482d207f$export$487549069bb5d2a9; });
$parcel$export(module.exports, "checkIfInherits", function () { return $612eb807482d207f$export$e187d7e20e9fd8fa; });
$parcel$export(module.exports, "createInheritedState", function () { return $612eb807482d207f$export$c546cc738d4564ba; });
$parcel$export(module.exports, "isState", function () { return $612eb807482d207f$export$e5d60a6bbabd36f; });
$parcel$export(module.exports, "createNestedObjectByKeyPath", function () { return $612eb807482d207f$export$a1831dd7b6191ba4; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");

var $4FK1a = parcelRequire("4FK1a");
'use strict';
const $612eb807482d207f$export$c138e045c9d99c0 = (stateKey, parentState)=>{
    if (!stateKey.includes('~/')) return;
    const arr = stateKey.split('~/');
    if (arr.length > 1) return parentState.root;
};
const $612eb807482d207f$export$f7dd4f6f6830b29d = (stateKey, parentState)=>{
    if (!stateKey.includes('../')) return;
    const arr = stateKey.split('../');
    const arrLength = arr.length - 1;
    for(let i = 0; i < arrLength; i++){
        if (!parentState.parent) return null;
        parentState = parentState.parent;
    }
    return parentState;
};
const $612eb807482d207f$export$e6d108f71cc7e736 = (stateKey, parentState, options = {})=>{
    const arr = stateKey.split('/');
    const arrLength = arr.length - 1;
    for(let i = 0; i < arrLength; i++){
        const childKey = arr[i];
        const grandChildKey = arr[i + 1];
        if (childKey === '__proto__' || grandChildKey === '__proto__') return;
        let childInParent = parentState[childKey];
        if (!childInParent) childInParent = parentState[childKey] = {} // check for array
        ;
        if (!childInParent[grandChildKey]) childInParent[grandChildKey] = {} // check for array
        ;
        stateKey = grandChildKey;
        parentState = childInParent;
    }
    if (options.returnParent) return parentState;
    return parentState[stateKey];
};
const $612eb807482d207f$export$487549069bb5d2a9 = (element, parent, options = {})=>{
    const ref = element.__ref;
    let stateKey = ref.__state;
    if (!$612eb807482d207f$export$e187d7e20e9fd8fa(element)) return;
    const rootState = $612eb807482d207f$export$c138e045c9d99c0(stateKey, parent.state);
    let parentState = parent.state;
    if (rootState) {
        parentState = rootState;
        stateKey = stateKey.replaceAll('~/', '');
    } else {
        const findGrandParentState = $612eb807482d207f$export$f7dd4f6f6830b29d(stateKey, parent.state);
        if (findGrandParentState) {
            parentState = findGrandParentState;
            stateKey = stateKey.replaceAll('../', '');
        }
    }
    if (!parentState) return;
    return $612eb807482d207f$export$e6d108f71cc7e736(stateKey, parentState, options);
};
const $612eb807482d207f$export$c546cc738d4564ba = (element, parent)=>{
    const ref = element.__ref;
    const inheritedState = $612eb807482d207f$export$487549069bb5d2a9(element, parent);
    if ((0, $amNJ8.isUndefined)(inheritedState)) return element.state;
    if ((0, $amNJ8.is)(inheritedState)('object', 'array')) return (0, $jm0BQ.deepClone)(inheritedState, {
        exclude: (0, $4FK1a.IGNORE_STATE_PARAMS)
    });
    else if ((0, $amNJ8.is)(inheritedState)('string', 'number', 'boolean')) {
        ref.__stateType = typeof inheritedState;
        return {
            value: inheritedState
        };
    }
    console.warn(ref.__state, 'is not present. Replacing with', {});
};
const $612eb807482d207f$export$e187d7e20e9fd8fa = (element)=>{
    const ref = element.__ref;
    const stateKey = ref.__state;
    if (stateKey && (0, $amNJ8.is)(stateKey)('number', 'string', 'boolean')) return true;
    return false;
};
const $612eb807482d207f$export$e5d60a6bbabd36f = function(state) {
    if (!(0, $amNJ8.isObjectLike)(state)) return false;
    return state.update && state.parse && state.clean && state.create && state.parent && state.destroy && state.rootUpdate && state.parentUpdate && state.keys && state.values && state.toggle && state.replace && state.quietUpdate && state.quietReplace && state.add && state.apply && state.applyReplace && state.setByPath && state.setPathCollection && state.removeByPath && state.removePathCollection && state.getByPath && state.applyFunction && state.__element && state.__children;
// return arrayContainsOtherArray(keys, ['update', 'parse', 'clean', 'create', 'parent', 'rootUpdate'])
};
const $612eb807482d207f$export$a1831dd7b6191ba4 = (path, value)=>{
    if (!path) return value || {};
    const keys = path.split('/');
    const obj = {};
    let ref = obj;
    keys.forEach((key, index)=>{
        ref[key] = index === keys.length - 1 ? value || {} : {};
        ref = ref[key];
    });
    return obj;
};

});




parcelRegister("3Yday", function(module, exports) {

$parcel$export(module.exports, "addMethods", function () { return $2e4130d50d31a7dc$export$626ce79af72fc3d3; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");

var $48DOr = parcelRequire("48DOr");

var $63mfJ = parcelRequire("63mfJ");

var $ggGSI = parcelRequire("ggGSI");

var $cKY7h = parcelRequire("cKY7h");
'use strict';
const $2e4130d50d31a7dc$export$626ce79af72fc3d3 = (element, parent, options = {})=>{
    const proto = {
        set: $48DOr.set,
        reset: $48DOr.reset,
        update: $63mfJ.update,
        variables: $cKY7h.variables,
        remove: $cKY7h.remove,
        updateContent: $ggGSI.updateContent,
        removeContent: $ggGSI.removeContent,
        setProps: $cKY7h.setProps,
        lookup: $cKY7h.lookup,
        lookdown: $cKY7h.lookdown,
        lookdownAll: $cKY7h.lookdownAll,
        getRef: $cKY7h.getRef,
        getPath: $cKY7h.getPath,
        setNodeStyles: $cKY7h.setNodeStyles,
        spotByPath: $cKY7h.spotByPath,
        parse: $cKY7h.parse,
        parseDeep: $cKY7h.parseDeep,
        keys: $cKY7h.keys,
        nextElement: $cKY7h.nextElement,
        previousElement: $cKY7h.previousElement,
        log: $cKY7h.log,
        verbose: $cKY7h.verbose,
        warn: $cKY7h.warn,
        error: $cKY7h.error,
        call: $cKY7h.call
    };
    if (element.context.methods) (options.strict ? (0, $jm0BQ.merge) : (0, $jm0BQ.overwrite))(proto, element.context.methods);
    Object.setPrototypeOf(element, proto);
};

});
parcelRegister("63mfJ", function(module, exports) {

$parcel$export(module.exports, "update", function () { return $468448d3962580bb$export$722fbec263ad908a; });
parcelRequire("imR0C");
var $7Ionn = parcelRequire("7Ionn");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
var $3Kzng = parcelRequire("3Kzng");
var $aLXZy = parcelRequire("aLXZy");
parcelRequire("QRTe9");
var $dKo7X = parcelRequire("dKo7X");

var $cKY7h = parcelRequire("cKY7h");
parcelRequire("5HLar");
var $cgkQP = parcelRequire("cgkQP");
parcelRequire("jnoTA");
var $2KOE6 = parcelRequire("2KOE6");
var $8liBK = parcelRequire("8liBK");

var $aWnFx = parcelRequire("aWnFx");

var $5uBBY = parcelRequire("5uBBY");
parcelRequire("6cTIH");
var $6l4Vl = parcelRequire("6l4Vl");

var $fY5pv = parcelRequire("fY5pv");

var $4QK8a = parcelRequire("4QK8a");
parcelRequire("94S26");
var $iPgcK = parcelRequire("iPgcK");
'use strict';
const $468448d3962580bb$var$snapshot = {
    snapshotId: (0, $7Ionn.createSnapshotId)
};
const $468448d3962580bb$var$UPDATE_DEFAULT_OPTIONS = {
    stackChanges: false,
    cleanExec: true,
    preventRecursive: false,
    currentSnapshot: false,
    calleeElement: false,
    excludes: (0, $iPgcK.METHODS_EXL)
};
const $468448d3962580bb$export$722fbec263ad908a = async function(params = {}, opts) {
    const calleeElementCache = opts?.calleeElement;
    const options = (0, $jm0BQ.deepClone)((0, $amNJ8.isObject)(opts) ? (0, $iPgcK.deepMerge)(opts, $468448d3962580bb$var$UPDATE_DEFAULT_OPTIONS) : $468448d3962580bb$var$UPDATE_DEFAULT_OPTIONS, {
        exclude: [
            'calleeElement'
        ]
    });
    options.calleeElement = calleeElementCache;
    const element = this;
    const { parent: parent, node: node, key: key } = element;
    const { excludes: excludes, preventInheritAtCurrentState: preventInheritAtCurrentState } = options;
    let ref = element.__ref;
    if (!ref) ref = element.__ref = {};
    const [snapshotOnCallee, calleeElement, snapshotHasUpdated] = $468448d3962580bb$var$captureSnapshot(element, options);
    if (snapshotHasUpdated) return;
    if (!options.preventListeners) await (0, $dKo7X.triggerEventOnUpdate)('startUpdate', params, element, options);
    if (preventInheritAtCurrentState && preventInheritAtCurrentState.__element === element) return;
    if (!excludes) (0, $jm0BQ.merge)(options, $468448d3962580bb$var$UPDATE_DEFAULT_OPTIONS);
    if ((0, $amNJ8.isString)(params) || (0, $amNJ8.isNumber)(params)) params = {
        text: params
    };
    const inheritState = await $468448d3962580bb$var$inheritStateUpdates(element, options);
    if (inheritState === false) return;
    const ifFails = $468448d3962580bb$var$checkIfOnUpdate(element, parent, options);
    if (ifFails) return;
    if (ref.__if && !options.preventPropsUpdate) {
        const hasParentProps = parent.props && (parent.props[key] || parent.props.childProps);
        const hasFunctionInProps = ref.__props.filter((v)=>(0, $amNJ8.isFunction)(v));
        const props = params.props || hasParentProps || hasFunctionInProps.length;
        if (props) (0, $cgkQP.updateProps)(props, element, parent);
    }
    if (!options.preventBeforeUpdateListener && !options.preventListeners) {
        const beforeUpdateReturns = await (0, $dKo7X.triggerEventOnUpdate)('beforeUpdate', params, element, options);
        if (beforeUpdateReturns === false) return element;
    }
    // apply new updates
    (0, $jm0BQ.overwriteDeep)(element, params, {
        exclude: (0, $iPgcK.METHODS_EXL)
    });
    // exec updates
    (0, $5uBBY.throughExecProps)(element);
    await (0, $5uBBY.throughUpdatedExec)(element, {
        ignore: $468448d3962580bb$var$UPDATE_DEFAULT_OPTIONS
    });
    await (0, $5uBBY.throughUpdatedDefine)(element);
    if (!options.isForced && !options.preventListeners) await (0, $dKo7X.triggerEventOn)('beforeClassAssign', element, options);
    if (!ref.__if) return false;
    if (!node) // return createNode(element, options)
    return;
    const { preventUpdate: preventUpdate, preventDefineUpdate: preventDefineUpdate, preventContentUpdate: preventContentUpdate, preventStateUpdate: preventStateUpdate, preventRecursive: preventRecursive, preventUpdateListener: preventUpdateListener, preventUpdateAfter: preventUpdateAfter, preventUpdateAfterCount: preventUpdateAfterCount } = options;
    if (preventUpdateAfter) {
        if ((0, $amNJ8.isNumber)(preventUpdateAfterCount) && preventUpdateAfter <= preventUpdateAfterCount) return;
        else if (options.preventUpdateAfterCount === undefined) options.preventUpdateAfterCount = 1;
        else options.preventUpdateAfterCount++;
    }
    for(const param in element){
        const prop = element[param];
        if (!Object.hasOwnProperty.call(element, param)) continue;
        const isInPreventUpdate = (0, $amNJ8.isArray)(preventUpdate) && preventUpdate.includes(param);
        const isInPreventDefineUpdate = (0, $amNJ8.isArray)(preventDefineUpdate) && preventDefineUpdate.includes(param);
        const hasCollection = element.$collection || element.$stateCollection || element.$propsCollection;
        if ((0, $amNJ8.isUndefined)(prop) || isInPreventUpdate || isInPreventDefineUpdate || preventDefineUpdate === true || preventDefineUpdate === param || preventContentUpdate && param === 'content' && !hasCollection || (preventStateUpdate && param) === 'state' || (0, $cKY7h.isMethod)(param, element) || (0, $amNJ8.isObject)((0, $6l4Vl.REGISTRY)[param]) || (0, $3Kzng.isVariant)(param)) continue;
        if (preventStateUpdate === 'once') options.preventStateUpdate = false;
        const isElement = await (0, $fY5pv.applyParam)(param, element, options);
        if (isElement) {
            const { hasDefine: hasDefine, hasContextDefine: hasContextDefine } = isElement;
            const canUpdate = (0, $amNJ8.isObject)(prop) && !hasDefine && !hasContextDefine && !preventRecursive;
            if (!canUpdate) continue;
            const lazyLoad = element.props.lazyLoad || options.lazyLoad;
            if (options.onEachUpdate) options.onEachUpdate(param, element, element.state, element.context);
            const childUpdateCall = async ()=>await $468448d3962580bb$export$722fbec263ad908a.call(prop, params[prop], {
                    ...options,
                    currentSnapshot: snapshotOnCallee,
                    calleeElement: calleeElement
                });
            lazyLoad ? (0, $aLXZy.window).requestAnimationFrame(async ()=>{
                // eslint-disable-line
                await childUpdateCall();
                // handle lazy load
                if (!options.preventUpdateListener) await (0, $dKo7X.triggerEventOn)('lazyLoad', element, options);
            }) : await childUpdateCall();
        }
    }
    if (!preventUpdateListener) await (0, $dKo7X.triggerEventOn)('update', element, options);
};
const $468448d3962580bb$var$captureSnapshot = (element, options)=>{
    const ref = element.__ref;
    const { currentSnapshot: currentSnapshot, calleeElement: calleeElement } = options;
    const isCallee = calleeElement === element;
    if (!calleeElement || isCallee) {
        const createdStanpshot = $468448d3962580bb$var$snapshot.snapshotId();
        ref.__currentSnapshot = createdStanpshot;
        return [
            createdStanpshot,
            element
        ];
    }
    const snapshotOnCallee = calleeElement.__ref.__currentSnapshot;
    if (currentSnapshot < snapshotOnCallee) return [
        snapshotOnCallee,
        calleeElement,
        true
    ];
    return [
        snapshotOnCallee,
        calleeElement
    ];
};
const $468448d3962580bb$var$checkIfOnUpdate = (element, parent, options)=>{
    if (!(0, $amNJ8.isFunction)(element.if) && !(0, $amNJ8.isFunction)(element.props?.if) || !parent) return;
    const ref = element.__ref;
    const ifPassed = (element.if || element.props?.if)(element, element.state, element.context, options);
    const itWasFalse = ref.__if !== true;
    if (ifPassed) {
        ref.__if = true;
        if (itWasFalse) {
            delete element.__hash;
            delete element.__text;
            delete element.extend;
            if (!ref.__hasRootState) delete element.state;
            if (ref.__state) element.state = ref.__state;
            else if (!ref.__hasRootState) delete element.state;
            if (element.node) {
                element.node.remove();
                delete element.node;
            }
            const contentKey = ref.contentElementKey;
            if (element.$collection || element.$stateCollection || element.$propsCollection) element.removeContent();
            else if (element[contentKey]?.parseDeep) element[contentKey] = element[contentKey].parseDeep();
            const previousElement = element.previousElement();
            const previousNode = previousElement?.node // document.body.contains(previousElement.node)
            ;
            const hasPrevious = previousNode?.parentNode // document.body.contains(previousElement.node)
            ;
            const nextElement = element.nextElement();
            const nextNode = nextElement?.node // document.body.contains(previousElement.node)
            ;
            const hasNext = nextNode?.parentNode // && document.body.contains(nextElement.node)
            ;
            // const hasNext = nextElement && document.body.contains(nextElement.node)
            const attachOptions = (hasPrevious || hasNext) && {
                position: hasPrevious ? 'after' : hasNext ? 'before' : null,
                node: hasPrevious && previousNode || hasNext && nextNode
            };
            delete element.__ref;
            delete element.parent;
            const createdElement = (0, $aWnFx.create)(element, parent, element.key, (0, $4QK8a.OPTIONS).create, attachOptions);
            // check preventUpdate for an array (Line: 87)
            if (options.preventUpdate !== true && element.on && (0, $amNJ8.isFunction)(element.on.update)) (0, $dKo7X.applyEvent)(element.on.update, createdElement, createdElement.state);
            return createdElement;
        }
    } else if (element.node && !ifPassed) {
        element.node.remove();
        delete ref.__if;
    }
};
/**
 * Inherit state updates for a given element based on the specified options.
 *
 * @param {Object} element - The element to inherit state updates for.
 * @param {Object} options - Configuration options for state update inheritance.
 * @param {boolean} [options.preventUpdateTriggerStateUpdate] - If true, prevent triggering state updates.
 * @param {boolean} [options.isHoisted] - Whether the state is hoisted.
 * @param {boolean} [options.execStateFunction] - Execute the state functions.
 * @param {boolean} [options.stateFunctionOverwrite] - If true, overwrite (not merge) current state with what function returns.
 * @param {boolean} [options.preventInheritedStateUpdate] - If true, prevent inheriting state updates.
 * @param {boolean} [options.preventBeforeStateUpdateListener] - If true, prevent the 'beforeStateUpdate' event listener.
 * @param {boolean} [options.preventStateUpdateListener] - If true, prevent the 'stateUpdate' event listener.
 * @returns {boolean} - If returns false, it breaks the update function
 */ const $468448d3962580bb$var$inheritStateUpdates = async (element, options)=>{
    const { __ref: ref } = element;
    const stateKey = ref.__state;
    const { parent: parent, state: state } = element;
    const { preventUpdateTriggerStateUpdate: preventUpdateTriggerStateUpdate, isHoisted: isHoisted, execStateFunction: execStateFunction } = options;
    if (preventUpdateTriggerStateUpdate) return;
    // If does not have own state inherit from parent
    if (!stateKey && !ref.__hasRootState) {
        element.state = parent && parent.state || {};
        return;
    }
    // If state is function, decide execution and apply setting a current state
    const shouldForceFunctionState = (0, $amNJ8.isFunction)(stateKey) && !isHoisted && execStateFunction;
    if (shouldForceFunctionState) {
        const execState = (0, $jm0BQ.exec)(stateKey, element);
        state.set(execState, {
            ...options,
            preventUpdate: true,
            preventStateUpdateListener: false,
            updatedByStateFunction: true
        });
        return;
    }
    // If state is string, find its value in the state tree
    const keyInParentState = (0, $8liBK.findInheritedState)(element, element.parent);
    if (!keyInParentState || options.preventInheritedStateUpdate) return;
    // Trigger on.beforeStateUpdate event
    if (!options.preventBeforeStateUpdateListener && !options.preventListeners) {
        const initStateReturns = await (0, $dKo7X.triggerEventOnUpdate)('beforeStateUpdate', keyInParentState, element, options);
        if (initStateReturns === false) return element;
    }
    // Recreate the state again
    const newState = await $468448d3962580bb$var$createStateUpdate(element, parent, options);
    // Trigger on.stateUpdate event
    if (!options.preventStateUpdateListener && !options.preventListeners) await (0, $dKo7X.triggerEventOnUpdate)('stateUpdate', newState.parse(), element, options);
};
const $468448d3962580bb$var$createStateUpdate = async (element, parent, options)=>{
    const __stateChildren = element.state.__children;
    const newState = await (0, $2KOE6.createState)(element, parent);
    element.state = newState;
    for(const child in __stateChildren){
        // check this for inherited states
        if (newState[child]) newState.__children[child] = __stateChildren[child];
        // __stateChildren[child].parent = newState
        Object.getPrototypeOf(__stateChildren[child]).parent = newState;
    }
    return newState;
};
var $468448d3962580bb$export$2e2bcd8739ae039 // save updates history
 // const overwriteChanges = overwriteDeep(element, params, { exclude: METHODS_EXL })
 // // const overwriteChanges = overwriteDeep(element, params)
 // const propsChanges = throughExecProps(element)
 // const execChanges = throughUpdatedExec(element, { ignore: UPDATE_DEFAULT_OPTIONS })
 // const definedChanges = throughUpdatedDefine(element)
 // if (options.stackChanges && ref.__stackChanges) {
 //   const stackChanges = merge(definedChanges, merge(execChanges, overwriteChanges))
 //   ref.__stackChanges.push(stackChanges)
 // }
 = $468448d3962580bb$export$722fbec263ad908a;

});





parcelRegister("jIduG", function(module, exports) {

$parcel$export(module.exports, "data", function () { return $e59c9800c8f449fc$export$4051a07651545597; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");

var $7S1uT = parcelRequire("7S1uT");
'use strict';
function $e59c9800c8f449fc$export$4051a07651545597(params, element, node) {
    if (params) {
        if (element.props.data) (0, $jm0BQ.deepMerge)(params, element.props.data);
        if (params.showOnNode) {
            if (!(0, $amNJ8.isObject)(params)) (0, $7S1uT.report)('HTMLInvalidData', params);
            // Apply data params on node
            for(const dataset in params)if (dataset !== 'showOnNode') node.dataset[dataset] = (0, $jm0BQ.exec)(params[dataset], element);
        }
    }
}
var $e59c9800c8f449fc$export$2e2bcd8739ae039 = $e59c9800c8f449fc$export$4051a07651545597;

});

parcelRegister("3PsYR", function(module, exports) {

$parcel$export(module.exports, "html", function () { return $2c9c9d77430b7091$export$c0bb0b647f701bb5; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
'use strict';
function $2c9c9d77430b7091$export$c0bb0b647f701bb5(param, element, node) {
    const prop = (0, $jm0BQ.exec)(param, element) || (0, $jm0BQ.exec)(element?.props?.html, element);
    const { __ref: __ref } = element;
    if (prop !== __ref.__html) {
        // const parser = new window.DOMParser()
        // param = parser.parseFromString(param, 'text/html')
        if (node.nodeName === 'SVG') node.textContent = prop;
        else node.innerHTML = prop;
        __ref.__html = prop;
    }
}
var $2c9c9d77430b7091$export$2e2bcd8739ae039 = $2c9c9d77430b7091$export$c0bb0b647f701bb5;

});

parcelRegister("2DT68", function(module, exports) {

$parcel$export(module.exports, "style", function () { return $1ec9f697af2b5aff$export$1d567c320f4763bc; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
var $jm0BQ = parcelRequire("jm0BQ");

var $7S1uT = parcelRequire("7S1uT");
'use strict';
function $1ec9f697af2b5aff$export$1d567c320f4763bc(params, element, node) {
    if (params) {
        if ((0, $amNJ8.isObject)(params)) (0, $jm0BQ.map)(node.style, params, element);
        else (0, $7S1uT.report)('HTMLInvalidStyles', params);
    }
}
var $1ec9f697af2b5aff$export$2e2bcd8739ae039 = $1ec9f697af2b5aff$export$1d567c320f4763bc;

});

parcelRegister("dgSmm", function(module, exports) {

$parcel$export(module.exports, "text", function () { return $9a96efaf792b2ae4$export$6f093cfa640b7166; });

var $aWnFx = parcelRequire("aWnFx");
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
function $9a96efaf792b2ae4$export$6f093cfa640b7166(param, element, node) {
    let prop = (0, $jm0BQ.exec)(param, element);
    if ((0, $amNJ8.isString)(prop) && prop.includes('{{')) prop = element.call('replaceLiteralsWithObjectFields', prop);
    if (element.tag === 'string') node.nodeValue = prop;
    else if (param !== undefined || param !== null) {
        if (element.__text) {
            if (element.__text.text === prop) return;
            element.__text.text = prop;
            if (element.__text.node) element.__text.node.nodeValue = prop;
        } else (0, $aWnFx.create)({
            tag: 'string',
            text: prop
        }, element, '__text');
    }
}
var $9a96efaf792b2ae4$export$2e2bcd8739ae039 = $9a96efaf792b2ae4$export$6f093cfa640b7166;

});

parcelRegister("FBHcQ", function(module, exports) {

$parcel$export(module.exports, "state", function () { return $07d11210a0455a89$export$ca000e230c0caa3e; });
parcelRequire("jnoTA");
var $4FK1a = parcelRequire("4FK1a");
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
async function $07d11210a0455a89$export$ca000e230c0caa3e(params, element, node) {
    const state = (0, $jm0BQ.exec)(params, element);
    if ((0, $amNJ8.isObject)(state)) for(const param in state){
        if ((0, $4FK1a.IGNORE_STATE_PARAMS).includes(param)) continue;
        if (!Object.hasOwnProperty.call(state, param)) continue;
    // element.state[param] = exec(state[param], element)
    }
    return element;
}
var $07d11210a0455a89$export$2e2bcd8739ae039 = $07d11210a0455a89$export$ca000e230c0caa3e;

});

parcelRegister("03Uv2", function(module, exports) {

$parcel$export(module.exports, "scope", function () { return $000308b3dbfc7075$export$5cff813ca8e50db9; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
function $000308b3dbfc7075$export$5cff813ca8e50db9(params, element, node) {
    if (!(0, $amNJ8.isObject)(params)) return;
    // Apply data params on node
    for(const scopeItem in params){
        const value = params[scopeItem];
        if ((0, $amNJ8.isFunction)(value)) element.scope[scopeItem] = value.bind(element);
        else element.scope[scopeItem] = value;
    }
}
var $000308b3dbfc7075$export$2e2bcd8739ae039 = $000308b3dbfc7075$export$5cff813ca8e50db9;

});

parcelRegister("6l4Vl", function(module, exports) {

$parcel$export(module.exports, "REGISTRY", function () { return $49d886068ddf20bd$export$21cc2ed387caee94; });
$parcel$export(module.exports, "parseFilters", function () { return $49d886068ddf20bd$export$2f387f690230eab4; });

var $2G8EG = parcelRequire("2G8EG");

var $alKml = parcelRequire("alKml");

var $ggGSI = parcelRequire("ggGSI");

var $jIduG = parcelRequire("jIduG");

var $3PsYR = parcelRequire("3PsYR");

var $03Uv2 = parcelRequire("03Uv2");

var $FBHcQ = parcelRequire("FBHcQ");

var $2DT68 = parcelRequire("2DT68");

var $dgSmm = parcelRequire("dgSmm");
'use strict';
const $49d886068ddf20bd$export$21cc2ed387caee94 = {
    attr: $2G8EG.attr,
    style: $2DT68.style,
    text: $dgSmm.text,
    html: $3PsYR.html,
    content: (0, $ggGSI.setContent),
    data: $jIduG.data,
    class: (0, $alKml.classList),
    state: $FBHcQ.state,
    scope: $03Uv2.scope,
    deps: (param, el)=>param || el.parent.deps,
    extend: {},
    childExtend: {},
    childExtendRecursive: {},
    props: {},
    path: {},
    if: {},
    define: {},
    transform: {},
    __name: {},
    __ref: {},
    __hash: {},
    __text: {},
    nextElement: {},
    previousElement: {},
    key: {},
    tag: {},
    query: {},
    parent: {},
    node: {},
    set: {},
    reset: {},
    update: {},
    error: {},
    warn: {},
    call: {},
    setProps: {},
    remove: {},
    updateContent: {},
    removeContent: {},
    variables: {},
    lookup: {},
    lookdown: {},
    getRef: {},
    getPath: {},
    lookdownAll: {},
    setNodeStyles: {},
    spotByPath: {},
    keys: {},
    log: {},
    parse: {},
    parseDeep: {},
    on: {},
    component: {},
    context: {},
    $collection: {},
    $stateCollection: {},
    $propsCollection: {},
    $setCollection: {},
    $setStateCollection: {},
    $setPropsCollection: {}
};
var $49d886068ddf20bd$export$2e2bcd8739ae039 = $49d886068ddf20bd$export$21cc2ed387caee94;
const $49d886068ddf20bd$export$2f387f690230eab4 = {
    elementKeys: [
        'tag',
        'text',
        'style',
        'attr',
        'class',
        'state',
        'props',
        'data',
        'content',
        'html',
        'on',
        'key',
        'extend',
        'childExtend',
        'childExtendRecursive',
        'scope',
        'query',
        '$collection',
        '$stateCollection',
        '$propsCollection'
    ],
    propsKeys: [
        '__element',
        'update'
    ],
    stateKeys: []
};
const $49d886068ddf20bd$export$9e7e3c1608cc7f28 = [
    '$collection',
    '$stateCollection',
    '$propsCollection'
];

});



parcelRegister("hXdei", function(module, exports) {

$parcel$export(module.exports, "connect", function () { return connect; });
$parcel$export(module.exports, "send", function () { return send; });

var $imR0C = parcelRequire("imR0C");

var $bKatJ = parcelRequire("bKatJ");
'use strict';
const { window, isFunction, isArray } = $imR0C.default || $imR0C;
const defautlOpts = {};
let CONNECT_ATTEPT = 0;
const CONNECT_ATTEPT_MAX_ALLOWED = 1;
const getIsDev = (options)=>{
    return options.development || window && window.location && window.location.host.includes('local') || $imR0C.isNotProduction();
};
const getSocketUrl = (options, isDev)=>{
    const SOCKET_BACKEND_URL = isDev ? 'http://localhost:8080/' : 'https://api.symbols.app/';
    const socketUrls = isArray(options.socketUrl) ? options.socketUrl : [
        options.socketUrl || SOCKET_BACKEND_URL
    ];
    const primaryUrl = socketUrls[0];
    const secondaryUrl = socketUrls[1] || 'api.symbols.app';
    return {
        primaryUrl: primaryUrl || SOCKET_BACKEND_URL,
        secondaryUrl: secondaryUrl
    };
};
const connect = (key, options = {})=>{
    const isDev = getIsDev(options);
    const { primaryUrl, secondaryUrl } = getSocketUrl(options, isDev);
    const socket = (0, $bKatJ.default)(primaryUrl || secondaryUrl, {
    });
    socket.on('connect', ()=>{
        if (isDev) console.warn(`Connected to %c${primaryUrl} %c${key} %c${socket.id}`, 'font-weight: bold; color: green;', 'font-weight: bold;', '');
        socket.emit('initConnect', {
            key: key,
            ...options
        });
        try {
            if (isFunction(options.onConnect)) options.onConnect(socket.id, socket);
        } catch (e) {
            console.error(e);
        }
    });
    socket.on('connect_error', (err)=>{
        console.log(`event: connect_error | reason: ${err.message}`);
        try {
            if (isFunction(options.onError)) options.onError(err, socket);
            if (CONNECT_ATTEPT < CONNECT_ATTEPT_MAX_ALLOWED) {
                CONNECT_ATTEPT++;
                socket.disconnect();
                if ($imR0C.isNotProduction()) console.log('Could not connect to %c' + primaryUrl + '%c, reconnecting to %c' + secondaryUrl, 'font-weight: bold; color: red;', '', 'font-weight: bold; color: green;');
                connect(key, {
                    ...options,
                    socketUrl: secondaryUrl
                });
            }
        } catch (e) {
            console.error(e);
        }
    });
    socket.on('disconnect', (reason)=>{
        console.log(`event: disconnect | reason: ${reason}`);
        try {
            if (isFunction(options.onDisconnect)) options.onDisconnect(reason, socket);
        } catch (e) {
            console.error(e);
        }
    });
    socket.onAny((event, ...args)=>{
        if (event === 'connect') return;
        try {
            if (isFunction(options.onChange)) options.onChange(event, args[0], socket);
        } catch (e) {
            console.error(e);
        }
    });
    return socket;
};
function send(event = 'change', changes, options) {
    this.emit(event, changes, {
        ...options,
        ...defautlOpts
    });
}
function disconnect() {
    this.disconnect();
}

});
parcelRegister("bKatJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88cc1e63c72b633d$export$841407ceb083bd74; });

var $fD4gJ = parcelRequire("fD4gJ");

var $ie43P = parcelRequire("ie43P");

var $c66wv = parcelRequire("c66wv");

var $8yAn1 = parcelRequire("8yAn1");
parcelRequire("jhlyV");
var $lm6pP = parcelRequire("lm6pP");
var $1qVlC = parcelRequire("1qVlC");
var $3pDF6 = parcelRequire("3pDF6");
var $giZTX = parcelRequire("giZTX");
/**
 * Managers cache.
 */ const $88cc1e63c72b633d$var$cache = {};
function $88cc1e63c72b633d$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $fD4gJ.url)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $88cc1e63c72b633d$var$cache[id] && path in $88cc1e63c72b633d$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $ie43P.Manager)(source, opts);
    else {
        if (!$88cc1e63c72b633d$var$cache[id]) $88cc1e63c72b633d$var$cache[id] = new (0, $ie43P.Manager)(source, opts);
        io = $88cc1e63c72b633d$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($88cc1e63c72b633d$export$841407ceb083bd74, {
    Manager: $ie43P.Manager,
    Socket: $c66wv.Socket,
    io: $88cc1e63c72b633d$export$841407ceb083bd74,
    connect: $88cc1e63c72b633d$export$841407ceb083bd74
});

});
parcelRegister("fD4gJ", function(module, exports) {

$parcel$export(module.exports, "url", function () { return $b60dcf3b6bdd15a1$export$128fa18b7194ef; });
parcelRequire("jhlyV");
var $4WsgU = parcelRequire("4WsgU");
function $b60dcf3b6bdd15a1$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $4WsgU.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}

});
parcelRegister("jhlyV", function(module, exports) {

$parcel$export(module.exports, "Socket", function () { return (parcelRequire("5vJgE")).Socket; });
$parcel$export(module.exports, "installTimerFunctions", function () { return (parcelRequire("ehn2L")).installTimerFunctions; });
$parcel$export(module.exports, "parse", function () { return (parcelRequire("4WsgU")).parse; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("2ftBv")).nextTick; });

var $5vJgE = parcelRequire("5vJgE");

var $b22ZK = parcelRequire("b22ZK");

var $2WtcZ = parcelRequire("2WtcZ");

var $ehn2L = parcelRequire("ehn2L");

var $4WsgU = parcelRequire("4WsgU");

var $2ftBv = parcelRequire("2ftBv");

var $lm6pP = parcelRequire("lm6pP");

var $1qVlC = parcelRequire("1qVlC");

var $1qVlC = parcelRequire("1qVlC");

var $3pDF6 = parcelRequire("3pDF6");

var $3pDF6 = parcelRequire("3pDF6");

var $giZTX = parcelRequire("giZTX");
const $e09054b0b0060718$export$a51d6b395ff4c65a = (0, $5vJgE.Socket).protocol;

});
parcelRegister("5vJgE", function(module, exports) {

$parcel$export(module.exports, "Socket", function () { return $4032f62c4c3e96e3$export$4798917dbf149b79; });

var $2WtcZ = parcelRequire("2WtcZ");

var $ehn2L = parcelRequire("ehn2L");

var $4NSvz = parcelRequire("4NSvz");

var $4WsgU = parcelRequire("4WsgU");

var $6SFaY = parcelRequire("6SFaY");

var $lORpY = parcelRequire("lORpY");

var $2ftBv = parcelRequire("2ftBv");
const $4032f62c4c3e96e3$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $4032f62c4c3e96e3$var$OFFLINE_EVENT_LISTENERS = [];
if ($4032f62c4c3e96e3$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $4032f62c4c3e96e3$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $4032f62c4c3e96e3$export$3874118029a0ee0d extends (0, $6SFaY.Emitter) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $2ftBv.defaultBinaryType);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $4WsgU.parse)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $4WsgU.parse)(opts.host).host;
        (0, $ehn2L.installTimerFunctions)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $4NSvz.decode)(this.opts.query);
        if ($4032f62c4c3e96e3$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $4032f62c4c3e96e3$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $2ftBv.createCookieJar)();
        this._open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $lORpY.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $4032f62c4c3e96e3$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $4032f62c4c3e96e3$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $ehn2L.byteLength)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $2ftBv.nextTick)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $4032f62c4c3e96e3$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($4032f62c4c3e96e3$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $4032f62c4c3e96e3$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $4032f62c4c3e96e3$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
}
$4032f62c4c3e96e3$export$3874118029a0ee0d.protocol = (0, $lORpY.protocol);
class $4032f62c4c3e96e3$export$cc521fcb1004e85c extends $4032f62c4c3e96e3$export$3874118029a0ee0d {
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $4032f62c4c3e96e3$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $4032f62c4c3e96e3$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
class $4032f62c4c3e96e3$export$4798917dbf149b79 extends $4032f62c4c3e96e3$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const o = typeof uri === "object" ? uri : opts;
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $2WtcZ.transports)[transportName]).filter((t)=>!!t);
        super(uri, o);
    }
}

});
parcelRegister("2WtcZ", function(module, exports) {

$parcel$export(module.exports, "transports", function () { return $2247a7bbcfd116f9$export$46dec00755c1153b; });

var $1qVlC = parcelRequire("1qVlC");

var $3pDF6 = parcelRequire("3pDF6");

var $giZTX = parcelRequire("giZTX");
const $2247a7bbcfd116f9$export$46dec00755c1153b = {
    websocket: (0, $3pDF6.WS),
    webtransport: (0, $giZTX.WT),
    polling: (0, $1qVlC.XHR)
};

});
parcelRegister("1qVlC", function(module, exports) {

$parcel$export(module.exports, "XHR", function () { return $10b4b434dee9668d$export$a2d42eb087c10497; });

var $i8vPX = parcelRequire("i8vPX");

var $6SFaY = parcelRequire("6SFaY");

var $ehn2L = parcelRequire("ehn2L");

var $2ftBv = parcelRequire("2ftBv");

var $fDNr5 = parcelRequire("fDNr5");
function $10b4b434dee9668d$var$empty() {}
class $10b4b434dee9668d$export$c959f2344155d309 extends (0, $i8vPX.Polling) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $10b4b434dee9668d$export$7fa6c5b6f8193917 extends (0, $6SFaY.Emitter) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $ehn2L.installTimerFunctions)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $ehn2L.pick)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $10b4b434dee9668d$export$7fa6c5b6f8193917.requestsCount++;
            $10b4b434dee9668d$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $10b4b434dee9668d$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $10b4b434dee9668d$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
}
$10b4b434dee9668d$export$7fa6c5b6f8193917.requestsCount = 0;
$10b4b434dee9668d$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $10b4b434dee9668d$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $2ftBv.globalThisShim) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $10b4b434dee9668d$var$unloadHandler, false);
    }
}
function $10b4b434dee9668d$var$unloadHandler() {
    for(let i in $10b4b434dee9668d$export$7fa6c5b6f8193917.requests)if ($10b4b434dee9668d$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $10b4b434dee9668d$export$7fa6c5b6f8193917.requests[i].abort();
}
const $10b4b434dee9668d$var$hasXHR2 = function() {
    const xhr = $10b4b434dee9668d$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $10b4b434dee9668d$export$a2d42eb087c10497 extends $10b4b434dee9668d$export$c959f2344155d309 {
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $10b4b434dee9668d$var$hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $10b4b434dee9668d$export$7fa6c5b6f8193917($10b4b434dee9668d$var$newRequest, this.uri(), opts);
    }
}
function $10b4b434dee9668d$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $fDNr5.hasCORS))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $2ftBv.globalThisShim)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}

});
parcelRegister("i8vPX", function(module, exports) {

$parcel$export(module.exports, "Polling", function () { return $d341ab83d6c3fd2c$export$265ee5eefd4c309b; });

var $b22ZK = parcelRequire("b22ZK");

var $ehn2L = parcelRequire("ehn2L");

var $lORpY = parcelRequire("lORpY");
class $d341ab83d6c3fd2c$export$265ee5eefd4c309b extends (0, $b22ZK.Transport) {
    constructor(){
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $lORpY.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $lORpY.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $ehn2L.randomString)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
}

});
parcelRegister("b22ZK", function(module, exports) {

$parcel$export(module.exports, "Transport", function () { return $80823453e94ee362$export$86495b081fef8e52; });
parcelRequire("lORpY");
var $6Jcu7 = parcelRequire("6Jcu7");

var $6SFaY = parcelRequire("6SFaY");

var $ehn2L = parcelRequire("ehn2L");

var $4NSvz = parcelRequire("4NSvz");
class $80823453e94ee362$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $80823453e94ee362$export$86495b081fef8e52 extends (0, $6SFaY.Emitter) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $ehn2L.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $80823453e94ee362$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $6Jcu7.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $4NSvz.encode)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}

});
parcelRegister("lORpY", function(module, exports) {

$parcel$export(module.exports, "encodePayload", function () { return $fe27b42f62a0b23a$export$144d64fe58dad441; });
$parcel$export(module.exports, "decodePayload", function () { return $fe27b42f62a0b23a$export$d10cc2e7f7566a2d; });
$parcel$export(module.exports, "createPacketEncoderStream", function () { return $fe27b42f62a0b23a$export$a525fb718e9c623a; });
$parcel$export(module.exports, "createPacketDecoderStream", function () { return $fe27b42f62a0b23a$export$552d20aac7500f47; });
$parcel$export(module.exports, "protocol", function () { return $fe27b42f62a0b23a$export$a51d6b395ff4c65a; });
$parcel$export(module.exports, "encodePacket", function () { return (parcelRequire("4EScm")).encodePacket; });
$parcel$export(module.exports, "decodePacket", function () { return (parcelRequire("6Jcu7")).decodePacket; });

var $4EScm = parcelRequire("4EScm");

var $6Jcu7 = parcelRequire("6Jcu7");

var $lllT5 = parcelRequire("lllT5");
const $fe27b42f62a0b23a$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $fe27b42f62a0b23a$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $4EScm.encodePacket)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($fe27b42f62a0b23a$var$SEPARATOR));
        });
    });
};
const $fe27b42f62a0b23a$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($fe27b42f62a0b23a$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $6Jcu7.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $fe27b42f62a0b23a$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $4EScm.encodePacketToBinary)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $fe27b42f62a0b23a$var$TEXT_DECODER;
function $fe27b42f62a0b23a$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $fe27b42f62a0b23a$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $fe27b42f62a0b23a$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$fe27b42f62a0b23a$var$TEXT_DECODER) $fe27b42f62a0b23a$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($fe27b42f62a0b23a$var$totalLength(chunks) < 1) break;
                    const header = $fe27b42f62a0b23a$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($fe27b42f62a0b23a$var$totalLength(chunks) < 2) break;
                    const headerArray = $fe27b42f62a0b23a$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($fe27b42f62a0b23a$var$totalLength(chunks) < 8) break;
                    const headerArray = $fe27b42f62a0b23a$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $lllT5.ERROR_PACKET));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($fe27b42f62a0b23a$var$totalLength(chunks) < expectedLength) break;
                    const data = $fe27b42f62a0b23a$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $6Jcu7.decodePacket)(isBinary ? data : $fe27b42f62a0b23a$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $lllT5.ERROR_PACKET));
                    break;
                }
            }
        }
    });
}
const $fe27b42f62a0b23a$export$a51d6b395ff4c65a = 4;

});
parcelRegister("4EScm", function(module, exports) {

$parcel$export(module.exports, "encodePacket", function () { return $3644f08176c9f2bb$export$57852049361a8e62; });
$parcel$export(module.exports, "encodePacketToBinary", function () { return $3644f08176c9f2bb$export$ec0c9b9013ee0ef5; });

var $lllT5 = parcelRequire("lllT5");
const $3644f08176c9f2bb$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $3644f08176c9f2bb$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $3644f08176c9f2bb$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $3644f08176c9f2bb$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($3644f08176c9f2bb$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $3644f08176c9f2bb$var$encodeBlobAsBase64(data, callback);
    } else if ($3644f08176c9f2bb$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $3644f08176c9f2bb$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $3644f08176c9f2bb$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $lllT5.PACKET_TYPES)[type] + (data || ""));
};
const $3644f08176c9f2bb$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $3644f08176c9f2bb$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $3644f08176c9f2bb$var$TEXT_ENCODER;
function $3644f08176c9f2bb$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($3644f08176c9f2bb$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($3644f08176c9f2bb$var$toArray).then(callback);
    else if ($3644f08176c9f2bb$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $3644f08176c9f2bb$var$isView(packet.data))) return callback($3644f08176c9f2bb$var$toArray(packet.data));
    $3644f08176c9f2bb$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$3644f08176c9f2bb$var$TEXT_ENCODER) $3644f08176c9f2bb$var$TEXT_ENCODER = new TextEncoder();
        callback($3644f08176c9f2bb$var$TEXT_ENCODER.encode(encoded));
    });
}

});
parcelRegister("lllT5", function(module, exports) {

$parcel$export(module.exports, "PACKET_TYPES", function () { return $f89c8989af59e866$export$c169aefb7330cccb; });
$parcel$export(module.exports, "PACKET_TYPES_REVERSE", function () { return $f89c8989af59e866$export$47791e8004edd485; });
$parcel$export(module.exports, "ERROR_PACKET", function () { return $f89c8989af59e866$export$c718b5840781f8a7; });
const $f89c8989af59e866$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$f89c8989af59e866$export$c169aefb7330cccb["open"] = "0";
$f89c8989af59e866$export$c169aefb7330cccb["close"] = "1";
$f89c8989af59e866$export$c169aefb7330cccb["ping"] = "2";
$f89c8989af59e866$export$c169aefb7330cccb["pong"] = "3";
$f89c8989af59e866$export$c169aefb7330cccb["message"] = "4";
$f89c8989af59e866$export$c169aefb7330cccb["upgrade"] = "5";
$f89c8989af59e866$export$c169aefb7330cccb["noop"] = "6";
const $f89c8989af59e866$export$47791e8004edd485 = Object.create(null);
Object.keys($f89c8989af59e866$export$c169aefb7330cccb).forEach((key)=>{
    $f89c8989af59e866$export$47791e8004edd485[$f89c8989af59e866$export$c169aefb7330cccb[key]] = key;
});
const $f89c8989af59e866$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};

});


parcelRegister("6Jcu7", function(module, exports) {

$parcel$export(module.exports, "decodePacket", function () { return $4e60a1440030b1e5$export$4647901878f33f31; });

var $lllT5 = parcelRequire("lllT5");

var $fjza0 = parcelRequire("fjza0");
const $4e60a1440030b1e5$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $4e60a1440030b1e5$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $4e60a1440030b1e5$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $4e60a1440030b1e5$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $lllT5.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, $lllT5.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, $lllT5.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $lllT5.PACKET_TYPES_REVERSE)[type]
    };
};
const $4e60a1440030b1e5$var$decodeBase64Packet = (data, binaryType)=>{
    if ($4e60a1440030b1e5$var$withNativeArrayBuffer) {
        const decoded = (0, $fjza0.decode)(data);
        return $4e60a1440030b1e5$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $4e60a1440030b1e5$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};

});
parcelRegister("fjza0", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $b263e77ac5d93d43$export$2f872c0f2117be69; });
// imported from https://github.com/socketio/base64-arraybuffer
const $b263e77ac5d93d43$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $b263e77ac5d93d43$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $b263e77ac5d93d43$var$chars.length; i++)$b263e77ac5d93d43$var$lookup[$b263e77ac5d93d43$var$chars.charCodeAt(i)] = i;
const $b263e77ac5d93d43$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $b263e77ac5d93d43$var$chars[bytes[i] >> 2];
        base64 += $b263e77ac5d93d43$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $b263e77ac5d93d43$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $b263e77ac5d93d43$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $b263e77ac5d93d43$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $b263e77ac5d93d43$var$lookup[base64.charCodeAt(i)];
        encoded2 = $b263e77ac5d93d43$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $b263e77ac5d93d43$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $b263e77ac5d93d43$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};

});



parcelRegister("6SFaY", function(module, exports) {

$parcel$export(module.exports, "Emitter", function () { return $5027b9ef9f081362$export$4293555f241ae35a; });
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $5027b9ef9f081362$export$4293555f241ae35a(obj) {
    if (obj) return $5027b9ef9f081362$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $5027b9ef9f081362$var$mixin(obj) {
    for(var key in $5027b9ef9f081362$export$4293555f241ae35a.prototype)obj[key] = $5027b9ef9f081362$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $5027b9ef9f081362$export$4293555f241ae35a.prototype.on = $5027b9ef9f081362$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $5027b9ef9f081362$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $5027b9ef9f081362$export$4293555f241ae35a.prototype.off = $5027b9ef9f081362$export$4293555f241ae35a.prototype.removeListener = $5027b9ef9f081362$export$4293555f241ae35a.prototype.removeAllListeners = $5027b9ef9f081362$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $5027b9ef9f081362$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$5027b9ef9f081362$export$4293555f241ae35a.prototype.emitReserved = $5027b9ef9f081362$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $5027b9ef9f081362$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $5027b9ef9f081362$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("ehn2L", function(module, exports) {

$parcel$export(module.exports, "pick", function () { return $a654872df0a37236$export$357523c63a2253b9; });
$parcel$export(module.exports, "installTimerFunctions", function () { return $a654872df0a37236$export$2f67576668b97183; });
$parcel$export(module.exports, "byteLength", function () { return $a654872df0a37236$export$a48f0734ac7c2329; });
$parcel$export(module.exports, "randomString", function () { return $a654872df0a37236$export$7fa8378418b4411e; });

var $2ftBv = parcelRequire("2ftBv");
function $a654872df0a37236$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $a654872df0a37236$var$NATIVE_SET_TIMEOUT = (0, $2ftBv.globalThisShim).setTimeout;
const $a654872df0a37236$var$NATIVE_CLEAR_TIMEOUT = (0, $2ftBv.globalThisShim).clearTimeout;
function $a654872df0a37236$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $a654872df0a37236$var$NATIVE_SET_TIMEOUT.bind((0, $2ftBv.globalThisShim));
        obj.clearTimeoutFn = $a654872df0a37236$var$NATIVE_CLEAR_TIMEOUT.bind((0, $2ftBv.globalThisShim));
    } else {
        obj.setTimeoutFn = (0, $2ftBv.globalThisShim).setTimeout.bind((0, $2ftBv.globalThisShim));
        obj.clearTimeoutFn = (0, $2ftBv.globalThisShim).clearTimeout.bind((0, $2ftBv.globalThisShim));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $a654872df0a37236$var$BASE64_OVERHEAD = 1.33;
function $a654872df0a37236$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $a654872df0a37236$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $a654872df0a37236$var$BASE64_OVERHEAD);
}
function $a654872df0a37236$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $a654872df0a37236$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}

});
parcelRegister("2ftBv", function(module, exports) {

$parcel$export(module.exports, "nextTick", function () { return $1a33f23aee47623c$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "globalThisShim", function () { return $1a33f23aee47623c$export$394f9358f6231289; });
$parcel$export(module.exports, "defaultBinaryType", function () { return $1a33f23aee47623c$export$790dcbc41e2d75d5; });
$parcel$export(module.exports, "createCookieJar", function () { return $1a33f23aee47623c$export$19413efcf2fac759; });
const $1a33f23aee47623c$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $1a33f23aee47623c$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $1a33f23aee47623c$export$790dcbc41e2d75d5 = "arraybuffer";
function $1a33f23aee47623c$export$19413efcf2fac759() {}

});


parcelRegister("4NSvz", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $37f6053cae6389f0$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $37f6053cae6389f0$export$2f872c0f2117be69; });
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $37f6053cae6389f0$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $37f6053cae6389f0$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}

});



parcelRegister("fDNr5", function(module, exports) {

$parcel$export(module.exports, "hasCORS", function () { return $b630d87d7a1aee8b$export$5235bbd4a1ef06e; });
// imported from https://github.com/component/has-cors
let $b630d87d7a1aee8b$var$value = false;
try {
    $b630d87d7a1aee8b$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $b630d87d7a1aee8b$export$5235bbd4a1ef06e = $b630d87d7a1aee8b$var$value;

});


parcelRegister("3pDF6", function(module, exports) {

$parcel$export(module.exports, "WS", function () { return $27c278f171ec7d18$export$911baa0677ac404c; });

var $b22ZK = parcelRequire("b22ZK");

var $ehn2L = parcelRequire("ehn2L");
parcelRequire("lORpY");
var $4EScm = parcelRequire("4EScm");

var $2ftBv = parcelRequire("2ftBv");
// detect ReactNative environment
const $27c278f171ec7d18$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $27c278f171ec7d18$export$570bf71d2367e261 extends (0, $b22ZK.Transport) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $27c278f171ec7d18$var$isReactNative ? {} : (0, $ehn2L.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $4EScm.encodePacket)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $2ftBv.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $ehn2L.randomString)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $27c278f171ec7d18$var$WebSocketCtor = (0, $2ftBv.globalThisShim).WebSocket || (0, $2ftBv.globalThisShim).MozWebSocket;
class $27c278f171ec7d18$export$911baa0677ac404c extends $27c278f171ec7d18$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$27c278f171ec7d18$var$isReactNative ? protocols ? new $27c278f171ec7d18$var$WebSocketCtor(uri, protocols) : new $27c278f171ec7d18$var$WebSocketCtor(uri) : new $27c278f171ec7d18$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}

});

parcelRegister("giZTX", function(module, exports) {

$parcel$export(module.exports, "WT", function () { return $bdee58236f217b97$export$961c930859384407; });

var $b22ZK = parcelRequire("b22ZK");

var $2ftBv = parcelRequire("2ftBv");

var $lORpY = parcelRequire("lORpY");
class $bdee58236f217b97$export$961c930859384407 extends (0, $b22ZK.Transport) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $lORpY.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $lORpY.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $2ftBv.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}

});


parcelRegister("4WsgU", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $39928263f1ba56b8$export$98e6a39c04603d36; });
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $39928263f1ba56b8$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $39928263f1ba56b8$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $39928263f1ba56b8$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $39928263f1ba56b8$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$39928263f1ba56b8$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $39928263f1ba56b8$var$pathNames(uri, uri['path']);
    uri.queryKey = $39928263f1ba56b8$var$queryKey(uri, uri['query']);
    return uri;
}
function $39928263f1ba56b8$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $39928263f1ba56b8$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}

});


parcelRegister("lm6pP", function(module, exports) {

var $i8vPX = parcelRequire("i8vPX");
class $f8c0a10704525998$export$1e7deca84b429035 extends (0, $i8vPX.Polling) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}

});



parcelRegister("ie43P", function(module, exports) {

$parcel$export(module.exports, "Manager", function () { return $d44caf2a0ad00b98$export$d0d38e7dec7a1a61; });
parcelRequire("jhlyV");
var $ehn2L = parcelRequire("ehn2L");
var $2ftBv = parcelRequire("2ftBv");
var $5vJgE = parcelRequire("5vJgE");

var $c66wv = parcelRequire("c66wv");

var $8yAn1 = parcelRequire("8yAn1");

var $g8OGO = parcelRequire("g8OGO");

var $bkw80 = parcelRequire("bkw80");

var $6SFaY = parcelRequire("6SFaY");
class $d44caf2a0ad00b98$export$d0d38e7dec7a1a61 extends (0, $6SFaY.Emitter) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $ehn2L.installTimerFunctions)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $bkw80.Backoff)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $8yAn1;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $5vJgE.Socket)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $g8OGO.on)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $g8OGO.on)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $g8OGO.on)(socket, "ping", this.onping.bind(this)), (0, $g8OGO.on)(socket, "data", this.ondata.bind(this)), (0, $g8OGO.on)(socket, "error", this.onerror.bind(this)), (0, $g8OGO.on)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $g8OGO.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $2ftBv.nextTick)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $c66wv.Socket)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}

});
parcelRegister("c66wv", function(module, exports) {

$parcel$export(module.exports, "Socket", function () { return $8ceb1af91e646b90$export$4798917dbf149b79; });

var $8yAn1 = parcelRequire("8yAn1");

var $g8OGO = parcelRequire("g8OGO");

var $6SFaY = parcelRequire("6SFaY");
/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $8ceb1af91e646b90$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $8ceb1af91e646b90$export$4798917dbf149b79 extends (0, $6SFaY.Emitter) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $g8OGO.on)(io, "open", this.onopen.bind(this)),
            (0, $g8OGO.on)(io, "packet", this.onpacket.bind(this)),
            (0, $g8OGO.on)(io, "error", this.onerror.bind(this)),
            (0, $g8OGO.on)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($8ceb1af91e646b90$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $8yAn1.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $8yAn1.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $8yAn1.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $8yAn1.PacketType).EVENT:
            case (0, $8yAn1.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $8yAn1.PacketType).ACK:
            case (0, $8yAn1.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $8yAn1.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $8yAn1.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $8yAn1.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $8yAn1.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}

});
parcelRegister("8yAn1", function(module, exports) {

$parcel$export(module.exports, "protocol", function () { return $63adb61906b50c52$export$a51d6b395ff4c65a; });
$parcel$export(module.exports, "PacketType", function () { return $63adb61906b50c52$export$84d4095e16c6fc19; });
$parcel$export(module.exports, "Encoder", function () { return $63adb61906b50c52$export$a50aceb0e02a00aa; });
$parcel$export(module.exports, "Decoder", function () { return $63adb61906b50c52$export$f9de6ca0bc043724; });

var $6SFaY = parcelRequire("6SFaY");

var $hENnX = parcelRequire("hENnX");

var $f7XFA = parcelRequire("f7XFA");
/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $63adb61906b50c52$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $63adb61906b50c52$export$a51d6b395ff4c65a = 5;
var $63adb61906b50c52$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($63adb61906b50c52$export$84d4095e16c6fc19 || ($63adb61906b50c52$export$84d4095e16c6fc19 = {}));
class $63adb61906b50c52$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $63adb61906b50c52$export$84d4095e16c6fc19.EVENT || obj.type === $63adb61906b50c52$export$84d4095e16c6fc19.ACK) {
            if ((0, $f7XFA.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === $63adb61906b50c52$export$84d4095e16c6fc19.EVENT ? $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_EVENT : $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $hENnX.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $63adb61906b50c52$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $63adb61906b50c52$export$f9de6ca0bc043724 extends (0, $6SFaY.Emitter) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $63adb61906b50c52$export$84d4095e16c6fc19.EVENT : $63adb61906b50c52$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $63adb61906b50c52$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $f7XFA.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($63adb61906b50c52$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($63adb61906b50c52$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $63adb61906b50c52$export$84d4095e16c6fc19.CONNECT:
                return $63adb61906b50c52$var$isObject(payload);
            case $63adb61906b50c52$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $63adb61906b50c52$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $63adb61906b50c52$var$isObject(payload);
            case $63adb61906b50c52$export$84d4095e16c6fc19.EVENT:
            case $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $63adb61906b50c52$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $63adb61906b50c52$export$84d4095e16c6fc19.ACK:
            case $63adb61906b50c52$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $63adb61906b50c52$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $hENnX.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}

});
parcelRegister("hENnX", function(module, exports) {

$parcel$export(module.exports, "deconstructPacket", function () { return $cdac7b05a4bd2e81$export$ac2edb9eb7af56f6; });
$parcel$export(module.exports, "reconstructPacket", function () { return $cdac7b05a4bd2e81$export$a00da3b1ec037a04; });

var $f7XFA = parcelRequire("f7XFA");
function $cdac7b05a4bd2e81$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $cdac7b05a4bd2e81$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $cdac7b05a4bd2e81$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $f7XFA.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $cdac7b05a4bd2e81$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $cdac7b05a4bd2e81$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $cdac7b05a4bd2e81$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $cdac7b05a4bd2e81$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $cdac7b05a4bd2e81$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $cdac7b05a4bd2e81$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $cdac7b05a4bd2e81$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}

});
parcelRegister("f7XFA", function(module, exports) {

$parcel$export(module.exports, "isBinary", function () { return $b035cba5787ae96b$export$37488ff1135b1696; });
$parcel$export(module.exports, "hasBinary", function () { return $b035cba5787ae96b$export$5234c529abdb5610; });
const $b035cba5787ae96b$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $b035cba5787ae96b$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $b035cba5787ae96b$var$toString = Object.prototype.toString;
const $b035cba5787ae96b$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $b035cba5787ae96b$var$toString.call(Blob) === "[object BlobConstructor]";
const $b035cba5787ae96b$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $b035cba5787ae96b$var$toString.call(File) === "[object FileConstructor]";
function $b035cba5787ae96b$export$37488ff1135b1696(obj) {
    return $b035cba5787ae96b$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $b035cba5787ae96b$var$isView(obj)) || $b035cba5787ae96b$var$withNativeBlob && obj instanceof Blob || $b035cba5787ae96b$var$withNativeFile && obj instanceof File;
}
function $b035cba5787ae96b$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($b035cba5787ae96b$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($b035cba5787ae96b$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $b035cba5787ae96b$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $b035cba5787ae96b$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}

});



parcelRegister("g8OGO", function(module, exports) {

$parcel$export(module.exports, "on", function () { return $bc04b69669b9ce9d$export$af631764ddc44097; });
function $bc04b69669b9ce9d$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}

});


parcelRegister("bkw80", function(module, exports) {

$parcel$export(module.exports, "Backoff", function () { return $83fa7bebd0a5dbe3$export$2d38012449449c89; });
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $83fa7bebd0a5dbe3$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $83fa7bebd0a5dbe3$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $83fa7bebd0a5dbe3$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $83fa7bebd0a5dbe3$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $83fa7bebd0a5dbe3$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $83fa7bebd0a5dbe3$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

});




parcelRegister("e0lzv", function(module, exports) {
module.exports = $parcel$resolve("70TDA");

});

parcelRegister("d3KIO", function(module, exports) {
module.exports = $parcel$resolve("42UX4");

});

parcelRegister("eUB2h", function(module, exports) {
module.exports = $parcel$resolve("k2iKq");

});

parcelRegister("hNfSb", function(module, exports) {
module.exports = $parcel$resolve("bOxpd");

});

parcelRegister("9Ap7e", function(module, exports) {
module.exports = $parcel$resolve("6ptcc");

});

parcelRegister("7JFDg", function(module, exports) {
module.exports = $parcel$resolve("jTWCH");

});

parcelRegister("dHL6K", function(module, exports) {
module.exports = $parcel$resolve("1ScDi");

});

parcelRegister("7pjFq", function(module, exports) {
module.exports = $parcel$resolve("jtHD2");

});

parcelRegister("e3aXB", function(module, exports) {
module.exports = $parcel$resolve("dqDQ4");

});

parcelRegister("8vbB0", function(module, exports) {
module.exports = $parcel$resolve("h3CrW");

});

parcelRegister("yRj0w", function(module, exports) {
module.exports = $parcel$resolve("28WOR");

});

parcelRegister("3EKvT", function(module, exports) {
module.exports = $parcel$resolve("dvRkW");

});

parcelRegister("kE4z0", function(module, exports) {
module.exports = $parcel$resolve("bSqB0");

});

parcelRegister("z0Skz", function(module, exports) {
module.exports = $parcel$resolve("13pn1");

});

parcelRegister("dsqxM", function(module, exports) {
module.exports = $parcel$resolve("5FF9h");

});

parcelRegister("7OO2T", function(module, exports) {
module.exports = $parcel$resolve("ax6Qw");

});

parcelRegister("bMQZX", function(module, exports) {
module.exports = $parcel$resolve("9cWr0");

});

parcelRegister("6fPSc", function(module, exports) {
module.exports = $parcel$resolve("efCtJ");

});

parcelRegister("8ZAo9", function(module, exports) {
module.exports = $parcel$resolve("1Gzla");

});

parcelRegister("AMokA", function(module, exports) {
module.exports = $parcel$resolve("1Oj90");

});

parcelRegister("5dUGz", function(module, exports) {
module.exports = $parcel$resolve("hB6EK");

});

parcelRegister("g5qZ0", function(module, exports) {
module.exports = $parcel$resolve("aF7QO");

});

parcelRegister("76EwH", function(module, exports) {
module.exports = $parcel$resolve("5lZjE");

});

parcelRegister("aVA6c", function(module, exports) {
module.exports = $parcel$resolve("fd8ck");

});

parcelRegister("bqvPv", function(module, exports) {
module.exports = $parcel$resolve("rPB0K");

});

parcelRegister("4pPjC", function(module, exports) {
module.exports = $parcel$resolve("6XY9g");

});

parcelRegister("6gZUK", function(module, exports) {
module.exports = $parcel$resolve("5veMo");

});

parcelRegister("kXKuk", function(module, exports) {
module.exports = $parcel$resolve("alYJZ");

});

parcelRegister("eTVvk", function(module, exports) {
module.exports = $parcel$resolve("fOapO");

});

parcelRegister("79NoA", function(module, exports) {
module.exports = $parcel$resolve("1S16S");

});

parcelRegister("i7K7z", function(module, exports) {
module.exports = $parcel$resolve("j6UAX");

});

parcelRegister("j32f0", function(module, exports) {
module.exports = $parcel$resolve("je46V");

});

parcelRegister("hHkz5", function(module, exports) {
module.exports = $parcel$resolve("iXLaJ");

});

parcelRegister("gVrTn", function(module, exports) {
module.exports = $parcel$resolve("f3UHr");

});

parcelRegister("7iEp3", function(module, exports) {
module.exports = $parcel$resolve("4rUKi");

});

parcelRegister("h7gho", function(module, exports) {
module.exports = $parcel$resolve("cFDWH");

});

parcelRegister("86RIu", function(module, exports) {
module.exports = $parcel$resolve("d9lZh");

});

var $97c2cf27b06bb3a4$exports = {};
$parcel$extendImportMap({
    "70TDA": "logo.92d76f39.svg",
    "42UX4": "arrow-down-circle.ef009e0c.svg",
    "k2iKq": "arrow-down-left.94d6af99.svg",
    "bOxpd": "arrow-down-right.64c53515.svg",
    "6ptcc": "arrow-down.6fd3e4b0.svg",
    "jTWCH": "arrow-left-circle.05631555.svg",
    "1ScDi": "arrow-left.98e167d1.svg",
    "jtHD2": "arrow-right.fdcccf3e.svg",
    "dqDQ4": "arrow-right-circle.30620e9f.svg",
    "h3CrW": "arrow-up-circle.7d9d0303.svg",
    "28WOR": "arrow-up-left.9e0f069a.svg",
    "dvRkW": "arrow-up-right.374e2251.svg",
    "bSqB0": "arrow-up.1d8f1bfa.svg",
    "13pn1": "check-circle.b4c11b26.svg",
    "5FF9h": "check.b4b96e1e.svg",
    "ax6Qw": "chevron-down.31f65087.svg",
    "9cWr0": "chevron-left.5ce2e5f2.svg",
    "efCtJ": "chevron-right.7d91ca1b.svg",
    "1Gzla": "chevron-up.f4c166d6.svg",
    "1Oj90": "copy.1516e3b0.svg",
    "hB6EK": "eye-off.a43b41de.svg",
    "aF7QO": "eye.18c33836.svg",
    "5lZjE": "info.4c464ca8.svg",
    "fd8ck": "lock.86664a9f.svg",
    "rPB0K": "minus.cd8efe2e.svg",
    "6XY9g": "sun.a425a1f7.svg",
    "5veMo": "moon.5b8b4f7c.svg",
    "alYJZ": "more-horizontal.0b63abef.svg",
    "fOapO": "more-vertical.e2e668fa.svg",
    "1S16S": "send.21b5c6dd.svg",
    "j6UAX": "smile.e74a3482.svg",
    "je46V": "star.42edb234.svg",
    "iXLaJ": "search.8223c77b.svg",
    "f3UHr": "upload.43f4e46b.svg",
    "4rUKi": "video.6da83bc4.svg",
    "cFDWH": "x.5db029e6.svg",
    "d9lZh": "plus.ecc041f9.svg"
});

var $15823c83ee6e64a1$exports = {};

var $imR0C = parcelRequire("imR0C");
var $97f45980f9c117e0$exports = {};

$parcel$export($97f45980f9c117e0$exports, "ARIA_ROLES", function () { return $97f45980f9c117e0$export$147ca7d289c2f7de; });
$parcel$export($97f45980f9c117e0$exports, "HTML_ATTRIBUTES", function () { return $97f45980f9c117e0$export$a073516cf3506ae6; });
$parcel$export($97f45980f9c117e0$exports, "DOM_EVENTS", function () { return $97f45980f9c117e0$export$f552dbb36ef6b3dd; });
$parcel$export($97f45980f9c117e0$exports, "checkAttributeByTagName", function () { return $97f45980f9c117e0$export$3c670b34323f5417; });
$parcel$export($97f45980f9c117e0$exports, "checkEventFunctions", function () { return $97f45980f9c117e0$export$12ab4f1a89970119; });
$parcel$export($97f45980f9c117e0$exports, "filterAttributesByTagName", function () { return $97f45980f9c117e0$export$a3d5d5e1a17535c6; });
$parcel$export($97f45980f9c117e0$exports, "executeAttr", function () { return $97f45980f9c117e0$export$a420285f97b772db; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $97f45980f9c117e0$export$147ca7d289c2f7de = [
    'alert',
    'alertdialog',
    'application',
    'article',
    'banner',
    'button',
    'cell',
    'checkbox',
    'columnheader',
    'combobox',
    'complementary',
    'contentinfo',
    'definition',
    'dialog',
    'directory',
    'document',
    'feed',
    'figure',
    'form',
    'grid',
    'gridcell',
    'group',
    'heading',
    'img',
    'link',
    'list',
    'listbox',
    'listitem',
    'log',
    'main',
    'marquee',
    'math',
    'menu',
    'menubar',
    'menuitem',
    'menuitemcheckbox',
    'menuitemradio',
    'navigation',
    'none',
    'note',
    'option',
    'presentation',
    'progressbar',
    'radio',
    'radiogroup',
    'region',
    'row',
    'rowgroup',
    'rowheader',
    'scrollbar',
    'search',
    'searchbox',
    'separator',
    'slider',
    'spinbutton',
    'status',
    'switch',
    'tab',
    'table',
    'tablist',
    'tabpanel',
    'term',
    'textbox',
    'timer',
    'toolbar',
    'tooltip',
    'tree',
    'treegrid',
    'treeitem'
];
const $97f45980f9c117e0$export$a073516cf3506ae6 = {
    default: [
        'accesskey',
        'autofocus',
        'class',
        'contenteditable',
        'contextmenu',
        'dir',
        'draggable',
        'hidden',
        'id',
        'lang',
        'part',
        'placeholder',
        'slot',
        'spellcheck',
        'style',
        'tabindex',
        'title',
        'translate',
        'inert',
        'radiogroup',
        'role',
        'about',
        'datatype',
        'inlist',
        'prefix',
        'property',
        'resource',
        'typeof',
        'vocab',
        'autocapitalize',
        'autocorrect',
        'autosave',
        'color',
        'itemprop',
        'itemscope',
        'itemtype',
        'itemid',
        'itemref',
        'results',
        'security',
        'unselectable',
        'is'
    ],
    a: [
        'accesskey',
        'charset',
        'coords',
        'download',
        'href',
        'hreflang',
        'name',
        'rel',
        'rev',
        'shape',
        'target',
        'type'
    ],
    aria: [
        'aria-activedescendant',
        'aria-atomic',
        'aria-autocomplete',
        'aria-checked',
        'aria-colcount',
        'aria-colindex',
        'aria-colspan',
        'aria-controls',
        'aria-current',
        'aria-describedby',
        'aria-details',
        'aria-dropeffect',
        'aria-errormessage',
        'aria-expanded',
        'aria-flowto',
        'aria-grabbed',
        'aria-haspopup',
        'aria-hidden',
        'aria-invalid',
        'aria-keyshortcuts',
        'aria-label',
        'aria-labelledby',
        'aria-level',
        'aria-live',
        'aria-modal',
        'aria-multiline',
        'aria-multiselectable',
        'aria-orientation',
        'aria-owns',
        'aria-placeholder',
        'aria-posinset',
        'aria-pressed',
        'aria-readonly',
        'aria-relevant',
        'aria-required',
        'aria-roledescription',
        'aria-rowcount',
        'aria-rowindex',
        'aria-rowspan',
        'aria-selected',
        'aria-setsize',
        'aria-sort',
        'aria-valuemax',
        'aria-valuemin',
        'aria-valuenow',
        'aria-valuetext'
    ],
    anchor: [
        'download',
        'href',
        'hreflang',
        'media',
        'ping',
        'rel',
        'target',
        'type',
        'referrerpolicy'
    ],
    audio: [],
    area: [
        'alt',
        'coords',
        'download',
        'href',
        'hreflang',
        'media',
        'referrerpolicy',
        'rel',
        'shape',
        'target',
        'ping'
    ],
    base: [
        'href',
        'target'
    ],
    blockquote: [
        'cite'
    ],
    button: [
        'disabled',
        'form',
        'formaction',
        'formenctype',
        'formmethod',
        'formnovalidate',
        'formtarget',
        'name',
        'type',
        'value'
    ],
    canvas: [
        'height',
        'width'
    ],
    col: [
        'span',
        'width'
    ],
    colgroup: [
        'span'
    ],
    data: [
        'value'
    ],
    details: [
        'open'
    ],
    del: [
        'cite',
        'datetime'
    ],
    dialog: [
        'open'
    ],
    embed: [
        'height',
        'src',
        'type',
        'width'
    ],
    fieldset: [
        'disabled',
        'form',
        'name'
    ],
    form: [
        'acceptcharset',
        'action',
        'autocomplete',
        'enctype',
        'method',
        'name',
        'novalidate',
        'target',
        'rel'
    ],
    html: [
        'manifest'
    ],
    iframe: [
        'allow',
        'allowfullscreen',
        'allowtransparency',
        'frameborder',
        'height',
        'loading',
        'marginheight',
        'marginwidth',
        'name',
        'referrerpolicy',
        'sandbox',
        'scrolling',
        'seamless',
        'src',
        'srcdoc',
        'width'
    ],
    img: [
        'alt',
        'crossorigin',
        'decoding',
        'height',
        'ismap',
        'loading',
        'referrerpolicy',
        'sizes',
        'src',
        'srcset',
        'usemap',
        'width'
    ],
    ins: [
        'cite',
        'datetime'
    ],
    input: [
        'accept',
        'alt',
        'autocomplete',
        'capture',
        'checked',
        'crossorigin',
        'disabled',
        'form',
        'formaction',
        'formenctype',
        'formmethod',
        'formnovalidate',
        'formtarget',
        'height',
        'indeterminate',
        'list',
        'max',
        'maxlength',
        'min',
        'minlength',
        'multiple',
        'name',
        'pattern',
        'placeholder',
        'readonly',
        'required',
        'size',
        'src',
        'step',
        'type',
        'value',
        'width'
    ],
    keygen: [
        'challenge',
        'disabled',
        'form',
        'keytype',
        'keyparams',
        'name'
    ],
    label: [
        'form',
        'for'
    ],
    li: [
        'value'
    ],
    link: [
        'as',
        'crossorigin',
        'href',
        'hreflang',
        'integrity',
        'media',
        'imagesrcset',
        'imagesizes',
        'referrerpolicy',
        'rel',
        'sizes',
        'type',
        'charset'
    ],
    map: [
        'name'
    ],
    menu: [
        'type'
    ],
    media: [
        'autoplay',
        'controls',
        'currenttime',
        'defaultmuted',
        'defaultplaybackrate',
        'loop',
        'mediagroup',
        'muted',
        'playsinline',
        'preload',
        'src',
        'volume'
    ],
    meta: [
        'charset',
        'content',
        'http-equiv',
        'name',
        'media'
    ],
    meter: [
        'form',
        'high',
        'low',
        'max',
        'min',
        'optimum',
        'value'
    ],
    quote: [
        'cite'
    ],
    object: [
        'classid',
        'data',
        'form',
        'height',
        'name',
        'type',
        'usemap',
        'width',
        'wmode'
    ],
    ol: [
        'reversed',
        'start',
        'type'
    ],
    optgroup: [
        'disabled',
        'label'
    ],
    option: [
        'disabled',
        'label',
        'selected',
        'value'
    ],
    output: [
        'form',
        'for',
        'name'
    ],
    param: [
        'name',
        'value'
    ],
    progress: [
        'max',
        'value'
    ],
    slot: [
        'name'
    ],
    script: [
        'async',
        'charset',
        'crossorigin',
        'defer',
        'integrity',
        'nomodule',
        'nonce',
        'referrerpolicy',
        'src',
        'type'
    ],
    select: [
        'autocomplete',
        'disabled',
        'form',
        'multiple',
        'name',
        'required',
        'size',
        'value',
        'onchange'
    ],
    source: [
        'height',
        'media',
        'sizes',
        'src',
        'srcset',
        'type',
        'width'
    ],
    style: [
        'media',
        'nonce',
        'scoped',
        'type'
    ],
    table: [
        'align',
        'bgcolor',
        'border',
        'cellpadding',
        'cellspacing',
        'frame',
        'rules',
        'summary',
        'width'
    ],
    textarea: [
        'autocomplete',
        'cols',
        'dirname',
        'disabled',
        'form',
        'maxlength',
        'minlength',
        'name',
        'placeholder',
        'readonly',
        'required',
        'rows',
        'value',
        'wrap'
    ],
    td: [
        'align',
        'colspan',
        'headers',
        'rowspan',
        'scope',
        'abbr',
        'height',
        'width',
        'valign'
    ],
    th: [
        'align',
        'colspan',
        'headers',
        'rowspan',
        'scope',
        'abbr'
    ],
    time: [
        'datetime'
    ],
    track: [
        'default',
        'kind',
        'label',
        'src',
        'srclang'
    ],
    video: [
        'height',
        'playsinline',
        'poster',
        'width',
        'disablepictureinpicture',
        'disableremoteplayback'
    ],
    svg: [
        'className',
        'class',
        'color',
        'height',
        'id',
        'lang',
        'max',
        'media',
        'method',
        'min',
        'name',
        'style',
        'target',
        'type',
        'width',
        // Other HTML properties supported by SVG elements in browsers
        'role',
        'tabindex',
        'crossorigin',
        // SVG Specific attributes
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'allowReorder',
        'alphabetic',
        'amplitude',
        'arabic-form',
        'ascent',
        'attributeName',
        'attributeType',
        'autoReverse',
        'azimuth',
        'baseFrequency',
        'baseline-shift',
        'baseProfile',
        'bbox',
        'begin',
        'bias',
        'by',
        'calcMode',
        'cap-height',
        'clip',
        'clip-path',
        'clipPathUnits',
        'clip-rule',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'contentScriptType',
        'contentStyleType',
        'cursor',
        'cx',
        'cy',
        'd',
        'decelerate',
        'descent',
        'diffuseConstant',
        'direction',
        'display',
        'divisor',
        'dominant-baseline',
        'dur',
        'dx',
        'dy',
        'edgeMode',
        'elevation',
        'enable-background',
        'end',
        'exponent',
        'externalResourcesRequired',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterRes',
        'filterUnits',
        'flood-color',
        'flood-opacity',
        'focusable',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'format',
        'from',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyph-orientation-horizontal',
        'glyph-orientation-vertical',
        'glyphRef',
        'gradientTransform',
        'gradientUnits',
        'hanging',
        'href',
        'horiz-adv-x',
        'horiz-origin-x',
        'ideographic',
        'image-rendering',
        'in2',
        'in',
        'intercept',
        'k1',
        'k2',
        'k3',
        'k4',
        'k',
        'kernelMatrix',
        'kernelUnitLength',
        'kerning',
        'keyPoints',
        'keySplines',
        'keyTimes',
        'lengthAdjust',
        'letter-spacing',
        'lighting-color',
        'limitingConeAngle',
        'local',
        'marker-end',
        'markerHeight',
        'marker-mid',
        'marker-start',
        'markerUnits',
        'markerWidth',
        'mask',
        'maskContentUnits',
        'maskUnits',
        'mathematical',
        'mode',
        'numOctaves',
        'offset',
        'opacity',
        'operator',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'overline-position',
        'overline-thickness',
        'paint-order',
        'panose-1',
        'path',
        'pathLength',
        'patternContentUnits',
        'patternTransform',
        'patternUnits',
        'pointer-events',
        'points',
        'pointsAtX',
        'pointsAtY',
        'pointsAtZ',
        'preserveAlpha',
        'preserveAspectRatio',
        'primitiveUnits',
        'r',
        'radius',
        'refX',
        'refY',
        'rendering-intent',
        'repeatCount',
        'repeatDur',
        'requiredExtensions',
        'requiredFeatures',
        'restart',
        'result',
        'rotate',
        'rx',
        'ry',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'spacing',
        'specularConstant',
        'specularExponent',
        'speed',
        'spreadMethod',
        'startOffset',
        'stdDeviation',
        'stemh',
        'stemv',
        'stitchTiles',
        'stop-color',
        'stop-opacity',
        'strikethrough-position',
        'strikethrough-thickness',
        'string',
        'stroke',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke-width',
        'surfaceScale',
        'systemLanguage',
        'tableValues',
        'targetX',
        'targetY',
        'text-anchor',
        'text-decoration',
        'textLength',
        'text-rendering',
        'to',
        'transform',
        'u1',
        'u2',
        'underline-position',
        'underline-thickness',
        'unicode',
        'unicode-bidi',
        'unicode-range',
        'units-per-em',
        'v-alphabetic',
        'values',
        'vector-effect',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'v-hanging',
        'v-ideographic',
        'viewBox',
        'viewTarget',
        'visibility',
        'v-mathematical',
        'widths',
        'word-spacing',
        'writing-mode',
        'x1',
        'x2',
        'x',
        'xChannelSelector',
        'x-height',
        'xlink:actuate',
        'xlink:arcrole',
        'xlink:href',
        'xlink:role',
        'xlink:show',
        'xlink:title',
        'xlink:type',
        'xml:base',
        'xml:lang',
        'xmlns',
        'xmlns:xlink',
        'xml:space',
        'y1',
        'y2',
        'y',
        'yChannelSelector',
        'z',
        'zoomAndPan'
    ]
};
const $97f45980f9c117e0$export$f552dbb36ef6b3dd = [
    // Clipboard Events
    'oncopy',
    'oncut',
    'onpaste',
    // Composition Events
    'oncompositionend',
    'oncompositionstart',
    'oncompositionupdate',
    // Focus Events
    'onfocus',
    'onfocusin',
    'onfocusout',
    'onblur',
    // Form Events
    'onchange',
    'onbeforeinput',
    'oninput',
    'onreset',
    'onsubmit',
    'oninvalid',
    'onformdata',
    // Image Events
    'onload',
    'onerror',
    // also a Media Event
    // Detail Events
    'ontoggle',
    // Keyboard Events
    'onkeydown',
    'onkeypress',
    'onkeyup',
    // Media Events
    'onabort',
    'oncanplay',
    'oncanplaythrough',
    'oncuechange',
    'ondurationchange',
    'onemptied',
    'onencrypted',
    'onended',
    'onloadeddata',
    'onloadedmetadata',
    'onloadstart',
    'onpause',
    'onplay',
    'onplaying',
    'onprogress',
    'onratechange',
    'onseeked',
    'onseeking',
    'onstalled',
    'onsuspend',
    'ontimeupdate',
    'onvolumechange',
    'onwaiting',
    // MouseEvents
    'onauxclick',
    'onclick',
    'oncontextmenu',
    'ondblclick',
    'ondrag',
    'ondragend',
    'ondragenter',
    'ondragexit',
    'ondragleave',
    'ondragover',
    'ondragstart',
    'ondrop',
    'onmousedown',
    'onmouseenter',
    'onmouseleave',
    'onmousemove',
    'onmouseout',
    'onmouseover',
    'onmouseup',
    // Selection Events
    'onselect',
    'onselectionchange',
    'onselectstart',
    // Touch Events
    'ontouchcancel',
    'ontouchend',
    'ontouchmove',
    'ontouchstart',
    // Pointer Events
    'ongotpointercapture',
    'onpointercancel',
    'onpointerdown',
    'onpointerenter',
    'onpointerleave',
    'onpointermove',
    'onpointerout',
    'onpointerover',
    'onpointerup',
    'onlostpointercapture',
    // UI Events
    'onscroll',
    'onresize',
    // Wheel Events
    'onwheel',
    // Animation Events
    'onanimationstart',
    'onanimationend',
    'onanimationiteration',
    // Transition Events
    'ontransitionstart',
    'ontransitionrun',
    'ontransitionend',
    'ontransitioncancel',
    // Svelte Transition Events
    'onoutrostart',
    'onoutroend',
    'onintrostart',
    'onintroend',
    // Message Events
    'onmessage',
    'onmessageerror',
    // Document Events
    'onvisibilitychange',
    // Global Events
    'oncancel',
    'onclose',
    'onfullscreenchange',
    'onfullscreenerror'
];
const $97f45980f9c117e0$export$3c670b34323f5417 = (tag, attribute)=>{
    if (Object.prototype.hasOwnProperty.call($97f45980f9c117e0$export$a073516cf3506ae6, tag)) {
        const attributes = $97f45980f9c117e0$export$a073516cf3506ae6[tag];
        return attributes.includes(attribute) || attributes.includes('default');
    } else {
        const defaultAttributes = $97f45980f9c117e0$export$a073516cf3506ae6.default;
        return defaultAttributes.includes(attribute);
    }
};
const $97f45980f9c117e0$export$12ab4f1a89970119 = (key)=>{
    if (!(0, $amNJ8.isString)(key)) return false;
    const normalizedKey = key.toLowerCase();
    return $97f45980f9c117e0$export$f552dbb36ef6b3dd.includes(normalizedKey);
};
const $97f45980f9c117e0$export$a3d5d5e1a17535c6 = (tag, props)=>{
    const filteredObject = {};
    for(const key in props)if (Object.prototype.hasOwnProperty.call(props, key)) {
        const isAttribute = $97f45980f9c117e0$export$3c670b34323f5417(tag, key);
        const isEvent = $97f45980f9c117e0$export$12ab4f1a89970119(key);
        if ((0, $amNJ8.isDefined)(props[key]) && (isAttribute || isEvent)) filteredObject[key] = props[key];
    }
    return filteredObject;
};
const $97f45980f9c117e0$export$a420285f97b772db = (elem, element)=>{
    const attrObj = {};
    if (elem.attr) for(const attrProp in elem.attr)attrObj[attrProp] = elem.attr[attrProp](element, element.state, element.context);
    return attrObj;
};


var $25b5ce44de4d06e3$exports = {};

$parcel$defineInteropFlag($25b5ce44de4d06e3$exports);

$parcel$export($25b5ce44de4d06e3$exports, "create", function () { return $25b5ce44de4d06e3$export$185802fd694ee1f5; });
$parcel$export($25b5ce44de4d06e3$exports, "createAsync", function () { return $25b5ce44de4d06e3$export$fa0abf86dcc47d66; });
$parcel$export($25b5ce44de4d06e3$exports, "createSync", function () { return $25b5ce44de4d06e3$export$df2a74307fafca3b; });
$parcel$export($25b5ce44de4d06e3$exports, "createSkeleton", function () { return $25b5ce44de4d06e3$export$9cb2e3fca5d0556e; });
$parcel$export($25b5ce44de4d06e3$exports, "default", function () { return $25b5ce44de4d06e3$export$2e2bcd8739ae039; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
var $e5c9cce2d37812b2$exports = {};

$parcel$export($e5c9cce2d37812b2$exports, "scratchUtils", function () { return $74b1239117fb29ff$exports; });
$parcel$export($e5c9cce2d37812b2$exports, "scratchSystem", function () { return $a4a3198d451be376$exports; });
$parcel$export($e5c9cce2d37812b2$exports, "set", function () { return $68d4b3e39e36311c$export$adaa4cf7ef1b65be; });
$parcel$export($e5c9cce2d37812b2$exports, "init", function () { return $84f69156e3582aea$export$2cd8252107eb640b; });
$parcel$export($e5c9cce2d37812b2$exports, "reinit", function () { return $84f69156e3582aea$export$b545ad0f2df0be16; });
$parcel$export($e5c9cce2d37812b2$exports, "applyCSS", function () { return $84f69156e3582aea$export$3a26aa64e59aeaff; });
var $9ab4e20a7cba0748$exports = {};

$parcel$export($9ab4e20a7cba0748$exports, "scratchUtils", function () { return $74b1239117fb29ff$exports; });
$parcel$export($9ab4e20a7cba0748$exports, "scratchSystem", function () { return $a4a3198d451be376$exports; });
var $74b1239117fb29ff$exports = {};
var $1597a9be83012ede$exports = {};

$parcel$export($1597a9be83012ede$exports, "isScalingUnit", function () { return $1597a9be83012ede$export$6a836bb704f10b75; });
'use strict';
const $1597a9be83012ede$export$6a836bb704f10b75 = (unit)=>{
    return unit === 'em' || unit === 'rem' || unit === 'vw' || unit === 'vh' || unit === 'vmax' || unit === 'vmin';
};


var $1ed3cce889a937d1$exports = {};

$parcel$export($1ed3cce889a937d1$exports, "colorStringToRgbaArray", function () { return $1ed3cce889a937d1$export$fa32e9c99a43479e; });
$parcel$export($1ed3cce889a937d1$exports, "mixTwoColors", function () { return $1ed3cce889a937d1$export$fc81362b978df912; });
$parcel$export($1ed3cce889a937d1$exports, "mixTwoRgba", function () { return $1ed3cce889a937d1$export$7aaa71d8fa03e6fa; });
$parcel$export($1ed3cce889a937d1$exports, "hexToRgb", function () { return $1ed3cce889a937d1$export$5a544e13ad4e1fa5; });
$parcel$export($1ed3cce889a937d1$exports, "hexToRgbArray", function () { return $1ed3cce889a937d1$export$fc66327a54d8eee6; });
$parcel$export($1ed3cce889a937d1$exports, "rgbToHex", function () { return $1ed3cce889a937d1$export$34d09c4a771c46ef; });
$parcel$export($1ed3cce889a937d1$exports, "rgbArrayToHex", function () { return $1ed3cce889a937d1$export$becee3e8de1b8d23; });
$parcel$export($1ed3cce889a937d1$exports, "hexToRgba", function () { return $1ed3cce889a937d1$export$9665a07d9187b414; });
$parcel$export($1ed3cce889a937d1$exports, "mixTwoRgb", function () { return $1ed3cce889a937d1$export$7d1bd62512294b2f; });
$parcel$export($1ed3cce889a937d1$exports, "changeLightness", function () { return $1ed3cce889a937d1$export$784aaa753604ca97; });
$parcel$export($1ed3cce889a937d1$exports, "rgbToHSL", function () { return $1ed3cce889a937d1$export$ac60e367bcb68b; });
$parcel$export($1ed3cce889a937d1$exports, "hslToRgb", function () { return $1ed3cce889a937d1$export$29fb7152bd3f781a; });
$parcel$export($1ed3cce889a937d1$exports, "getColorShade", function () { return $1ed3cce889a937d1$export$e1d0a0f5f1f4ce36; });
$parcel$export($1ed3cce889a937d1$exports, "opacify", function () { return $1ed3cce889a937d1$export$f4f50e3877dd0530; });
$parcel$export($1ed3cce889a937d1$exports, "getRgbTone", function () { return $1ed3cce889a937d1$export$2d78fefdcfb7f222; });
parcelRequire("imR0C");
var $aLXZy = parcelRequire("aLXZy");
var $kitvZ = parcelRequire("kitvZ");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $1ed3cce889a937d1$export$fa32e9c99a43479e = (color)=>{
    if (color === '') return [
        0,
        0,
        0,
        0
    ];
    if (color.toLowerCase() === 'transparent') return [
        0,
        0,
        0,
        0
    ];
    // convert #RGB and #RGBA to #RRGGBB and #RRGGBBAA
    if (color[0] === '#') {
        if (color.length < 7) color = '#' + color[1] + color[1] + color[2] + color[2] + color[3] + color[3] + (color.length > 4 ? color[4] + color[4] : '');
        return [
            parseInt(color.substr(1, 2), 16),
            parseInt(color.substr(3, 2), 16),
            parseInt(color.substr(5, 2), 16),
            color.length > 7 ? parseInt(color.substr(7, 2), 16) / 255 : 1
        ];
    }
    // convert named colors
    if (color.indexOf('rgb') === -1) {
        if ((0, $aLXZy.document) && (0, $aLXZy.window)) {
            // intentionally use unknown tag to lower chances of css rule override with !important
            const elem = (0, $aLXZy.document).body.appendChild((0, $aLXZy.document).createElement('fictum'));
            // this flag tested on chrome 59, ff 53, ie9, ie10, ie11, edge 14
            const flag = 'rgb(1, 2, 3)';
            elem.style.color = flag;
            // color set failed - some monstrous css rule is probably taking over the color of our object
            if (elem.style.color !== flag) {
                (0, $aLXZy.document).body.removeChild(elem);
                return;
            }
            elem.style.color = color;
            if (elem.style.color === flag || elem.style.color === '') {
                (0, $aLXZy.document).body.removeChild(elem);
                return [
                    0,
                    0,
                    0,
                    0
                ]; // color parse failed
            }
            color = (0, $aLXZy.window).getComputedStyle(elem).color;
            (0, $aLXZy.document).body.removeChild(elem);
        }
    }
    // convert 'rgb(R,G,B)' to 'rgb(R,G,B,A)' which looks awful but will pass the regxep below
    if (color.indexOf('rgb') === 0) {
        if (color.indexOf('rgba') === -1) color = `${color}, 1`;
        return color.match(/[\.\d]+/g).map((a)=>+a); // eslint-disable-line
    }
    return [
        0,
        0,
        0,
        0
    ];
};
const $1ed3cce889a937d1$export$fc81362b978df912 = (colorA, colorB, range = 0.5)=>{
    colorA = $1ed3cce889a937d1$export$fa32e9c99a43479e(colorA);
    colorB = $1ed3cce889a937d1$export$fa32e9c99a43479e(colorB);
    return $1ed3cce889a937d1$export$7aaa71d8fa03e6fa(colorA, colorB, range);
};
const $1ed3cce889a937d1$export$5a544e13ad4e1fa5 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return `rgb(${r},${g},${b})`;
};
const $1ed3cce889a937d1$export$fc66327a54d8eee6 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return [
        r,
        g,
        b
    ];
};
const $1ed3cce889a937d1$export$34d09c4a771c46ef = (r, g, b)=>{
    return '#' + (16777216 | r << 16 | g << 8 | b).toString(16).slice(1);
};
const $1ed3cce889a937d1$export$becee3e8de1b8d23 = ([r, g, b])=>{
    return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
};
const $1ed3cce889a937d1$export$9665a07d9187b414 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
};
const $1ed3cce889a937d1$export$7d1bd62512294b2f = (colorA, colorB, range = 0.5)=>{
    const arr = [];
    for(let i = 0; i < 3; i++)arr[i] = ~~(colorA[i] + (colorB[i] - colorA[i]) * range);
    return `rgb(${arr})`;
};
const $1ed3cce889a937d1$export$784aaa753604ca97 = (delta, hsl)=>{
    const [hue, saturation, lightness] = hsl;
    const newLightness = Math.max(0, Math.min(100, lightness + parseFloat(delta)));
    return [
        hue,
        saturation,
        newLightness
    ];
};
const $1ed3cce889a937d1$export$ac60e367bcb68b = (r, g, b)=>{
    const a = Math.max(r, g, b);
    const n = a - Math.min(r, g, b);
    const f = 1 - Math.abs(a + a - n - 1);
    const h = n && (a == r ? (g - b) / n : a == g ? 2 + (b - r) / n : 4 + (r - g) / n); //eslint-disable-line
    return [
        60 * (h < 0 ? h + 6 : h),
        f ? n / f : 0,
        (a + a - n) / 2
    ];
};
const $1ed3cce889a937d1$export$29fb7152bd3f781a = (h, s, l, a = s * Math.min(l, 1 - l), f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1))=>[
        f(0),
        f(8),
        f(4)
    ];
const $1ed3cce889a937d1$export$e1d0a0f5f1f4ce36 = (col, amt)=>{
    const num = parseInt(col, 16);
    let r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if (r < 0) r = 0;
    let b = (num >> 8 & 0x00ff) + amt;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;
    let g = (num & 0x0000ff) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    return ((g | b << 8 | r << 16) + 0x1000000).toString(16).slice(1);
};
const $1ed3cce889a937d1$export$7aaa71d8fa03e6fa = (colorA, colorB, range = 0.5)=>{
    const arr = [];
    for(let i = 0; i < 4; i++){
        const round = i === 3 ? (x)=>x : Math.round;
        arr[i] = round(colorA[i] + (colorB[i] - colorA[i]) * range);
    }
    return `rgba(${arr})`;
};
const $1ed3cce889a937d1$export$f4f50e3877dd0530 = (color, opacity)=>{
    const arr = $1ed3cce889a937d1$export$fa32e9c99a43479e(color);
    if (!arr) {
        if ((0, $kitvZ.isNotProduction)()) console.warn(color + ' color is not rgba');
        return;
    }
    arr[3] = opacity;
    return `rgba(${arr})`;
};
const $1ed3cce889a937d1$export$2d78fefdcfb7f222 = (rgb, tone)=>{
    if ((0, $amNJ8.isString)(rgb) && rgb.includes('rgb')) rgb = $1ed3cce889a937d1$export$fa32e9c99a43479e(rgb).join(', ');
    if ((0, $amNJ8.isString)(rgb)) rgb = rgb.split(',').map((v)=>parseFloat(v.trim()));
    if ((0, $amNJ8.isNumber)(tone)) tone += '';
    const toHex = $1ed3cce889a937d1$export$becee3e8de1b8d23(rgb);
    const abs = tone.slice(0, 1);
    if (abs === '-' || abs === '+') {
        const colorShade = $1ed3cce889a937d1$export$e1d0a0f5f1f4ce36(toHex, parseFloat(tone));
        return $1ed3cce889a937d1$export$fc66327a54d8eee6(colorShade).join(', ');
    } else {
        const [r, g, b] = rgb;
        const hsl = $1ed3cce889a937d1$export$ac60e367bcb68b(r, g, b);
        const [h, s, l] = hsl; // eslint-disable-line
        const newRgb = $1ed3cce889a937d1$export$29fb7152bd3f781a(h, s, parseFloat(tone) / 100 * 255);
        return newRgb;
    }
};


var $66d66f809d0fb015$exports = {};

$parcel$export($66d66f809d0fb015$exports, "returnSubThemeOrDefault", function () { return $66d66f809d0fb015$export$b653d4648867fe18; });
'use strict';
const $66d66f809d0fb015$export$b653d4648867fe18 = (orig, theme)=>{
    if (!orig) return;
    if (orig.themes && orig.themes[theme]) return orig.themes[theme];
    if (orig[theme]) return [
        orig,
        orig[theme]
    ];
    return orig;
};


var $ff75c5d288dc2745$exports = {};

$parcel$export($ff75c5d288dc2745$exports, "getDefaultOrFirstKey", function () { return $ff75c5d288dc2745$export$73aa7d12a2d2fb83; });
$parcel$export($ff75c5d288dc2745$exports, "getFontFormat", function () { return $ff75c5d288dc2745$export$6c7bbed5530e9474; });
$parcel$export($ff75c5d288dc2745$exports, "setInCustomFontMedia", function () { return $ff75c5d288dc2745$export$e84fe2812840a337; });
$parcel$export($ff75c5d288dc2745$exports, "setCustomFont", function () { return $ff75c5d288dc2745$export$27bb82ae7d3ac02b; });
$parcel$export($ff75c5d288dc2745$exports, "setCustomFontMedia", function () { return $ff75c5d288dc2745$export$2593ac3417be5ed7; });
$parcel$export($ff75c5d288dc2745$exports, "getFontFaceEach", function () { return $ff75c5d288dc2745$export$198e04e3616f042a; });
$parcel$export($ff75c5d288dc2745$exports, "getFontFace", function () { return $ff75c5d288dc2745$export$e9d70cd3a9044b8e; });
$parcel$export($ff75c5d288dc2745$exports, "getFontFaceEachString", function () { return $ff75c5d288dc2745$export$c26ef91aac8931ec; });
$parcel$export($ff75c5d288dc2745$exports, "getFontFaceString", function () { return $ff75c5d288dc2745$export$8b73d71a1d936bc; });
'use strict';
const $ff75c5d288dc2745$export$73aa7d12a2d2fb83 = (LIBRARY, key)=>{
    if (LIBRARY[key]) return LIBRARY[key].value;
    if (LIBRARY.default) return LIBRARY[LIBRARY.default].value;
    const hasValue = Object.keys(LIBRARY)[0];
    return hasValue && LIBRARY[hasValue] && LIBRARY[hasValue].value;
};
const $ff75c5d288dc2745$export$6c7bbed5530e9474 = (url)=>url.split(/[#?]/)[0].split('.').pop().trim();
const $ff75c5d288dc2745$export$e84fe2812840a337 = (str)=>`@font-face { ${str} }`;
const $ff75c5d288dc2745$export$27bb82ae7d3ac02b = (name, url, weight)=>`
  font-family: '${name}';
  font-style: normal;
  ${weight && `font-weight: ${weight};`}
  src: url('${url}') format('${$ff75c5d288dc2745$export$6c7bbed5530e9474(url)}');`;
const $ff75c5d288dc2745$export$2593ac3417be5ed7 = (name, url, weight)=>`@font-face {
  ${$ff75c5d288dc2745$export$27bb82ae7d3ac02b(name, url, weight)}
}`;
const $ff75c5d288dc2745$export$198e04e3616f042a = (name, weights)=>{
    const keys = Object.keys(weights);
    return keys.map((key)=>{
        const { url: url, fontWeight: fontWeight } = weights[key];
        return $ff75c5d288dc2745$export$27bb82ae7d3ac02b(name, url, fontWeight);
    });
};
const $ff75c5d288dc2745$export$e9d70cd3a9044b8e = (LIBRARY)=>{
    const keys = Object.keys(LIBRARY);
    return keys.map((key)=>$ff75c5d288dc2745$export$198e04e3616f042a(key, LIBRARY[key].value));
};
const $ff75c5d288dc2745$export$c26ef91aac8931ec = (name, weights)=>{
    const isArr = weights[0];
    if (isArr) return $ff75c5d288dc2745$export$198e04e3616f042a(name, weights).map($ff75c5d288dc2745$export$e84fe2812840a337);
    return $ff75c5d288dc2745$export$2593ac3417be5ed7(name, weights.url);
};
const $ff75c5d288dc2745$export$8b73d71a1d936bc = (LIBRARY)=>{
    const keys = Object.keys(LIBRARY);
    return keys.map((key)=>$ff75c5d288dc2745$export$c26ef91aac8931ec(key, LIBRARY[key].value));
};


var $ba3cd441ab4bb524$exports = {};

$parcel$export($ba3cd441ab4bb524$exports, "numToLetterMap", function () { return $ba3cd441ab4bb524$export$81ab9dc24d52c4ba; });
$parcel$export($ba3cd441ab4bb524$exports, "setScalingVar", function () { return $ba3cd441ab4bb524$export$68dfa61d698afbde; });
$parcel$export($ba3cd441ab4bb524$exports, "setSubScalingVar", function () { return $ba3cd441ab4bb524$export$c9d5ef57eeb83fa; });
$parcel$export($ba3cd441ab4bb524$exports, "getSubratioDifference", function () { return $ba3cd441ab4bb524$export$12adf55fdaa50348; });
$parcel$export($ba3cd441ab4bb524$exports, "getSubratio", function () { return $ba3cd441ab4bb524$export$50db87b17b1557b4; });
$parcel$export($ba3cd441ab4bb524$exports, "generateSubSequence", function () { return $ba3cd441ab4bb524$export$622ae6209895c34e; });
$parcel$export($ba3cd441ab4bb524$exports, "generateSequence", function () { return $ba3cd441ab4bb524$export$29708af739d9b0fc; });
$parcel$export($ba3cd441ab4bb524$exports, "generateSequencePosition", function () { return $ba3cd441ab4bb524$export$7b7c0090b74e1e64; });
$parcel$export($ba3cd441ab4bb524$exports, "getSequenceValue", function () { return $ba3cd441ab4bb524$export$efde09b5692f9bd0; });
$parcel$export($ba3cd441ab4bb524$exports, "getSequenceValuePropertyPair", function () { return $ba3cd441ab4bb524$export$86c0052f25dacc45; });
$parcel$export($ba3cd441ab4bb524$exports, "findHeadingLetter", function () { return $ba3cd441ab4bb524$export$14c834a042d41297; });
$parcel$export($ba3cd441ab4bb524$exports, "findHeadings", function () { return $ba3cd441ab4bb524$export$8dc77c00fe04c40a; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
var $9eb7ca543617066e$exports = {};

$parcel$export($9eb7ca543617066e$exports, "copyStringToClipboard", function () { return $9eb7ca543617066e$export$4cdfed7d7fed21b8; });
$parcel$export($9eb7ca543617066e$exports, "copyJavaScriptToClipboard", function () { return $9eb7ca543617066e$export$62b326c3a2efe2fb; });
$parcel$export($9eb7ca543617066e$exports, "removeChars", function () { return $9eb7ca543617066e$export$3cc82ee301fb0516; });
$parcel$export($9eb7ca543617066e$exports, "toCamelCase", function () { return $9eb7ca543617066e$export$86f54f62aa7a7514; });
$parcel$export($9eb7ca543617066e$exports, "toTitleCase", function () { return $9eb7ca543617066e$export$f06f8b3003f18927; });
$parcel$export($9eb7ca543617066e$exports, "toDashCase", function () { return $9eb7ca543617066e$export$6401d9e8afa09755; });
$parcel$export($9eb7ca543617066e$exports, "toDescriptionCase", function () { return $9eb7ca543617066e$export$c82070d8669cc24e; });
$parcel$export($9eb7ca543617066e$exports, "arrayzeValue", function () { return $9eb7ca543617066e$export$d1ef4b1a340dec10; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
var $0f338119ea2a074a$exports = {};

$parcel$export($0f338119ea2a074a$exports, "toggleFullscreen", function () { return $0f338119ea2a074a$export$1aba1ee5e6dc1474; });
'use strict';
async function $0f338119ea2a074a$export$1aba1ee5e6dc1474(opts) {
    if (!document.fullscreenElement) try {
        await (this.node || document).requestFullscreen();
    } catch (err) {
        console.warn(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
    }
    else await document.exitFullscreen();
}


var $a4451f4a0386a828$exports = {};

$parcel$export($a4451f4a0386a828$exports, "findClosestNumber", function () { return $a4451f4a0386a828$export$97a41db892f2d4c; });
$parcel$export($a4451f4a0386a828$exports, "findClosestNumberInFactory", function () { return $a4451f4a0386a828$export$63c606e1170dd201; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $a4451f4a0386a828$export$97a41db892f2d4c = (number, arr)=>{
    return ((0, $amNJ8.isArray)(arr) ? arr : Object.values(arr)).reduce((prev, curr)=>{
        return Math.abs(curr - number) < Math.abs(prev - number) ? curr : prev;
    });
};
const $a4451f4a0386a828$export$63c606e1170dd201 = (val, factory)=>{
    val = parseFloat(val);
    if ((0, $amNJ8.isObject)(factory)) factory = Object.values(factory);
    return $a4451f4a0386a828$export$97a41db892f2d4c(val, factory);
};


var $9a2761f3ff1c1780$exports = {};

$parcel$export($9a2761f3ff1c1780$exports, "formatDate", function () { return $9a2761f3ff1c1780$export$3ae94a2503e890a1; });
'use strict';
const $9a2761f3ff1c1780$export$3ae94a2503e890a1 = (timestamp)=>{
    if (!timestamp) return '';
    const d = new Date(timestamp);
    const ye = new Intl.DateTimeFormat('en', {
        year: 'numeric'
    }).format(d);
    const mo = new Intl.DateTimeFormat('en', {
        month: 'short'
    }).format(d);
    const da = new Intl.DateTimeFormat('en', {
        day: '2-digit'
    }).format(d);
    return `${da} ${mo}, ${ye}`;
};


var $9b369504afe99f21$exports = {};

$parcel$export($9b369504afe99f21$exports, "fibonacciNumberByIndex", function () { return $9b369504afe99f21$export$6d35f41941932cbd; });
'use strict';
const $9b369504afe99f21$export$6d35f41941932cbd = function fibonacciNumberByIndex(n) {
    const fib = [
        0,
        1
    ];
    for(let i = 2; i <= n; i++)fib[i] = fib[i - 1] + fib[i - 2];
    return fib[n];
};


var $5efe1b93427dad73$exports = {};

$parcel$export($5efe1b93427dad73$exports, "loadJavascriptFile", function () { return $5efe1b93427dad73$export$f5254c626a3f7f04; });
$parcel$export($5efe1b93427dad73$exports, "loadJavascriptFileSync", function () { return $5efe1b93427dad73$export$f846581269718859; });
$parcel$export($5efe1b93427dad73$exports, "loadJavascriptFileEmbedSync", function () { return $5efe1b93427dad73$export$2e2cf34468b4616; });
$parcel$export($5efe1b93427dad73$exports, "loadCssFile", function () { return $5efe1b93427dad73$export$adc703d835881894; });
$parcel$export($5efe1b93427dad73$exports, "loadJavascript", function () { return $5efe1b93427dad73$export$8b7778d7ecfcc995; });
$parcel$export($5efe1b93427dad73$exports, "loadRemoteScript", function () { return $5efe1b93427dad73$export$c432db100969a36b; });
$parcel$export($5efe1b93427dad73$exports, "loadRemoteCSS", function () { return $5efe1b93427dad73$export$d146908f5d25486; });
'use strict';
const $5efe1b93427dad73$export$f5254c626a3f7f04 = (FILE_URL, async = false, doc = document, type = 'text/javascript')=>{
    return new Promise((resolve, reject)=>{
        try {
            const scriptEle = doc.createElement('script');
            scriptEle.type = type;
            scriptEle.async = async;
            scriptEle.src = FILE_URL;
            scriptEle.addEventListener('load', (ev)=>{
                resolve({
                    status: true
                });
            });
            scriptEle.addEventListener('error', (ev)=>{
                reject(new Error({
                    status: false,
                    message: `Failed to load the script ${FILE_URL}`
                }));
            });
            doc.body.appendChild(scriptEle);
        } catch (error) {
            reject(error);
        }
    });
};
const $5efe1b93427dad73$export$f846581269718859 = (fileUrl, doc = document, type = 'text/javascript')=>{
    return new Promise((resolve, reject)=>{
        const scriptEle = doc.createElement('script');
        scriptEle.type = type;
        scriptEle.src = fileUrl;
        // Create a blocking overlay
        const blocker = doc.createElement('div');
        blocker.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.8);z-index:9999;';
        doc.body.appendChild(blocker);
        scriptEle.onload = ()=>{
            console.log(`Successfully loaded: ${fileUrl}`);
            doc.body.removeChild(blocker);
            resolve();
        };
        scriptEle.onerror = ()=>{
            doc.body.removeChild(blocker);
            reject(new Error(`Failed to load: ${fileUrl}`));
        };
        doc.body.appendChild(scriptEle);
    });
};
const $5efe1b93427dad73$export$2e2cf34468b4616 = (FILE_URL, doc = document, fallback, type = 'text/javascript')=>{
    const xhr = new window.XMLHttpRequest();
    xhr.open('GET', FILE_URL, false); // false makes the request synchronous
    xhr.send();
    if (xhr.status === 200) {
        const scriptEle = doc.createElement('script');
        scriptEle.type = type;
        scriptEle.text = xhr.responseText;
        doc.body.appendChild(scriptEle);
        if (typeof fallback === 'function') fallback();
    } else throw new Error(`Failed to load the script ${FILE_URL}`);
};
const $5efe1b93427dad73$export$adc703d835881894 = (FILE_URL, async = false, doc = document, type = 'text/javascript')=>{
    return new Promise((resolve, reject)=>{
        try {
            const linkElem = doc.createElement('link');
            linkElem.rel = 'stylesheet';
            linkElem.href = FILE_URL;
            linkElem.addEventListener('load', (ev)=>{
                resolve({
                    status: true
                });
            });
            doc.head.appendChild(linkElem);
        } catch (error) {
            reject(error);
        }
    });
};
const $5efe1b93427dad73$export$8b7778d7ecfcc995 = (body, async = false, doc = document, type = 'text/javascript', id = 'smbls-script')=>{
    try {
        const scriptEle = doc.createElement('script');
        scriptEle.type = type;
        scriptEle.async = async;
        scriptEle.id = id;
        scriptEle.innerHTML = body;
        doc.body.appendChild(scriptEle);
    } catch (error) {
        console.warn(error);
    }
};
function $5efe1b93427dad73$export$c432db100969a36b(url, options = {}) {
    const { window: window1 = globalThis } = options;
    const { document: document1 = window1.document } = options;
    return new Promise((resolve, reject)=>{
        // Check if script is already loaded
        const existingScript = document1.querySelector(`script[src="${url}"]`);
        if (existingScript) return resolve(existingScript);
        // Create script element
        const script = document1.createElement('script');
        script.src = url;
        script.async = options.async === true;
        script.type = options.type || 'text/javascript';
        // Add optional attributes
        if (options.id) script.id = options.id;
        if (options.integrity) script.integrity = options.integrity;
        if (options.crossOrigin) script.crossOrigin = options.crossOrigin;
        // Setup load and error handlers
        script.onload = ()=>{
            script.onerror = script.onload = null;
            resolve(script);
        };
        script.onerror = ()=>{
            script.onerror = script.onload = null;
            reject(new Error(`Failed to load script: ${url}`));
        };
        // Append the script to the document head
        document1.head.appendChild(script);
    });
}
async function $5efe1b93427dad73$export$d146908f5d25486(url, options = {}) {
    const { window: window1 = globalThis } = options;
    const { document: document1 = window1.document } = options;
    return new Promise((resolve, reject)=>{
        // Check if stylesheet is already loaded
        const existingLink = document1.querySelector(`link[href="${url}"]`);
        if (existingLink) return resolve(existingLink);
        // Create link element
        const link = document1.createElement('link');
        link.href = url;
        link.rel = options.rel || 'stylesheet';
        link.type = 'text/css';
        link.media = options.media || 'all';
        // Add optional attributes
        if (options.id) link.id = options.id;
        if (options.integrity) link.integrity = options.integrity;
        if (options.crossOrigin) link.crossOrigin = options.crossOrigin;
        // Setup load and error handlers
        link.onload = ()=>{
            link.onerror = link.onload = null;
            resolve(link);
        };
        link.onerror = ()=>{
            link.onerror = link.onload = null;
            reject(new Error(`Failed to load stylesheet: ${url}`));
        };
        // Append the link to the document head
        document1.head.appendChild(link);
    });
}


var $f80eb9ff280273c9$exports = {};

$parcel$export($f80eb9ff280273c9$exports, "isPhoto", function () { return $f80eb9ff280273c9$export$722f9ea87a439ca4; });
'use strict';
const $f80eb9ff280273c9$export$722f9ea87a439ca4 = (format)=>[
        'jpeg',
        'gif',
        'jpg',
        'png',
        'tiff',
        'woff'
    ].includes(format);


'use strict';
const $9eb7ca543617066e$export$4cdfed7d7fed21b8 = async (str)=>{
    try {
        await navigator.clipboard.writeText(str);
    } catch (err) {
        console.warn('Failed to copy text: ', err);
    }
};
const $9eb7ca543617066e$export$62b326c3a2efe2fb = async (jsCode)=>{
    try {
        // Create a Blob for the JavaScript code with the 'text/javascript' MIME type
        const blob = new Blob([
            jsCode
        ], {
            type: 'text/javascript'
        });
        // Create a ClipboardItem with the 'text/javascript' Blob
        const clipboardItem = new window.ClipboardItem({
            'text/plain': blob
        });
        // Copy the ClipboardItem to the clipboard
        await navigator.clipboard.write([
            clipboardItem
        ]);
        console.log('JavaScript code copied to clipboard as text/javascript');
    } catch (err) {
        console.error('Failed to copy JavaScript code: ', err);
    }
};
const $9eb7ca543617066e$export$3cc82ee301fb0516 = (str)=>{
    return str.replace(/[^a-zA-Z0-9_]/g, '');
};
const $9eb7ca543617066e$export$86f54f62aa7a7514 = (str)=>{
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replaceAll(/\s+/g, '');
};
const $9eb7ca543617066e$export$f06f8b3003f18927 = (str)=>str && str.replace(/\w\S*/g, (txt)=>{
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
const $9eb7ca543617066e$export$6401d9e8afa09755 = (val)=>val.replace(/[^a-zA-Z0-9]/g, ' ') // Replace non-alphanumeric characters with spaces
    .trim() // Remove leading and trailing spaces
    .toLowerCase() // Convert to lowercase
    .replace(/\s+/g, '-') // Replace spaces with dashes
    .replace(/-+/g, '-') // Replace consecutive dashes with a single dash
    .replace(/^-|-$/g, ''); // Remove leading and trailing dashes
const $9eb7ca543617066e$export$c82070d8669cc24e = (str = '')=>{
    if (typeof str !== 'string') return;
    const result = str.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
};
const $9eb7ca543617066e$export$d1ef4b1a340dec10 = (val)=>{
    if ((0, $amNJ8.isArray)(val)) return val;
    if ((0, $amNJ8.isString)(val)) return val.split(' ');
    if ((0, $amNJ8.isObject)(val)) return Object.values(val);
    if ((0, $amNJ8.isNumber)(val)) return [
        val
    ];
};
$parcel$exportWildcard($9eb7ca543617066e$exports, $0f338119ea2a074a$exports);
$parcel$exportWildcard($9eb7ca543617066e$exports, $a4451f4a0386a828$exports);
$parcel$exportWildcard($9eb7ca543617066e$exports, $9a2761f3ff1c1780$exports);
$parcel$exportWildcard($9eb7ca543617066e$exports, $9b369504afe99f21$exports);
$parcel$exportWildcard($9eb7ca543617066e$exports, $5efe1b93427dad73$exports);
$parcel$exportWildcard($9eb7ca543617066e$exports, $f80eb9ff280273c9$exports);


var $6c2510166886baa2$exports = {};

$parcel$export($6c2510166886baa2$exports, "CSS_VARS", function () { return $6c2510166886baa2$export$220f2e5d84ced4cb; });
$parcel$export($6c2510166886baa2$exports, "CONFIG", function () { return $6c2510166886baa2$export$1630b5343357e8b5; });
$parcel$export($6c2510166886baa2$exports, "FACTORY", function () { return $6c2510166886baa2$export$ee513c29aad6cc62; });
$parcel$export($6c2510166886baa2$exports, "activateConfig", function () { return $6c2510166886baa2$export$8a278b801d0668ff; });
$parcel$export($6c2510166886baa2$exports, "getActiveConfig", function () { return $6c2510166886baa2$export$e23c3d522afb24cd; });
$parcel$export($6c2510166886baa2$exports, "setActiveConfig", function () { return $6c2510166886baa2$export$5e61d1b6fff0c794; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
var $3e5c92ae435958cf$exports = {};

$parcel$export($3e5c92ae435958cf$exports, "RESET", function () { return $3e5c92ae435958cf$export$4a991c87e640ef77; });
var $f8d7cccacce45137$exports = {};

$parcel$export($f8d7cccacce45137$exports, "SEQUENCE", function () { return $f8d7cccacce45137$export$34694f8d8b23ee2a; });
'use strict';
const $f8d7cccacce45137$export$34694f8d8b23ee2a = {
    'minor-second': 1.067,
    'major-second': 1.125,
    'minor-third': 1.2,
    'major-third': 1.25,
    'perfect-fourth': 1.333,
    'augmented-fourth': 1.414,
    'perfect-fifth': 1.5,
    'minor-sixth': 1.6,
    phi: 1.618,
    // golden-ratio
    'major-sixth': 1.667,
    'square-root-3': 1.732,
    // theodorus
    'minor-seventh': 1.778,
    'major-seventh': 1.875,
    octave: 2,
    'square-root-5': 2.23,
    // pythagoras
    'major-tenth': 2.5,
    'major-eleventh': 2.667,
    'major-twelfth': 3,
    pi: 3.14,
    // archimedes
    'double-octave': 4
};


var $e7ab165d336e639e$exports = {};

$parcel$export($e7ab165d336e639e$exports, "UNIT", function () { return $e7ab165d336e639e$export$97361b7a0c542045; });
'use strict';
const $e7ab165d336e639e$export$97361b7a0c542045 = {
    default: 'em'
};


var $d82d3d8c0ffc98e7$exports = {};

$parcel$export($d82d3d8c0ffc98e7$exports, "TYPOGRAPHY", function () { return $d82d3d8c0ffc98e7$export$d36796ab73e728d9; });

'use strict';
const $d82d3d8c0ffc98e7$var$defaultProps = {
    browserDefault: 16,
    base: 16,
    type: 'font-size',
    ratio: (0, $f8d7cccacce45137$export$34694f8d8b23ee2a)['minor-third'],
    range: [
        -3,
        12
    ],
    h1Matches: 6,
    lineHeight: 1.5,
    subSequence: true,
    mediaRegenerate: false,
    unit: 'em',
    templates: {},
    sequence: {},
    scales: {},
    vars: {}
};
const $d82d3d8c0ffc98e7$export$d36796ab73e728d9 = $d82d3d8c0ffc98e7$var$defaultProps;


var $2b80c381c86b196e$exports = {};

$parcel$export($2b80c381c86b196e$exports, "FONT", function () { return $2b80c381c86b196e$export$75d3998385cc196f; });
'use strict';
var $2b80c381c86b196e$var$defFont = {
    // eslint-disable-line
    name: '',
    url: '',
    fontStyle: '',
    fontWeight: 500,
    fontStretch: 'normal',
    fontOpticalSizing: 'auto'
};
const $2b80c381c86b196e$export$75d3998385cc196f = {};


var $04a9c5ff19c78b88$exports = {};

$parcel$export($04a9c5ff19c78b88$exports, "FONT_FAMILY", function () { return $04a9c5ff19c78b88$export$530097e879f93363; });
$parcel$export($04a9c5ff19c78b88$exports, "FONT_FAMILY_TYPES", function () { return $04a9c5ff19c78b88$export$756e583a6734f96e; });
$parcel$export($04a9c5ff19c78b88$exports, "FONT_FACE", function () { return $04a9c5ff19c78b88$export$2c16de31893252e6; });
'use strict';
var $04a9c5ff19c78b88$var$defaultFont = {
    // eslint-disable-line
    name: '',
    family: '',
    type: ''
};
const $04a9c5ff19c78b88$export$530097e879f93363 = {};
const $04a9c5ff19c78b88$export$756e583a6734f96e = {
    'sans-serif': 'Helvetica, Arial, sans-serif, --system-default',
    serif: 'Times New Roman, Georgia, serif, --system-default',
    monospace: 'Courier New, monospace, --system-default'
};
const $04a9c5ff19c78b88$export$2c16de31893252e6 = {};


var $8eb8a0d7a3e83373$exports = {};

$parcel$export($8eb8a0d7a3e83373$exports, "MEDIA", function () { return $8eb8a0d7a3e83373$export$500415a86c544f73; });
'use strict';
const $8eb8a0d7a3e83373$export$500415a86c544f73 = {
    tv: '(min-width: 2780px)',
    light: '(prefers-color-scheme: light)',
    dark: '(prefers-color-scheme: dark)',
    print: 'print'
};


var $e573589561e9e750$exports = {};

$parcel$export($e573589561e9e750$exports, "SPACING", function () { return $e573589561e9e750$export$82ea42e772d49e5b; });


'use strict';
const $e573589561e9e750$var$defaultProps = {
    base: (0, $d82d3d8c0ffc98e7$export$d36796ab73e728d9).base,
    type: 'spacing',
    ratio: (0, $f8d7cccacce45137$export$34694f8d8b23ee2a).phi,
    range: [
        -5,
        15
    ],
    subSequence: true,
    mediaRegenerate: false,
    unit: 'em',
    sequence: {},
    scales: {},
    vars: {}
};
const $e573589561e9e750$export$82ea42e772d49e5b = $e573589561e9e750$var$defaultProps;


var $b2dfd1aa2d282898$exports = {};

$parcel$export($b2dfd1aa2d282898$exports, "COLOR", function () { return $b2dfd1aa2d282898$export$9b982809044276a6; });
$parcel$export($b2dfd1aa2d282898$exports, "GRADIENT", function () { return $b2dfd1aa2d282898$export$3d856cf049c09ba8; });
'use strict';
var $b2dfd1aa2d282898$var$proto = {
    // eslint-disable-line
    name: '',
    value: ''
};
const $b2dfd1aa2d282898$export$9b982809044276a6 = {};
const $b2dfd1aa2d282898$export$3d856cf049c09ba8 = {};


var $98640742648e5ddc$exports = {};

$parcel$export($98640742648e5ddc$exports, "THEME", function () { return $98640742648e5ddc$export$5714e40777c1bcc2; });
'use strict';
const $98640742648e5ddc$var$themeA = {
    // eslint-disable-line no-unused-vars
    text: 'blue',
    background: 'white',
    border: 'black',
    // .opacity(0.2),
    active: {},
    helpers: [],
    themes: {},
    inverse: {} // schemeAInverse
};
const $98640742648e5ddc$export$5714e40777c1bcc2 = {};


var $c93bdb137db249c8$exports = {};

$parcel$export($c93bdb137db249c8$exports, "SHADOW", function () { return $c93bdb137db249c8$export$98b6069deb71e13e; });
'use strict';
const $c93bdb137db249c8$var$shadow = {
    // eslint-disable-line
    name: 'primaryShadow',
    boxShadow: 'gray12, 0 0px 50px 50px'
};
const $c93bdb137db249c8$export$98b6069deb71e13e = {};


var $ba2d615ea48e9353$exports = {};

$parcel$export($ba2d615ea48e9353$exports, "ICONS", function () { return $ba2d615ea48e9353$export$fde44257752a9f60; });
$parcel$export($ba2d615ea48e9353$exports, "SEMANTIC_ICONS", function () { return $ba2d615ea48e9353$export$e63edd959d6ceec9; });
'use strict';
const $ba2d615ea48e9353$export$fde44257752a9f60 = {};
const $ba2d615ea48e9353$export$e63edd959d6ceec9 = {};


var $5aad2c9281a7f70c$exports = {};

$parcel$export($5aad2c9281a7f70c$exports, "TIMING", function () { return $5aad2c9281a7f70c$export$3c9e9dc0cdfaa753; });

'use strict';
const $5aad2c9281a7f70c$var$defaultProps = {
    default: 150,
    base: 150,
    type: 'timing',
    ratio: (0, $f8d7cccacce45137$export$34694f8d8b23ee2a)['perfect-fourth'],
    range: [
        -3,
        12
    ],
    mediaRegenerate: false,
    unit: 'ms',
    sequence: {},
    scales: {},
    vars: {}
};
const $5aad2c9281a7f70c$export$3c9e9dc0cdfaa753 = $5aad2c9281a7f70c$var$defaultProps;


var $5370664ea9c7d3bc$exports = {};

$parcel$export($5370664ea9c7d3bc$exports, "DOCUMENT", function () { return $5370664ea9c7d3bc$export$ef011b4e114b1fba; });
'use strict';
const $5370664ea9c7d3bc$export$ef011b4e114b1fba = {};


var $1c070382006cb80b$exports = {};

$parcel$export($1c070382006cb80b$exports, "BREAKPOINTS", function () { return $1c070382006cb80b$export$426e07cd0772984d; });
$parcel$export($1c070382006cb80b$exports, "DEVICES", function () { return $1c070382006cb80b$export$7e1b78538df536d8; });
'use strict';
const $1c070382006cb80b$export$426e07cd0772984d = {
    screenL: 1920,
    screenM: 1680,
    screenS: 1440,
    tabletL: 1366,
    tabletM: 1280,
    tabletS: 1024,
    mobileL: 768,
    mobileM: 560,
    mobileS: 480,
    mobileXS: 375
};
const $1c070382006cb80b$export$7e1b78538df536d8 = {
    screenXXL: [
        2560,
        1440
    ],
    screenXL: [
        2240,
        1260
    ],
    screenL: [
        1920,
        1024
    ],
    screenM: [
        1680,
        1024
    ],
    screenS: [
        1440,
        720
    ],
    tabletL: [
        1366,
        926
    ],
    tabletM: [
        1280,
        768
    ],
    tabletS: [
        1024,
        768
    ],
    mobileL: [
        768,
        375
    ],
    mobileM: [
        560,
        768
    ],
    mobileS: [
        480,
        768
    ],
    mobileXS: [
        375,
        768
    ]
};


var $6b761d7d1b978707$exports = {};

$parcel$export($6b761d7d1b978707$exports, "CASES", function () { return $6b761d7d1b978707$export$ddbef7dfaa374d2d; });
'use strict';
const $6b761d7d1b978707$export$ddbef7dfaa374d2d = {};


var $b7fc8c43764dabea$exports = {};

$parcel$export($b7fc8c43764dabea$exports, "ANIMATION", function () { return $b7fc8c43764dabea$export$a8fef325e42f6db3; });
'use strict';
const $b7fc8c43764dabea$export$a8fef325e42f6db3 = {};


var $06f7d759d116e966$exports = {};

$parcel$export($06f7d759d116e966$exports, "SVG", function () { return $06f7d759d116e966$export$13f4b12aafeba5d6; });
$parcel$export($06f7d759d116e966$exports, "SVG_DATA", function () { return $06f7d759d116e966$export$9738e40199601663; });
'use strict';
const $06f7d759d116e966$export$13f4b12aafeba5d6 = {};
const $06f7d759d116e966$export$9738e40199601663 = {};


var $4e1d40ebea6cc811$exports = {};

$parcel$export($4e1d40ebea6cc811$exports, "TEMPLATES", function () { return $4e1d40ebea6cc811$export$b8020e85ad90bfe5; });
'use strict';
const $4e1d40ebea6cc811$export$b8020e85ad90bfe5 = {};


var $98e19dabe8c72ac0$exports = {};

$parcel$export($98e19dabe8c72ac0$exports, "GRID", function () { return $98e19dabe8c72ac0$export$e2b0b9a5e613f348; });
'use strict';
const $98e19dabe8c72ac0$var$defaultProps = {};
const $98e19dabe8c72ac0$export$e2b0b9a5e613f348 = $98e19dabe8c72ac0$var$defaultProps;


var $8c331b502dba2b60$exports = {};

$parcel$export($8c331b502dba2b60$exports, "CLASS", function () { return $8c331b502dba2b60$export$6120d77db9a8f6cb; });
'use strict';
const $8c331b502dba2b60$var$defaultProps = {};
const $8c331b502dba2b60$export$6120d77db9a8f6cb = $8c331b502dba2b60$var$defaultProps;


'use strict';
const $3e5c92ae435958cf$export$4a991c87e640ef77 = {};
$parcel$exportWildcard($3e5c92ae435958cf$exports, $f8d7cccacce45137$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $e7ab165d336e639e$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $d82d3d8c0ffc98e7$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $2b80c381c86b196e$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $04a9c5ff19c78b88$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $8eb8a0d7a3e83373$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $e573589561e9e750$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $b2dfd1aa2d282898$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $98640742648e5ddc$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $c93bdb137db249c8$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $ba2d615ea48e9353$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $5aad2c9281a7f70c$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $5370664ea9c7d3bc$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $1c070382006cb80b$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $6b761d7d1b978707$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $b7fc8c43764dabea$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $06f7d759d116e966$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $4e1d40ebea6cc811$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $98e19dabe8c72ac0$exports);
$parcel$exportWildcard($3e5c92ae435958cf$exports, $8c331b502dba2b60$exports);


'use strict';
const $6c2510166886baa2$export$220f2e5d84ced4cb = {};
const $6c2510166886baa2$export$1630b5343357e8b5 = {
    verbose: false,
    useVariable: true,
    useReset: true,
    CSS_VARS: $6c2510166886baa2$export$220f2e5d84ced4cb,
    ...$3e5c92ae435958cf$exports.default || $3e5c92ae435958cf$exports
};
const $6c2510166886baa2$var$cachedConfig = (0, $jm0BQ.deepClone)($6c2510166886baa2$export$1630b5343357e8b5);
const $6c2510166886baa2$export$ee513c29aad6cc62 = {
    active: '0',
    0: $6c2510166886baa2$export$1630b5343357e8b5
};
const $6c2510166886baa2$export$8a278b801d0668ff = (def)=>{
    if ((0, $amNJ8.isDefined)(def)) $6c2510166886baa2$export$ee513c29aad6cc62.active = def;
    return $6c2510166886baa2$export$ee513c29aad6cc62[def || $6c2510166886baa2$export$ee513c29aad6cc62.active];
};
const $6c2510166886baa2$export$e23c3d522afb24cd = (def)=>{
    return $6c2510166886baa2$export$ee513c29aad6cc62[def || $6c2510166886baa2$export$ee513c29aad6cc62.active] || $6c2510166886baa2$export$1630b5343357e8b5;
};
const $6c2510166886baa2$export$5e61d1b6fff0c794 = (newConfig)=>{
    if (!(0, $amNJ8.isObject)(newConfig)) return;
    $6c2510166886baa2$export$ee513c29aad6cc62.active = '1';
    $6c2510166886baa2$export$ee513c29aad6cc62['1'] = (0, $jm0BQ.deepMerge)(newConfig, (0, $jm0BQ.deepClone)($6c2510166886baa2$var$cachedConfig));
    return newConfig;
};



'use strict';
const $ba3cd441ab4bb524$export$81ab9dc24d52c4ba = {
    '-6': 'U',
    '-5': 'V',
    '-4': 'W',
    '-3': 'X',
    '-2': 'Y',
    '-1': 'Z',
    0: 'A',
    1: 'B',
    2: 'C',
    3: 'D',
    4: 'E',
    5: 'F',
    6: 'G',
    7: 'H',
    8: 'I',
    9: 'J',
    10: 'K',
    11: 'L',
    12: 'M',
    13: 'N',
    14: 'O',
    15: 'P',
    16: 'Q',
    17: 'R',
    18: 'S',
    19: 'T'
};
const $ba3cd441ab4bb524$var$setSequenceValue = (props, sequenceProps)=>{
    const { key: key, variable: variable, value: value, scaling: scaling, index: index, scalingVariable: scalingVariable } = props;
    sequenceProps.sequence[key] = {
        key: key,
        decimal: ~~(value * 100) / 100,
        val: ~~value,
        scaling: scaling,
        index: index,
        scalingVariable: scalingVariable,
        variable: variable
    };
    sequenceProps.scales[key] = scaling;
    sequenceProps.vars[variable] = scaling + sequenceProps.unit;
};
const $ba3cd441ab4bb524$export$68dfa61d698afbde = (key, sequenceProps)=>{
    const { base: base, type: type, unit: unit } = sequenceProps;
    const defaultVal = ((0, $1597a9be83012ede$export$6a836bb704f10b75)(unit) ? 1 : base) + unit;
    if (key === 0) return defaultVal;
    const prefix = '--' + (type && type.replace('.', '-'));
    const ratioVar = `${prefix}-ratio`;
    if (key > 0) {
        const prevLetterKey = $ba3cd441ab4bb524$export$81ab9dc24d52c4ba[key - 1];
        return `calc(var(${prefix}-${prevLetterKey}) * var(${ratioVar}))`;
    }
    if (key < 0) {
        const nextLetterKey = $ba3cd441ab4bb524$export$81ab9dc24d52c4ba[key + 1];
        return `calc(var(${prefix}-${nextLetterKey}) / var(${ratioVar}))`;
    }
};
const $ba3cd441ab4bb524$export$c9d5ef57eeb83fa = (index, arr, variable, sequenceProps)=>{
    const { type: type } = sequenceProps;
    const skipMiddle = index === 2 && arr.length === 2;
    const indexMapWithLength = skipMiddle ? index + 1 : index;
    const prefix = '--' + (type && type.replace('.', '-'));
    const subRatioVarPrefix = `${prefix}-sub-ratio-`;
    return `calc(var(${variable}) * var(${subRatioVarPrefix + indexMapWithLength}))`;
};
const $ba3cd441ab4bb524$export$12adf55fdaa50348 = (base, ratio)=>{
    const diff = base * ratio - base;
    const subRatio = diff / 1.618;
    const first = base * ratio - subRatio;
    const second = base + subRatio;
    const middle = (first + second) / 2;
    return [
        first,
        middle,
        second
    ];
};
const $ba3cd441ab4bb524$export$50db87b17b1557b4 = (base, ratio)=>{
    return $ba3cd441ab4bb524$export$12adf55fdaa50348(base, ratio).map((v)=>v / base);
};
const $ba3cd441ab4bb524$export$622ae6209895c34e = (props, sequenceProps)=>{
    const { key: key, base: base, value: value, ratio: ratio, variable: variable, index: index } = props;
    const next = value * ratio;
    const diffRounded = ~~next - ~~value;
    let arr;
    const [first, middle, second] = $ba3cd441ab4bb524$export$12adf55fdaa50348(value, ratio);
    if (diffRounded > 16) arr = [
        first,
        middle,
        second
    ];
    else arr = [
        first,
        second
    ];
    arr.forEach((v, k)=>{
        const scaling = ~~(v / base * 1000) / 1000;
        const newVar = variable + (k + 1);
        const newIndex = index + (k + 1) / 10;
        const scalingVariable = $ba3cd441ab4bb524$export$c9d5ef57eeb83fa(k + 1, arr, variable, sequenceProps);
        const props = {
            key: key + (k + 1),
            variable: newVar,
            value: v,
            scaling: scaling,
            scalingVariable: scalingVariable,
            index: newIndex
        };
        $ba3cd441ab4bb524$var$setSequenceValue(props, sequenceProps);
    });
};
const $ba3cd441ab4bb524$var$switchSequenceOnNegative = (key, base, ratio)=>{
    // const values = Object.values(SEQUENCE)
    // const index = values.indexOf(ratio)
    // const diffRatio = ratio / SPACING.ratio
    // const total = values[values.length - 1] - values[0]
    // const avg = total / 2
    // const diff = avg - ratio
    // const scale = total / ratio
    // const finalDiff = avg + avg / diffRatio
    // if (key < 0) return base * Math.pow(avg, key)
    return base * Math.pow(ratio, key);
};
const $ba3cd441ab4bb524$export$29708af739d9b0fc = (sequenceProps)=>{
    const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence } = sequenceProps;
    const n = Math.abs(range[0]) + Math.abs(range[1]);
    const prefix = '--' + (type && type.replace('.', '-')) + '-';
    for(let i = 0; i <= n; i++){
        const key = range[1] - i;
        const letterKey = $ba3cd441ab4bb524$export$81ab9dc24d52c4ba[key];
        const value = $ba3cd441ab4bb524$var$switchSequenceOnNegative(key, base, ratio);
        const scaling = ~~(value / base * 100) / 100;
        const variable = prefix + letterKey;
        const scalingVariable = $ba3cd441ab4bb524$export$68dfa61d698afbde(key, sequenceProps);
        const props = {
            key: letterKey,
            variable: variable,
            value: value,
            base: base,
            scaling: scaling,
            scalingVariable: scalingVariable,
            ratio: ratio,
            index: key
        };
        $ba3cd441ab4bb524$var$setSequenceValue(props, sequenceProps);
        if (subSequence) $ba3cd441ab4bb524$export$622ae6209895c34e(props, sequenceProps);
    }
    return sequenceProps;
};
const $ba3cd441ab4bb524$export$7b7c0090b74e1e64 = (sequenceProps, position = 0)=>{
    const { type: type, base: base, ratio: ratio, subSequence: subSequence } = sequenceProps;
    const letterKey = (0, $amNJ8.isString)(position) ? position : $ba3cd441ab4bb524$export$81ab9dc24d52c4ba[position];
    const index = (0, $amNJ8.isString)(position) ? Object.entries($ba3cd441ab4bb524$export$81ab9dc24d52c4ba).find(([, value])=>value === position)?.[0] : position;
    if (!letterKey) {
        console.warn(`Position ${position} is out of range in numToLetterMap`);
        return null;
    }
    const result = {
        sequence: {},
        scales: {},
        vars: {},
        ...sequenceProps
    };
    const value = base * Math.pow(ratio, index);
    const scaling = ~~(value / base * 100) / 100;
    const prefix = '--' + (type && type.replace('.', '-')) + '-';
    const variable = prefix + letterKey;
    const scalingVariable = $ba3cd441ab4bb524$export$68dfa61d698afbde(index, sequenceProps);
    const props = {
        key: letterKey,
        variable: variable,
        value: value,
        base: base,
        scaling: scaling,
        scalingVariable: scalingVariable,
        ratio: ratio,
        index: index
    };
    $ba3cd441ab4bb524$var$setSequenceValue(props, result);
    if (subSequence) $ba3cd441ab4bb524$export$622ae6209895c34e(props, result);
    return result;
};
const $ba3cd441ab4bb524$export$efde09b5692f9bd0 = (value = 'A', sequenceProps)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { UNIT: UNIT } = CONFIG;
    const { sequence: sequence, unit: unit = UNIT.default, useVariable: useVariable } = sequenceProps;
    if ((0, $amNJ8.isString)(value) && value.slice(0, 2) === '--') return `var(${value})`;
    const prefix = `--${(0, $9eb7ca543617066e$export$6401d9e8afa09755)(sequenceProps.type.replace('.', '-'))}-`;
    const startsWithDashOrLetterRegex = /^-?[a-zA-Z]/i;
    const startsWithDashOrLetter = startsWithDashOrLetterRegex.test(value);
    if (value === 'none' || value === 'auto' || value === 'unset' || value === 'inherit' || value === 'fit-content' || value === 'min-content' || value === 'max-content' || value.includes('calc') || value.includes('var') || !startsWithDashOrLetter) return value;
    const letterVal = value.toUpperCase();
    const isNegative = letterVal.slice(0, 1) === '-' ? '-' : '';
    let absValue = isNegative ? letterVal.slice(1) : letterVal;
    let mediaName = '';
    if (absValue.includes('_')) {
        mediaName = '_' + absValue.split('_')[1].toLowerCase();
        absValue = absValue.split('_')[0];
    }
    const varValue = (v)=>startsWithDashOrLetterRegex.test(v) ? `var(${prefix}${v}${mediaName})` : v;
    if (absValue.includes('+')) {
        const [first, second] = absValue.split('+');
        const joint = `${varValue(first)} + ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    } else if (absValue.includes('*')) {
        const [first, second] = absValue.split('*');
        const joint = `${varValue(first)} * ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    } else if (absValue.includes('-')) {
        // TODO: check this
        // check for the first char
        const [first, second] = absValue.split('-');
        const joint = `${varValue(first)} - ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    }
    // if subsequence is not set but value is applied
    if (!sequence[absValue] && absValue.length === 2) {
        if (CONFIG.verbose) console.warn(absValue, '- value is not found because `subSequence` is set to false');
        absValue = absValue.slice(0, 1);
    }
    if (useVariable || CONFIG.useVariable) {
        const varValue = `var(${prefix}${absValue}${mediaName})`;
        return isNegative ? `calc(${varValue} * -1)` : varValue;
    }
    const sequenceItem = sequence ? sequence[absValue] : null;
    if (!sequenceItem) return console.warn('can\'t find', sequence, absValue);
    if (unit === 'ms' || unit === 's') return isNegative + sequenceItem.val + unit;
    return isNegative + sequenceItem.scaling + unit;
};
const $ba3cd441ab4bb524$export$86c0052f25dacc45 = (value, propertyName, sequenceProps)=>{
    if (typeof value !== 'string') {
        const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
        if (CONFIG.verbose) console.warn(propertyName, value, 'is not a string');
        return {
            [propertyName]: value
        };
    }
    if (value === '-' || value === '') return {};
    return {
        [propertyName]: $ba3cd441ab4bb524$export$efde09b5692f9bd0(value, sequenceProps)
    };
};
const $ba3cd441ab4bb524$export$14c834a042d41297 = (h1Matches, index)=>$ba3cd441ab4bb524$export$81ab9dc24d52c4ba[h1Matches - index];
const $ba3cd441ab4bb524$export$8dc77c00fe04c40a = (propertyNames)=>{
    const { h1Matches: h1Matches, sequence: sequence } = propertyNames;
    return new Array(6).fill(null).map((_, i)=>{
        const findLetter = $ba3cd441ab4bb524$export$14c834a042d41297(h1Matches, i);
        return sequence[findLetter];
    });
};


var $54021ffc265b21f6$exports = {};

$parcel$export($54021ffc265b21f6$exports, "setVariables", function () { return $54021ffc265b21f6$export$7c38483ff47439d8; });
$parcel$export($54021ffc265b21f6$exports, "applySequenceGlobalVars", function () { return $54021ffc265b21f6$export$eba6b21fdce78bcd; });
$parcel$export($54021ffc265b21f6$exports, "applySequenceVars", function () { return $54021ffc265b21f6$export$97ab4e7d8ade5018; });
$parcel$export($54021ffc265b21f6$exports, "applyMediaSequenceVars", function () { return $54021ffc265b21f6$export$768e417cbfe71417; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");



'use strict';
const $54021ffc265b21f6$export$7c38483ff47439d8 = (result, key)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { CSS_VARS: CSS_VARS } = CONFIG;
    if ((0, $amNJ8.isObjectLike)(result.value)) ;
    else CSS_VARS[result.var] = result.value;
};
const $54021ffc265b21f6$export$eba6b21fdce78bcd = (vars, obj, options)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { UNIT: UNIT } = CONFIG;
    const unit = obj.unit || UNIT.default;
    const { base: base, ratio: ratio, type: type } = obj;
    const prefix = '--' + (type && type.replace('.', '-'));
    vars[`${prefix}-base`] = base;
    vars[`${prefix}-unit`] = unit;
    const ratioVar = `${prefix}-ratio`;
    vars[ratioVar] = ratio;
    const [first, middle, second] = (0, $ba3cd441ab4bb524$export$50db87b17b1557b4)(base, ratio);
    vars[`${prefix}-sub-ratio-1`] = `calc(var(${prefix}-ratio) * ${first / ratio})`;
    vars[`${prefix}-sub-ratio-2`] = `calc(var(${prefix}-ratio) * ${middle / ratio})`;
    vars[`${prefix}-sub-ratio-3`] = `calc(var(${prefix}-ratio) * ${second / ratio})`;
// vars[`${prefix}-sub-ratio-1`] = first
// vars[`${prefix}-sub-ratio-2`] = middle
// vars[`${prefix}-sub-ratio-3`] = second
};
const $54021ffc265b21f6$export$97ab4e7d8ade5018 = (FACTORY, options = {})=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { UNIT: UNIT, TIMING: TIMING, CSS_VARS: CSS_VARS } = CONFIG;
    const unit = FACTORY.unit || UNIT.default;
    const { mediaRegenerate: mediaRegenerate, sequence: sequence, scales: scales } = FACTORY;
    if (!mediaRegenerate) $54021ffc265b21f6$export$eba6b21fdce78bcd(CSS_VARS, FACTORY, options);
    for(const key in sequence){
        const item = sequence[key];
        const value = (FACTORY.type === TIMING.type ? sequence[key].val : scales[key]) + unit;
        if (!mediaRegenerate) {
            CSS_VARS[item.variable + '_default'] = value;
            CSS_VARS[item.variable] = item.scalingVariable;
            continue;
        }
        if (options.useDefault === false) CSS_VARS[item.variable] = value;
        else {
            CSS_VARS[item.variable + '_default'] = value;
            CSS_VARS[item.variable] = `var(${item.variable + '_default'})`;
        }
    }
};
const $54021ffc265b21f6$export$768e417cbfe71417 = (FACTORY, media, options = {})=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { UNIT: UNIT, MEDIA: MEDIA, CSS_VARS: CSS_VARS } = CONFIG;
    const mediaName = media.slice(1);
    const unit = FACTORY.unit || UNIT.default;
    const { mediaRegenerate: mediaRegenerate } = FACTORY;
    const { sequence: sequence, scales: scales } = FACTORY[media];
    const query = MEDIA[mediaName];
    if (!query && CONFIG.verbose) console.warn('Can\'t find media query ', query);
    // if mediaRegenerate is not applied ratio and and sequence sizes
    // will be applied using CSS vars
    if (!mediaRegenerate) {
        let underMediaQuery = CSS_VARS[`@media ${query}`];
        if (!underMediaQuery) underMediaQuery = CSS_VARS[`@media ${query}`] = {};
        $54021ffc265b21f6$export$eba6b21fdce78bcd(underMediaQuery, FACTORY[media], options);
        return;
    }
    for(const key in sequence){
        const item = sequence[key];
        const value = ((0, $1597a9be83012ede$export$6a836bb704f10b75)(unit) ? scales[key] : sequence[key].val) + unit;
        if (!query && CONFIG.verbose) console.warn('Can\'t find query ', query);
        let underMediaQuery = CSS_VARS[`@media ${query}`];
        if (!underMediaQuery) underMediaQuery = CSS_VARS[`@media ${query}`] = {};
        underMediaQuery[item.variable] = `var(${item.variable + '_' + mediaName})`;
        CSS_VARS[item.variable + '_' + mediaName] = value;
    }
};


var $84c5cfd3f5f31fd3$exports = {};

$parcel$export($84c5cfd3f5f31fd3$exports, "generateSprite", function () { return $84c5cfd3f5f31fd3$export$121b8d85aca89bf6; });
$parcel$export($84c5cfd3f5f31fd3$exports, "convertSvgToSymbol", function () { return $84c5cfd3f5f31fd3$export$510fb280711ea968; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
var $kitvZ = parcelRequire("kitvZ");

'use strict';
const $84c5cfd3f5f31fd3$var$isDev = (0, $kitvZ.isNotProduction)();
const $84c5cfd3f5f31fd3$export$121b8d85aca89bf6 = (icons)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    let sprite = '';
    for(const key in icons){
        if (CONFIG.__svg_cache[key]) continue;
        else CONFIG.__svg_cache[key] = true;
        sprite += icons[key];
    }
    return sprite;
};
const $84c5cfd3f5f31fd3$var$parseRootAttributes = (htmlString)=>{
    const val = htmlString.default || htmlString;
    if (!(0, $amNJ8.isString)(val)) {
        if ($84c5cfd3f5f31fd3$var$isDev) console.warn('parseRootAttributes:', val, 'is not a string');
        return;
    }
    const match = val.match(/<svg\s+(.*?)>/);
    if (!match || !match[1]) return {};
    const attrString = match[1];
    const attrs = attrString.match(/(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.)["']?/gm);
    return attrs.reduce((acc, attr)=>{
        const [key, value] = attr.split('=');
        acc[key] = value.replace(/['"]/g, '');
        return acc;
    }, {});
};
const $84c5cfd3f5f31fd3$var$replaceIdsAndUrls = (code, key)=>{
    const idRegex = /id="([^"]*)"/;
    const urlRegex = /url\(#([^)]*)\)/g;
    const matches = code.match(/id="([^"]*)"/g);
    let replacedCode = code;
    if ((0, $amNJ8.isArray)(matches)) matches.forEach(()=>{
        const randomKey = Math.floor(Math.random() * 100000);
        replacedCode = code.replace(idRegex, `id="${key}-${randomKey}"`).replace(urlRegex, `url(#${key}-${randomKey})`);
    });
    return replacedCode;
};
const $84c5cfd3f5f31fd3$export$510fb280711ea968 = (key, code)=>{
    const extractAttrs = $84c5cfd3f5f31fd3$var$parseRootAttributes(code);
    const { width: width, height: height } = extractAttrs;
    const viewBox = extractAttrs.viewBox || `0 0 ${width || 24} ${height || 24}`;
    const xmlns = 'http://www.w3.org/2000/svg';
    const replacedCode = $84c5cfd3f5f31fd3$var$replaceIdsAndUrls(code, key);
    let symbol = replacedCode.replace('<svg', `<symbol id="${key}" xmlns="${xmlns}" viewBox="${viewBox}"`);
    symbol = symbol.replace(/width="[^"]*"/, '');
    symbol = symbol.replace(/height="[^"]*"/, '');
    symbol = symbol.replace('</svg', '</symbol');
    return symbol;
};


'use strict';
$parcel$exportWildcard($74b1239117fb29ff$exports, $1597a9be83012ede$exports);
$parcel$exportWildcard($74b1239117fb29ff$exports, $1ed3cce889a937d1$exports);
$parcel$exportWildcard($74b1239117fb29ff$exports, $66d66f809d0fb015$exports);
$parcel$exportWildcard($74b1239117fb29ff$exports, $ff75c5d288dc2745$exports);
$parcel$exportWildcard($74b1239117fb29ff$exports, $ba3cd441ab4bb524$exports);
$parcel$exportWildcard($74b1239117fb29ff$exports, $54021ffc265b21f6$exports);
$parcel$exportWildcard($74b1239117fb29ff$exports, $84c5cfd3f5f31fd3$exports);


var $a4a3198d451be376$exports = {};
var $31bb7c46f86719dd$exports = {};

$parcel$export($31bb7c46f86719dd$exports, "getColor", function () { return $31bb7c46f86719dd$export$5551a2d24ff40153; });
$parcel$export($31bb7c46f86719dd$exports, "getMediaColor", function () { return $31bb7c46f86719dd$export$dd72f6d9deea7207; });
$parcel$export($31bb7c46f86719dd$exports, "setColor", function () { return $31bb7c46f86719dd$export$130a5dc1bc9cd8e1; });
$parcel$export($31bb7c46f86719dd$exports, "setGradient", function () { return $31bb7c46f86719dd$export$afaa8352c6a43a44; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");


'use strict';
const $31bb7c46f86719dd$export$5551a2d24ff40153 = (value, key, config)=>{
    const CONFIG = config || (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    if (!(0, $amNJ8.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, '- type for color is not valid');
        return;
    }
    if (value.slice(0, 2) === '--') return `var(${value})`;
    if (key && value[key]) value = value[key];
    const [name, alpha, tone] = (0, $amNJ8.isArray)(value) ? value : value.split(' ');
    const { COLOR: COLOR, GRADIENT: GRADIENT } = CONFIG;
    let val = COLOR[name] || GRADIENT[name];
    if (!val) {
        if (CONFIG.verbose) console.warn('Can\'t find color ', name);
        return value;
    }
    if (key) {
        if (val[key]) val = val[key];
        else if (CONFIG.verbose) console.warn(value, ' - does not have ', key);
    }
    // TODO: support variables
    // if (alpha) return `rgba(var(${val[shade || ''].var}), ${modifier})`
    let rgb = val.rgb;
    if (!rgb) return CONFIG.useVariable ? `var(${val.var})` : val.value;
    if (tone && !val[tone]) {
        rgb = (0, $1ed3cce889a937d1$export$2d78fefdcfb7f222)(rgb, tone);
        val[tone] = {
            rgb: rgb,
            var: `${val.var}-${tone}`
        };
    }
    if (val[tone]) rgb = val[tone].rgb;
    if (alpha) return `rgba(${rgb}, ${alpha})`;
    return CONFIG.useVariable ? `var(${val.var})` : `rgb(${rgb})`;
};
const $31bb7c46f86719dd$export$dd72f6d9deea7207 = (value, globalTheme, config)=>{
    const CONFIG = config || (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    if (!globalTheme) globalTheme = CONFIG.globalTheme;
    if (!(0, $amNJ8.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, '- type for color is not valid');
        return;
    }
    if (value.slice(0, 2) === '--') return `var(${value})`;
    const [name] = (0, $amNJ8.isArray)(value) ? value : value.split(' ');
    const { COLOR: COLOR, GRADIENT: GRADIENT } = CONFIG;
    const val = COLOR[name] || GRADIENT[name];
    const isObj = (0, $amNJ8.isObject)(val);
    if (isObj && val.value) return $31bb7c46f86719dd$export$5551a2d24ff40153(value, `@${globalTheme}`, config);
    else if (isObj) {
        if (globalTheme) return $31bb7c46f86719dd$export$5551a2d24ff40153(value, `@${globalTheme}`, config);
        else {
            const obj = {};
            for(const mediaName in val){
                const query = CONFIG.MEDIA[mediaName.slice(1)];
                const media = '@media ' + (query === 'print' ? `${query}` : `screen and ${query}`);
                obj[media] = $31bb7c46f86719dd$export$5551a2d24ff40153(value, mediaName, config);
            }
            return obj;
        }
    } else {
        if (CONFIG.verbose) console.warn('Can\'t find color', value);
        return value;
    }
};
const $31bb7c46f86719dd$export$130a5dc1bc9cd8e1 = (val, key, suffix)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    if ((0, $amNJ8.isString)(val) && val.slice(0, 2) === '--') {
        val = $31bb7c46f86719dd$export$5551a2d24ff40153(val.slice(2));
        if (!(val.includes('rgb') || val.includes('var') || val.includes('#'))) {
            if (CONFIG.verbose) console.warn(val, '- referred but does not exist');
            val = val.split(' ')[0];
        }
    }
    if ((0, $amNJ8.isArray)(val)) return {
        '@light': $31bb7c46f86719dd$export$130a5dc1bc9cd8e1(val[0], key, 'light'),
        '@dark': $31bb7c46f86719dd$export$130a5dc1bc9cd8e1(val[1], key, 'dark')
    };
    if ((0, $amNJ8.isObject)(val)) {
        const obj = {};
        for(const variant in val)obj[variant] = $31bb7c46f86719dd$export$130a5dc1bc9cd8e1(val[variant], key, variant.slice(0, 1) === '@' ? variant.slice(1) : variant);
        return obj;
    }
    const CSSVar = `--color-${key}` + (suffix ? `-${suffix}` : '');
    const colorArr = (0, $1ed3cce889a937d1$export$fa32e9c99a43479e)(val.value || val);
    const [r, g, b, a = 1] = colorArr;
    const alpha = parseFloat(a.toFixed(2));
    const rgb = `${r}, ${g}, ${b}`;
    const value = `rgba(${rgb}, ${alpha})`;
    if (CONFIG.useVariable) CONFIG.CSS_VARS[CSSVar] = value;
    return {
        var: CSSVar,
        rgb: rgb,
        alpha: alpha,
        value: value
    };
};
const $31bb7c46f86719dd$export$afaa8352c6a43a44 = (val, key, suffix)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    if ((0, $amNJ8.isString)(val) && val.slice(0, 2) === '--') val = $31bb7c46f86719dd$export$5551a2d24ff40153(val.slice(2));
    if ((0, $amNJ8.isArray)(val)) return {
        '@light': $31bb7c46f86719dd$export$afaa8352c6a43a44(val[0], key, 'light'),
        '@dark': $31bb7c46f86719dd$export$afaa8352c6a43a44(val[0], key, 'dark')
    };
    if ((0, $amNJ8.isObject)(val)) {
        const obj = {};
        for(const variant in val)obj[variant] = $31bb7c46f86719dd$export$afaa8352c6a43a44(val[variant], key, variant.slice(0, 1) === '@' ? variant.slice(1) : variant);
        return obj;
    }
    const CSSVar = `--gradient-${key}` + (suffix ? `-${suffix}` : '');
    if (CONFIG.useVariable) CONFIG.CSS_VARS[CSSVar] = val.value || val;
    return {
        var: CSSVar,
        value: val.value || val
    };
};


var $50d2ff83e590f376$exports = {};

$parcel$export($50d2ff83e590f376$exports, "getTheme", function () { return $50d2ff83e590f376$export$89cbf1a0881c8b9c; });
$parcel$export($50d2ff83e590f376$exports, "getMediaTheme", function () { return $50d2ff83e590f376$export$b3cf7317de2f2233; });
$parcel$export($50d2ff83e590f376$exports, "setTheme", function () { return $50d2ff83e590f376$export$2e49b867b7a0847c; });
$parcel$export($50d2ff83e590f376$exports, "setMediaTheme", function () { return $50d2ff83e590f376$export$c57b11cd015ce162; });


parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $50d2ff83e590f376$var$setThemeValue = (theme)=>{
    const value = {};
    const { state: state, media: media, helpers: helpers, ...rest } = theme;
    const keys = Object.keys(rest);
    keys.map((key)=>{
        const conditions = [
            'color',
            'Color',
            'background',
            'border'
        ];
        const isColor = conditions.some((k)=>key.includes(k));
        return value[key] = isColor ? (0, $31bb7c46f86719dd$export$5551a2d24ff40153)(theme[key]) : theme[key];
    });
    return value;
};
const $50d2ff83e590f376$var$getThemeValue = (theme)=>{
    if (theme.value) return theme.value;
    theme.value = $50d2ff83e590f376$var$setThemeValue(theme);
    return theme.value;
};
const $50d2ff83e590f376$export$89cbf1a0881c8b9c = (value, modifier)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    if (CONFIG.useVariable) return $50d2ff83e590f376$export$b3cf7317de2f2233(value, modifier);
    const { THEME: THEME } = CONFIG;
    if ((0, $amNJ8.isString)(value)) {
        const [theme, subtheme] = value.split(' ');
        const isOurTheme = THEME[theme];
        if (isOurTheme) {
            if (!subtheme && !modifier) return $50d2ff83e590f376$var$getThemeValue(isOurTheme);
            value = [
                theme,
                subtheme || modifier
            ];
        }
    }
    if ((0, $amNJ8.isObjectLike)(value) && value[1]) {
        const themeName = value[0];
        const subThemeName = value[1];
        const { helpers: helpers, media: media, state: state } = THEME[themeName];
        if (media && media[subThemeName]) return $50d2ff83e590f376$var$getThemeValue(media[subThemeName]);
        if (helpers && helpers[subThemeName]) return $50d2ff83e590f376$var$getThemeValue(helpers[subThemeName]);
        if (state && state[subThemeName]) return $50d2ff83e590f376$var$getThemeValue(state[subThemeName]);
    } else if ((0, $amNJ8.isObject)(value)) return $50d2ff83e590f376$var$setThemeValue(value);
};
const $50d2ff83e590f376$var$setInverseTheme = (theme, variant, value)=>{
    if ((0, $amNJ8.isObject)(variant)) theme.variants.inverse.value = $50d2ff83e590f376$var$setThemeValue(variant);
    else if (variant === true) {
        const { color: color, background: background } = value;
        theme.variants.inverse = {
            value: {
                color: background,
                background: color
            }
        };
    }
};
const $50d2ff83e590f376$var$setPseudo = (theme, key, variant, themeValue)=>{
    const result = $50d2ff83e590f376$export$89cbf1a0881c8b9c(variant);
    themeValue[`&:${key}`] = result;
    if ((0, $amNJ8.isObject)(variant) && !variant.value) variant.value = result;
};
const $50d2ff83e590f376$var$setSelectors = (theme, value)=>{
    const { state: state } = theme;
    if (!state) return;
    const keys = Object.keys(state);
    keys.map((key)=>{
        const variant = state[key];
        $50d2ff83e590f376$var$setPseudo(theme, key, variant, value);
        return theme;
    });
    return theme;
};
const $50d2ff83e590f376$var$setPrefersScheme = (theme, key, variant, themeValue)=>{
    const result = $50d2ff83e590f376$export$89cbf1a0881c8b9c(variant);
    themeValue[`@media (prefers-color-scheme: ${key})`] = result;
    if ((0, $amNJ8.isObject)(variant) && !variant.value) variant.value = result;
};
const $50d2ff83e590f376$var$setMedia = (theme, value)=>{
    const { media: media } = theme;
    if (!media) return;
    const keys = Object.keys(media);
    keys.map((key)=>{
        const variant = media[key];
        if (key === 'dark' || key === 'light') $50d2ff83e590f376$var$setPrefersScheme(theme, key, variant, value);
        if (key === 'inverse') $50d2ff83e590f376$var$setInverseTheme(theme, variant, value);
        return theme;
    });
    return theme;
};
const $50d2ff83e590f376$var$setHelpers = (theme, value)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { helpers: helpers } = theme;
    if (!helpers) return;
    const keys = Object.keys(helpers);
    keys.map((key)=>{
        const helper = helpers[key];
        if ((0, $amNJ8.isString)(helper)) helpers[key] = CONFIG.THEME[helper];
        else $50d2ff83e590f376$var$getThemeValue(helpers[key]);
        return theme;
    });
    return theme;
};
const $50d2ff83e590f376$export$2e49b867b7a0847c = (val, key)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    if (CONFIG.useVariable) return $50d2ff83e590f376$export$c57b11cd015ce162(val, key);
    const { state: state, media: media, helpers: helpers } = val;
    const value = $50d2ff83e590f376$var$setThemeValue(val, key);
    const CSSvar = `--theme-${key}`;
    $50d2ff83e590f376$var$setSelectors(val, value);
    $50d2ff83e590f376$var$setMedia(val, value);
    $50d2ff83e590f376$var$setHelpers(val, value);
    return {
        var: CSSvar,
        value: value,
        state: state,
        media: media,
        helpers: helpers
    };
};
const $50d2ff83e590f376$var$keySetters = {
    // eslint-disable-line
    '@': (theme, value)=>$50d2ff83e590f376$var$setMedia(theme, value),
    ':': (theme, value)=>$50d2ff83e590f376$var$setSelectors(theme, value),
    '.': (theme, value)=>$50d2ff83e590f376$var$setHelpers(theme, value)
};
const $50d2ff83e590f376$export$c57b11cd015ce162 = (val, key, suffix, prefers)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { CSS_VARS: CSS_VARS } = CONFIG;
    const theme = {
        value: val
    };
    if ((0, $amNJ8.isObjectLike)(val)) {
        for(const param in val){
            const symb = param.slice(0, 1);
            const value = val[param];
            if (symb === '@' || symb === ':' || symb === '.') {
                const hasPrefers = symb === '@' && param;
                theme[param] = $50d2ff83e590f376$export$c57b11cd015ce162(value, key, param, prefers || hasPrefers);
            } else {
                const color = (0, $31bb7c46f86719dd$export$5551a2d24ff40153)(value, prefers);
                const metaSuffixes = [
                    ...new Set([
                        prefers,
                        suffix
                    ].filter((v)=>v).map((v)=>v.slice(1)))
                ];
                const varmetaSuffixName = metaSuffixes.length ? '-' + metaSuffixes.join('-') : '';
                const CSSVar = `--theme-${key}${varmetaSuffixName}-${param}`;
                if (CONFIG.useVariable) {
                    CSS_VARS[CSSVar] = color;
                    theme[param] = `var(${CSSVar})`;
                } else theme[param] = color;
                theme[`.${param}`] = {
                    [param]: theme[param]
                };
            }
        }
        if (theme.background || theme.color || theme.backgroundColor) theme['.inversed'] = {
            color: theme.background || theme.backgroundColor,
            background: theme.color
        };
    }
    if ((0, $amNJ8.isString)(val) && val.slice(0, 2) === '--') {
        const { THEME: THEME } = CONFIG;
        const value = THEME[val.slice(2)];
        const getReferenced = $50d2ff83e590f376$export$b3cf7317de2f2233(value, prefers);
        return getReferenced;
    }
    return theme;
};
const $50d2ff83e590f376$var$recursiveTheme = (val)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const obj = {};
    for(const param in val){
        const symb = param.slice(0, 1);
        if ((0, $amNJ8.isObjectLike)(val[param])) {
            if (symb === '@') {
                const query = CONFIG.MEDIA[param.slice(1)];
                const media = '@media ' + (query === 'print' ? `${query}` : `screen and ${query}`);
                obj[media] = $50d2ff83e590f376$var$recursiveTheme(val[param]);
            } else if (symb === ':') obj[`&${param}`] = $50d2ff83e590f376$var$recursiveTheme(val[param]);
        } else obj[param] = val[param];
    }
    return obj;
};
const $50d2ff83e590f376$var$findModifierFromArray = (val, modifierArray)=>{
    const currentMod = modifierArray.shift();
    if (val[currentMod]) return $50d2ff83e590f376$var$findModifierFromArray(val[currentMod], modifierArray);
    return val;
};
const $50d2ff83e590f376$var$findModifier = (val, modifier)=>{
    if ((0, $amNJ8.isArray)(modifier)) return $50d2ff83e590f376$var$findModifierFromArray(val, modifier);
    else if ((0, $amNJ8.isString)(modifier) && val[modifier]) return val[modifier];
    else return val;
};
const $50d2ff83e590f376$var$checkForReference = (val, callback)=>{
    if ((0, $amNJ8.isString)(val) && val.slice(0, 2) === '--') return $50d2ff83e590f376$export$b3cf7317de2f2233(val.slice(2));
    return val;
};
const $50d2ff83e590f376$var$checkThemeReference = (val)=>$50d2ff83e590f376$var$checkForReference(val, $50d2ff83e590f376$var$checkThemeReference); // eslint-disable-line
const $50d2ff83e590f376$export$b3cf7317de2f2233 = (value, modifier)=>{
    const activeConfig = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    if ((0, $amNJ8.isString)(value) && value.slice(0, 2) === '--') value = $50d2ff83e590f376$export$b3cf7317de2f2233(value.slice(2));
    if (!value || !(0, $amNJ8.isString)(value)) {
        if (activeConfig.verbose) console.warn(`${value} - Theme is not a string`);
        return;
    }
    const [themeName, ...themeModifiers] = (0, $amNJ8.isArray)(value) ? value : value.split(' ');
    let themeValue = activeConfig.THEME[themeName];
    if (themeValue && (themeModifiers || modifier)) themeValue = $50d2ff83e590f376$var$findModifier(themeValue, themeModifiers.length ? themeModifiers : modifier);
    const resolvedTheme = $50d2ff83e590f376$var$recursiveTheme(themeValue);
    return resolvedTheme;
};


var $4474b96e1a761f26$exports = {};

$parcel$export($4474b96e1a761f26$exports, "setFont", function () { return $4474b96e1a761f26$export$69e9bdef456a9c46; });
$parcel$export($4474b96e1a761f26$exports, "getFontFamily", function () { return $4474b96e1a761f26$export$c4930fc256cef44f; });
$parcel$export($4474b96e1a761f26$exports, "setFontFamily", function () { return $4474b96e1a761f26$export$5fae120d779aafec; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");



'use strict';
const $4474b96e1a761f26$export$69e9bdef456a9c46 = (val, key)=>{
    const CSSvar = `--font-${key}`;
    if (!val || (0, $amNJ8.isArray)(val) && !val[0]) return;
    const fontFace = val[0] ? (0, $ff75c5d288dc2745$export$198e04e3616f042a)(key, val) : (0, $ff75c5d288dc2745$export$2593ac3417be5ed7)(key, val.url);
    return {
        var: CSSvar,
        value: val,
        fontFace: fontFace
    };
};
const $4474b96e1a761f26$export$c4930fc256cef44f = (key, factory)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { FONT_FAMILY: FONT_FAMILY } = CONFIG;
    return (0, $ff75c5d288dc2745$export$73aa7d12a2d2fb83)(factory || FONT_FAMILY, key);
};
const $4474b96e1a761f26$export$5fae120d779aafec = (val, key)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { FONT_FAMILY: FONT_FAMILY, FONT_FAMILY_TYPES: FONT_FAMILY_TYPES } = CONFIG;
    let { value: value, type: type } = val;
    if (val.isDefault) FONT_FAMILY.default = key;
    if ((0, $amNJ8.isObject)(value)) value = (0, $9eb7ca543617066e$export$d1ef4b1a340dec10)(value);
    const CSSvar = `--font-family-${key}`;
    const str = `${value.join(', ')}, ${FONT_FAMILY_TYPES[type]}`;
    return {
        var: CSSvar,
        value: str,
        arr: value,
        type: type
    };
};


var $2cd01d71c583d41c$exports = {};

$parcel$export($2cd01d71c583d41c$exports, "runThroughMedia", function () { return $2cd01d71c583d41c$export$ee622839cb6e2b5d; });
$parcel$export($2cd01d71c583d41c$exports, "applyHeadings", function () { return $2cd01d71c583d41c$export$7fc39a69c6299a60; });
$parcel$export($2cd01d71c583d41c$exports, "applyTypographySequence", function () { return $2cd01d71c583d41c$export$7c7d7b0d076fe8b5; });
$parcel$export($2cd01d71c583d41c$exports, "getFontSizeByKey", function () { return $2cd01d71c583d41c$export$ea9b2cd64205746b; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");


'use strict';
const $2cd01d71c583d41c$export$ee622839cb6e2b5d = (FACTORY)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { TYPOGRAPHY: TYPOGRAPHY, MEDIA: MEDIA } = CONFIG;
    for(const prop in FACTORY){
        const isPropMedia = prop.slice(0, 1) === '@';
        const mediaValue = FACTORY[prop];
        if (!isPropMedia) continue;
        const { mediaRegenerate: mediaRegenerate } = FACTORY;
        const mediaName = prop.slice(1);
        const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence, h1Matches: h1Matches, unit: unit } = FACTORY;
        (0, $jm0BQ.merge)(mediaValue, {
            type: type,
            base: base,
            ratio: ratio,
            range: range,
            subSequence: subSequence,
            h1Matches: h1Matches,
            unit: unit
        });
        const query = MEDIA[mediaName];
        const media = '@media ' + (query === 'print' ? `${query}` : `screen and ${query}`);
        TYPOGRAPHY.templates[media] = {
            fontSize: mediaValue.base / TYPOGRAPHY.browserDefault + unit
        };
        if (!mediaRegenerate) {
            (0, $54021ffc265b21f6$export$768e417cbfe71417)(FACTORY, prop);
            continue;
        }
        (0, $jm0BQ.merge)(mediaValue, {
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        });
        (0, $ba3cd441ab4bb524$export$29708af739d9b0fc)(mediaValue);
        (0, $54021ffc265b21f6$export$768e417cbfe71417)(FACTORY, prop);
    }
};
const $2cd01d71c583d41c$export$7fc39a69c6299a60 = (props)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    if (props.h1Matches) {
        const unit = props.unit;
        const HEADINGS = (0, $ba3cd441ab4bb524$export$8dc77c00fe04c40a)(props);
        const { templates: templates } = props;
        for(const k in HEADINGS){
            const headerName = `h${parseInt(k) + 1}`;
            const headerStyle = templates[headerName];
            templates[headerName] = {
                fontSize: CONFIG.useVariable ? `var(${HEADINGS[k]?.variable})` : `${HEADINGS[k]?.scaling}${unit}`,
                margin: headerStyle ? headerStyle.margin : 0,
                lineHeight: headerStyle ? headerStyle.lineHeight : props.lineHeight,
                letterSpacing: headerStyle ? headerStyle.letterSpacing : props.letterSpacing,
                fontWeight: headerStyle ? headerStyle.fontWeight : 900 - k * 100
            };
        }
    }
};
const $2cd01d71c583d41c$export$7c7d7b0d076fe8b5 = ()=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { TYPOGRAPHY: TYPOGRAPHY } = CONFIG;
    (0, $ba3cd441ab4bb524$export$29708af739d9b0fc)(TYPOGRAPHY);
    $2cd01d71c583d41c$export$7fc39a69c6299a60(TYPOGRAPHY);
    (0, $54021ffc265b21f6$export$97ab4e7d8ade5018)(TYPOGRAPHY);
    $2cd01d71c583d41c$export$ee622839cb6e2b5d(TYPOGRAPHY);
};
const $2cd01d71c583d41c$export$ea9b2cd64205746b = (value)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { TYPOGRAPHY: TYPOGRAPHY } = CONFIG;
    return (0, $ba3cd441ab4bb524$export$86c0052f25dacc45)(value, 'fontSize', TYPOGRAPHY);
};


var $8d2bd189328d3a32$exports = {};

$parcel$export($8d2bd189328d3a32$exports, "applySpacingSequence", function () { return $8d2bd189328d3a32$export$9bfe8384addafa7c; });
$parcel$export($8d2bd189328d3a32$exports, "getSpacingByKey", function () { return $8d2bd189328d3a32$export$4f949d23b5dbefe6; });
$parcel$export($8d2bd189328d3a32$exports, "getSpacingBasedOnRatio", function () { return $8d2bd189328d3a32$export$94679ba49f16fc2e; });

parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
var $jm0BQ = parcelRequire("jm0BQ");


'use strict';
const $8d2bd189328d3a32$var$runThroughMedia = (FACTORY)=>{
    for(const prop in FACTORY){
        const mediaProps = FACTORY[prop];
        const isMediaName = prop.slice(0, 1) === '@';
        if (!isMediaName) continue;
        const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence, h1Matches: h1Matches, unit: unit } = FACTORY;
        (0, $jm0BQ.merge)(mediaProps, {
            type: type,
            base: base,
            ratio: ratio,
            range: range,
            subSequence: subSequence,
            h1Matches: h1Matches,
            unit: unit,
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        });
        (0, $ba3cd441ab4bb524$export$29708af739d9b0fc)(mediaProps);
        (0, $54021ffc265b21f6$export$768e417cbfe71417)(FACTORY, prop);
    }
};
const $8d2bd189328d3a32$export$9bfe8384addafa7c = ()=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { SPACING: SPACING } = CONFIG;
    (0, $ba3cd441ab4bb524$export$29708af739d9b0fc)(SPACING);
    (0, $54021ffc265b21f6$export$97ab4e7d8ade5018)(SPACING);
    $8d2bd189328d3a32$var$runThroughMedia(SPACING);
};
const $8d2bd189328d3a32$var$getSequence = (sequenceProps)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { SPACING: SPACING } = CONFIG;
    if (!sequenceProps) return SPACING;
    const hasGenerated = Object.keys(sequenceProps.sequence).length > 0;
    return hasGenerated ? sequenceProps : (0, $ba3cd441ab4bb524$export$29708af739d9b0fc)(sequenceProps);
};
const $8d2bd189328d3a32$export$4f949d23b5dbefe6 = (value, propertyName = 'padding', sequenceProps)=>{
    const sequence = $8d2bd189328d3a32$var$getSequence(sequenceProps);
    if ((0, $amNJ8.isString)(value) && (value.includes('calc') || value.includes('var'))) return {
        [propertyName]: value
    };
    const stack = (0, $9eb7ca543617066e$export$d1ef4b1a340dec10)(value);
    if (!(0, $amNJ8.isArray)(stack)) return;
    if (stack.length > 1) {
        let suffix = '';
        if (propertyName === 'borderWidth') {
            propertyName = 'border';
            suffix = 'Width';
        }
        const directions = {
            2: [
                'Block',
                'Inline'
            ],
            3: [
                'BlockStart',
                'Inline',
                'BlockEnd'
            ],
            4: [
                'BlockStart',
                'InlineEnd',
                'BlockEnd',
                'InlineStart'
            ]
        };
        const wrapSequenceValueByDirection = (direction, i)=>(0, $ba3cd441ab4bb524$export$86c0052f25dacc45)(stack[i], propertyName + direction + suffix, sequence);
        return directions[stack.length].map((dir, key)=>wrapSequenceValueByDirection(dir, key));
    }
    return (0, $ba3cd441ab4bb524$export$86c0052f25dacc45)(value, propertyName, sequence);
};
const $8d2bd189328d3a32$export$94679ba49f16fc2e = (props, propertyName, val)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { SPACING: SPACING } = CONFIG;
    const { spacingRatio: spacingRatio, unit: unit } = props;
    const value = val || props[propertyName];
    if (spacingRatio) {
        let sequenceProps = SPACING[spacingRatio];
        if (!sequenceProps) {
            const { type: type, base: base, range: range, subSequence: subSequence } = SPACING;
            sequenceProps = SPACING[spacingRatio] = (0, $jm0BQ.merge)({
                ratio: spacingRatio,
                type: type + '-' + spacingRatio,
                unit: unit,
                sequence: {},
                scales: {},
                templates: {},
                vars: {}
            }, {
                base: base,
                range: range,
                subSequence: subSequence,
                ratio: SPACING.ratio,
                unit: SPACING.unit
            });
        }
        (0, $54021ffc265b21f6$export$97ab4e7d8ade5018)(sequenceProps, {
            useDefault: false
        });
        return $8d2bd189328d3a32$export$4f949d23b5dbefe6(value, propertyName, sequenceProps);
    }
    return $8d2bd189328d3a32$export$4f949d23b5dbefe6(value, propertyName);
};


var $64681d3817a16d5b$exports = {};

$parcel$export($64681d3817a16d5b$exports, "setShadow", function () { return $64681d3817a16d5b$export$9cd3672191b5a46f; });
$parcel$export($64681d3817a16d5b$exports, "getShadow", function () { return $64681d3817a16d5b$export$db93b77dbb14f011; });



parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $64681d3817a16d5b$export$9cd3672191b5a46f = (value, key, suffix, prefers)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    // const { CSS_VARS } = CONFIG
    // const theme = { valueue: value }
    if ((0, $amNJ8.isArray)(value)) return {
        '@light': $64681d3817a16d5b$export$9cd3672191b5a46f(value[0], key, 'light'),
        '@dark': $64681d3817a16d5b$export$9cd3672191b5a46f(value[1], key, 'dark')
    };
    if ((0, $amNJ8.isObject)(value)) {
        const obj = {};
        for(const variant in value)obj[variant] = $64681d3817a16d5b$export$9cd3672191b5a46f(value[variant], key, variant.startsWith('@') ? variant.slice(1) : variant);
        return obj;
    }
    if ((0, $amNJ8.isString)(value) && value.includes(',')) value = value.split(',').map((v)=>{
        v = v.trim();
        if (v.startsWith('--')) return `var(${v})`;
        if ((0, $31bb7c46f86719dd$export$5551a2d24ff40153)(v).length > 2) return (0, $31bb7c46f86719dd$export$5551a2d24ff40153)(v);
        if (v.includes('px') || v.slice(-2) === 'em') return v;
        const arr = v.split(' ');
        if (!arr.length) return v;
        return arr.map((v)=>(0, $8d2bd189328d3a32$export$4f949d23b5dbefe6)(v, 'shadow').shadow).join(' ');
    }).join(' ');
    const CSSVar = `--shadow-${key}` + (suffix ? `-${suffix}` : '');
    if (CONFIG.useVariable) CONFIG.CSS_VARS[CSSVar] = value;
    return {
        var: CSSVar,
        value: value
    };
};
const $64681d3817a16d5b$export$db93b77dbb14f011 = (value, globalTheme)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    if (!globalTheme) globalTheme = CONFIG.globalTheme;
    if (!(0, $amNJ8.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, '- type for color is not valid');
        return;
    }
    if (value.slice(0, 2) === '--') return `var(${value})`;
    const [name] = (0, $amNJ8.isArray)(value) ? value : value.split(' ');
    const { SHADOW: SHADOW } = CONFIG;
    const val = SHADOW[name];
    const isObj = (0, $amNJ8.isObject)(val);
    if (!val) {
        if (CONFIG.verbose) console.warn('Can\'t find color ', name);
        return value;
    }
    if (globalTheme) {
        if (val[globalTheme]) return val[globalTheme].value;
        else if (CONFIG.verbose) console.warn(value, ' - does not have ', globalTheme);
    }
    if (isObj && val.value) return val.value;
    if (isObj) {
        const obj = {};
        for(const mediaName in val){
            const query = CONFIG.MEDIA[mediaName.slice(1)];
            const media = '@media ' + (query === 'print' ? `${query}` : `screen and ${query}`);
            obj[media] = val.value;
        }
        return obj;
    }
    if (CONFIG.verbose) console.warn('Can\'t find color', value);
    return value;
};


var $9779037853e3fa59$exports = {};

$parcel$export($9779037853e3fa59$exports, "applyTimingSequence", function () { return $9779037853e3fa59$export$a5be618f63a441ac; });
$parcel$export($9779037853e3fa59$exports, "getTimingFunction", function () { return $9779037853e3fa59$export$23ba66c7c3e2e613; });
$parcel$export($9779037853e3fa59$exports, "getTimingByKey", function () { return $9779037853e3fa59$export$3fa311edc5edd22f; });



'use strict';
const $9779037853e3fa59$export$a5be618f63a441ac = ()=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { TIMING: TIMING } = CONFIG;
    (0, $ba3cd441ab4bb524$export$29708af739d9b0fc)(TIMING);
    (0, $54021ffc265b21f6$export$97ab4e7d8ade5018)(TIMING);
};
const $9779037853e3fa59$export$23ba66c7c3e2e613 = (value)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { TIMING: TIMING } = CONFIG;
    return TIMING[value] || TIMING[(0, $9eb7ca543617066e$export$86f54f62aa7a7514)(value)] || value;
};
const $9779037853e3fa59$export$3fa311edc5edd22f = (value, property = 'timing')=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { TIMING: TIMING } = CONFIG;
    return (0, $ba3cd441ab4bb524$export$86c0052f25dacc45)(value, property, TIMING);
};


var $929de5633bc6bdb1$exports = {};

$parcel$export($929de5633bc6bdb1$exports, "applyDocument", function () { return $929de5633bc6bdb1$export$25b333cdc54cc186; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");


'use strict';
const $929de5633bc6bdb1$export$25b333cdc54cc186 = ()=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { DOCUMENT: DOCUMENT, FONT_FAMILY: FONT_FAMILY, THEME: THEME, TYPOGRAPHY: TYPOGRAPHY } = CONFIG;
    return (0, $jm0BQ.merge)(DOCUMENT, {
        theme: THEME.document,
        fontFamily: (0, $ff75c5d288dc2745$export$73aa7d12a2d2fb83)(FONT_FAMILY),
        fontSize: TYPOGRAPHY.base,
        lineHeight: TYPOGRAPHY.lineHeight
    });
};


var $e85e1bf37dde218c$exports = {};

$parcel$export($e85e1bf37dde218c$exports, "setSVG", function () { return $e85e1bf37dde218c$export$694c6c574069ebf2; });
$parcel$export($e85e1bf37dde218c$exports, "appendSVGSprite", function () { return $e85e1bf37dde218c$export$2c4662f4a995c568; });
$parcel$export($e85e1bf37dde218c$exports, "setSvgIcon", function () { return $e85e1bf37dde218c$export$46739718ff556447; });
$parcel$export($e85e1bf37dde218c$exports, "appendSvgIconsSprite", function () { return $e85e1bf37dde218c$export$6892263c3fbefa8c; });
parcelRequire("imR0C");
var $aLXZy = parcelRequire("aLXZy");


'use strict';
const $e85e1bf37dde218c$var$DEF_OPTIONS = {
    document: $aLXZy.document
};
const $e85e1bf37dde218c$export$694c6c574069ebf2 = (val, key)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    if (!val) {
        if (CONFIG.verbose) console.warn('setSVG: val is not defined', key);
        return;
    }
    if (CONFIG.useSvgSprite) return (0, $84c5cfd3f5f31fd3$export$510fb280711ea968)(key, val);
    return val;
};
const $e85e1bf37dde218c$export$2c4662f4a995c568 = (LIBRARY, options = $e85e1bf37dde218c$var$DEF_OPTIONS)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const lib = Object.keys(LIBRARY).length ? {} : CONFIG.SVG;
    for(const key in LIBRARY)lib[key] = CONFIG.SVG[key];
    $e85e1bf37dde218c$var$appendSVG(lib, options);
};
const $e85e1bf37dde218c$export$46739718ff556447 = (val, key)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    if (CONFIG.useIconSprite && !CONFIG.SEMANTIC_ICONS?.[key]) return $e85e1bf37dde218c$export$694c6c574069ebf2(val, key);
    return val;
};
const $e85e1bf37dde218c$export$6892263c3fbefa8c = (LIBRARY, options = $e85e1bf37dde218c$var$DEF_OPTIONS)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const lib = Object.keys(LIBRARY).length ? {} : CONFIG.ICONS;
    for(const key in LIBRARY)lib[key] = CONFIG.ICONS[key];
    $e85e1bf37dde218c$var$appendSVG(lib, options);
};
const $e85e1bf37dde218c$var$createSVGSpriteElement = (options = {
    isRoot: true
})=>{
    if (!(0, $aLXZy.document) || !(0, $aLXZy.document).createElementNS) return;
    const svgElem = (0, $aLXZy.document).createElementNS('http://www.w3.org/2000/svg', 'svg');
    if (options.isRoot) {
        svgElem.setAttribute('aria-hidden', 'true');
        svgElem.setAttribute('width', '0');
        svgElem.setAttribute('height', '0');
        svgElem.setAttribute('style', 'position:absolute');
        svgElem.setAttribute('id', 'svgSprite');
    }
    return svgElem;
};
const $e85e1bf37dde218c$var$appendSVG = (lib, options = $e85e1bf37dde218c$var$DEF_OPTIONS)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const doc = options.document || (0, $aLXZy.document);
    if (!doc || !doc.documentElement) {
        if (CONFIG.verbose) console.warn('To append SVG sprites it should be run in browser environment');
        return (0, $84c5cfd3f5f31fd3$export$121b8d85aca89bf6)(lib);
    }
    const exists = doc.querySelector('#svgSprite');
    const SVGsprite = (0, $84c5cfd3f5f31fd3$export$121b8d85aca89bf6)(lib);
    if (exists) {
        const tempSVG = $e85e1bf37dde218c$var$createSVGSpriteElement({
            isRoot: false
        });
        // const svgSpriteWithoutRoot = doc.createElement('template')
        tempSVG.innerHTML = SVGsprite;
        exists.append(...tempSVG.children);
    } else {
        const svgSpriteDOM = $e85e1bf37dde218c$var$createSVGSpriteElement();
        if (svgSpriteDOM && svgSpriteDOM.nodeType) {
            svgSpriteDOM.innerHTML = SVGsprite;
            doc.body.prepend(svgSpriteDOM);
        }
    }
};


var $1639f24c790d29ae$exports = {};

$parcel$export($1639f24c790d29ae$exports, "applyReset", function () { return $1639f24c790d29ae$export$984fb5f73961424e; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");


'use strict';
const $1639f24c790d29ae$export$984fb5f73961424e = (reset = {})=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { RESET: RESET, TYPOGRAPHY: TYPOGRAPHY, DOCUMENT: DOCUMENT } = CONFIG;
    if (RESET) {
        if (RESET[':root']) {
            const configReset = RESET;
            const configTemplates = TYPOGRAPHY.templates;
            configReset.body = {
                ...CONFIG.useDocumentTheme ? (0, $50d2ff83e590f376$export$b3cf7317de2f2233)('document', `@${CONFIG.globalTheme}`) : {},
                ...configTemplates.body
            };
            configReset.h1 = configTemplates.h1;
            configReset.h2 = configTemplates.h2;
            configReset.h3 = configTemplates.h3;
            configReset.h4 = configTemplates.h4;
            configReset.h5 = configTemplates.h5;
            configReset.h6 = configTemplates.h6;
        }
        const { body: body, ...templates } = TYPOGRAPHY.templates;
        const globalTheme = CONFIG.useDocumentTheme ? (0, $50d2ff83e590f376$export$b3cf7317de2f2233)('document', `@${CONFIG.globalTheme}`) : {};
        if (RESET.html) (0, $jm0BQ.overwriteDeep)(RESET.html, globalTheme);
        return (0, $jm0BQ.deepMerge)((0, $jm0BQ.merge)(RESET, reset), {
            html: {
                position: 'absolute',
                // overflow: 'hidden',
                width: '100%',
                height: '100%',
                top: '0',
                left: '0',
                margin: '0',
                WebkitFontSmoothing: 'subpixel-antialiased',
                scrollBehavior: 'smooth',
                ...globalTheme,
                fontSize: TYPOGRAPHY.browserDefault + 'px',
                fontFamily: DOCUMENT.fontFamily,
                lineHeight: DOCUMENT.lineHeight
            },
            body: {
                boxSizing: 'border-box',
                height: '100%',
                margin: 0,
                fontFamily: DOCUMENT.fontFamily,
                fontSize: TYPOGRAPHY.base / TYPOGRAPHY.browserDefault + CONFIG.UNIT.default,
                ...templates,
                ...body
            },
            // form elements
            fieldset: {
                border: 0,
                padding: 0,
                margin: 0
            },
            'select, input': {
                fontFamily: DOCUMENT.fontFamily
            }
        });
    }
};


'use strict';
$parcel$exportWildcard($a4a3198d451be376$exports, $31bb7c46f86719dd$exports);
$parcel$exportWildcard($a4a3198d451be376$exports, $50d2ff83e590f376$exports);
$parcel$exportWildcard($a4a3198d451be376$exports, $4474b96e1a761f26$exports);
$parcel$exportWildcard($a4a3198d451be376$exports, $2cd01d71c583d41c$exports);
$parcel$exportWildcard($a4a3198d451be376$exports, $8d2bd189328d3a32$exports);
$parcel$exportWildcard($a4a3198d451be376$exports, $64681d3817a16d5b$exports);
$parcel$exportWildcard($a4a3198d451be376$exports, $9779037853e3fa59$exports);
$parcel$exportWildcard($a4a3198d451be376$exports, $929de5633bc6bdb1$exports);
$parcel$exportWildcard($a4a3198d451be376$exports, $e85e1bf37dde218c$exports);
$parcel$exportWildcard($a4a3198d451be376$exports, $1639f24c790d29ae$exports);






var $260ce182974bc204$exports = {};

$parcel$export($260ce182974bc204$exports, "transformBorder", function () { return $260ce182974bc204$export$ca4ef6ca6dc743f2; });
$parcel$export($260ce182974bc204$exports, "transformTextStroke", function () { return $260ce182974bc204$export$8bcd50b221b13db; });
$parcel$export($260ce182974bc204$exports, "transformShadow", function () { return $260ce182974bc204$export$837e4beeff9ff924; });
$parcel$export($260ce182974bc204$exports, "transformBoxShadow", function () { return $260ce182974bc204$export$9c296746f296a70; });
$parcel$export($260ce182974bc204$exports, "transformBackgroundImage", function () { return $260ce182974bc204$export$15f2b9b64835b137; });
$parcel$export($260ce182974bc204$exports, "transfromGap", function () { return $260ce182974bc204$export$1e420ad2d0d06436; });
$parcel$export($260ce182974bc204$exports, "transformTransition", function () { return $260ce182974bc204$export$df2b736a06860be7; });
$parcel$export($260ce182974bc204$exports, "transformDuration", function () { return $260ce182974bc204$export$d87c1c5f4a8ec3d9; });
$parcel$export($260ce182974bc204$exports, "splitTransition", function () { return $260ce182974bc204$export$d9f7ff0c2b32d4b5; });
$parcel$export($260ce182974bc204$exports, "checkIfBoxSize", function () { return $260ce182974bc204$export$80eafc63c0bb6c49; });
$parcel$export($260ce182974bc204$exports, "transformSize", function () { return $260ce182974bc204$export$f09d9444954afeda; });
$parcel$export($260ce182974bc204$exports, "transformSizeRatio", function () { return $260ce182974bc204$export$b6e34d20a288a08c; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");


'use strict';
const $260ce182974bc204$var$isBorderStyle = (str)=>[
        'none',
        'hidden',
        'dotted',
        'dashed',
        'solid',
        'double',
        'groove',
        'ridge',
        'inset',
        'outset',
        'initial'
    ].some((v)=>str.includes(v));
const $260ce182974bc204$export$ca4ef6ca6dc743f2 = (border)=>{
    const arr = border.split(', ');
    return arr.map((v)=>{
        v = v.trim();
        if (v.slice(0, 2) === '--') return `var(${v})`;
        else if ($260ce182974bc204$var$isBorderStyle(v)) return v || 'solid';
        else if (v.slice(-2) === 'px' || v.slice(-2) === 'em') return v; // TODO: add map spacing
        else if ((0, $31bb7c46f86719dd$export$5551a2d24ff40153)(v).length > 2) return (0, $31bb7c46f86719dd$export$5551a2d24ff40153)(v);
        return (0, $8d2bd189328d3a32$export$4f949d23b5dbefe6)(v, 'border').border;
    }).join(' ');
};
const $260ce182974bc204$export$8bcd50b221b13db = (stroke)=>{
    return stroke.split(', ').map((v)=>{
        if (v.slice(0, 2) === '--') return `var(${v})`;
        if (v.includes('px')) return v;
        else if ((0, $31bb7c46f86719dd$export$5551a2d24ff40153)(v)) return (0, $31bb7c46f86719dd$export$5551a2d24ff40153)(v);
        return v;
    }).join(' ');
};
const $260ce182974bc204$export$837e4beeff9ff924 = (sh, globalTheme)=>(0, $64681d3817a16d5b$export$db93b77dbb14f011)(sh, globalTheme);
const $260ce182974bc204$export$9c296746f296a70 = (shadows, globalTheme)=>shadows.split('|').map((shadow)=>{
        return shadow.split(',').map((v)=>{
            v = v.trim();
            if (v.slice(0, 2) === '--') return `var(${v})`;
            if ((0, $31bb7c46f86719dd$export$5551a2d24ff40153)(v).length > 2) {
                const color = (0, $31bb7c46f86719dd$export$dd72f6d9deea7207)(v, globalTheme);
                if ((0, $amNJ8.isObject)(color)) return Object.values(color).filter((v)=>v.includes(': ' + globalTheme))[0];
                return color;
            }
            if (v.includes('px') || v.slice(-2) === 'em') return v;
            const arr = v.split(' ');
            if (!arr.length) return v;
            return arr.map((v)=>(0, $8d2bd189328d3a32$export$4f949d23b5dbefe6)(v, 'shadow').shadow).join(' ');
        }).join(' ');
    }).join(',');
const $260ce182974bc204$export$15f2b9b64835b137 = (backgroundImage, globalTheme)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    return backgroundImage.split(', ').map((v)=>{
        if (v.slice(0, 2) === '--') return `var(${v})`;
        if (v.includes('url') || v.includes('gradient')) return v;
        else if (CONFIG.GRADIENT[backgroundImage]) return {
            backgroundImage: (0, $31bb7c46f86719dd$export$dd72f6d9deea7207)(backgroundImage, globalTheme || CONFIG.globalTheme)
        };
        else if (v.includes('/') || v.startsWith('http') || v.includes('.')) return `url(${v})`;
        return v;
    }).join(' ');
};
const $260ce182974bc204$export$1e420ad2d0d06436 = (gap)=>(0, $amNJ8.isString)(gap) && gap.split(' ').map((v)=>(0, $8d2bd189328d3a32$export$4f949d23b5dbefe6)(v, 'gap').gap).join(' ');
const $260ce182974bc204$export$df2b736a06860be7 = (transition)=>{
    const arr = transition.split(' ');
    if (!arr.length) return transition;
    return arr.map((v)=>{
        if (v.slice(0, 2) === '--') return `var(${v})`;
        if (v.length < 3 || v.includes('ms')) {
            const mapWithSequence = (0, $9779037853e3fa59$export$3fa311edc5edd22f)(v);
            return mapWithSequence.timing || v;
        }
        if ((0, $9779037853e3fa59$export$23ba66c7c3e2e613)(v)) return (0, $9779037853e3fa59$export$23ba66c7c3e2e613)(v);
        return v;
    }).join(' ');
};
const $260ce182974bc204$export$d87c1c5f4a8ec3d9 = (duration, props, propertyName)=>{
    if (!(0, $amNJ8.isString)(duration)) return;
    return duration.split(',').map((v)=>(0, $9779037853e3fa59$export$3fa311edc5edd22f)(v).timing || v).join(',');
};
const $260ce182974bc204$export$d9f7ff0c2b32d4b5 = (transition)=>{
    const arr = transition.split(',');
    if (!arr.length) return;
    return arr.map($260ce182974bc204$export$df2b736a06860be7).join(',');
};
const $260ce182974bc204$export$80eafc63c0bb6c49 = (propertyName)=>{
    const prop = propertyName.toLowerCase();
    return (prop.includes('width') || prop.includes('height')) && !prop.includes('border');
};
const $260ce182974bc204$export$f09d9444954afeda = (propertyName, val, props = {}, opts = {})=>{
    let value = val || props[propertyName];
    if ((0, $amNJ8.isUndefined)(value) && (0, $amNJ8.isNull)(value)) return;
    const shouldScaleBoxSize = props.scaleBoxSize;
    const isBoxSize = $260ce182974bc204$export$80eafc63c0bb6c49(propertyName);
    if (!shouldScaleBoxSize && isBoxSize && (0, $amNJ8.isString)(value)) value = value.split(' ').map((v)=>{
        const isSingleLetter = v.length < 3 && /[A-Z]/.test(v);
        const hasUnits = [
            '%',
            'vw',
            'vh',
            'ch'
        ].some((unit)=>value.includes(unit));
        if (isSingleLetter && !hasUnits) return v + '_default';
        return v;
    }).join(' ');
    if (opts.ratio) return (0, $8d2bd189328d3a32$export$94679ba49f16fc2e)(props, propertyName, value);
    else return (0, $8d2bd189328d3a32$export$4f949d23b5dbefe6)(value, propertyName);
};
const $260ce182974bc204$export$b6e34d20a288a08c = (propertyName, props)=>{
    return $260ce182974bc204$export$f09d9444954afeda(propertyName, null, props, {
        ratio: true
    });
};


var $68d4b3e39e36311c$exports = {};

$parcel$export($68d4b3e39e36311c$exports, "VALUE_TRANSFORMERS", function () { return $68d4b3e39e36311c$export$9ae1d0dd64d4a382; });
$parcel$export($68d4b3e39e36311c$exports, "setValue", function () { return $68d4b3e39e36311c$export$80746c6bc6142fc8; });
$parcel$export($68d4b3e39e36311c$exports, "setEach", function () { return $68d4b3e39e36311c$export$943920cf7e6d5f23; });
$parcel$export($68d4b3e39e36311c$exports, "set", function () { return $68d4b3e39e36311c$export$adaa4cf7ef1b65be; });


parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $68d4b3e39e36311c$var$setCases = (val, key)=>{
    if ((0, $amNJ8.isFunction)(val)) return val();
    return val;
};
const $68d4b3e39e36311c$var$setSameValue = (val, key)=>val;
const $68d4b3e39e36311c$export$9ae1d0dd64d4a382 = {
    color: (0, $31bb7c46f86719dd$export$130a5dc1bc9cd8e1),
    gradient: (0, $31bb7c46f86719dd$export$afaa8352c6a43a44),
    font: (0, $4474b96e1a761f26$export$69e9bdef456a9c46),
    font_family: (0, $4474b96e1a761f26$export$5fae120d779aafec),
    theme: (0, $50d2ff83e590f376$export$2e49b867b7a0847c),
    icons: (0, $e85e1bf37dde218c$export$46739718ff556447),
    semantic_icons: $68d4b3e39e36311c$var$setSameValue,
    svg: (0, $e85e1bf37dde218c$export$694c6c574069ebf2),
    svg_data: $68d4b3e39e36311c$var$setSameValue,
    typography: $68d4b3e39e36311c$var$setSameValue,
    cases: $68d4b3e39e36311c$var$setCases,
    shadow: (0, $64681d3817a16d5b$export$9cd3672191b5a46f),
    spacing: $68d4b3e39e36311c$var$setSameValue,
    media: $68d4b3e39e36311c$var$setSameValue,
    grid: $68d4b3e39e36311c$var$setSameValue,
    class: $68d4b3e39e36311c$var$setSameValue,
    timing: $68d4b3e39e36311c$var$setSameValue,
    reset: $68d4b3e39e36311c$var$setSameValue,
    unit: $68d4b3e39e36311c$var$setSameValue,
    animation: $68d4b3e39e36311c$var$setSameValue
};
const $68d4b3e39e36311c$export$80746c6bc6142fc8 = (FACTORY_NAME, value, key)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const factoryName = FACTORY_NAME.toLowerCase();
    const FACTORY = CONFIG[FACTORY_NAME];
    if ($68d4b3e39e36311c$export$9ae1d0dd64d4a382[factoryName]) try {
        const result = $68d4b3e39e36311c$export$9ae1d0dd64d4a382[factoryName](value, key);
        FACTORY[key] = result;
        return FACTORY;
    } catch (error) {
        if (CONFIG.verbose) console.warn('Error setting', factoryName, 'value', value, key, error);
    }
    if (CONFIG.verbose) console.warn('Can not find', factoryName, 'method in scratch');
};
const $68d4b3e39e36311c$export$943920cf7e6d5f23 = (factoryName, props)=>{
    const CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const FACTORY_NAME = factoryName.toUpperCase();
    const keys = Object.keys(props);
    keys.forEach((key)=>{
        try {
            return $68d4b3e39e36311c$export$80746c6bc6142fc8(FACTORY_NAME, props[key], key);
        } catch (error) {
            if (CONFIG.verbose) console.warn('Error setting', FACTORY_NAME, 'value', props[key], key, error);
        }
    });
    return CONFIG[FACTORY_NAME];
};
const $68d4b3e39e36311c$var$SET_OPTIONS = {};
const $68d4b3e39e36311c$export$adaa4cf7ef1b65be = (recivedConfig, options = $68d4b3e39e36311c$var$SET_OPTIONS)=>{
    let CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
    const { version: version, verbose: verbose, useVariable: useVariable, useReset: useReset, useSvgSprite: useSvgSprite, useFontImport: useFontImport, useIconSprite: useIconSprite, globalTheme: globalTheme, useDocumentTheme: useDocumentTheme, useDefaultConfig: useDefaultConfig, SEMANTIC_ICONS: SEMANTIC_ICONS, ...config } = recivedConfig;
    if (options.newConfig) CONFIG = (0, $6c2510166886baa2$export$5e61d1b6fff0c794)(options.newConfig);
    if (verbose !== undefined) CONFIG.verbose = verbose;
    if (useVariable !== undefined) CONFIG.useVariable = useVariable;
    if (useReset !== undefined) CONFIG.useReset = useReset;
    if (useFontImport !== undefined) CONFIG.useFontImport = useFontImport;
    if (useSvgSprite !== undefined) CONFIG.useSvgSprite = useSvgSprite;
    if (useIconSprite !== undefined) CONFIG.useIconSprite = useIconSprite;
    if (useDocumentTheme !== undefined) CONFIG.useDocumentTheme = useDocumentTheme;
    if (globalTheme !== undefined) CONFIG.globalTheme = globalTheme;
    if (useDefaultConfig !== undefined) CONFIG.useDefaultConfig = useDefaultConfig;
    if (SEMANTIC_ICONS !== undefined) CONFIG.SEMANTIC_ICONS = SEMANTIC_ICONS;
    if (CONFIG.verbose) console.log(CONFIG);
    if (!CONFIG.__svg_cache) CONFIG.__svg_cache = {};
    const keys = Object.keys(config);
    keys.map((key)=>$68d4b3e39e36311c$export$943920cf7e6d5f23(key, config[key]));
    // apply generic configs
    if (config.TYPOGRAPHY) try {
        (0, $2cd01d71c583d41c$export$7c7d7b0d076fe8b5)();
    } catch (e) {
        if (CONFIG.verbose) console.warn('Error applying typography sequence', e);
    }
    if (config.SPACING) try {
        (0, $8d2bd189328d3a32$export$9bfe8384addafa7c)();
    } catch (e) {
        if (CONFIG.verbose) console.warn('Error applying typography sequence', e);
    }
    if (config.TIMING) try {
        (0, $9779037853e3fa59$export$a5be618f63a441ac)();
    } catch (e) {
        if (CONFIG.verbose) console.warn('Error applying typography sequence', e);
    }
    (0, $929de5633bc6bdb1$export$25b333cdc54cc186)();
    (0, $1639f24c790d29ae$export$984fb5f73961424e)();
    return CONFIG;
};


'use strict';
$parcel$exportWildcard($9ab4e20a7cba0748$exports, $6c2510166886baa2$exports);
$parcel$exportWildcard($9ab4e20a7cba0748$exports, $3e5c92ae435958cf$exports);
$parcel$exportWildcard($9ab4e20a7cba0748$exports, $a4a3198d451be376$exports);
$parcel$exportWildcard($9ab4e20a7cba0748$exports, $74b1239117fb29ff$exports);
$parcel$exportWildcard($9ab4e20a7cba0748$exports, $260ce182974bc204$exports);
$parcel$exportWildcard($9ab4e20a7cba0748$exports, $68d4b3e39e36311c$exports);



var $imR0C = parcelRequire("imR0C");

var $84f69156e3582aea$exports = {};

$parcel$export($84f69156e3582aea$exports, "init", function () { return $84f69156e3582aea$export$2cd8252107eb640b; });
$parcel$export($84f69156e3582aea$exports, "reinit", function () { return $84f69156e3582aea$export$b545ad0f2df0be16; });
$parcel$export($84f69156e3582aea$exports, "applyCSS", function () { return $84f69156e3582aea$export$3a26aa64e59aeaff; });
$parcel$export($84f69156e3582aea$exports, "updateVars", function () { return $84f69156e3582aea$export$ed2c61d2d8a098be; });
$parcel$export($84f69156e3582aea$exports, "setClass", function () { return $84f69156e3582aea$export$2796c4ce44e61efa; });
$parcel$export($84f69156e3582aea$exports, "DYNAMIC_JSON", function () { return (/*@__PURE__*/$parcel$interopDefault($edf97ce22d544a62$exports)); });

parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
var $9119ccb14775b2d1$exports = {};

$parcel$export($9119ccb14775b2d1$exports, "createEmotion", function () { return $9119ccb14775b2d1$export$100c3af055d141e0; });
$parcel$export($9119ccb14775b2d1$exports, "emotion", function () { return $9119ccb14775b2d1$export$51d693b3d243fd90; });
var $e97b5f72ed127b53$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e97b5f72ed127b53$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e97b5f72ed127b53$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e97b5f72ed127b53$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e97b5f72ed127b53$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e97b5f72ed127b53$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e97b5f72ed127b53$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $783faa7ec18221fc$export$71ad59f2e432cfe8 = "-ms-";
var $783faa7ec18221fc$export$2c0f367103c8d01c = "-moz-";
var $783faa7ec18221fc$export$39dfd62a25e0fe93 = "-webkit-";
var $783faa7ec18221fc$export$a29989082612d0d9 = "comm";
var $783faa7ec18221fc$export$aa3a2e812ca8570d = "rule";
var $783faa7ec18221fc$export$527d108ccf083c2b = "decl";
var $783faa7ec18221fc$export$d3d35020fa5b54f0 = "@page";
var $783faa7ec18221fc$export$500415a86c544f73 = "@media";
var $783faa7ec18221fc$export$a763edbf796b780a = "@import";
var $783faa7ec18221fc$export$2790aeb8b4e5c826 = "@charset";
var $783faa7ec18221fc$export$1cc683e23b84b133 = "@viewport";
var $783faa7ec18221fc$export$9447a5efea57e862 = "@supports";
var $783faa7ec18221fc$export$ef011b4e114b1fba = "@document";
var $783faa7ec18221fc$export$6aad947bda0f3f46 = "@namespace";
var $783faa7ec18221fc$export$b44a8529a35fcb60 = "@keyframes";
var $783faa7ec18221fc$export$2c16de31893252e6 = "@font-face";
var $783faa7ec18221fc$export$3d846dd52e150c6f = "@counter-style";
var $783faa7ec18221fc$export$22314bfbb57653fe = "@font-feature-values";
var $783faa7ec18221fc$export$d773506282b3cfe6 = "@layer";
var $783faa7ec18221fc$export$2335f513bbd82c6d = Math.abs;
var $783faa7ec18221fc$export$6788812c4e6611e6 = String.fromCharCode;
var $783faa7ec18221fc$export$e6e34fd1f2686227 = Object.assign;
function $783faa7ec18221fc$export$d6af199866bfb566(e, r) {
    return $783faa7ec18221fc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 0)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 1)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 2)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 3) : 0;
}
function $783faa7ec18221fc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $783faa7ec18221fc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $783faa7ec18221fc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $783faa7ec18221fc$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $783faa7ec18221fc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $783faa7ec18221fc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $783faa7ec18221fc$export$36776f635604f274(e) {
    return e.length;
}
function $783faa7ec18221fc$export$f9084667e487ed46(e) {
    return e.length;
}
function $783faa7ec18221fc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $783faa7ec18221fc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $783faa7ec18221fc$export$53f1d5ea8de3d7c = 1;
var $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1;
var $783faa7ec18221fc$export$f24224f1c91d8156 = 0;
var $783faa7ec18221fc$export$5880b8b5730aff45 = 0;
var $783faa7ec18221fc$export$c0306caf338ac095 = 0;
var $783faa7ec18221fc$export$30a86d91af8ff6e6 = "";
function $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $783faa7ec18221fc$export$53f1d5ea8de3d7c,
        column: $783faa7ec18221fc$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $783faa7ec18221fc$export$784d13d8ee351f07(e, r) {
    return $783faa7ec18221fc$export$e6e34fd1f2686227($783faa7ec18221fc$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $783faa7ec18221fc$export$eba6f6f03b0a92e7() {
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$232faf9add678146() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 > 0 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, --$783faa7ec18221fc$export$5880b8b5730aff45) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3--, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c--;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$48cfd1e771a65c4f() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 < $783faa7ec18221fc$export$f24224f1c91d8156 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45++) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3++, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c++;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$4d3fb11e950abb9e() {
    return $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$e88cb2efb12ae807() {
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$58adb3bec8346d0f(e, r) {
    return $783faa7ec18221fc$export$2f35ab04d2335697($783faa7ec18221fc$export$30a86d91af8ff6e6, e, r);
}
function $783faa7ec18221fc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $783faa7ec18221fc$export$2de70f21292aac9e(e) {
    return $783faa7ec18221fc$export$53f1d5ea8de3d7c = $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$f24224f1c91d8156 = $783faa7ec18221fc$export$36776f635604f274($783faa7ec18221fc$export$30a86d91af8ff6e6 = e), $783faa7ec18221fc$export$5880b8b5730aff45 = 0, [];
}
function $783faa7ec18221fc$export$45918ac1574455b1(e) {
    return $783faa7ec18221fc$export$30a86d91af8ff6e6 = "", e;
}
function $783faa7ec18221fc$export$410ac95b9ec204b8(e) {
    return $783faa7ec18221fc$export$87c2784dc9fc4ab($783faa7ec18221fc$export$58adb3bec8346d0f($783faa7ec18221fc$export$5880b8b5730aff45 - 1, $783faa7ec18221fc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $783faa7ec18221fc$export$660b2ee2d4fb4eff(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$5f8c09e3ae6f64e1($783faa7ec18221fc$export$2de70f21292aac9e(e)));
}
function $783faa7ec18221fc$export$7af1228ff777d175(e) {
    while($783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$4d3fb11e950abb9e())if ($783faa7ec18221fc$export$c0306caf338ac095 < 33) $783faa7ec18221fc$export$48cfd1e771a65c4f();
    else break;
    return $783faa7ec18221fc$export$9e1725a4cfeada27(e) > 2 || $783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $783faa7ec18221fc$export$5f8c09e3ae6f64e1(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095)){
        case 0:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$c0306caf338ac095), e);
            break;
        default:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$c0306caf338ac095), e);
    }
    return e;
}
function $783faa7ec18221fc$export$955ba06d119e085e(e, r) {
    while(--r && $783faa7ec18221fc$export$48cfd1e771a65c4f())if ($783faa7ec18221fc$export$c0306caf338ac095 < 48 || $783faa7ec18221fc$export$c0306caf338ac095 > 102 || $783faa7ec18221fc$export$c0306caf338ac095 > 57 && $783faa7ec18221fc$export$c0306caf338ac095 < 65 || $783faa7ec18221fc$export$c0306caf338ac095 > 70 && $783faa7ec18221fc$export$c0306caf338ac095 < 97) break;
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$e88cb2efb12ae807() + (r < 6 && $783faa7ec18221fc$export$4d3fb11e950abb9e() == 32 && $783faa7ec18221fc$export$48cfd1e771a65c4f() == 32));
}
function $783faa7ec18221fc$export$c889f2fcc19dbf12(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$c0306caf338ac095){
        case e:
            return $783faa7ec18221fc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $783faa7ec18221fc$export$c889f2fcc19dbf12($783faa7ec18221fc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $783faa7ec18221fc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $783faa7ec18221fc$export$48cfd1e771a65c4f();
            break;
    }
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$4254d4e2b3745c4c(e, r) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 57) break;
    else if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 84 && $783faa7ec18221fc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $783faa7ec18221fc$export$58adb3bec8346d0f(r, $783faa7ec18221fc$export$5880b8b5730aff45 - 1) + "*" + $783faa7ec18221fc$export$6788812c4e6611e6(e === 47 ? e : $783faa7ec18221fc$export$48cfd1e771a65c4f());
}
function $783faa7ec18221fc$export$c2ab62c7bf24634(e) {
    while(!$783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$4d3fb11e950abb9e()))$783faa7ec18221fc$export$48cfd1e771a65c4f();
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$ef7acd7185315e22(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $783faa7ec18221fc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $783faa7ec18221fc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $783faa7ec18221fc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $783faa7ec18221fc$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($783faa7ec18221fc$export$f8e21b1e77979a08(j += $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $783faa7ec18221fc$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $783faa7ec18221fc$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $783faa7ec18221fc$export$955ba06d119e085e($783faa7ec18221fc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($783faa7ec18221fc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$4a34f930e789283c($783faa7ec18221fc$export$4254d4e2b3745c4c($783faa7ec18221fc$export$48cfd1e771a65c4f(), $783faa7ec18221fc$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $783faa7ec18221fc$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $783faa7ec18221fc$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $783faa7ec18221fc$export$36776f635604f274(j) - l) $783faa7ec18221fc$export$10d8903dec122b9d(p > 32 ? $783faa7ec18221fc$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $783faa7ec18221fc$export$f8483753829ec8f3($783faa7ec18221fc$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $783faa7ec18221fc$export$10d8903dec122b9d(y = $783faa7ec18221fc$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $783faa7ec18221fc$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $783faa7ec18221fc$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $783faa7ec18221fc$export$98e6a39c04603d36(e, y, y, n && $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $783faa7ec18221fc$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $783faa7ec18221fc$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $783faa7ec18221fc$export$232faf9add678146() == 125) continue;
            }
            switch(j += $783faa7ec18221fc$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($783faa7ec18221fc$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($783faa7ec18221fc$export$4d3fb11e950abb9e() === 45) j += $783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$48cfd1e771a65c4f());
                    v = $783faa7ec18221fc$export$4d3fb11e950abb9e(), o = l = $783faa7ec18221fc$export$36776f635604f274(g = j += $783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $783faa7ec18221fc$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $783faa7ec18221fc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $783faa7ec18221fc$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $783faa7ec18221fc$export$2f35ab04d2335697(e, v + 1, v = $783faa7ec18221fc$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $783faa7ec18221fc$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $783faa7ec18221fc$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, s === 0 ? $783faa7ec18221fc$export$aa3a2e812ca8570d : i, f, o, l);
}
function $783faa7ec18221fc$export$4a34f930e789283c(e, r, a) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$a29989082612d0d9, $783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$eba6f6f03b0a92e7()), $783faa7ec18221fc$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $783faa7ec18221fc$export$f8483753829ec8f3(e, r, a, n) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$527d108ccf083c2b, $783faa7ec18221fc$export$2f35ab04d2335697(e, 0, n), $783faa7ec18221fc$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $783faa7ec18221fc$export$82e9f45cca5ba907(n, c, s) {
    switch($783faa7ec18221fc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $783faa7ec18221fc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$2c0f367103c8d01c + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-$1$2" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-item-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-line-pack" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-pack:$3" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-column-align" + $783faa7ec18221fc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$783faa7ec18221fc$export$f8e21b1e77979a08(s, "span") ? $783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) : +$783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) - +$783faa7ec18221fc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($783faa7ec18221fc$export$36776f635604f274(n) - 1 - c > 6) switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $783faa7ec18221fc$export$2c0f367103c8d01c + ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n, "stretch") ? $783faa7ec18221fc$export$82e9f45cca5ba907($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 6) === 121) return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, $783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + ($783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $783faa7ec18221fc$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $783faa7ec18221fc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $783faa7ec18221fc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $783faa7ec18221fc$export$a763edbf796b780a:
        case $783faa7ec18221fc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $783faa7ec18221fc$export$a29989082612d0d9:
            return "";
        case $783faa7ec18221fc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $783faa7ec18221fc$export$36776f635604f274(a = $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $783faa7ec18221fc$export$5a7767152ae0305f(e) {
    var r = $783faa7ec18221fc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $783faa7ec18221fc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $783faa7ec18221fc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $783faa7ec18221fc$export$527d108ccf083c2b:
                n.return = $783faa7ec18221fc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $783faa7ec18221fc$export$b44a8529a35fcb60:
                return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                    $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                        value: $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $783faa7ec18221fc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $783faa7ec18221fc$export$aa3a2e812ca8570d:
                if (n.length) return $783faa7ec18221fc$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($783faa7ec18221fc$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $783faa7ec18221fc$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $783faa7ec18221fc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $783faa7ec18221fc$export$1be1fc439b849fdf($783faa7ec18221fc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($783faa7ec18221fc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $783faa7ec18221fc$export$2f35ab04d2335697(r, 1, $783faa7ec18221fc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $783faa7ec18221fc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $783faa7ec18221fc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $783faa7ec18221fc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d469aa6647f846c1$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $9145dbf8e0e857b1$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $bc7a9ccd09b383ef$var$isBrowser = typeof document !== 'undefined';
var $bc7a9ccd09b383ef$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $783faa7ec18221fc$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $783faa7ec18221fc$export$9e1725a4cfeada27)(character)) break;
        (0, $783faa7ec18221fc$export$48cfd1e771a65c4f)();
    }
    return (0, $783faa7ec18221fc$export$58adb3bec8346d0f)(begin, (0, $783faa7ec18221fc$export$5880b8b5730aff45));
};
var $bc7a9ccd09b383ef$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $783faa7ec18221fc$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $783faa7ec18221fc$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $bc7a9ccd09b383ef$var$identifierWithPointTracking((0, $783faa7ec18221fc$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $783faa7ec18221fc$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $783faa7ec18221fc$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $783faa7ec18221fc$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $783faa7ec18221fc$export$48cfd1e771a65c4f)());
    return parsed;
};
var $bc7a9ccd09b383ef$var$getRules = function getRules(value, points) {
    return (0, $783faa7ec18221fc$export$45918ac1574455b1)($bc7a9ccd09b383ef$var$toRules((0, $783faa7ec18221fc$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $bc7a9ccd09b383ef$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $bc7a9ccd09b383ef$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$bc7a9ccd09b383ef$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $bc7a9ccd09b383ef$var$fixedElements.set(element, true);
    var points = [];
    var rules = $bc7a9ccd09b383ef$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $bc7a9ccd09b383ef$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $bc7a9ccd09b383ef$var$prefix(value, length) {
    switch((0, $783faa7ec18221fc$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + value + (0, $783faa7ec18221fc$export$2c0f367103c8d01c) + value + (0, $783faa7ec18221fc$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + value + (0, $783faa7ec18221fc$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + value + (0, $783faa7ec18221fc$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + value + (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $783faa7ec18221fc$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + value + (0, $783faa7ec18221fc$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + value + (0, $783faa7ec18221fc$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + value + (0, $783faa7ec18221fc$export$71ad59f2e432cfe8) + (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + value + (0, $783faa7ec18221fc$export$71ad59f2e432cfe8) + (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + 'box-' + (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + value + (0, $783faa7ec18221fc$export$71ad59f2e432cfe8) + (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)((0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)((0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)((0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $783faa7ec18221fc$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $783faa7ec18221fc$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $783faa7ec18221fc$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $783faa7ec18221fc$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $783faa7ec18221fc$export$2c0f367103c8d01c) + ((0, $783faa7ec18221fc$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $783faa7ec18221fc$export$f8e21b1e77979a08)(value, 'stretch') ? $bc7a9ccd09b383ef$var$prefix((0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $783faa7ec18221fc$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $783faa7ec18221fc$export$a9db5e087081082d)(value, (0, $783faa7ec18221fc$export$36776f635604f274)(value) - 3 - (~(0, $783faa7ec18221fc$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $783faa7ec18221fc$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + ((0, $783faa7ec18221fc$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $783faa7ec18221fc$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $783faa7ec18221fc$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + value + (0, $783faa7ec18221fc$export$71ad59f2e432cfe8) + (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + value + (0, $783faa7ec18221fc$export$71ad59f2e432cfe8) + (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + value + (0, $783faa7ec18221fc$export$71ad59f2e432cfe8) + (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + value + (0, $783faa7ec18221fc$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $bc7a9ccd09b383ef$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $783faa7ec18221fc$export$527d108ccf083c2b:
                element["return"] = $bc7a9ccd09b383ef$var$prefix(element.value, element.length);
                break;
            case 0, $783faa7ec18221fc$export$b44a8529a35fcb60:
                return (0, $783faa7ec18221fc$export$dfdc1655ccc5b9cb)([
                    (0, $783faa7ec18221fc$export$784d13d8ee351f07)(element, {
                        value: (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $783faa7ec18221fc$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $783faa7ec18221fc$export$aa3a2e812ca8570d:
                if (element.length) return (0, $783faa7ec18221fc$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $783faa7ec18221fc$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $783faa7ec18221fc$export$dfdc1655ccc5b9cb)([
                                (0, $783faa7ec18221fc$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $783faa7ec18221fc$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $783faa7ec18221fc$export$dfdc1655ccc5b9cb)([
                                (0, $783faa7ec18221fc$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $783faa7ec18221fc$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $783faa7ec18221fc$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $783faa7ec18221fc$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $783faa7ec18221fc$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $783faa7ec18221fc$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $783faa7ec18221fc$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $bc7a9ccd09b383ef$var$getServerStylisCache = $bc7a9ccd09b383ef$var$isBrowser ? undefined : (0, $d469aa6647f846c1$export$2e2bcd8739ae039)(function() {
    return (0, $9145dbf8e0e857b1$export$2e2bcd8739ae039)(function() {
        return {};
    });
});
var $bc7a9ccd09b383ef$var$defaultStylisPlugins = [
    $bc7a9ccd09b383ef$var$prefixer
];
var $bc7a9ccd09b383ef$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($bc7a9ccd09b383ef$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $bc7a9ccd09b383ef$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($bc7a9ccd09b383ef$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $bc7a9ccd09b383ef$var$compat,
        $bc7a9ccd09b383ef$var$removeLabel
    ];
    if (!$bc7a9ccd09b383ef$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $783faa7ec18221fc$export$fac44ee5b035f737),
            (0, $783faa7ec18221fc$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $783faa7ec18221fc$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $783faa7ec18221fc$export$dfdc1655ccc5b9cb)((0, $783faa7ec18221fc$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $783faa7ec18221fc$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $783faa7ec18221fc$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $783faa7ec18221fc$export$dfdc1655ccc5b9cb)((0, $783faa7ec18221fc$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $bc7a9ccd09b383ef$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $e97b5f72ed127b53$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $0cf7dd2d70c55cf3$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $78b52bced097bc64$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $6eac5a28f6e72cd5$var$isDevelopment = false;
var $6eac5a28f6e72cd5$var$hyphenateRegex = /[A-Z]|^ms/g;
var $6eac5a28f6e72cd5$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $6eac5a28f6e72cd5$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $6eac5a28f6e72cd5$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $6eac5a28f6e72cd5$var$processStyleName = /* #__PURE__ */ (0, $9145dbf8e0e857b1$export$2e2bcd8739ae039)(function(styleName) {
    return $6eac5a28f6e72cd5$var$isCustomProperty(styleName) ? styleName : styleName.replace($6eac5a28f6e72cd5$var$hyphenateRegex, '-$&').toLowerCase();
});
var $6eac5a28f6e72cd5$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($6eac5a28f6e72cd5$var$animationRegex, function(match, p1, p2) {
                $6eac5a28f6e72cd5$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $6eac5a28f6e72cd5$var$cursor
                };
                return p1;
            });
    }
    if ((0, $78b52bced097bc64$export$2e2bcd8739ae039)[key] !== 1 && !$6eac5a28f6e72cd5$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $6eac5a28f6e72cd5$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $6eac5a28f6e72cd5$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $6eac5a28f6e72cd5$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $6eac5a28f6e72cd5$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $6eac5a28f6e72cd5$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $6eac5a28f6e72cd5$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $6eac5a28f6e72cd5$var$cursor;
                var result = interpolation(mergedProps);
                $6eac5a28f6e72cd5$var$cursor = previousCursor;
                return $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $6eac5a28f6e72cd5$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($6eac5a28f6e72cd5$var$isProcessableValue(asString)) string += $6eac5a28f6e72cd5$var$processStyleName(key) + ":" + $6eac5a28f6e72cd5$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $6eac5a28f6e72cd5$var$isDevelopment) throw new Error($6eac5a28f6e72cd5$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($6eac5a28f6e72cd5$var$isProcessableValue(value[_i])) string += $6eac5a28f6e72cd5$var$processStyleName(key) + ":" + $6eac5a28f6e72cd5$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $6eac5a28f6e72cd5$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $6eac5a28f6e72cd5$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $6eac5a28f6e72cd5$var$cursor;
function $6eac5a28f6e72cd5$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $6eac5a28f6e72cd5$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $6eac5a28f6e72cd5$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $6eac5a28f6e72cd5$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $0cf7dd2d70c55cf3$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $6eac5a28f6e72cd5$var$cursor
    };
}


var $8e4aa61dd4b95f07$var$isBrowser = typeof document !== 'undefined';
function $8e4aa61dd4b95f07$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $8e4aa61dd4b95f07$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $8e4aa61dd4b95f07$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $8e4aa61dd4b95f07$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $8e4aa61dd4b95f07$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$8e4aa61dd4b95f07$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$8e4aa61dd4b95f07$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


function $be0b73abefc1556e$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert('', serialized, cache.sheet, true);
}
function $be0b73abefc1556e$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8e4aa61dd4b95f07$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $be0b73abefc1556e$export$2e2bcd8739ae039 = function createEmotion(options) {
    var cache = (0, $bc7a9ccd09b383ef$export$2e2bcd8739ae039)(options);
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $6eac5a28f6e72cd5$export$6321afa313b251b5)(args, cache.registered, undefined);
        (0, $8e4aa61dd4b95f07$export$6f077d94b33a01aa)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $6eac5a28f6e72cd5$export$6321afa313b251b5)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $be0b73abefc1556e$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $6eac5a28f6e72cd5$export$6321afa313b251b5)(args, cache.registered);
        $be0b73abefc1556e$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $be0b73abefc1556e$var$merge(cache.registered, css, $be0b73abefc1556e$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $8e4aa61dd4b95f07$export$95d99596f328fd52).bind(null, cache.registered),
        merge: $be0b73abefc1556e$var$merge.bind(null, cache.registered, css)
    };
};
var $be0b73abefc1556e$var$classnames = function classnames(args) {
    var cls = '';
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};


'use strict';
const $9119ccb14775b2d1$export$100c3af055d141e0 = (key = 'smbls', container)=>{
    const cleanKey = key.replaceAll(/\./g, '-');
    return (0, $be0b73abefc1556e$export$2e2bcd8739ae039)({
        key: cleanKey,
        container: container
    });
};
const $9119ccb14775b2d1$export$51d693b3d243fd90 = $9119ccb14775b2d1$export$100c3af055d141e0();


var $edf97ce22d544a62$exports = {};
$edf97ce22d544a62$exports = JSON.parse("{}");


'use strict';
const $84f69156e3582aea$var$CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
const $84f69156e3582aea$var$mergeWithLocalFile = (config = $84f69156e3582aea$var$CONFIG, options)=>{
    const rcfile = (0, $amNJ8.isObject)(options.localFile) ? options.localFile : (0, (/*@__PURE__*/$parcel$interopDefault($edf97ce22d544a62$exports))) || {};
    const clonedFile = (0, $jm0BQ.deepClone)(rcfile.designSystem || {});
    return (0, $jm0BQ.deepMerge)(config, clonedFile);
};
const $84f69156e3582aea$var$SET_OPTIONS = {
    emotion: (0, $9119ccb14775b2d1$export$51d693b3d243fd90),
    useVariable: true,
    useReset: true,
    useFontImport: true,
    useIconSprite: true,
    useDocumentTheme: true,
    useSvgSprite: true
};
const $84f69156e3582aea$export$2cd8252107eb640b = (config, options = $84f69156e3582aea$var$SET_OPTIONS)=>{
    const emotion = options.emotion || (0, $9119ccb14775b2d1$export$51d693b3d243fd90);
    const resultConfig = $84f69156e3582aea$var$mergeWithLocalFile(config || {}, options);
    const conf = (0, $68d4b3e39e36311c$export$adaa4cf7ef1b65be)({
        verbose: options.verbose,
        useReset: options.useReset,
        useFontImport: options.useFontImport,
        useVariable: options.useVariable,
        useSvgSprite: options.useSvgSprite,
        useDocumentTheme: options.useDocumentTheme,
        useIconSprite: options.useIconSprite,
        useDefaultConfig: options.useDefaultConfig,
        ...resultConfig
    }, {
        newConfig: options.newConfig
    });
    const FontFace = (0, $ff75c5d288dc2745$export$8b73d71a1d936bc)(conf.FONT);
    const useReset = conf.useReset;
    const useVariable = conf.useVariable;
    const useFontImport = conf.useFontImport;
    const useSvgSprite = conf.useSvgSprite;
    const hasSvgs = config.svg || config.SVG;
    const useIconSprite = conf.useIconSprite;
    const hasIcons = config.icons || config.ICONS;
    if (useFontImport) emotion.injectGlobal(FontFace);
    if (useVariable) emotion.injectGlobal({
        ':root': conf.CSS_VARS
    });
    if (useReset) emotion.injectGlobal(conf.RESET);
    if (hasSvgs) (0, $e85e1bf37dde218c$export$2c4662f4a995c568)(hasSvgs, {
        document: options.document
    });
    else if (useSvgSprite) (0, $e85e1bf37dde218c$export$2c4662f4a995c568)(conf.SVG, {
        document: options.document
    });
    if (hasIcons) (0, $e85e1bf37dde218c$export$6892263c3fbefa8c)(hasIcons, {
        document: options.document
    });
    else if (useIconSprite) (0, $e85e1bf37dde218c$export$6892263c3fbefa8c)(conf.ICONS, {
        document: options.document
    });
    return conf;
};
const $84f69156e3582aea$var$UPDATE_OPTIONS = {
    emotion: (0, $9119ccb14775b2d1$export$51d693b3d243fd90)
};
const $84f69156e3582aea$export$b545ad0f2df0be16 = (config, options = $84f69156e3582aea$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $9119ccb14775b2d1$export$51d693b3d243fd90);
    const resultConfig = $84f69156e3582aea$var$mergeWithLocalFile(config || {}, options);
    // const prevStyles = document.querySelector('[data-emotion="smbls"]')
    // console.log(prevStyles)
    const conf = (0, $68d4b3e39e36311c$export$adaa4cf7ef1b65be)({
        verbose: false,
        ...resultConfig
    });
    if (!options.preventInject) {
        emotion.injectGlobal({
            ':root': conf.CSS_VARS
        });
        emotion.injectGlobal(conf.RESET);
    }
    return conf;
};
const $84f69156e3582aea$export$3a26aa64e59aeaff = (styles, options = $84f69156e3582aea$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $9119ccb14775b2d1$export$51d693b3d243fd90);
    emotion.injectGlobal(styles);
};
const $84f69156e3582aea$export$ed2c61d2d8a098be = (config, options = $84f69156e3582aea$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $9119ccb14775b2d1$export$51d693b3d243fd90);
    emotion.injectGlobal({
        ':root': config.CSS_VARS
    });
};
const $84f69156e3582aea$export$2796c4ce44e61efa = (props, options = $84f69156e3582aea$var$UPDATE_OPTIONS)=>{}; // setClassname(props, options.emotion.css)



var $7S1uT = parcelRequire("7S1uT");
var $20758fd265e78843$exports = {};

$parcel$defineInteropFlag($20758fd265e78843$exports);

$parcel$export($20758fd265e78843$exports, "getActiveRoute", function () { return $20758fd265e78843$export$e7a685f330e7752; });
$parcel$export($20758fd265e78843$exports, "lastPathname", function () { return $20758fd265e78843$export$7a9e7a91cdf4fce1; });
$parcel$export($20758fd265e78843$exports, "lastLevel", function () { return $20758fd265e78843$export$ed098f724085d263; });
$parcel$export($20758fd265e78843$exports, "router", function () { return $20758fd265e78843$export$5375cda95f0b0eb4; });
$parcel$export($20758fd265e78843$exports, "default", function () { return $20758fd265e78843$export$2e2bcd8739ae039; });
parcelRequire("QRTe9");
var $dKo7X = parcelRequire("dKo7X");
parcelRequire("imR0C");
var $aLXZy = parcelRequire("aLXZy");
var $3Kzng = parcelRequire("3Kzng");
var $20758fd265e78843$var$__defProp = Object.defineProperty;
var $20758fd265e78843$var$__defProps = Object.defineProperties;
var $20758fd265e78843$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $20758fd265e78843$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $20758fd265e78843$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $20758fd265e78843$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $20758fd265e78843$var$__defNormalProp = (obj, key, value)=>key in obj ? $20758fd265e78843$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $20758fd265e78843$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($20758fd265e78843$var$__hasOwnProp.call(b, prop)) $20758fd265e78843$var$__defNormalProp(a, prop, b[prop]);
    if ($20758fd265e78843$var$__getOwnPropSymbols) {
        for (var prop of $20758fd265e78843$var$__getOwnPropSymbols(b))if ($20758fd265e78843$var$__propIsEnum.call(b, prop)) $20758fd265e78843$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $20758fd265e78843$var$__spreadProps = (a, b)=>$20758fd265e78843$var$__defProps(a, $20758fd265e78843$var$__getOwnPropDescs(b));
const $20758fd265e78843$export$e7a685f330e7752 = (level = 0, route = (0, $aLXZy.window).location.pathname)=>{
    const routeArray = route.split("/");
    const activeRoute = routeArray[level + 1];
    if (activeRoute) return `/${activeRoute}`;
};
let $20758fd265e78843$export$7a9e7a91cdf4fce1;
let $20758fd265e78843$export$ed098f724085d263 = 0;
const $20758fd265e78843$var$defaultOptions = {
    level: $20758fd265e78843$export$ed098f724085d263,
    pushState: true,
    initialRender: false,
    scrollToTop: true,
    scrollToNode: false,
    scrollNode: (0, $aLXZy.document) && (0, $aLXZy.document).documentElement,
    scrollBody: false,
    useFragment: false,
    updateState: true,
    scrollToOffset: 0,
    contentElementKey: "content",
    scrollToOptions: {
        behavior: "smooth"
    }
};
const $20758fd265e78843$export$5375cda95f0b0eb4 = async (path, el, state = {}, options = {})=>{
    const element = el || void 0;
    const win = element.context.window || (0, $aLXZy.window);
    const doc = element.context.document || (0, $aLXZy.document);
    const opts = $20758fd265e78843$var$__spreadValues($20758fd265e78843$var$__spreadValues($20758fd265e78843$var$__spreadValues({}, $20758fd265e78843$var$defaultOptions), element.context.routerOptions), options);
    $20758fd265e78843$export$ed098f724085d263 = opts.lastLevel;
    const ref = element.__ref;
    if (opts.contentElementKey !== "content" && opts.contentElementKey !== ref.contentElementKey || !ref.contentElementKey) ref.contentElementKey = opts.contentElementKey || "content";
    const contentElementKey = (0, $3Kzng.setContentKey)(element, opts);
    const urlObj = new win.URL(win.location.origin + path);
    const { pathname: pathname, search: search, hash: hash } = urlObj;
    const rootNode = element.node;
    const route = $20758fd265e78843$export$e7a685f330e7752(opts.level, pathname);
    const content = element.routes[route || "/"] || element.routes["/*"];
    const scrollNode = opts.scrollToNode ? rootNode : opts.scrollNode;
    const hashChanged = hash && hash !== win.location.hash.slice(1);
    const pathChanged = pathname !== $20758fd265e78843$export$7a9e7a91cdf4fce1;
    $20758fd265e78843$export$7a9e7a91cdf4fce1 = pathname;
    if (!content || element.state.root.debugging) {
        element.state.root.debugging = false;
        return;
    }
    if (opts.pushState) win.history.pushState(state, null, pathname + (search || "") + (hash || ""));
    if (pathChanged || !hashChanged) {
        if (opts.updateState) await element.state.update({
            route: route,
            hash: hash,
            debugging: false
        }, {
            preventContentUpdate: true
        });
        if (contentElementKey && opts.removeOldElement) element[contentElementKey].remove();
        await element.set({
            tag: opts.useFragment && "fragment",
            extend: content
        }, {
            contentElementKey: contentElementKey
        });
    }
    if (opts.scrollToTop) scrollNode.scrollTo($20758fd265e78843$var$__spreadProps($20758fd265e78843$var$__spreadValues({}, opts.scrollToOptions || {}), {
        top: 0,
        left: 0
    }));
    if (opts.scrollToNode) content[contentElementKey].node.scrollTo($20758fd265e78843$var$__spreadProps($20758fd265e78843$var$__spreadValues({}, opts.scrollToOptions || {}), {
        top: 0,
        left: 0
    }));
    if (hash) {
        const activeNode = doc.getElementById(hash);
        if (activeNode) {
            const top = activeNode.getBoundingClientRect().top + rootNode.scrollTop - opts.scrollToOffset || 0;
            scrollNode.scrollTo($20758fd265e78843$var$__spreadProps($20758fd265e78843$var$__spreadValues({}, opts.scrollToOptions || {}), {
                top: top,
                left: 0
            }));
        }
    }
    await (0, $dKo7X.triggerEventOn)("routeChanged", element, opts);
};
var $20758fd265e78843$export$2e2bcd8739ae039 = $20758fd265e78843$export$5375cda95f0b0eb4;


'use strict';
$parcel$exportWildcard($e5c9cce2d37812b2$exports, $imR0C);
$parcel$exportWildcard($e5c9cce2d37812b2$exports, $9eb7ca543617066e$exports);
$parcel$exportWildcard($e5c9cce2d37812b2$exports, $7S1uT);
$parcel$exportWildcard($e5c9cce2d37812b2$exports, $20758fd265e78843$exports);



parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
var $aLXZy = parcelRequire("aLXZy");
var $e6fd4882357b9f2d$exports = {};
var $aa8df985725866a7$exports = {};
var $2340ecba3950811a$exports = {};

$parcel$export($2340ecba3950811a$exports, "Block", function () { return $2340ecba3950811a$export$d96a8827a60d6b69; });
$parcel$export($2340ecba3950811a$exports, "Hr", function () { return $2340ecba3950811a$export$c65504044f62f430; });
$parcel$export($2340ecba3950811a$exports, "Br", function () { return $2340ecba3950811a$export$9130f216d904f5ea; });
$parcel$export($2340ecba3950811a$exports, "Div", function () { return $2340ecba3950811a$export$5bfb0bc6cd684584; });
$parcel$export($2340ecba3950811a$exports, "Span", function () { return $2340ecba3950811a$export$5f1714a13ed34c01; });
$parcel$export($2340ecba3950811a$exports, "Li", function () { return $2340ecba3950811a$export$4de39c9f3329bb96; });
$parcel$export($2340ecba3950811a$exports, "Ul", function () { return $2340ecba3950811a$export$d4f99c77eeffeaea; });
$parcel$export($2340ecba3950811a$exports, "Ol", function () { return $2340ecba3950811a$export$60180a808b215c38; });
$parcel$export($2340ecba3950811a$exports, "Gutter", function () { return $2340ecba3950811a$export$b710539649c46ff; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");

'use strict';
const $2340ecba3950811a$var$props = {
    show: (el, s, ctx)=>!!(ctx.utils.exec(el.props.show, el, s) === false) && {
            display: 'none !important'
        },
    hide: (el, s, ctx)=>!!ctx.utils.exec(el.props.hide, el, s) && {
            display: 'none !important'
        },
    height: ({ props: props, deps: deps })=>deps.transformSizeRatio('height', props),
    width: ({ props: props, deps: deps })=>deps.transformSizeRatio('width', props),
    boxSizing: ({ props: props, deps: deps })=>!deps.isUndefined(props.boxSizing) ? {
            boxSizing: props.boxSizing
        } : {
            boxSizing: 'border-box'
        },
    boxSize: ({ props: props, deps: deps })=>{
        if (!deps.isString(props.boxSize)) return;
        const [height, width] = props.boxSize.split(' ');
        return {
            ...deps.transformSize('height', height),
            ...deps.transformSize('width', width || height)
        };
    },
    inlineSize: ({ props: props, deps: deps })=>deps.transformSizeRatio('inlineSize', props),
    blockSize: ({ props: props, deps: deps })=>deps.transformSizeRatio('blockSize', props),
    minWidth: ({ props: props, deps: deps })=>deps.transformSizeRatio('minWidth', props),
    maxWidth: ({ props: props, deps: deps })=>deps.transformSizeRatio('maxWidth', props),
    widthRange: ({ props: props, deps: deps })=>{
        if (!deps.isString(props.widthRange)) return;
        const [minWidth, maxWidth] = props.widthRange.split(' ');
        return {
            ...deps.transformSize('minWidth', minWidth),
            ...deps.transformSize('maxWidth', maxWidth || minWidth)
        };
    },
    minHeight: ({ props: props, deps: deps })=>deps.transformSizeRatio('minHeight', props),
    maxHeight: ({ props: props, deps: deps })=>deps.transformSizeRatio('maxHeight', props),
    heightRange: ({ props: props, deps: deps })=>{
        if (!deps.isString(props.heightRange)) return;
        const [minHeight, maxHeight] = props.heightRange.split(' ');
        return {
            ...deps.transformSize('minHeight', minHeight),
            ...deps.transformSize('maxHeight', maxHeight || minHeight)
        };
    },
    size: ({ props: props, deps: deps })=>{
        if (!deps.isString(props.size)) return;
        const [inlineSize, blockSize] = props.size.split(' ');
        return {
            ...deps.transformSizeRatio('inlineSize', inlineSize),
            ...deps.transformSizeRatio('blockSize', blockSize || inlineSize)
        };
    },
    minBlockSize: ({ props: props, deps: deps })=>deps.transformSizeRatio('minBlockSize', props),
    minInlineSize: ({ props: props, deps: deps })=>deps.transformSizeRatio('minInlineSize', props),
    maxBlockSize: ({ props: props, deps: deps })=>deps.transformSizeRatio('maxBlockSize', props),
    maxInlineSize: ({ props: props, deps: deps })=>deps.transformSizeRatio('maxInlineSize', props),
    minSize: ({ props: props, deps: deps })=>{
        if (!deps.isString(props.minSize)) return;
        const [minInlineSize, minBlockSize] = props.minSize.split(' ');
        return {
            ...deps.transformSize('minInlineSize', minInlineSize),
            ...deps.transformSize('minBlockSize', minBlockSize || minInlineSize)
        };
    },
    maxSize: ({ props: props, deps: deps })=>{
        if (!deps.isString(props.maxSize)) return;
        const [maxInlineSize, maxBlockSize] = props.maxSize.split(' ');
        return {
            ...deps.transformSize('maxInlineSize', maxInlineSize),
            ...deps.transformSize('maxBlockSize', maxBlockSize || maxInlineSize)
        };
    },
    borderWidth: ({ props: props, deps: deps })=>deps.transformSizeRatio('borderWidth', props),
    padding: ({ props: props, deps: deps })=>deps.transformSizeRatio('padding', props),
    scrollPadding: ({ props: props, deps: deps })=>deps.transformSizeRatio('scrollPadding', props),
    paddingInline: ({ props: props, deps: deps })=>{
        if (!deps.isString(props.paddingInline)) return;
        const [paddingInlineStart, paddingInlineEnd] = props.paddingInline.split(' ');
        return {
            ...deps.transformSize('paddingInlineStart', paddingInlineStart),
            ...deps.transformSize('paddingInlineEnd', paddingInlineEnd || paddingInlineStart)
        };
    },
    paddingBlock: ({ props: props, deps: deps })=>{
        if (!deps.isString(props.paddingBlock)) return;
        const [paddingBlockStart, paddingBlockEnd] = props.paddingBlock.split(' ');
        return {
            ...deps.transformSize('paddingBlockStart', paddingBlockStart),
            ...deps.transformSize('paddingBlockEnd', paddingBlockEnd || paddingBlockStart)
        };
    },
    paddingInlineStart: ({ props: props, deps: deps })=>deps.transformSizeRatio('paddingInlineStart', props),
    paddingInlineEnd: ({ props: props, deps: deps })=>deps.transformSizeRatio('paddingInlineEnd', props),
    paddingBlockStart: ({ props: props, deps: deps })=>deps.transformSizeRatio('paddingBlockStart', props),
    paddingBlockEnd: ({ props: props, deps: deps })=>deps.transformSizeRatio('paddingBlockEnd', props),
    margin: ({ props: props, deps: deps })=>deps.transformSizeRatio('margin', props),
    marginInline: ({ props: props, deps: deps })=>{
        if (!deps.isString(props.marginInline)) return;
        const [marginInlineStart, marginInlineEnd] = props.marginInline.split(' ');
        return {
            ...deps.transformSize('marginInlineStart', marginInlineStart),
            ...deps.transformSize('marginInlineEnd', marginInlineEnd || marginInlineStart)
        };
    },
    marginBlock: ({ props: props, deps: deps })=>{
        if (!deps.isString(props.marginBlock)) return;
        const [marginBlockStart, marginBlockEnd] = props.marginBlock.split(' ');
        return {
            ...deps.transformSize('marginBlockStart', marginBlockStart),
            ...deps.transformSize('marginBlockEnd', marginBlockEnd || marginBlockStart)
        };
    },
    marginInlineStart: ({ props: props, deps: deps })=>deps.transformSizeRatio('marginInlineStart', props),
    marginInlineEnd: ({ props: props, deps: deps })=>deps.transformSizeRatio('marginInlineEnd', props),
    marginBlockStart: ({ props: props, deps: deps })=>deps.transformSizeRatio('marginBlockStart', props),
    marginBlockEnd: ({ props: props, deps: deps })=>deps.transformSizeRatio('marginBlockEnd', props),
    gap: ({ props: props, deps: deps })=>!deps.isUndefined(props.gap) && {
            gap: (0, $260ce182974bc204$export$1e420ad2d0d06436)(props.gap)
        },
    columnGap: ({ props: props, deps: deps })=>!deps.isUndefined(props.columnGap) ? deps.getSpacingBasedOnRatio(props, 'columnGap') : null,
    rowGap: ({ props: props, deps: deps })=>!deps.isUndefined(props.rowGap) ? deps.getSpacingBasedOnRatio(props, 'rowGap') : null,
    flexWrap: ({ props: props, deps: deps })=>!deps.isUndefined(props.flexWrap) && {
            display: 'flex',
            flexFlow: (props.flexFlow || 'row').split(' ')[0] + ' ' + props.flexWrap
        },
    flexFlow: ({ props: props, deps: deps })=>{
        const { flexFlow: flexFlow, reverse: reverse } = props;
        if (!deps.isString(flexFlow)) return;
        let [direction, wrap] = (flexFlow || 'row').split(' ');
        if (flexFlow.startsWith('x') || flexFlow === 'row') direction = 'row';
        if (flexFlow.startsWith('y') || flexFlow === 'column') direction = 'column';
        return {
            display: 'flex',
            flexFlow: (direction || '') + (!direction.includes('-reverse') && reverse ? '-reverse' : '') + ' ' + (wrap || '')
        };
    },
    flexAlign: ({ props: props, deps: deps })=>{
        if (!deps.isString(props.flexAlign)) return;
        const [alignItems, justifyContent] = props.flexAlign.split(' ');
        return {
            display: 'flex',
            alignItems: alignItems,
            justifyContent: justifyContent
        };
    }
};
const $2340ecba3950811a$export$d96a8827a60d6b69 = {
    deps: {
        getSpacingBasedOnRatio: $8d2bd189328d3a32$export$94679ba49f16fc2e,
        getSpacingByKey: $8d2bd189328d3a32$export$4f949d23b5dbefe6,
        transfromGap: $260ce182974bc204$export$1e420ad2d0d06436,
        transformSizeRatio: $260ce182974bc204$export$b6e34d20a288a08c,
        transformSize: $260ce182974bc204$export$f09d9444954afeda,
        isUndefined: $amNJ8.isUndefined,
        isString: $amNJ8.isString
    },
    class: {
        ...$2340ecba3950811a$var$props,
        display: ({ props: props, deps: deps })=>!deps.isUndefined(props.display) && {
                display: props.display
            },
        direction: ({ props: props, deps: deps })=>!deps.isUndefined(props.direction) && {
                direction: props.direction
            },
        objectFit: ({ props: props, deps: deps })=>!deps.isUndefined(props.objectFit) && {
                objectFit: props.objectFit
            },
        aspectRatio: ({ props: props, deps: deps })=>!deps.isUndefined(props.aspectRatio) && {
                aspectRatio: props.aspectRatio
            },
        gridArea: ({ props: props, deps: deps })=>props.gridArea && {
                gridArea: props.gridArea
            },
        float: ({ props: props, deps: deps })=>!deps.isUndefined(props.float) && {
                float: props.float
            },
        flex: ({ props: props, deps: deps })=>!deps.isUndefined(props.flex) && {
                flex: props.flex
            },
        flexDirection: ({ props: props, deps: deps })=>!deps.isUndefined(props.flexDirection) && {
                flexDirection: props.flexDirection
            },
        alignItems: ({ props: props, deps: deps })=>!deps.isUndefined(props.alignItems) && {
                alignItems: props.alignItems
            },
        alignContent: ({ props: props, deps: deps })=>!deps.isUndefined(props.alignContent) && {
                alignContent: props.alignContent
            },
        justifyContent: ({ props: props, deps: deps })=>!deps.isUndefined(props.justifyContent) && {
                justifyContent: props.justifyContent
            },
        justifyItems: ({ props: props, deps: deps })=>!deps.isUndefined(props.justifyItems) && {
                justifyItems: props.justifyItems
            },
        alignSelf: ({ props: props, deps: deps })=>!deps.isUndefined(props.alignSelf) && {
                alignSelf: props.alignSelf
            },
        order: ({ props: props, deps: deps })=>!deps.isUndefined(props.order) && {
                order: props.order
            },
        gridColumn: ({ props: props, deps: deps })=>!deps.isUndefined(props.gridColumn) && {
                gridColumn: props.gridColumn
            },
        gridColumnStart: ({ props: props, deps: deps })=>!deps.isUndefined(props.gridColumnStart) && {
                gridColumnStart: props.gridColumnStart
            },
        gridRow: ({ props: props, deps: deps })=>!deps.isUndefined(props.gridRow) && {
                gridRow: props.gridRow
            },
        gridRowStart: ({ props: props, deps: deps })=>!deps.isUndefined(props.gridRowStart) && {
                gridRowStart: props.gridRowStart
            },
        resize: ({ props: props, deps: deps })=>!deps.isUndefined(props.resize) && {
                resize: props.resize
            },
        verticalAlign: ({ props: props, deps: deps })=>!deps.isUndefined(props.verticalAlign) && {
                verticalAlign: props.verticalAlign
            },
        columns: ({ props: props, deps: deps })=>!deps.isUndefined(props.columns) && {
                columns: props.columns
            },
        columnRule: ({ props: props, deps: deps })=>!deps.isUndefined(props.columnRule) && {
                columnRule: props.columnRule
            },
        columnWidth: ({ props: props, deps: deps })=>!deps.isUndefined(props.columnWidth) && {
                columnWidth: props.columnWidth
            },
        columnSpan: ({ props: props, deps: deps })=>!deps.isUndefined(props.columnSpan) && {
                columnSpan: props.columnSpan
            },
        columnFill: ({ props: props, deps: deps })=>!deps.isUndefined(props.columnFill) && {
                columnFill: props.columnFill
            },
        columnCount: ({ props: props, deps: deps })=>!deps.isUndefined(props.columnCount) && {
                columnCount: props.columnCount
            }
    }
};
const $2340ecba3950811a$export$c65504044f62f430 = {
    tag: 'hr',
    props: {
        margin: 'C1 0'
    }
};
const $2340ecba3950811a$export$9130f216d904f5ea = {
    tag: 'br'
};
const $2340ecba3950811a$export$5bfb0bc6cd684584 = {
    tag: 'div'
};
const $2340ecba3950811a$export$5f1714a13ed34c01 = {
    tag: 'span'
};
const $2340ecba3950811a$export$4de39c9f3329bb96 = {
    tag: 'li'
};
const $2340ecba3950811a$export$d4f99c77eeffeaea = {
    tag: 'ul',
    childExtend: {
        extend: 'Li'
    }
};
const $2340ecba3950811a$export$60180a808b215c38 = {
    tag: 'ol',
    childExtend: {
        extend: 'Li'
    }
};
const $2340ecba3950811a$export$b710539649c46ff = {
    props: {
        size: 'C1'
    }
}; // alt approach
 // blockProps: (el, s, ctx) => {
 //   const { props, deps } = el
 //   const styles = {}
 //   // Utility to conditionally add a style
 //   const addStyle = (key, value) => {
 //     if (deps.isObject(value)) deps.merge(styles, value)
 //     else if (value) styles[key] = value
 //   }
 //   // Box sizing
 //   addStyle('boxSizing', !deps.isUndefined(props.boxSizing) ? props.boxSizing : 'border-box')
 //   // Display
 //   addStyle('display', !deps.isUndefined(props.display) ? props.display : undefined)
 //   // Show/Hide
 //   if (ctx.utils.exec(el.props.show, el, s) === false) {
 //     addStyle('display', 'none !important')
 //   }
 //   if (ctx.utils.exec(el.props.hide, el, s)) {
 //     addStyle('display', 'none !important')
 //   }
 //   // Size transformations
 //   const sizeKeys = ['height', 'width', 'inlineSize', 'blockSize', 'minWidth', 'maxWidth', 'minHeight', 'maxHeight', 'minBlockSize', 'maxBlockSize', 'minInlineSize', 'maxInlineSize']
 //   sizeKeys.forEach(key => addStyle(key, deps.transformSizeRatio(key, props)))
 //   // Box size
 //   if (deps.isString(props.boxSize)) {
 //     const [height, width] = props.boxSize.split(' ')
 //     Object.assign(styles, deps.transformSize('height', height))
 //     Object.assign(styles, deps.transformSize('width', width || height))
 //   }
 //   // Size ranges
 //   const rangeKeys = ['widthRange', 'heightRange', 'minSize', 'maxSize']
 //   rangeKeys.forEach(key => {
 //     if (deps.isString(props[key])) {
 //       const [min, max] = props[key].split(' ')
 //       addStyle(`min${key.charAt(0).toUpperCase() + key.slice(1)}`, deps.transformSize('min' + key, min))
 //       addStyle(`max${key.charAt(0).toUpperCase() + key.slice(1)}`, deps.transformSize('max' + key, max || min))
 //     }
 //   })
 //   // Direction, objectFit, aspectRatio, etc.
 //   const simpleProps = ['direction', 'objectFit', 'aspectRatio', 'float', 'flex', 'flexDirection', 'alignItems', 'alignContent', 'justifyContent', 'justifyItems', 'alignSelf', 'order', 'resize', 'verticalAlign', 'columns', 'columnRule', 'columnWidth', 'columnSpan', 'columnFill', 'columnCount']
 //   simpleProps.forEach(key => addStyle(key, !deps.isUndefined(props[key]) ? props[key] : undefined))
 //   // Flex and grid specific properties
 //   if (props.flexWrap) {
 //     addStyle('flexWrap', props.flexWrap)
 //   }
 //   if (deps.isString(props.flexFlow)) {
 //     let [direction, wrap] = props.flexFlow.split(' ')
 //     direction = direction.startsWith('x') || direction === 'row' ? 'row' : 'column'
 //     addStyle('flexFlow', direction + ' ' + (wrap || ''))
 //   }
 //   if (deps.isString(props.flexAlign)) {
 //     const [alignItems, justifyContent] = props.flexAlign.split(' ')
 //     addStyle('alignItems', alignItems)
 //     addStyle('justifyContent', justifyContent)
 //   }
 //   // Gap properties
 //   if (!deps.isUndefined(props.gap)) {
 //     addStyle('gap', transfromGap(props.gap))
 //   }
 //   if (props.columnGap) {
 //     addStyle('columnGap', deps.getSpacingBasedOnRatio(props, 'columnGap'))
 //   }
 //   if (props.rowGap) {
 //     addStyle('rowGap', deps.getSpacingBasedOnRatio(props, 'rowGap'))
 //   }
 //   // Grid properties
 //   const gridProps = ['gridColumn', 'gridColumnStart', 'gridRow', 'gridRowStart']
 //   gridProps.forEach(key => addStyle(key, !deps.isUndefined(props[key]) ? props[key] : undefined))
 //   console.log(styles)
 //   return styles
 // }


var $7c9e38fe1a9b9734$exports = {};

$parcel$export($7c9e38fe1a9b9734$exports, "Direction", function () { return $7c9e38fe1a9b9734$export$cacd6541cfeeb6c1; });
'use strict';
const $7c9e38fe1a9b9734$export$cacd6541cfeeb6c1 = {
    props: {
        direction: 'ltr'
    },
    class: {
        direction: ({ props: props })=>({
                direction: props.direction
            })
    }
};


var $d1b6f6dccd731295$exports = {};

$parcel$export($d1b6f6dccd731295$exports, "Flex", function () { return $d1b6f6dccd731295$export$f51f4c4ede09e011; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $d1b6f6dccd731295$export$f51f4c4ede09e011 = {
    props: {
        display: 'flex'
    },
    class: {
        flow: ({ props: props })=>{
            const { flow: flow, reverse: reverse } = props;
            if (!(0, $amNJ8.isString)(flow)) return;
            let [direction, wrap] = (flow || 'row').split(' ');
            if (flow.startsWith('x') || flow === 'row') direction = 'row';
            if (flow.startsWith('y') || flow === 'column') direction = 'column';
            return {
                flexFlow: (direction || '') + (!direction.includes('-reverse') && reverse ? '-reverse' : '') + ' ' + (wrap || '')
            };
        },
        wrap: ({ props: props })=>props.wrap && {
                flexWrap: props.wrap
            },
        align: ({ props: props })=>{
            if (!(0, $amNJ8.isString)(props.align)) return;
            const [alignItems, justifyContent] = props.align.split(' ');
            return {
                alignItems: alignItems,
                justifyContent: justifyContent
            };
        }
    }
};


var $16579ed67f3c9b7f$exports = {};

$parcel$export($16579ed67f3c9b7f$exports, "Grid", function () { return $16579ed67f3c9b7f$export$ef2184bd89960b14; });

'use strict';
const $16579ed67f3c9b7f$export$ef2184bd89960b14 = {
    deps: {
        getSpacingBasedOnRatio: $8d2bd189328d3a32$export$94679ba49f16fc2e
    },
    props: {
        display: 'grid'
    },
    class: {
        area: ({ props: props })=>props.area ? {
                gridArea: props.area
            } : null,
        template: ({ props: props })=>props.template ? {
                gridTemplate: props.template
            } : null,
        templateAreas: ({ props: props })=>props.templateAreas ? {
                gridTemplateAreas: props.templateAreas
            } : null,
        column: ({ props: props })=>props.column ? {
                gridColumn: props.column
            } : null,
        columns: ({ props: props })=>props.columns ? {
                gridTemplateColumns: props.columns
            } : null,
        templateColumns: ({ props: props })=>props.templateColumns ? {
                gridTemplateColumns: props.templateColumns
            } : null,
        autoColumns: ({ props: props })=>props.autoColumns ? {
                gridAutoColumns: props.autoColumns
            } : null,
        columnStart: ({ props: props })=>props.columnStart ? {
                gridColumnStart: props.columnStart
            } : null,
        row: ({ props: props })=>props.row ? {
                gridRow: props.row
            } : null,
        rows: ({ props: props })=>props.rows ? {
                gridTemplateRows: props.rows
            } : null,
        templateRows: ({ props: props })=>props.templateRows ? {
                gridTemplateRows: props.templateRows
            } : null,
        autoRows: ({ props: props })=>props.autoRows ? {
                gridAutoRows: props.autoRows
            } : null,
        rowStart: ({ props: props })=>props.rowStart ? {
                gridRowStart: props.rowStart
            } : null,
        autoFlow: ({ props: props })=>props.autoFlow ? {
                gridAutoFlow: props.autoFlow
            } : null
    }
};


var $76525dc5e29bbed4$exports = {};

$parcel$export($76525dc5e29bbed4$exports, "Img", function () { return $76525dc5e29bbed4$export$cc7b5f925acc71d3; });
'use strict';
const $76525dc5e29bbed4$export$cc7b5f925acc71d3 = {
    tag: 'img',
    attr: {
        src: (el)=>{
            const { props: props, context: context } = el;
            let src = (props.preSrc || '') + el.call('exec', props.src, el);
            if (el.call('isString', src) && src.includes('{{')) src = el.call('replaceLiteralsWithObjectFields', src);
            let isUrl;
            try {
                isUrl = new URL(src);
            } catch (e) {}
            if (isUrl) return src;
            const file = context.files && context.files[src];
            if (file) return file.content && file.content.src;
        },
        alt: ({ props: props })=>props.alt,
        title: ({ props: props })=>props.title || props.alt
    }
};


var $1b351a6e260dfcb4$exports = {};

$parcel$export($1b351a6e260dfcb4$exports, "Form", function () { return $1b351a6e260dfcb4$export$a7fed597f4b8afd8; });
'use strict';
const $1b351a6e260dfcb4$export$a7fed597f4b8afd8 = {
    tag: 'form',
    attr: {
        action: ({ props: props })=>props.action,
        method: ({ props: props })=>props.method,
        enctype: ({ props: props })=>props.enctype
    }
};


var $8bf0bee715543d08$exports = {};

$parcel$export($8bf0bee715543d08$exports, "keySetters", function () { return $8bf0bee715543d08$export$5c168558fab3755c; });
$parcel$export($8bf0bee715543d08$exports, "Media", function () { return $8bf0bee715543d08$export$7fc53215244aec38; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
var $jm0BQ = parcelRequire("jm0BQ");
var $3f3bd33101f88eb8$exports = {};

$parcel$export($3f3bd33101f88eb8$exports, "getSystemGlobalTheme", function () { return $3f3bd33101f88eb8$export$f12bbb197a836138; });
$parcel$export($3f3bd33101f88eb8$exports, "Theme", function () { return $3f3bd33101f88eb8$export$14faa19a0f3bbeb2; });


var $836338cbaed52506$exports = {};

$parcel$export($836338cbaed52506$exports, "Timing", function () { return $836338cbaed52506$export$ef1e5872612852d1; });

parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $836338cbaed52506$export$ef1e5872612852d1 = {
    deps: {
        getTimingFunction: $9779037853e3fa59$export$23ba66c7c3e2e613,
        splitTransition: $260ce182974bc204$export$d9f7ff0c2b32d4b5,
        transformDuration: $260ce182974bc204$export$d87c1c5f4a8ec3d9
    },
    class: {
        transition: ({ props: props, deps: deps })=>!(0, $amNJ8.isUndefined)(props.transition) && {
                transition: deps.splitTransition(props.transition)
            },
        willChange: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.willChange) && {
                willChange: props.willChange
            },
        transitionDuration: ({ props: props, deps: deps })=>!(0, $amNJ8.isUndefined)(props.transitionDuration) && {
                transitionDuration: deps.transformDuration(props.transitionDuration)
            },
        transitionDelay: ({ props: props, deps: deps })=>!(0, $amNJ8.isUndefined)(props.transitionDelay) && {
                transitionDelay: deps.transformDuration(props.transitionDelay)
            },
        transitionTimingFunction: ({ props: props, deps: deps })=>!(0, $amNJ8.isUndefined)(props.transitionTimingFunction) && {
                transitionTimingFunction: deps.getTimingFunction(props.transitionTimingFunction)
            },
        transitionProperty: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.transitionProperty) && {
                transitionProperty: props.transitionProperty,
                willChange: props.transitionProperty
            }
    }
};


'use strict';
const $8893aa143bee9fdd$var$CONFIG = (0, $6c2510166886baa2$export$e23c3d522afb24cd)();
const $8893aa143bee9fdd$export$b202ba015b5882cd = {
    4: {
        boxShadow: `rgba(0,0,0,.10) 0 2${$8893aa143bee9fdd$var$CONFIG.UNIT.default} 4${$8893aa143bee9fdd$var$CONFIG.UNIT.default}`
    },
    6: {
        boxShadow: `rgba(0,0,0,.10) 0 3${$8893aa143bee9fdd$var$CONFIG.UNIT.default} 6${$8893aa143bee9fdd$var$CONFIG.UNIT.default}`
    },
    10: {
        boxShadow: `rgba(0,0,0,.10) 0 4${$8893aa143bee9fdd$var$CONFIG.UNIT.default} 10${$8893aa143bee9fdd$var$CONFIG.UNIT.default}`
    },
    16: {
        boxShadow: `rgba(0,0,0,.10) 0 8${$8893aa143bee9fdd$var$CONFIG.UNIT.default} 16${$8893aa143bee9fdd$var$CONFIG.UNIT.default}`
    },
    26: {
        boxShadow: `rgba(0,0,0,.10) 0 14${$8893aa143bee9fdd$var$CONFIG.UNIT.default} 26${$8893aa143bee9fdd$var$CONFIG.UNIT.default}`
    },
    42: {
        boxShadow: `rgba(0,0,0,.10) 0 20${$8893aa143bee9fdd$var$CONFIG.UNIT.default} 42${$8893aa143bee9fdd$var$CONFIG.UNIT.default}`
    }
};
const $8893aa143bee9fdd$var$getComputedBackgroundColor = ({ props: props })=>{
    return (0, $31bb7c46f86719dd$export$5551a2d24ff40153)(props.shapeDirectionColor) || (0, $31bb7c46f86719dd$export$5551a2d24ff40153)(props.borderColor) || (0, $31bb7c46f86719dd$export$5551a2d24ff40153)(props.backgroundColor) || (0, $31bb7c46f86719dd$export$5551a2d24ff40153)(props.background);
};
const $8893aa143bee9fdd$var$inheritTransition = ({ props: props, deps: deps })=>{
    const exec = (0, $836338cbaed52506$export$ef1e5872612852d1).class.transition({
        props: props,
        deps: deps
    });
    return exec && exec.transition;
};
const $8893aa143bee9fdd$export$511e1d54a4a8684e = {
    rectangle: {},
    circle: {
        borderRadius: '100%'
    },
    bubble: {},
    tv: {
        borderRadius: '1.15em/2.5em'
    },
    tooltip: ({ props: props, deps: deps })=>({
            position: props.position || 'relative',
            '&:before': {
                content: '""',
                display: 'block',
                width: '0px',
                height: '0px',
                border: '.35em solid',
                borderColor: $8893aa143bee9fdd$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                transition: $8893aa143bee9fdd$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: 'border-color',
                position: 'absolute',
                borderRadius: '.15em'
            }
        }),
    tooltipDirection: {
        top: {
            '&:before': {
                top: '0',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            }
        },
        right: {
            '&:before': {
                top: '50%',
                right: '0',
                transform: 'translate(50%, -50%) rotate(45deg)'
            }
        },
        bottom: {
            '&:before': {
                bottom: '0',
                left: '50%',
                transform: 'translate(-50%, 50%) rotate(45deg)'
            }
        },
        left: {
            '&:before': {
                top: '50%',
                left: '0',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            }
        }
    },
    tag: ({ props: props, deps: deps })=>({
            position: 'relative',
            '&:before': {
                content: '""',
                display: 'block',
                background: $8893aa143bee9fdd$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                transition: $8893aa143bee9fdd$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: 'background',
                borderRadius: '.25em',
                position: 'absolute',
                zIndex: '-1',
                aspectRatio: '1/1',
                top: '50%',
                transformOrigin: '50% 50%',
                height: '73%'
            }
        }),
    tagDirection: {
        top: {
            '&:before': {
                bottom: '100%',
                left: '50%',
                transform: 'translate(-50%, 50%) rotate(45deg)'
            }
        },
        right: {
            '&:before': {
                top: '50%',
                left: '100%',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            }
        },
        bottom: {
            '&:before': {
                top: '100%',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            }
        },
        left: {
            '&:before': {
                top: '50%',
                right: '100%',
                transform: 'translate(50%, -50%) rotate(45deg)'
            }
        }
    },
    hexagon: ({ props: props, deps: deps })=>({
            position: 'relative',
            '&:before, &:after': {
                content: '""',
                display: 'block',
                position: 'absolute',
                zIndex: '-1',
                borderRadius: '.25em',
                aspectRatio: '1/1',
                top: '50%',
                transformOrigin: '50% 50%',
                height: '73%',
                background: $8893aa143bee9fdd$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                transition: $8893aa143bee9fdd$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: 'background'
            },
            '&:before': {
                left: '0',
                transform: 'translate3d(-50%, -50%, 1px) rotate(45deg)'
            },
            '&:after': {
                left: '100%',
                transform: 'translate3d(-50%, -50%, 1px) rotate(45deg)'
            }
        }),
    chevron: ({ props: props, deps: deps })=>({
            position: 'relative',
            '&:before, &:after': {
                content: '""',
                display: 'block',
                position: 'absolute',
                zIndex: '-1',
                aspectRatio: '1/1',
                top: '50%',
                transformOrigin: '50% 50%',
                transition: $8893aa143bee9fdd$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: 'background'
            },
            '&:before': {
                background: `linear-gradient(225deg, ${$8893aa143bee9fdd$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                })} 25%, transparent 25%), linear-gradient(315deg, ${$8893aa143bee9fdd$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                })} 25%, transparent 25%)`
            },
            '&:after': {
                background: $8893aa143bee9fdd$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                borderRadius: '.25em'
            }
        }),
    chevronDirection: {
        left: {
            '&:before': {
                height: '100%',
                left: '100%',
                transform: 'translate3d(-1%, -50%, 1px) scale(-1, 1)'
            },
            '&:after': {
                height: '73%',
                left: '0',
                transform: 'translate3d(-50%, -50%, 1px) rotate(45deg)'
            }
        },
        right: {
            '&:before': {
                height: '100%',
                left: '0',
                transform: 'translate3d(-99%, -50%, 1px)'
            },
            '&:after': {
                height: '73%',
                left: '100%',
                transform: 'translate3d(-50%, -50%, 1px) rotate(45deg)'
            }
        }
    }
};


parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $3f3bd33101f88eb8$export$f12bbb197a836138 = ({ context: context, state: state })=>{
    const rootState = state && state.root;
    return rootState && rootState.globalTheme ? rootState.globalTheme : context.designSystem && context.designSystem.globalTheme;
};
const $3f3bd33101f88eb8$export$14faa19a0f3bbeb2 = {
    deps: {
        depth: $8893aa143bee9fdd$export$b202ba015b5882cd,
        getSystemGlobalTheme: $3f3bd33101f88eb8$export$f12bbb197a836138,
        getMediaTheme: $50d2ff83e590f376$export$b3cf7317de2f2233,
        getMediaColor: $31bb7c46f86719dd$export$dd72f6d9deea7207,
        transformTextStroke: $260ce182974bc204$export$8bcd50b221b13db,
        transformShadow: $260ce182974bc204$export$837e4beeff9ff924,
        transformBoxShadow: $260ce182974bc204$export$9c296746f296a70,
        transformBorder: $260ce182974bc204$export$ca4ef6ca6dc743f2,
        transformBackgroundImage: $260ce182974bc204$export$15f2b9b64835b137
    },
    class: {
        depth: ({ props: props, deps: deps })=>!(0, $amNJ8.isUndefined)(props.depth) && deps.depth[props.depth],
        theme: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemGlobalTheme(element);
            if (!props.theme) return;
            const hasSubtheme = props.theme.includes(' ') && !props.theme.includes('@');
            const globalThemeForced = `@${props.themeModifier || globalTheme}`;
            if (hasSubtheme) {
                const themeAppliedInVal = props.theme.split(' ');
                themeAppliedInVal.splice(1, 0, globalThemeForced);
                return deps.getMediaTheme(themeAppliedInVal);
            } else if (props.theme.includes('@{globalTheme}')) props.theme.replace('@{globalTheme}', globalThemeForced);
            return deps.getMediaTheme(props.theme, `@${props.themeModifier || globalTheme}`);
        },
        color: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemGlobalTheme(element);
            if (!props.color) return;
            return {
                color: deps.getMediaColor(props.color, globalTheme)
            };
        },
        background: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemGlobalTheme(element);
            if (!props.background) return;
            return {
                background: deps.getMediaColor(props.background, globalTheme)
            };
        },
        backgroundColor: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemGlobalTheme(element);
            if (!props.backgroundColor) return;
            return {
                backgroundColor: deps.getMediaColor(props.backgroundColor, globalTheme)
            };
        },
        backgroundImage: (element, s, context)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemGlobalTheme(element);
            let val = props.backgroundImage;
            if (!val) return;
            const file = context.files && context.files[val];
            if (file && file.content) val = file.content.src;
            return {
                backgroundImage: deps.transformBackgroundImage(val, globalTheme)
            };
        },
        backgroundSize: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.backgroundSize) ? {
                backgroundSize: props.backgroundSize
            } : null,
        backgroundPosition: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.backgroundPosition) ? {
                backgroundPosition: props.backgroundPosition
            } : null,
        backgroundRepeat: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.backgroundRepeat) ? {
                backgroundRepeat: props.backgroundRepeat
            } : null,
        textStroke: ({ props: props, deps: deps })=>!(0, $amNJ8.isUndefined)(props.textStroke) ? {
                WebkitTextStroke: deps.transformTextStroke(props.textStroke)
            } : null,
        outline: ({ props: props, deps: deps })=>!(0, $amNJ8.isUndefined)(props.outline) && {
                outline: deps.transformBorder(props.outline)
            },
        outlineOffset: ({ props: props, deps: deps })=>deps.transformSizeRatio('outlineOffset', props),
        border: ({ props: props, deps: deps })=>!(0, $amNJ8.isUndefined)(props.border) && {
                border: deps.transformBorder(props.border)
            },
        borderColor: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemGlobalTheme(element);
            if (!props.borderColor) return;
            return {
                borderColor: deps.getMediaColor(props.borderColor, globalTheme)
            };
        },
        borderStyle: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.borderStyle) && {
                borderStyle: props.borderStyle
            },
        borderLeft: ({ props: props, deps: deps })=>!(0, $amNJ8.isUndefined)(props.borderLeft) && {
                borderLeft: deps.transformBorder(props.borderLeft)
            },
        borderTop: ({ props: props, deps: deps })=>!(0, $amNJ8.isUndefined)(props.borderTop) && {
                borderTop: deps.transformBorder(props.borderTop)
            },
        borderRight: ({ props: props, deps: deps })=>!(0, $amNJ8.isUndefined)(props.borderRight) && {
                borderRight: deps.transformBorder(props.borderRight)
            },
        borderBottom: ({ props: props, deps: deps })=>!(0, $amNJ8.isUndefined)(props.borderBottom) && {
                borderBottom: deps.transformBorder(props.borderBottom)
            },
        shadow: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemGlobalTheme(element);
            if (!props.backgroundImage) return;
            return {
                boxShadow: deps.transformShadow(props.shadow, globalTheme)
            };
        },
        // boxShadow: ({ props, deps }) => isString(props.boxShadow) && ({
        //   boxShadow: deps.transformBoxShadow(props.boxShadow)
        // }),
        boxShadow: (element, state, context)=>{
            const { props: props, deps: deps } = element;
            if (!(0, $amNJ8.isString)(props.boxShadow)) return;
            const [val, hasImportant] = props.boxShadow.split('!importan');
            const globalTheme = $3f3bd33101f88eb8$export$f12bbb197a836138(element);
            const important = hasImportant ? ' !important' : '';
            return {
                boxShadow: deps.transformBoxShadow(val.trim(), globalTheme) + important
            };
        },
        textShadow: ({ props: props, deps: deps, context: context })=>!(0, $amNJ8.isUndefined)(props.textShadow) && {
                textShadow: deps.transformBoxShadow(props.textShadow, context.designSystem.globalTheme)
            },
        backdropFilter: ({ props: props, deps: deps })=>!(0, $amNJ8.isUndefined)(props.backdropFilter) && {
                backdropFilter: props.backdropFilter
            },
        caretColor: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.caretColor) && {
                caretColor: props.caretColor
            },
        opacity: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.opacity) && {
                opacity: props.opacity
            },
        visibility: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.visibility) && {
                visibility: props.visibility
            },
        columnRule: ({ props: props, deps: deps })=>!(0, $amNJ8.isUndefined)(props.columnRule) && {
                columnRule: deps.transformBorder(props.columnRule)
            },
        filter: ({ props: props, deps: deps })=>!(0, $amNJ8.isUndefined)(props.filter) && {
                filter: props.filter
            },
        mixBlendMode: ({ props: props, deps: deps })=>!(0, $amNJ8.isUndefined)(props.mixBlendMode) && {
                mixBlendMode: props.mixBlendMode
            },
        appearance: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.appearance) && {
                appearance: props.appearance
            }
    }
};


'use strict';
const $8bf0bee715543d08$export$5c168558fab3755c = {
    '@': (key, props, result, element, isSubtree)=>$8bf0bee715543d08$var$applyMediaProps(key, props, isSubtree ? result : result && result.media, element),
    ':': (key, props, result, element, isSubtree)=>$8bf0bee715543d08$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    '[': (key, props, result, element, isSubtree)=>$8bf0bee715543d08$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    '*': (key, props, result, element, isSubtree)=>$8bf0bee715543d08$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    '+': (key, props, result, element, isSubtree)=>$8bf0bee715543d08$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    '~': (key, props, result, element, isSubtree)=>$8bf0bee715543d08$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    '&': (key, props, result, element, isSubtree)=>$8bf0bee715543d08$var$applyAndProps(key, props, isSubtree ? result : result && result.selector, element),
    '>': (key, props, result, element, isSubtree)=>$8bf0bee715543d08$var$applyAndProps(key, props, isSubtree ? result : result && result.selector, element),
    $: (key, props, result, element, isSubtree)=>$8bf0bee715543d08$var$applyCaseProps(key, props, isSubtree ? result : result && result.case, element),
    '-': (key, props, result, element, isSubtree)=>$8bf0bee715543d08$var$applyVariableProps(key, props, isSubtree ? result : result && result.variable, element),
    '.': (key, props, result, element, isSubtree)=>$8bf0bee715543d08$var$applyConditionalCaseProps(key, props, isSubtree ? result : result && result.case, element),
    '!': (key, props, result, element, isSubtree)=>$8bf0bee715543d08$var$applyConditionalFalsyProps(key, props, isSubtree ? result : result && result.case, element)
};
const $8bf0bee715543d08$var$execClass = (key, props, result, element)=>{
    const { class: className } = element;
    const classnameExec = className[key];
    if (typeof classnameExec !== 'function') return;
    let classExec = classnameExec({
        props: props,
        context: element.context,
        state: element.state,
        deps: element.deps
    }, element.state, element.context);
    if ((0, $amNJ8.isArray)(classExec)) classExec = classExec.reduce((a, c)=>(0, $jm0BQ.merge)(a, c), {});
    for(const finalProp in classExec)result[finalProp] = classExec[finalProp];
    return classExec;
};
const $8bf0bee715543d08$var$convertPropsToClass = (props, result, element)=>{
    const propsClassObj = {};
    for(const key in props){
        const setter = $8bf0bee715543d08$export$5c168558fab3755c[key.slice(0, 1)];
        if (setter) {
            setter(key, props[key], propsClassObj, element, true);
            continue;
        } else $8bf0bee715543d08$var$execClass(key, props, propsClassObj, element);
    }
    return propsClassObj;
};
const $8bf0bee715543d08$var$applyMediaProps = (key, props, result, element)=>{
    const { context: context } = element;
    if (!context.designSystem || !context.designSystem.MEDIA) return;
    const globalTheme = (0, $3f3bd33101f88eb8$export$f12bbb197a836138)(element);
    const { MEDIA: MEDIA } = context.designSystem;
    const mediaValue = MEDIA[key.slice(1)];
    const generatedClass = $8bf0bee715543d08$var$convertPropsToClass(props, result, element);
    const name = key.slice(1);
    const isTheme = [
        'dark',
        'light'
    ].includes(name);
    const matchesGlobal = name === globalTheme;
    if (globalTheme && isTheme) {
        if (matchesGlobal) return (0, $jm0BQ.merge)(result, generatedClass);
        return;
    }
    const printValue = '@media ' + (mediaValue === 'print' ? `${mediaValue}` : `screen and ${mediaValue}`);
    const mediaKey = mediaValue ? printValue : key;
    result[mediaKey] = generatedClass;
    return result[mediaKey];
};
const $8bf0bee715543d08$var$applyAndProps = (key, props, result, element)=>{
    result[key] = $8bf0bee715543d08$var$convertPropsToClass(props, result, element);
    return result[key];
};
const $8bf0bee715543d08$var$applySelectorProps = (key, props, result, element)=>{
    const selectorKey = `&${key}`;
    result[selectorKey] = $8bf0bee715543d08$var$convertPropsToClass(props, result, element);
    return result[selectorKey];
};
const $8bf0bee715543d08$var$applyCaseProps = (key, props, result, element)=>{
    const { CASES: CASES } = element.context && element.context.designSystem;
    const caseKey = key.slice(1);
    const isPropTrue = element.props[caseKey];
    if (!CASES[caseKey] && !isPropTrue) return;
    return (0, $jm0BQ.merge)(result, $8bf0bee715543d08$var$convertPropsToClass(props, result, element));
};
const $8bf0bee715543d08$var$applyVariableProps = (key, props, result, element)=>{
    result[key] = props;
    return result;
};
const $8bf0bee715543d08$var$applyConditionalCaseProps = (key, props, result, element)=>{
    const caseKey = key.slice(1);
    const isPropTrue = element.props[caseKey] === true || element.state[caseKey] || element[caseKey];
    if (!isPropTrue) return; // remove classname if not here
    return (0, $jm0BQ.overwriteDeep)(result, $8bf0bee715543d08$var$convertPropsToClass(props, result, element));
};
const $8bf0bee715543d08$var$applyConditionalFalsyProps = (key, props, result, element)=>{
    const caseKey = key.slice(1);
    const isPropTrue = element.props[caseKey] === true || element.state[caseKey] || element[caseKey];
    if (!isPropTrue) return (0, $jm0BQ.overwriteDeep)(result, $8bf0bee715543d08$var$convertPropsToClass(props, result, element));
};
const $8bf0bee715543d08$var$applyTrueProps = (props, result, element)=>(0, $jm0BQ.merge)(result, $8bf0bee715543d08$var$convertPropsToClass(props, result, element));
const $8bf0bee715543d08$var$beforeClassAssign = (element, s, ctx)=>{
    const { props: props, class: className, context: context } = element;
    const CLASS_NAMES = {
        media: {},
        selector: {},
        case: {},
        variable: {}
    };
    if (!context) return;
    const globalTheme = context.designSystem.globalTheme;
    for(const key in props){
        const setter = $8bf0bee715543d08$export$5c168558fab3755c[key.slice(0, 1)];
        if (globalTheme) {
            if (key === 'theme' && !props.themeModifier) props.update({
                themeModifier: globalTheme
            }, {
                preventListeners: true,
                preventRecursive: true,
                isForced: true,
                preventDefineUpdate: true
            });
        }
        if (setter) setter(key, props[key], CLASS_NAMES, element);
        else if (key === 'class') {
            const value = element.props.class;
            if (!element.call('isString', value)) return;
            const classArr = value.split(' ');
            const scratchClasses = ctx.designSystem.CLASS;
            CLASS_NAMES.class = classArr.reduce((accumulator, current)=>{
                const scratchClass = scratchClasses[current];
                return (0, $jm0BQ.merge)(accumulator, scratchClass);
            }, {});
        } else if (key === 'true') $8bf0bee715543d08$var$applyTrueProps(props[key], CLASS_NAMES, element);
    }
    // override props
    // if (props['^']) {
    //   for (const key in props['^']) {
    //     execClass(key, props, CLASS_NAMES, element)
    //   }
    // }
    const parentProps = element.parent && element.parent.props;
    if (parentProps && parentProps.spacingRatio && parentProps.inheritSpacingRatio) element.setProps({
        spacingRatio: parentProps.spacingRatio,
        inheritSpacingRatio: true
    }, {
        preventListeners: true,
        preventRecursive: true,
        isForced: true,
        preventDefineUpdate: true
    });
    (0, $jm0BQ.overwriteShallow)(className, CLASS_NAMES);
};
const $8bf0bee715543d08$export$7fc53215244aec38 = {
    class: {
        case: (el, s)=>{
            return {
            };
        }
    },
    on: {
        beforeClassAssign: $8bf0bee715543d08$var$beforeClassAssign
    }
};


var $13529cac56e876e3$exports = {};

$parcel$export($13529cac56e876e3$exports, "Iframe", function () { return $13529cac56e876e3$export$5137ec99f248330b; });
'use strict';
const $13529cac56e876e3$export$5137ec99f248330b = {
    tag: 'iframe',
    props: {
        position: 'relative',
        minWidth: 'H',
        minHeight: 'H'
    },
    attr: {
        src: (el, s)=>{
            let src = el.call('exec', el.props.src, el);
            if (el.call('isString', src) && src.includes('{{')) src = el.call('replaceLiteralsWithObjectFields', src);
            let isUrl;
            try {
                isUrl = new URL(src);
            } catch (e) {}
            if (isUrl) return src;
        },
        srcdoc: ({ props: props })=>props.srcdoc,
        sandbox: ({ props: props })=>props.sandbox,
        seamless: ({ props: props })=>props.seamless,
        loading: ({ props: props })=>props.loading,
        allowfullscreen: ({ props: props })=>props.allowfullscreen,
        frameborder: ({ props: props })=>props.frameborder,
        allow: ({ props: props })=>props.allow,
        referrerpolicy: ({ props: props })=>props.referrerpolicy
    }
};


var $dac5daea1dcbcf9a$exports = {};

$parcel$export($dac5daea1dcbcf9a$exports, "Interaction", function () { return $dac5daea1dcbcf9a$export$a13296960cae0384; });
'use strict';
const $dac5daea1dcbcf9a$export$a13296960cae0384 = {
    class: {
        userSelect: ({ props: props })=>props.userSelect && {
                userSelect: props.userSelect
            },
        pointerEvents: ({ props: props })=>props.pointerEvents && {
                pointerEvents: props.pointerEvents
            },
        cursor: (el, s, ctx)=>{
            let val = el.props.cursor;
            if (!val) return;
            const file = ctx.files && ctx.files[val];
            if (file && file.content) val = `url(${file.content.src})`;
            return {
                cursor: val
            };
        }
    }
};


var $a3728907a9aad1ec$exports = {};

$parcel$export($a3728907a9aad1ec$exports, "Hoverable", function () { return $a3728907a9aad1ec$export$8cf654b375a16d2d; });
$parcel$export($a3728907a9aad1ec$exports, "Clickable", function () { return $a3728907a9aad1ec$export$2f51d37476d4c437; });
$parcel$export($a3728907a9aad1ec$exports, "Focusable", function () { return $a3728907a9aad1ec$export$35a3bebf7ef2d934; });
$parcel$export($a3728907a9aad1ec$exports, "FocusableComponent", function () { return $a3728907a9aad1ec$export$b177f82f5511f000; });
'use strict';
const $a3728907a9aad1ec$var$style = {
    appearance: 'none',
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'inherit'
};
const $a3728907a9aad1ec$export$8cf654b375a16d2d = {
    props: {
        transition: 'C defaultBezier',
        transitionProperty: 'opacity, transform',
        opacity: 0.85,
        ':hover': {
            opacity: 0.9,
            transform: 'scale(1.015)'
        },
        ':active': {
            opacity: 1,
            transform: 'scale(1.015)'
        },
        '.active': {
            opacity: 1,
            transform: 'scale(1.015)',
            ':hover': {
                opacity: 1
            }
        }
    }
};
const $a3728907a9aad1ec$export$2f51d37476d4c437 = {
    extend: $a3728907a9aad1ec$export$8cf654b375a16d2d,
    props: {
        ':active': {
            opacity: 1,
            transform: 'scale(1.015)'
        },
        '.active': {
            opacity: 1
        }
    }
};
const $a3728907a9aad1ec$export$35a3bebf7ef2d934 = {
    props: {
        border: 'none',
        outline: 'solid, 0, blue .3',
        ':focus-visible': {
            opacity: 1,
            outline: 'solid, X, blue .3'
        }
    },
    attr: {
        placeholder: ({ props: props })=>props.placeholder,
        tabIndex: ({ props: props })=>props.tabIndex
    }
};
const $a3728907a9aad1ec$export$b177f82f5511f000 = {
    extend: $a3728907a9aad1ec$export$35a3bebf7ef2d934,
    tag: 'button',
    props: {
        fontSize: 'A',
        type: 'button',
        border: 'none',
        textDecoration: 'none',
        lineHeight: '1',
        whiteSpace: 'nowrap',
        fontFamily: 'inherit',
        style: $a3728907a9aad1ec$var$style
    },
    attr: {
        type: ({ props: props })=>props.type
    }
};


var $16f068d5dcc1a960$exports = {};

$parcel$export($16f068d5dcc1a960$exports, "Overflow", function () { return $16f068d5dcc1a960$export$25d20c189d4a23b8; });
'use strict';
const $16f068d5dcc1a960$export$25d20c189d4a23b8 = {
    class: {
        overflow: ({ props: props, deps: deps })=>!deps.isUndefined(props.overflow) && {
                overflow: props.overflow,
                scrollBehavior: 'smooth'
            },
        overflowX: ({ props: props, deps: deps })=>!deps.isUndefined(props.overflowX) && {
                overflowX: props.overflowX
            },
        overflowY: ({ props: props, deps: deps })=>!deps.isUndefined(props.overflowY) && {
                overflowY: props.overflowY
            },
        overscrollBehavior: ({ props: props, deps: deps })=>!deps.isUndefined(props.overscrollBehavior) && {
                overscrollBehavior: props.overscrollBehavior
            }
    }
};


var $bbb58e1b70381780$exports = {};

$parcel$export($bbb58e1b70381780$exports, "Collection", function () { return $bbb58e1b70381780$export$fb8073518f34e6ec; });
parcelRequire("jnoTA");
var $8liBK = parcelRequire("8liBK");
parcelRequire("imR0C");
var $3Kzng = parcelRequire("3Kzng");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $bbb58e1b70381780$export$fb8073518f34e6ec = {
    define: {
        $collection: async (param, el, state)=>{
            const { __ref: ref } = el;
            const { children: childrenProps, childrenAs: childrenAs, childExtends: childExtends } = el.props || {};
            const children = childrenProps && await (0, $jm0BQ.exec)(childrenProps, el, state);
            const childrenAsDefault = childrenAs || 'props';
            if (children) {
                if ((0, $amNJ8.isObject)(children)) {
                    if (children.$$typeof) return el.call('renderReact', children, el);
                    param = (0, $jm0BQ.deepClone)(children);
                    param = Object.keys(param).map((v)=>{
                        const val = param[v];
                        return (0, $3Kzng.addAdditionalExtend)(v, val);
                    });
                } else if ((0, $amNJ8.isArray)(children)) {
                    param = (0, $jm0BQ.deepClone)(children);
                    if (childrenAsDefault && childrenAsDefault !== 'element') param = param.map((v)=>({
                            ...childExtends && {
                                extend: childExtends
                            },
                            [childrenAsDefault]: (0, $amNJ8.isObjectLike)(v) ? v : childrenAsDefault === 'state' ? {
                                value: v
                            } : {
                                text: v
                            }
                        }));
                } else if ((0, $amNJ8.isString)(children) || (0, $amNJ8.isNumber)(children)) {
                    el.removeContent();
                    el.content = {
                        text: param
                    };
                    return;
                }
            }
            if (!param) return;
            const filterReact = param.filter((v)=>!v.$$typeof);
            if (filterReact.length !== param.length) {
                const extractedReactComponents = param.filter((v)=>v.$$typeof);
                el.call('renderReact', extractedReactComponents, el);
            }
            param = filterReact;
            if ((0, $amNJ8.isString)(param)) {
                if (param === 'state') param = state.parse();
                else param = (0, $8liBK.getChildStateInKey)(param, state);
            }
            if ((0, $8liBK.isState)(param)) param = param.parse();
            if ((0, $amNJ8.isNot)(param)('array', 'object')) return;
            param = (0, $jm0BQ.deepClone)(param);
            if (ref.__collectionCache) {
                const equals = JSON.stringify(param) === JSON.stringify(ref.__collectionCache);
                if (equals) {
                    ref.__noCollectionDifference = true;
                    return;
                } else {
                    ref.__collectionCache = (0, $jm0BQ.deepClone)(param);
                    delete ref.__noCollectionDifference;
                }
            } else ref.__collectionCache = (0, $jm0BQ.deepClone)(param);
            const obj = {
                tag: 'fragment',
                props: {
                    ignoreChildProps: true,
                    childProps: el.props && el.props.childProps
                }
            };
            for(const key in param){
                const value = param[key];
                if (value) obj[key] = (0, $amNJ8.isObjectLike)(value) ? value : {
                    value: value
                };
            }
            el.removeContent();
            el.content = obj;
        // return deepClone(param)
        },
        $setCollection: async (param, el, state)=>{
            if (!param) return;
            if ((0, $amNJ8.isString)(param)) {
                if (param === 'state') param = state.parse();
                else param = (0, $8liBK.getChildStateInKey)(param, state);
            }
            const data = ((0, $amNJ8.isArray)(param) ? param : (0, $amNJ8.isObject)(param) ? Object.values(param) : []).map((item)=>!(0, $amNJ8.isObjectLike)(item) ? {
                    props: {
                        value: item
                    }
                } : item);
            if (data.length) {
                const t = setTimeout(()=>{
                    el.set({
                        tag: 'fragment',
                        ...data
                    }, {
                        preventDefineUpdate: '$setCollection'
                    });
                    clearTimeout(t);
                });
            }
            return data;
        },
        $stateCollection: async (param, el, state, ctx)=>{
            const { children: children, childrenAs: childrenAs } = el.props || {};
            if (!param || children || childrenAs) return;
            if ((0, $amNJ8.isString)(param)) {
                if (param === 'state') param = state.parse();
                else param = (0, $8liBK.getChildStateInKey)(param, state);
            }
            if ((0, $8liBK.isState)(param)) param = param.parse();
            if ((0, $amNJ8.isNot)(param)('array', 'object')) return;
            const { __ref: ref } = el;
            param = (0, $jm0BQ.deepClone)(param);
            if (ref.__stateCollectionCache) {
                const equals = JSON.stringify(param) === JSON.stringify(ref.__stateCollectionCache);
                if (equals) {
                    ref.__noCollectionDifference = true;
                    return;
                } else {
                    ref.__stateCollectionCache = (0, $jm0BQ.deepClone)(param);
                    delete ref.__noCollectionDifference;
                }
            } else ref.__stateCollectionCache = (0, $jm0BQ.deepClone)(param);
            const obj = {
                tag: 'fragment',
                props: {
                    ignoreChildProps: true,
                    childProps: el.props && el.props.childProps
                }
            };
            for(const key in param){
                const value = param[key];
                if (value) obj[key] = {
                    state: (0, $amNJ8.isObjectLike)(value) ? value : {
                        value: value
                    }
                };
            }
            el.removeContent();
            el.content = obj;
        // return deepClone(param)
        },
        $propsCollection: async (param, el, state)=>{
            const { children: children, childrenAs: childrenAs } = el.props || {};
            if (!param || children || childrenAs) return;
            if ((0, $amNJ8.isString)(param)) {
                if (param === 'state') param = state.parse();
                else param = (0, $8liBK.getChildStateInKey)(param, state);
            }
            if ((0, $8liBK.isState)(param)) param = param.parse();
            if ((0, $amNJ8.isNot)(param)('array', 'object')) return;
            const { __ref: ref } = el;
            param = (0, $jm0BQ.deepClone)(param);
            if (ref.__propsCollectionCache) {
                const equals = JSON.stringify(param) === JSON.stringify(ref.__propsCollectionCache); // eslint-disable-line
                if (equals) {
                    ref.__noCollectionDifference = true;
                    return;
                } else {
                    ref.__propsCollectionCache = (0, $jm0BQ.deepClone)(param);
                    delete ref.__noCollectionDifference;
                }
            } else ref.__propsCollectionCache = (0, $jm0BQ.deepClone)(param);
            const obj = {
                tag: 'fragment',
                props: {
                    ignoreChildProps: true,
                    childProps: el.props && el.props.childProps
                }
            };
            for(const key in param){
                const value = param[key];
                if (value) obj[key] = {
                    props: (0, $amNJ8.isObjectLike)(value) ? value : {
                        value: value
                    }
                };
            }
            el.removeContent();
            el.content = obj;
        // const set = () => {
        //   el.set(obj, { preventDefineUpdate: '$propsCollection' })
        // }
        // if (el.props && el.props.lazyLoad) {
        //   window.requestAnimationFrame(set)
        // } else set()
        // return deepClone(param)
        }
    }
};


var $871c31bc83970b54$exports = {};

$parcel$export($871c31bc83970b54$exports, "Position", function () { return $871c31bc83970b54$export$13807d9ee5a34a42; });

'use strict';
const $871c31bc83970b54$export$13807d9ee5a34a42 = {
    deps: {
        getSpacingByKey: $8d2bd189328d3a32$export$4f949d23b5dbefe6
    },
    class: {
        position: ({ props: props })=>props.position && {
                position: props.position
            },
        inset: ({ props: props, deps: deps, context: context })=>{
            const { inset: inset } = props;
            if (context.utils.isNumber(inset)) return {
                inset: inset
            };
            if (!context.utils.isString(inset)) return;
            return {
                inset: inset.split(' ').map((v)=>deps.getSpacingByKey(v, 'k').k).join(' ')
            };
        },
        left: ({ props: props, deps: deps })=>deps.getSpacingByKey(props.left, 'left'),
        top: ({ props: props, deps: deps })=>deps.getSpacingByKey(props.top, 'top'),
        right: ({ props: props, deps: deps })=>deps.getSpacingByKey(props.right, 'right'),
        bottom: ({ props: props, deps: deps })=>deps.getSpacingByKey(props.bottom, 'bottom'),
        verticalInset: ({ props: props, deps: deps })=>{
            const { verticalInset: verticalInset } = props;
            if (typeof verticalInset !== 'string') return;
            const vi = verticalInset.split(' ').map((v)=>deps.getSpacingByKey(v, 'k').k);
            return {
                top: vi[0],
                bottom: vi[1] || vi[0]
            };
        },
        horizontalInset: ({ props: props, deps: deps })=>{
            const { horizontalInset: horizontalInset } = props;
            if (typeof horizontalInset !== 'string') return;
            const vi = horizontalInset.split(' ').map((v)=>deps.getSpacingByKey(v, 'k').k);
            return {
                left: vi[0],
                right: vi[1] || vi[0]
            };
        }
    }
};


var $9b5781858217ab88$exports = {};

$parcel$export($9b5781858217ab88$exports, "Picture", function () { return $9b5781858217ab88$export$f0d5dc2ce3e4cb5f; });

'use strict';
const $9b5781858217ab88$export$f0d5dc2ce3e4cb5f = {
    deps: {
        getSystemGlobalTheme: $3f3bd33101f88eb8$export$f12bbb197a836138
    },
    tag: 'picture',
    childExtend: {
        tag: 'source',
        attr: {
            media: (element)=>{
                const { props: props, key: key, context: context, deps: deps } = element;
                const { MEDIA: MEDIA } = context.designSystem;
                const globalTheme = deps.getSystemGlobalTheme(element);
                const mediaName = (props.media || key).slice(1);
                if (mediaName === globalTheme) return '(min-width: 0px)';
                else if (mediaName === 'dark' || mediaName === 'light') return '(max-width: 0px)';
                return MEDIA[mediaName];
            },
            srcset: ({ props: props })=>props.srcset
        }
    },
    Img: ({ props: props })=>({
            width: 'inherit',
            ignoreChildExtend: true,
            height: 'inherit',
            src: props.src
        })
};


var $e35f08a051d13164$exports = {};

$parcel$export($e35f08a051d13164$exports, "Pseudo", function () { return $e35f08a051d13164$export$36c664c5efe2f59c; });
'use strict';
const $e35f08a051d13164$export$36c664c5efe2f59c = {
    class: {
        content: ({ props: props })=>props.content && {
                content: props.content
            }
    }
};


var $271936c1ac0abbce$exports = {};

$parcel$export($271936c1ac0abbce$exports, "Svg", function () { return $271936c1ac0abbce$export$e17b9c1182212c96; });
'use strict';
const $271936c1ac0abbce$export$e17b9c1182212c96 = {
    tag: 'svg',
    props: {},
    attr: {
        xmlns: 'http://www.w3.org/2000/svg',
        'xmlns:xlink': 'http://www.w3.org/1999/xlink'
    },
    html: (el)=>{
        const { props: props, context: context } = el;
        if (props.semantic_symbols) return;
        if (props.html) return el.call('exec', props.html, el);
        const { designSystem: designSystem, utils: utils } = context;
        const SVG = designSystem && designSystem.SVG;
        const useSvgSprite = props.spriteId || context.designSystem && context.designSystem.useSvgSprite;
        const src = el.call('exec', props.src, el);
        if (!useSvgSprite && src) return src;
        const useSVGSymbol = (icon)=>`<use xlink:href="#${icon}" />`;
        const spriteId = props.spriteId;
        if (spriteId) return useSVGSymbol(spriteId);
        const symbolId = Symbol.for(src);
        let SVGKey = SVG[symbolId];
        if (SVGKey && SVG[SVGKey]) return useSVGSymbol(SVGKey);
        SVGKey = SVG[symbolId] = Math.random();
        if (src) utils.init({
            svg: {
                [SVGKey]: src
            }
        }, {
            document: context.document,
            emotion: context.emotion
        });
        return useSVGSymbol(SVGKey);
    }
};


var $092e29b554101b61$exports = {};

$parcel$defineInteropFlag($092e29b554101b61$exports);

$parcel$export($092e29b554101b61$exports, "Shape", function () { return $092e29b554101b61$export$6428a7f2611ef1fa; });
$parcel$export($092e29b554101b61$exports, "default", function () { return $092e29b554101b61$export$2e2bcd8739ae039; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");


'use strict';
const $092e29b554101b61$var$transformBorderRadius = (radius, props, propertyName)=>{
    if (!(0, $amNJ8.isString)(radius)) return;
    return {
        borderRadius: radius.split(' ').map((v, k)=>(0, $8d2bd189328d3a32$export$94679ba49f16fc2e)(props, propertyName, v)[propertyName]).join(' ')
    };
};
const $092e29b554101b61$export$6428a7f2611ef1fa = {
    extend: 'Pseudo',
    deps: {
        exec: $jm0BQ.exec,
        getSpacingBasedOnRatio: $8d2bd189328d3a32$export$94679ba49f16fc2e,
        getMediaColor: $31bb7c46f86719dd$export$dd72f6d9deea7207,
        transformBorderRadius: $092e29b554101b61$var$transformBorderRadius
    },
    class: {
        shape: ({ props: props, deps: deps })=>{
            const { shape: shape } = props;
            return deps.exec((0, $8893aa143bee9fdd$export$511e1d54a4a8684e)[shape], {
                props: props,
                deps: deps
            });
        },
        shapeDirection: ({ props: props })=>{
            const { shape: shape, shapeDirection: shapeDirection } = props;
            if (!shape || !shapeDirection) return;
            const shapeDir = (0, $8893aa143bee9fdd$export$511e1d54a4a8684e)[shape + 'Direction'];
            return shape && shapeDir ? shapeDir[shapeDirection || 'left'] : null;
        },
        shapeDirectionColor: ({ props: props, deps: deps })=>{
            const { background: background, backgroundColor: backgroundColor } = props;
            const borderColor = {
                borderColor: deps.getMediaColor(background || backgroundColor)
            };
            return props.shapeDirection ? borderColor : null;
        },
        round: ({ props: props, key: key, deps: deps, ...el })=>deps.transformBorderRadius(props.round || props.borderRadius, props, 'round'),
        borderRadius: ({ props: props, key: key, deps: deps, ...el })=>deps.transformBorderRadius(props.borderRadius || props.round, props, 'borderRadius')
    }
};
var $092e29b554101b61$export$2e2bcd8739ae039 = $092e29b554101b61$export$6428a7f2611ef1fa;


var $303f823aab96748f$exports = {};

$parcel$export($303f823aab96748f$exports, "Video", function () { return $303f823aab96748f$export$ae01dedf5c052bb; });
'use strict';
const $303f823aab96748f$export$ae01dedf5c052bb = {
    tag: 'video',
    childExtend: {
        tag: 'source',
        attr: {
            src: ({ props: props })=>props.src,
            type: ({ props: props })=>props.type,
            controls: ({ props: props })=>props.controls
        }
    },
    props: {
        controls: true
    },
    attr: {
        src: ({ props: props })=>props.src,
        playsinline: ({ props: props })=>props.playsinline,
        autoplay: ({ props: props })=>props.autoplay,
        loop: ({ props: props })=>props.loop,
        poster: ({ props: props })=>props.poster,
        muted: ({ props: props })=>props.muted,
        preload: ({ props: props })=>props.preload,
        controls: ({ props: props })=>props.controls
    }
};



var $dadcc042eebbf1ae$exports = {};

$parcel$export($dadcc042eebbf1ae$exports, "Text", function () { return $dadcc042eebbf1ae$export$5f1af8db9871e1d6; });
$parcel$export($dadcc042eebbf1ae$exports, "H1", function () { return $dadcc042eebbf1ae$export$5523b16adee8048; });
$parcel$export($dadcc042eebbf1ae$exports, "H2", function () { return $dadcc042eebbf1ae$export$cb94397127ac9363; });
$parcel$export($dadcc042eebbf1ae$exports, "H3", function () { return $dadcc042eebbf1ae$export$746be9e3a3dfff1f; });
$parcel$export($dadcc042eebbf1ae$exports, "H4", function () { return $dadcc042eebbf1ae$export$cc5e069d64fda823; });
$parcel$export($dadcc042eebbf1ae$exports, "H5", function () { return $dadcc042eebbf1ae$export$88ef9fdaf11f7a1f; });
$parcel$export($dadcc042eebbf1ae$exports, "H6", function () { return $dadcc042eebbf1ae$export$a559fb8039b06400; });
$parcel$export($dadcc042eebbf1ae$exports, "P", function () { return $dadcc042eebbf1ae$export$56c0d5a1e737357d; });
$parcel$export($dadcc042eebbf1ae$exports, "Caption", function () { return $dadcc042eebbf1ae$export$32fbfacc5d962e0c; });
$parcel$export($dadcc042eebbf1ae$exports, "Strong", function () { return $dadcc042eebbf1ae$export$f301627d437cff88; });
$parcel$export($dadcc042eebbf1ae$exports, "Underline", function () { return $dadcc042eebbf1ae$export$741ee5bff4f2bc22; });
$parcel$export($dadcc042eebbf1ae$exports, "Italic", function () { return $dadcc042eebbf1ae$export$1cfcf4275506b1c6; });
$parcel$export($dadcc042eebbf1ae$exports, "Title", function () { return $dadcc042eebbf1ae$export$f99233281efd08a0; });
$parcel$export($dadcc042eebbf1ae$exports, "Headline", function () { return $dadcc042eebbf1ae$export$e1faab0803786bcf; });
$parcel$export($dadcc042eebbf1ae$exports, "Subhead", function () { return $dadcc042eebbf1ae$export$17e07beff4cf82a6; });
$parcel$export($dadcc042eebbf1ae$exports, "Footnote", function () { return $dadcc042eebbf1ae$export$54539b446c9863da; });
$parcel$export($dadcc042eebbf1ae$exports, "B", function () { return $dadcc042eebbf1ae$export$ef35774e6d314e91; });
$parcel$export($dadcc042eebbf1ae$exports, "I", function () { return $dadcc042eebbf1ae$export$9bb611d729802a56; });
$parcel$export($dadcc042eebbf1ae$exports, "Data", function () { return $dadcc042eebbf1ae$export$2d0294657ab35f1b; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");

'use strict';
const $dadcc042eebbf1ae$var$props = {
    fontSize: (el)=>{
        const { props: props, deps: deps } = el;
        return props.fontSize ? deps.getFontSizeByKey(props.fontSize) : null;
    },
    fontFamily: ({ props: props, deps: deps })=>({
            fontFamily: deps.getFontFamily(props.fontFamily) || props.fontFamily
        }),
    fontWeight: ({ props: props })=>({
            fontWeight: props.fontWeight,
            fontVariationSettings: '"wght" ' + props.fontWeight
        })
};
const $dadcc042eebbf1ae$export$5f1af8db9871e1d6 = {
    deps: {
        exec: $jm0BQ.exec,
        getFontSizeByKey: $2cd01d71c583d41c$export$ea9b2cd64205746b,
        getFontFamily: $4474b96e1a761f26$export$c4930fc256cef44f
    },
    text: (el)=>{
        const { key: key, props: props, state: state, deps: deps } = el;
        if (props.text === true) return state && state[key] || props && props[key];
        return deps.exec(props.text, el);
    },
    class: {
        font: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.font) && {
                font: props.font
            },
        lineHeight: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.lineHeight) && {
                lineHeight: props.lineHeight
            },
        // lineHeight: ({ props }) => !isUndefined(props.lineHeight) && getSpacingBasedOnRatio(props, 'lineHeight', null, ''),
        textDecoration: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.textDecoration) && {
                textDecoration: props.textDecoration
            },
        textTransform: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.textTransform) && {
                textTransform: props.textTransform
            },
        wordBreak: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.wordBreak) && {
                wordBreak: props.wordBreak
            },
        whiteSpace: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.whiteSpace) && {
                whiteSpace: props.whiteSpace
            },
        wordWrap: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.wordWrap) && {
                wordWrap: props.wordWrap
            },
        letterSpacing: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.letterSpacing) && {
                letterSpacing: props.letterSpacing
            },
        textOverflow: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.textOverflow) && {
                textOverflow: props.textOverflow
            },
        textAlign: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.textAlign) && {
                textAlign: props.textAlign
            },
        writingMode: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.writingMode) && {
                writingMode: props.writingMode
            },
        textOrientation: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.textOrientation) && {
                textOrientation: props.textOrientation
            },
        textIndent: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.textIndent) && {
                textIndent: props.textIndent
            },
        ...$dadcc042eebbf1ae$var$props
    }
};
const $dadcc042eebbf1ae$export$5523b16adee8048 = {
    tag: 'h1'
};
const $dadcc042eebbf1ae$export$cb94397127ac9363 = {
    tag: 'h2'
};
const $dadcc042eebbf1ae$export$746be9e3a3dfff1f = {
    tag: 'h3'
};
const $dadcc042eebbf1ae$export$cc5e069d64fda823 = {
    tag: 'h4'
};
const $dadcc042eebbf1ae$export$88ef9fdaf11f7a1f = {
    tag: 'h5'
};
const $dadcc042eebbf1ae$export$a559fb8039b06400 = {
    tag: 'h6'
};
const $dadcc042eebbf1ae$export$56c0d5a1e737357d = {
    tag: 'p'
};
const $dadcc042eebbf1ae$export$32fbfacc5d962e0c = {
    tag: 'caption'
};
const $dadcc042eebbf1ae$export$f301627d437cff88 = {
    tag: 'strong',
    props: {
        fontWeight: '700'
    }
};
const $dadcc042eebbf1ae$export$741ee5bff4f2bc22 = {
    tag: 'u'
};
const $dadcc042eebbf1ae$export$1cfcf4275506b1c6 = {
    tag: 'i'
};
const $dadcc042eebbf1ae$export$f99233281efd08a0 = {};
const $dadcc042eebbf1ae$export$e1faab0803786bcf = {
    tag: 'h6',
    props: {
        fontSize: 'B',
        fontWeight: 500
    }
};
const $dadcc042eebbf1ae$export$17e07beff4cf82a6 = {
    tag: 'span',
    props: {
        fontSize: 'Z1'
    }
};
const $dadcc042eebbf1ae$export$54539b446c9863da = {
    tag: 'span',
    props: {
        fontSize: 'Z'
    }
};
const $dadcc042eebbf1ae$export$ef35774e6d314e91 = {
    tag: 'b'
};
const $dadcc042eebbf1ae$export$9bb611d729802a56 = {
    tag: 'i'
};
const $dadcc042eebbf1ae$export$2d0294657ab35f1b = {
    tag: 'data'
};



var $6386605f6bd8a4ff$exports = {};

$parcel$export($6386605f6bd8a4ff$exports, "Hgroup", function () { return $6386605f6bd8a4ff$export$bd5b3f7ef3b94a4a; });
$parcel$export($6386605f6bd8a4ff$exports, "HgroupRows", function () { return $6386605f6bd8a4ff$export$4c6ac4526c395f50; });
$parcel$export($6386605f6bd8a4ff$exports, "HgroupButton", function () { return $6386605f6bd8a4ff$export$7fa5389f12735f1f; });
'use strict';
const $6386605f6bd8a4ff$export$bd5b3f7ef3b94a4a = {
    tag: 'hgroup',
    extend: [
        'Flex'
    ],
    props: {
        flow: 'y',
        gap: 'Z'
    },
    H: {
        tag: 'h3',
        text: 'Heading',
        lineHeight: '1em',
        margin: '0'
    },
    P: {
        text: 'Paragraph',
        margin: '0',
        color: 'paragraph'
    }
};
const $6386605f6bd8a4ff$export$4c6ac4526c395f50 = {
    extend: 'Hgroup',
    H: {
        extends: 'Flex',
        color: 'title',
        align: 'center space-between'
    },
    P: {
        color: 'paragraph',
        align: 'center space-between'
    }
};
const $6386605f6bd8a4ff$export$7fa5389f12735f1f = {
    extend: 'HgroupRows',
    H: {
        justifyContent: 'space-between',
        Span: {},
        Button: {
            background: 'transparent',
            color: 'currentColor',
            padding: '0',
            Icon: {
                name: 'x',
                fontSize: 'C'
            }
        }
    },
    P: {}
};


var $a4ea0dc306f2bb25$exports = {};

$parcel$export($a4ea0dc306f2bb25$exports, "Transform", function () { return $a4ea0dc306f2bb25$export$563a914cafbdc389; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $a4ea0dc306f2bb25$export$563a914cafbdc389 = {
    class: {
        zoom: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.zoom) && {
                zoom: props.zoom
            },
        transform: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.transform) && {
                transform: props.transform
            },
        transformOrigin: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.transformOrigin) && {
                transformOrigin: props.transformOrigin
            },
        backfaceVisibility: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.backfaceVisibility) && {
                backfaceVisibility: props.backfaceVisibility
            }
    }
};


var $4cb9b2e3a5a60a57$exports = {};

$parcel$export($4cb9b2e3a5a60a57$exports, "XYZ", function () { return $4cb9b2e3a5a60a57$export$36b810b8b2e73231; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $4cb9b2e3a5a60a57$export$36b810b8b2e73231 = {
    class: {
        zIndex: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.zIndex) && {
                zIndex: props.zIndex
            },
        perspective: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.perspective) && {
                perspective: props.perspective
            },
        perspectiveOrigin: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.perspectiveOrigin) && {
                perspectiveOrigin: props.perspectiveOrigin
            }
    }
};


var $2ab55593ea7c1829$exports = {};

$parcel$export($2ab55593ea7c1829$exports, "Animation", function () { return $2ab55593ea7c1829$export$c35d437ae5945fcd; });

parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");

'use strict';
const $2ab55593ea7c1829$var$applyAnimationProps = (animation, element)=>{
    const { emotion: ctxEmotion } = element.context;
    const { keyframes: keyframes } = ctxEmotion || (0, $9119ccb14775b2d1$export$51d693b3d243fd90);
    if ((0, $amNJ8.isObject)(animation)) return {
        animationName: keyframes(animation)
    };
    const { ANIMATION: ANIMATION } = element.context && element.context.designSystem;
    const record = ANIMATION[animation];
    return keyframes(record);
};
const $2ab55593ea7c1829$var$props = {
    animation: (el)=>el.props.animation && {
            animationName: el.deps.applyAnimationProps(el.props.animation, el),
            animationDuration: el.deps.getTimingByKey(el.props.animationDuration || 'A').timing,
            animationDelay: el.deps.getTimingByKey(el.props.animationDelay || '0s').timing,
            animationTimingFunction: el.deps.getTimingFunction(el.props.animationTimingFunction || 'ease'),
            animationFillMode: el.props.animationFillMode || 'both',
            animationPlayState: el.props.animationPlayState,
            animationDirection: el.props.animationDirection
        },
    animationName: (el)=>el.props.animationName && {
            animationName: el.deps.applyAnimationProps(el.props.animationName, el)
        },
    animationDuration: ({ props: props, deps: deps })=>props.animationDuration && {
            animationDuration: deps.getTimingByKey(props.animationDuration).timing
        },
    animationDelay: ({ props: props, deps: deps })=>props.animationDelay && {
            animationDelay: deps.getTimingByKey(props.animationDelay).timing
        },
    animationTimingFunction: ({ props: props, deps: deps })=>props.animationTimingFunction && {
            animationTimingFunction: deps.getTimingFunction(props.animationTimingFunction)
        }
};
const $2ab55593ea7c1829$export$c35d437ae5945fcd = {
    deps: {
        isObject: $amNJ8.isObject,
        getTimingByKey: $9779037853e3fa59$export$3fa311edc5edd22f,
        getTimingFunction: $9779037853e3fa59$export$23ba66c7c3e2e613,
        applyAnimationProps: $2ab55593ea7c1829$var$applyAnimationProps
    },
    class: {
        ...$2ab55593ea7c1829$var$props,
        animationFillMode: ({ props: props })=>props.animationFillMode && {
                animationFillMode: props.animationFillMode
            },
        animationPlayState: ({ props: props })=>props.animationPlayState && {
                animationPlayState: props.animationPlayState
            },
        animationIterationCount: ({ props: props })=>props.animationIterationCount && {
                animationIterationCount: props.animationIterationCount || 1
            },
        animationDirection: ({ props: props })=>props.animationDirection && {
                animationDirection: props.animationDirection
            }
    }
};


'use strict';
$parcel$exportWildcard($aa8df985725866a7$exports, $2340ecba3950811a$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $7c9e38fe1a9b9734$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $d1b6f6dccd731295$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $16579ed67f3c9b7f$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $76525dc5e29bbed4$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $1b351a6e260dfcb4$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $8bf0bee715543d08$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $13529cac56e876e3$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $dac5daea1dcbcf9a$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $a3728907a9aad1ec$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $16f068d5dcc1a960$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $bbb58e1b70381780$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $871c31bc83970b54$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $9b5781858217ab88$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $e35f08a051d13164$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $271936c1ac0abbce$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $092e29b554101b61$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $303f823aab96748f$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $3f3bd33101f88eb8$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $dadcc042eebbf1ae$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $836338cbaed52506$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $6386605f6bd8a4ff$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $a4ea0dc306f2bb25$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $4cb9b2e3a5a60a57$exports);
$parcel$exportWildcard($aa8df985725866a7$exports, $2ab55593ea7c1829$exports);


var $dadb0cb046bc2284$exports = {};

$parcel$export($dadb0cb046bc2284$exports, "Box", function () { return $dadb0cb046bc2284$export$e71c4d32a2263218; });
$parcel$export($dadb0cb046bc2284$exports, "Circle", function () { return $dadb0cb046bc2284$export$c89a927ffc67e6fa; });
'use strict';
// import {
//   Shape,
//   Position,
//   Theme,
//   Block,
//   Text,
//   Overflow,
//   Timing,
//   Transform,
//   Media,
//   Interaction,
//   XYZ,
//   Animation
// } from '@symbo.ls/atoms'
const $dadb0cb046bc2284$var$PropsCSS = {
    class: {
        style: (el)=>el.props && el.props.style
    }
};
const $dadb0cb046bc2284$export$e71c4d32a2263218 = {
    extend: [
        $dadb0cb046bc2284$var$PropsCSS,
        'Shape',
        'Position',
        'Theme',
        'Block',
        'Text',
        'Overflow',
        'Timing',
        'Transform',
        'Media',
        'Interaction',
        'XYZ',
        'Animation'
    ],
    attr: {
        id: (el)=>el.call('isString', el.props.id) && el.props.id,
        title: (el)=>el.call('isString', el.props.title) && el.props.title,
        contentEditable: (el)=>el.props.contentEditable || el.props.contenteditable,
        dir: (el)=>el.props.dir,
        draggable: (el)=>el.props.draggable,
        hidden: (el)=>el.props.hidden,
        lang: (el)=>el.props.lang,
        spellcheck: (el)=>el.props.spellcheck,
        tabindex: (el)=>el.props.tabindex,
        translate: (el)=>el.props.translate,
        'data-testid': (el, s)=>(s.root.ENV === 'testing' || s.root.ENV === 'staging') && ((el.__ref.path.length > 5 ? el.__ref.path.slice(1, 4).concat(el.__ref.path.slice(-2)) : el.__ref.path.slice(1)).join('.') || 'root')
    }
};
const $dadb0cb046bc2284$export$c89a927ffc67e6fa = {
    props: {
        round: '100%'
    }
};


var $8704dc4f4e8df80e$exports = {};

$parcel$export($8704dc4f4e8df80e$exports, "Icon", function () { return $8704dc4f4e8df80e$export$f04a61298a47a40f; });
$parcel$export($8704dc4f4e8df80e$exports, "IconText", function () { return $8704dc4f4e8df80e$export$fe7c634bfc18e397; });
$parcel$export($8704dc4f4e8df80e$exports, "FileIcon", function () { return $8704dc4f4e8df80e$export$8c1a3d13e85d78b7; });
'use strict';
const $8704dc4f4e8df80e$var$inheritFromIsActive = (el)=>{
    const { props: props } = el;
    const propsActive = props['.isActive'];
    return el.call('exec', propsActive.name || propsActive.icon);
};
const $8704dc4f4e8df80e$var$getIconName = (el, s)=>{
    const { key: key, props: props } = el;
    let icon = el.call('exec', props.name || props.icon || key, el);
    if (el.call('isString', icon) && icon.includes('{{')) icon = el.call('replaceLiteralsWithObjectFields', icon);
    return el.call('isString', icon) ? icon : key;
};
const $8704dc4f4e8df80e$export$f04a61298a47a40f = {
    extend: 'Svg',
    props: (el, s, ctx)=>{
        const { props: props, parent: parent } = el;
        const { ICONS: ICONS, useIconSprite: useIconSprite, verbose: verbose } = ctx && ctx.designSystem;
        const { toCamelCase: toCamelCase } = ctx && ctx.utils;
        const iconName = $8704dc4f4e8df80e$var$getIconName(el, s);
        const camelCase = toCamelCase(iconName);
        const isArray = camelCase.split(/([a-z])([A-Z])/g);
        const semanticIcon = $8704dc4f4e8df80e$var$getSemanticIcon(el, s, ctx);
        if (semanticIcon) return semanticIcon;
        let activeIconName;
        if (props.isActive) activeIconName = $8704dc4f4e8df80e$var$inheritFromIsActive(el);
        const parentProps = parent.props;
        const parentPropsActive = parentProps['.isActive'];
        if (parent && parentProps && parentProps.isActive && parentPropsActive && parentPropsActive.icon) activeIconName = el.call('exec', parentPropsActive.icon || parentPropsActive.Icon.name || parentPropsActive.Icon.icon, el);
        if (el.call('isString', activeIconName) && activeIconName.includes('{{')) activeIconName = el.call('replaceLiteralsWithObjectFields', activeIconName);
        let iconInContext;
        if (ICONS[activeIconName]) iconInContext = activeIconName;
        if (ICONS[camelCase]) iconInContext = camelCase;
        else if (ICONS[isArray[0] + isArray[1]]) iconInContext = isArray[0] + isArray[1];
        else if (ICONS[isArray[0]]) iconInContext = isArray[0];
        else if (verbose) el.warn('Can\'t find icon:', iconName, iconInContext);
        const iconFromLibrary = ICONS[iconInContext];
        const directSrc = parent && parent.props && parent.props.src || props.src;
        return {
            width: 'A',
            height: 'A',
            display: 'inline-block',
            spriteId: useIconSprite && iconInContext,
            src: iconFromLibrary || directSrc || ICONS.noIcon,
            style: {
                fill: 'currentColor',
                '*': {
                    fill: 'currentColor'
                }
            }
        };
    },
    attr: {
        viewBox: '0 0 24 24'
    }
};
const $8704dc4f4e8df80e$export$fe7c634bfc18e397 = {
    extend: 'Flex',
    props: {
        align: 'center center',
        lineHeight: 1,
        '.reversed': {
            flow: 'row-reverse'
        },
        '.vertical': {
            flow: 'column'
        }
    },
    Icon: {
        if: (el)=>{
            const { parent: parent, props: props } = el;
            return el.call('exec', parent.props.icon || props.name || props.sfSymbols || parent.props.sfSymbols, el);
        },
        icon: (el)=>el.call('exec', el.parent.props.icon, el.parent)
    },
    text: ({ props: props })=>props.text
};
const $8704dc4f4e8df80e$export$8c1a3d13e85d78b7 = {
    extend: 'Flex',
    props: {
        theme: 'tertiary',
        boxSize: 'C1',
        align: 'center center',
        round: 'Z'
    },
    Icon: {
        fontSize: 'B',
        margin: 'auto',
        icon: 'file'
    }
};
const $8704dc4f4e8df80e$var$getSemanticIcon = (el, s, ctx)=>{
    const { SEMANTIC_ICONS: SEMANTIC_ICONS } = ctx && ctx.designSystem;
    const { toCamelCase: toCamelCase } = ctx && ctx.utils;
    let iconName = $8704dc4f4e8df80e$var$getIconName(el, s);
    const camelCase = toCamelCase(iconName);
    const isArray = camelCase.split(/([a-z])([A-Z])/g);
    const semanticIconRootName = isArray[1] ? isArray[0] : iconName.split('.')[0].split(' ')[0];
    const semanticIcon = SEMANTIC_ICONS && SEMANTIC_ICONS[semanticIconRootName];
    if (semanticIcon) {
        const iconKey = iconName.includes('.') ? 'sfsymbols.' + iconName.split('.').slice(1).join('.') : 'sfsymbols';
        iconName = semanticIcon[iconKey] || semanticIcon[iconName.split('.')[0].split(' ')[0]];
        return {
            tag: 'span',
            semantic_symbols: true,
            width: 'A',
            height: 'A',
            lineHeight: '1em',
            ':after': {
                fontSize: 'Z',
                fontWeight: '300',
                content: `"${iconName}"`,
                textAlign: 'center',
                display: 'inline-block',
                style: {
                    color: 'currentColor',
                    fontFamily: "'SF Pro Icons', 'SF Pro', 'SF Symbols', 'Segoe UI'"
                }
            }
        };
    }
};


var $c758e9252127af0a$exports = {};

$parcel$export($c758e9252127af0a$exports, "Link", function () { return $c758e9252127af0a$export$a6c7ac8248d6e38a; });
$parcel$export($c758e9252127af0a$exports, "RouterLink", function () { return $c758e9252127af0a$export$fce709ebdac448ed; });
$parcel$export($c758e9252127af0a$exports, "RouteLink", function () { return $c758e9252127af0a$export$9a6dc2d0fce7da79; });

'use strict';
const $c758e9252127af0a$export$a6c7ac8248d6e38a = {
    extend: 'Focusable',
    tag: 'a',
    props: {
        aria: {},
        fontWeight: 'bold',
        textDecoration: 'none',
        color: 'currentColor',
        draggable: false
    },
    attr: {
        href: (el, s, ctx)=>{
            const props = el.props;
            const href = el.call('exec', props.href, el) || el.call('exec', el.call('exec', props, el).href, el);
            if (el.call('isString', href) && href.includes('{{')) return el.call('replaceLiteralsWithObjectFields', href);
            return href;
        },
        target: ({ props: props })=>props.target,
        'aria-label': ({ props: props })=>props.aria ? props.aria.label : props.text,
        draggable: ({ props: props })=>props.draggable
    }
};
const $c758e9252127af0a$export$fce709ebdac448ed = {
    on: {
        click: (event, el, s)=>{
            const { props: props, context: ctx } = el;
            const { href: h, scrollToTop: scrollToTop, stopPropagation: stopPropagation } = props;
            let href = el.call('exec', h, el);
            if (el.call('isString', href) && href.includes('{{')) href = el.call('replaceLiteralsWithObjectFields', href);
            if (stopPropagation) event.stopPropagation();
            if (!href) return;
            const { utils: utils, snippets: snippets, functions: functions, routerOptions: routerOptions } = ctx;
            const root = el.__ref.root;
            const linkIsExternal = href.includes('http://') || href.includes('https://') || href.includes('mailto:') || href.includes('tel:');
            if (href && !linkIsExternal) try {
                (functions.router || snippets.router || utils.router || (0, $20758fd265e78843$export$5375cda95f0b0eb4))(href, root, {}, {
                    scrollToOptions: {
                        behaviour: 'instant'
                    },
                    scrollToTop: el.call('isDefined', scrollToTop) ? scrollToTop : true,
                    ...routerOptions,
                    ...props.routerOptions
                });
                event.preventDefault();
            } catch (e) {
                console.warn(e);
            }
        }
    }
};
const $c758e9252127af0a$export$9a6dc2d0fce7da79 = {
    extend: [
        $c758e9252127af0a$export$a6c7ac8248d6e38a,
        $c758e9252127af0a$export$fce709ebdac448ed
    ]
};


var $79e391eb9bc0ecdb$exports = {};
var $96174637406cda42$exports = {};

$parcel$export($96174637406cda42$exports, "Input", function () { return $96174637406cda42$export$f5b8910cec6cf069; });
'use strict';
const $96174637406cda42$export$f5b8910cec6cf069 = {
    extend: [
        'Focusable'
    ],
    tag: 'input',
    props: {
        border: 'none',
        type: 'input',
        theme: 'field',
        fontSize: 'A',
        round: 'C',
        lineHeight: '1',
        padding: 'Z2 B'
    },
    attr: {
        pattern: ({ props: props })=>props.pattern,
        minLength: ({ props: props })=>props.minlength,
        maxLength: ({ props: props })=>props.maxlength,
        name: ({ props: props })=>props.name,
        autocomplete: ({ props: props })=>props.autocomplete,
        placeholder: ({ props: props })=>props.placeholder,
        value: (el)=>{
            if (!el.props || !el.props.value) return;
            const val = el.call('exec', el.props.value, el);
            if (el.call('isString', val) && val.includes('{{')) return el.call('replaceLiteralsWithObjectFields', val);
            return val;
        },
        checked: (el)=>el.call('exec', el.props.checked, el),
        disabled: ({ props: props })=>props.disabled || null,
        readonly: ({ props: props })=>props.readonly,
        required: ({ props: props })=>props.required,
        type: ({ props: props })=>props.type
    }
};


var $8dc3cf931405f6e7$exports = {};

$parcel$export($8dc3cf931405f6e7$exports, "NumberInput", function () { return $8dc3cf931405f6e7$export$6bf0cd3a219bbade; });
'use strict';
const $8dc3cf931405f6e7$export$6bf0cd3a219bbade = {
    extend: [
        'Flex',
        'Input'
    ],
    props: {
        type: 'number',
        boxSize: 'C+X',
        align: 'center center',
        textAlign: 'center',
        round: 'Y1',
        theme: 'transparent',
        border: 'solid, gray3',
        borderWidth: '1px',
        placeholder: '0',
        fontWeight: '400',
        '::-webkit-inner-spin-button': {
            appearance: 'none'
        }
    },
    attr: {
        step: ({ props: props })=>props.step,
        min: ({ props: props })=>props.min,
        max: ({ props: props })=>props.max
    }
};


var $6a7187a72a66e52d$exports = {};

$parcel$export($6a7187a72a66e52d$exports, "Checkbox", function () { return $6a7187a72a66e52d$export$48513f6b9f8ce62d; });
$parcel$export($6a7187a72a66e52d$exports, "CheckboxHgroup", function () { return $6a7187a72a66e52d$export$8d7a3c6c6de62e1f; });
'use strict';
const $6a7187a72a66e52d$export$48513f6b9f8ce62d = {
    extend: 'Focusable',
    tag: 'label',
    props: {
        boxSize: 'fit-content fit-content',
        cursor: 'pointer',
        round: 'Y'
    },
    Input: {
        type: 'checkbox',
        display: 'none',
        ':checked + div': {
            theme: 'primary'
        },
        ':checked + div > svg': {
            transform: 'none',
            opacity: '1'
        },
        attr: {
            checked: (el)=>el.call('exec', el.parent.props.checked)
        }
    },
    Flex: {
        align: 'center center',
        fontSize: 'B1',
        padding: 'V',
        theme: 'field',
        round: 'X2',
        transition: 'background A defaultBezier',
        Icon: {
            icon: 'check',
            opacity: '0',
            transform: 'scale(0.9) rotate(-15deg)',
            transition: 'opacity B defaultBezier'
        }
    }
};
const $6a7187a72a66e52d$export$8d7a3c6c6de62e1f = {
    extend: 'Flex',
    tag: 'label',
    props: {
        boxSize: 'fit-content',
        align: 'flex-start flex-start',
        gap: 'A'
    },
    Checkbox: {
        tag: 'div'
    },
    HgroupRows: {
        gap: 'Z1',
        margin: 'Y - - -'
    }
};


var $96d5be5a3112d06e$exports = {};

$parcel$export($96d5be5a3112d06e$exports, "Radio", function () { return $96d5be5a3112d06e$export$d7b12c4107be0d61; });
$parcel$export($96d5be5a3112d06e$exports, "RadioHgroup", function () { return $96d5be5a3112d06e$export$4a51391209c6c8b9; });
'use strict';
const $96d5be5a3112d06e$export$d7b12c4107be0d61 = {
    extend: 'Checkbox',
    Input: {
        type: 'radio',
        ':checked + div:after': {
            opacity: '1'
        }
    },
    Flex: {
        round: '100%',
        padding: 'Y',
        ':after': {
            content: '""',
            display: 'block',
            boxSize: 'X+W1',
            round: '100%',
            background: 'white',
            opacity: '0',
            transition: 'opacity .15s ease-in-out'
        },
        Icon: null
    }
};
const $96d5be5a3112d06e$export$4a51391209c6c8b9 = {
    extend: 'CheckboxHgroup',
    Checkbox: null,
    Radio: {}
};


var $928970196bcbf368$exports = {};

$parcel$export($928970196bcbf368$exports, "Toggle", function () { return $928970196bcbf368$export$bea8ebba691c5813; });
$parcel$export($928970196bcbf368$exports, "ToggleHgroup", function () { return $928970196bcbf368$export$9c397544fb27ca65; });
'use strict';
const $928970196bcbf368$export$bea8ebba691c5813 = {
    extend: 'Checkbox',
    Input: {
        ':checked + div': {
            background: 'green2 +8',
            justifyContent: 'flex-end'
        }
    },
    Flex: {
        boxSize: 'A1 B1',
        padding: '- W_default',
        round: 'D',
        align: 'center flex-start',
        theme: 'field',
        border: 'none',
        transition: 'opacity .15s ease',
        ':after': {
            content: '""',
            boxSize: 'A A',
            round: '100%',
            background: 'white',
            boxShadow: '1px, 1px, Z, gray .2'
        },
        Icon: null
    }
};
const $928970196bcbf368$export$9c397544fb27ca65 = {
    extend: 'CheckboxHgroup',
    Checkbox: null,
    Toggle: {}
};


var $c9d612767d9f43a9$exports = {};

$parcel$export($c9d612767d9f43a9$exports, "Textarea", function () { return $c9d612767d9f43a9$export$379139ebc1c2b235; });
$parcel$export($c9d612767d9f43a9$exports, "TextareaWithButton", function () { return $c9d612767d9f43a9$export$b70f05b5c6092f02; });
'use strict';
const $c9d612767d9f43a9$export$379139ebc1c2b235 = {
    tag: 'textarea',
    extend: [
        'Input',
        'Flex'
    ],
    props: {
        variant: 'outlined',
        fontfamily: 'Avenir',
        round: 'Z1',
        placeholder: 'Leave us a message...',
        padding: 'A',
        theme: 'field',
        border: 'none',
        maxWidth: 'G1_default',
        minHeight: 'E_default',
        width: '100%',
        height: 'E1_default',
        fontFamily: 'inherit',
        style: {
            resize: 'none'
        }
    },
    '.simple': {
        props: {
            theme: 'field',
            round: 'Z2',
            lineHeight: 1.4
        }
    },
    '.outlined': {
        props: {
            theme: 'field',
            borderWidth: '1px',
            borderStyle: 'solid',
            lineHeight: 1.4,
            placeholder: 'Leave us a message...',
            resize: 'none'
        }
    },
    html: (el, s)=>el.props.value
};
const $c9d612767d9f43a9$export$b70f05b5c6092f02 = {
    extend: 'Flex',
    props: {
        gap: 'Y2'
    },
    Textarea: {
        height: 'C2+W',
        minWidth: 'H',
        padding: 'A',
        fontSize: 'Z1',
        round: 'Z2',
        minHeight: 'fit-content'
    },
    SquareButton: {
        background: 'blue',
        Icon: {
            name: 'send'
        }
    }
};


'use strict';
$parcel$exportWildcard($79e391eb9bc0ecdb$exports, $96174637406cda42$exports);
$parcel$exportWildcard($79e391eb9bc0ecdb$exports, $8dc3cf931405f6e7$exports);
$parcel$exportWildcard($79e391eb9bc0ecdb$exports, $6a7187a72a66e52d$exports);
$parcel$exportWildcard($79e391eb9bc0ecdb$exports, $96d5be5a3112d06e$exports);
$parcel$exportWildcard($79e391eb9bc0ecdb$exports, $928970196bcbf368$exports);
$parcel$exportWildcard($79e391eb9bc0ecdb$exports, $c9d612767d9f43a9$exports);


var $13a554edf8984773$exports = {};

$parcel$export($13a554edf8984773$exports, "Select", function () { return $13a554edf8984773$export$ef9b1a59e592288f; });
'use strict';
const $13a554edf8984773$export$ef9b1a59e592288f = {
    extend: 'Focusable',
    tag: 'select',
    props: {
        fontSize: 'A',
        border: 'none',
        boxSizing: 'border-box',
        theme: 'field',
        cursor: 'pointer',
        childProps: {
            tag: 'option',
            attr: {
                value: ({ props: props })=>props.value,
                selected: ({ props: props })=>props.selected,
                disabled: ({ props: props })=>props.disabled
            }
        }
    },
    attr: {
        required: ({ props: props })=>props.required,
        name: ({ props: props })=>props.name,
        disabled: ({ props: props })=>props.disabled,
        value: (el)=>{
            if (!el.props || !el.props.value) return;
            const val = el.call('exec', el.props.value, el);
            if (el.call('isString', val) && val.includes('{{')) return el.call('replaceLiteralsWithObjectFields', val);
            return val;
        }
    }
};


var $28fc4cdebd573cb1$exports = {};

$parcel$export($28fc4cdebd573cb1$exports, "Button", function () { return $28fc4cdebd573cb1$export$353f5b6fc5456de1; });
$parcel$export($28fc4cdebd573cb1$exports, "SquareButton", function () { return $28fc4cdebd573cb1$export$51cd5c72b5e560c6; });
$parcel$export($28fc4cdebd573cb1$exports, "CircleButton", function () { return $28fc4cdebd573cb1$export$235c11ae4b685dbd; });
$parcel$export($28fc4cdebd573cb1$exports, "KangorooButton", function () { return $28fc4cdebd573cb1$export$6fbe98cd572b6a70; });
$parcel$export($28fc4cdebd573cb1$exports, "ButtonSet", function () { return $28fc4cdebd573cb1$export$87e672a75327e04b; });
$parcel$export($28fc4cdebd573cb1$exports, "IconButton", function () { return $28fc4cdebd573cb1$export$c25acd513dcc8062; });
'use strict';
const $28fc4cdebd573cb1$export$353f5b6fc5456de1 = {
    extend: [
        'IconText',
        'FocusableComponent'
    ],
    tag: 'button',
    props: {
        fontSize: 'A',
        type: 'button',
        borderStyle: 'none',
        display: 'inline-flex',
        align: 'center center',
        textDecoration: 'none',
        lineHeight: '1',
        whiteSpace: 'nowrap',
        padding: 'Z B2',
        fontWeight: '500',
        fontFamily: 'inherit',
        round: 'C2'
    },
    attr: {
        type: ({ props: props })=>props.type
    }
};
const $28fc4cdebd573cb1$export$51cd5c72b5e560c6 = {
    extend: 'Button',
    props: {
        fontSize: 'A',
        width: 'A',
        padding: 'Z',
        aspectRatio: '1 / 1',
        icon: 'smile',
        boxSize: 'fit-content fit-content',
        justifyContent: 'center',
        round: 'Z',
        boxSizing: 'content-box'
    }
};
const $28fc4cdebd573cb1$export$235c11ae4b685dbd = {
    extend: 'SquareButton',
    props: {
        round: 'C'
    }
};
const $28fc4cdebd573cb1$export$6fbe98cd572b6a70 = {
    extend: 'Button',
    childExtend: 'IconText'
};
const $28fc4cdebd573cb1$export$87e672a75327e04b = {
    tag: 'nav',
    extend: 'Flex',
    childExtend: 'SquareButton'
};
const $28fc4cdebd573cb1$export$c25acd513dcc8062 = {
    extend: [
        'SquareButton',
        'ClickableItem'
    ],
    props: {
        round: 'Z'
    },
    __hash: '3a7v57sk5rd'
};


var $d8b4d25b7ff8b728$exports = {};

$parcel$export($d8b4d25b7ff8b728$exports, "Dialog", function () { return $d8b4d25b7ff8b728$export$3ddf2d174ce01153; });
$parcel$export($d8b4d25b7ff8b728$exports, "DialogHeader", function () { return $d8b4d25b7ff8b728$export$742513523b177e3b; });
$parcel$export($d8b4d25b7ff8b728$exports, "DialogFooter", function () { return $d8b4d25b7ff8b728$export$7bbfb2d443473050; });
'use strict';
const $d8b4d25b7ff8b728$export$3ddf2d174ce01153 = {
    extend: 'Flex',
    tag: 'dialog',
    props: {
        flow: 'column',
        border: '0',
        theme: 'dialog',
        round: 'Z2'
    }
};
const $d8b4d25b7ff8b728$export$742513523b177e3b = {
    extend: 'Hgroup',
    props: {
        minWidth: '100%',
        gap: 'A'
    },
    Title: {
        align: 'center space-between',
        Text: {
            text: 'Title'
        },
        SquareButton: {
            icon: 'x',
            theme: 'transparent'
        }
    },
    Paragraph: {
        color: 'caption'
    }
};
const $d8b4d25b7ff8b728$export$7bbfb2d443473050 = {
    extend: 'Flex',
    props: {
        align: 'center flex-end',
        gap: 'X2',
        margin: 'auto - -',
        padding: 'Y2 X2'
    },
    childExtend: {
        extend: 'Button',
        props: {
            textTransform: 'uppercase',
            background: 'transparent',
            '@dark': {
                theme: 'primary @dark .color-only'
            },
            '@light': {
                theme: 'primary @light .color-only'
            },
            '&': {
                padding: 'Z A'
            },
            ':hover': {
                theme: 'tertiary'
            },
            ':active': {
                background: 'white .1'
            }
        }
    },
    cancel: {
        text: 'cancel'
    },
    ok: {
        text: 'ok'
    }
};


var $740e5148058b54cb$exports = {};

$parcel$export($740e5148058b54cb$exports, "Tooltip", function () { return $740e5148058b54cb$export$28c660c63b792dea; });
$parcel$export($740e5148058b54cb$exports, "TooltipHidden", function () { return $740e5148058b54cb$export$92ba62bde414cbb2; });
$parcel$export($740e5148058b54cb$exports, "TooltipParent", function () { return $740e5148058b54cb$export$1d54d90a050b9c15; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $740e5148058b54cb$export$28c660c63b792dea = {
    extend: 'Flex',
    props: {
        theme: 'dialog',
        background: 'black',
        flow: 'column',
        shape: 'tooltip',
        shapeDirection: 'left',
        padding: 'Z1 A',
        round: 'Y2',
        width: 'fit-content',
        minWidth: 'D2',
        maxWidth: 'F2',
        gap: 'X',
        textAlign: 'center'
    },
    attr: {
        tooltip: true
    },
    Title: {
        if: ({ parent: parent, props: props })=>(0, $amNJ8.isDefined)(parent.props.title) || props.text,
        width: 'fit-content',
        fontWeight: 500,
        color: 'gray12',
        text: ({ parent: parent })=>parent.props.title
    },
    P: {
        if: (el, s)=>el.call('isDefined', el.call('exec', el.parent.props.description, el)) || el.props.text,
        width: 'fit-content',
        fontSize: 'Z2',
        margin: '0',
        color: 'gray6',
        fontWeight: '400',
        text: (el, s)=>el.call('exec', el.parent.props.description, el)
    }
};
const $740e5148058b54cb$export$92ba62bde414cbb2 = {
    extend: 'Tooltip',
    props: ({ props: props })=>({
            position: 'absolute',
            pointerEvents: 'none',
            opacity: '0',
            visibility: 'hidden',
            transition: 'C defaultBezier opacity, C defaultBezier visibility, B defaultBezier transform',
            ...!props.shapeDirection || props.shapeDirection === 'top' ? {
                top: '112%',
                left: '50%',
                transform: 'translate3d(-50%,10%,0)',
                '.isActive': {
                    transform: 'translate3d(-50%,0,0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            } : props.shapeDirection === 'right' ? {
                transform: 'translate3d(10%,-50%,0)',
                left: '112%',
                top: '50%',
                '.isActive': {
                    transform: 'translate3d(0%,-50%,0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            } : ({ props: props })=>props.shapeDirection === 'bottom' ? {
                    transform: 'translate3d(-50%,-10%,0)',
                    bottom: '112%',
                    left: '50%',
                    '.isActive': {
                        transform: 'translate3d(-50%,0,0)',
                        opacity: 1,
                        visibility: 'visible'
                    }
                } : props.shapeDirection === 'left' ? {
                    transform: 'translate3d(10%,-50%,0)',
                    right: '112%',
                    top: '50%',
                    '.isActive': {
                        transform: 'translate3d(0%,-50%,0)',
                        opacity: 1,
                        visibility: 'visible'
                    }
                } : {}
        })
};
const $740e5148058b54cb$export$1d54d90a050b9c15 = {
    props: (el)=>{
        const { Tooltip: Tooltip, TooltipHidden: TooltipHidden } = el;
        const TooltipElem = Tooltip || TooltipHidden;
        if (!TooltipElem) return;
        const TooltipActive = TooltipElem && TooltipElem.props && TooltipElem.props['.isActive'];
        return {
            position: 'relative',
            zIndex: 999,
            ':hover, &:focus-visible': {
                zIndex: 1000,
                '& [tooltip]': TooltipActive || {
                    transform: 'translate3d(-50%, 0, 0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            }
        };
    }
};


var $d88c869523ad5a9b$exports = {};

$parcel$export($d88c869523ad5a9b$exports, "Avatar", function () { return $d88c869523ad5a9b$export$e2255cf6045e8d47; });
'use strict';
const $d88c869523ad5a9b$export$e2255cf6045e8d47 = {
    extend: 'Img',
    props: {
        display: 'block',
        avatarType: 'adventurer-neutral',
        borderRadius: '100%',
        boxSize: 'C+X C+X',
        src: (el)=>`https://api.dicebear.com/7.x/${el.props.avatarType || 'initials'}/svg?seed=${el.props.key || el.key || 'no-avatar'}`
    }
};


var $c68b3a087070f481$exports = {};

$parcel$export($c68b3a087070f481$exports, "Range", function () { return $c68b3a087070f481$export$9a58ef0d7ad3278c; });

'use strict';
const $c68b3a087070f481$export$9a58ef0d7ad3278c = {
    props: {
        appearance: 'none',
        width: '100%',
        height: '2px',
        outline: 'none',
        flex: 1,
        onInput: (ev, el, s)=>{
            const props = el.props;
            if (el.call('isFunction', props.onInput)) props.onInput(ev, el, s);
            else s.update({
                value: parseFloat(el.node.value)
            });
        },
        onChange: (ev, el, s)=>{
            const props = el.props;
            if (el.call('isFunction', props.onChange)) props.onChange(ev, el, s);
            else s.update({
                value: parseFloat(el.node.value)
            });
        },
        '::-webkit-slider-thumb': {
            boxSizing: 'content-box',
            width: '8px',
            height: '8px',
            borderWidth: '2px',
            borderStyle: 'solid',
            borderRadius: '100%',
            opacity: '.8',
            style: {
                appearance: 'none'
            }
        },
        '::-webkit-slider-runnable-track': {},
        '@dark': {
            background: 'white 0.2',
            '::-webkit-slider-thumb': {
                background: '#232526',
                borderColor: (0, $1ed3cce889a937d1$export$f4f50e3877dd0530)('#454646', 0.75)
            },
            ':hover': {
                '::-webkit-slider-thumb': {
                    borderColor: (0, $1ed3cce889a937d1$export$f4f50e3877dd0530)('#fff', 0.35)
                }
            },
            ':focus': {
                '::-webkit-slider-thumb': {
                    borderColor: '#3C6AC0'
                }
            }
        },
        '@light': {
            background: 'gray9',
            '::-webkit-slider-thumb': {
                background: 'white',
                borderColor: 'gray9'
            },
            ':hover': {
                '::-webkit-slider-thumb': {
                    borderColor: 'gray7'
                }
            },
            ':focus': {
                '::-webkit-slider-thumb': {
                    borderColor: 'blue'
                }
            }
        }
    },
    deps: {
        returnPropertyValue: (el, property, def)=>{
            const val = el.props && el.call('exec', el.props[property], el);
            const r = el.call('isFunction', val) ? val(el, el.state) : val !== undefined ? val : def !== undefined ? def : 0;
            return r + '';
        }
    },
    tag: 'input',
    attr: {
        type: 'range',
        value: (el, s)=>el.call('exec', s.value || el.props.value || el.props.defaultValue, el),
        min: (el, s)=>el.deps.returnPropertyValue(el, 'min', 0),
        max: (el, s)=>el.deps.returnPropertyValue(el, 'max', 100),
        step: (el, s)=>el.deps.returnPropertyValue(el, 'step', 1)
    }
};


var $9383039da6b075af$exports = {};

$parcel$export($9383039da6b075af$exports, "DropdownList", function () { return $9383039da6b075af$export$e40cc1c58d22b809; });
$parcel$export($9383039da6b075af$exports, "DropdownParent", function () { return $9383039da6b075af$export$b162207c9836937; });
$parcel$export($9383039da6b075af$exports, "DropdownParentFocus", function () { return $9383039da6b075af$export$89c2e92edc22fd8f; });
'use strict';
const $9383039da6b075af$export$e40cc1c58d22b809 = {
    extend: 'Flex',
    attr: {
        dropdown: true
    },
    props: {
        padding: '0 Y',
        maxHeight: 'G',
        flow: 'column',
        theme: 'quaternary',
        overflow: 'hidden auto',
        style: {
            listStyleType: 'none'
        },
        transition: 'B defaultBezier',
        transitionProperty: 'transform, opacity, visibility',
        children: ({ props: props })=>props.options || [],
        childrenAs: 'props',
        '.hidden': {
            transform: 'translate3d(0,10%,0)',
            opacity: 0,
            visibility: 'hidden'
        }
    },
    childExtend: {
        extend: 'Button',
        state: {},
        props: {
            isActive: ({ key: key, state: state })=>state.active === key,
            position: 'relative',
            round: '0',
            align: 'center flex-end',
            flow: 'row-reverse',
            padding: 'Z2 C Z2 Y2',
            margin: '0',
            gap: 'Y2',
            theme: 'quaternary .child',
            ':hover': {
                style: {
                    svg: {
                        opacity: '0.5'
                    }
                }
            },
            Icon: {
                isActive: ({ key: key, state: state })=>state.active === key,
                name: 'checkmark',
                opacity: '0.1',
                '.active': {
                    opacity: '1'
                }
            },
            ':not(:first-child)': {
                '@dark': {
                    border: 'gray4 .65, solid'
                },
                '@light': {
                    border: 'gray11, solid'
                },
                borderWidth: '1px 0 0'
            }
        }
    }
};
const $9383039da6b075af$export$b162207c9836937 = {
    props: {
        position: 'relative',
        zIndex: 999,
        style: {
            '&:hover': {
                zIndex: 1000,
                '& [dropdown]': {
                    transform: 'translate3d(0,0,0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            }
        }
    }
};
const $9383039da6b075af$export$89c2e92edc22fd8f = {
    props: {
        position: 'relative',
        tabindex: '0',
        style: {
            '&:focus-within': {
                zIndex: 1000,
                '& [dropdown]': {
                    transform: 'translate3d(0,0,0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            }
        }
    },
    Input_trigger: {
        type: 'checkbox',
        opacity: '0',
        position: 'absolute',
        inset: '0',
        onUpdate: (el)=>el.node.blur()
    },
    Dropdown: {
        // onClick: (ev, el) => el.parent.Input_trigger.node.blur()
        onClick: ()=>{
            document.activeElement?.blur();
        }
    }
};


var $b3995b98110f9594$exports = {};

$parcel$export($b3995b98110f9594$exports, "Notification", function () { return $b3995b98110f9594$export$14834abbfce3b8cd; });
'use strict';
const $b3995b98110f9594$export$14834abbfce3b8cd = {
    extend: 'Flex',
    props: {
        theme: 'alert',
        padding: 'Z1 B Z A',
        round: 'A A A Y2',
        gap: 'X2',
        cursor: 'pointer',
        align: 'flex-start center'
    },
    IconText: {
        Icon: {
            name: 'info outline'
        },
        Text: {
            ':empty': {
                hide: true
            }
        }
    },
    Hgroup: {
        extends: [
            'Flex',
            'Hgroup'
        ],
        flow: 'y',
        align: 'flex-start',
        gap: 'X2',
        H: {
            tag: 'h6',
            margin: '0',
            fontWeight: '600',
            lineHeight: '1em',
            text: 'Notification',
            ':empty': {
                hide: true
            }
        },
        P: {
            fontSize: 'Z',
            margin: '0',
            text: 'is not always a distraction',
            ':empty': {
                hide: true
            }
        }
    }
};


'use strict';
$parcel$exportWildcard($e6fd4882357b9f2d$exports, $aa8df985725866a7$exports);
$parcel$exportWildcard($e6fd4882357b9f2d$exports, $dadb0cb046bc2284$exports);
$parcel$exportWildcard($e6fd4882357b9f2d$exports, $8704dc4f4e8df80e$exports);
$parcel$exportWildcard($e6fd4882357b9f2d$exports, $c758e9252127af0a$exports);
$parcel$exportWildcard($e6fd4882357b9f2d$exports, $79e391eb9bc0ecdb$exports);
$parcel$exportWildcard($e6fd4882357b9f2d$exports, $13a554edf8984773$exports);
$parcel$exportWildcard($e6fd4882357b9f2d$exports, $28fc4cdebd573cb1$exports);
$parcel$exportWildcard($e6fd4882357b9f2d$exports, $d8b4d25b7ff8b728$exports);
$parcel$exportWildcard($e6fd4882357b9f2d$exports, $740e5148058b54cb$exports);
$parcel$exportWildcard($e6fd4882357b9f2d$exports, $d88c869523ad5a9b$exports);
$parcel$exportWildcard($e6fd4882357b9f2d$exports, $c68b3a087070f481$exports);
$parcel$exportWildcard($e6fd4882357b9f2d$exports, $9383039da6b075af$exports);
$parcel$exportWildcard($e6fd4882357b9f2d$exports, $b3995b98110f9594$exports);


'use strict';
const $aa3c642730ef8d69$var$DEFAULT_ROUTING_OPTIONS = {
    initRouter: true,
    injectRouterInLinkComponent: true,
    popState: true
};
const $aa3c642730ef8d69$export$cf7ee87ede64229c = (element, context)=>{
    if (context.router === false) return;
    else if (context.router === true) context.router = $aa3c642730ef8d69$var$DEFAULT_ROUTING_OPTIONS;
    else (0, $jm0BQ.merge)(context.router || {}, $aa3c642730ef8d69$var$DEFAULT_ROUTING_OPTIONS);
    const routerOptions = context.router;
    const router = context.utils && context.utils.router ? context.utils.router : (0, $20758fd265e78843$export$5375cda95f0b0eb4);
    const onRouterRenderDefault = (el, s)=>{
        const { pathname: pathname, search: search, hash: hash } = (0, $aLXZy.window).location;
        const url = pathname + search + hash;
        if (el.routes) router(url, el, {}, {
            initialRender: true
        });
    };
    const hasRenderRouter = element.on && !(0, $amNJ8.isUndefined)(element.on.renderRouter);
    if (routerOptions && routerOptions.initRouter && !hasRenderRouter) {
        if (element.on) element.on.renderRouter = onRouterRenderDefault;
        else element.on = {
            renderRouter: onRouterRenderDefault
        };
    }
    $aa3c642730ef8d69$export$54b760094ac80b64(routerOptions);
    return routerOptions;
};
let $aa3c642730ef8d69$var$popStateFired;
const $aa3c642730ef8d69$export$423945072aa2156 = (element, context)=>{
    if ($aa3c642730ef8d69$var$popStateFired) return;
    $aa3c642730ef8d69$var$popStateFired = true;
    const routerOptions = context.router || $aa3c642730ef8d69$var$DEFAULT_ROUTING_OPTIONS;
    if (!routerOptions.popState) return;
    const router = context.utils && context.utils.router ? context.utils.router : (0, $20758fd265e78843$export$5375cda95f0b0eb4);
    (0, $aLXZy.window).onpopstate = async (event)=>{
        const { pathname: pathname, search: search, hash: hash } = (0, $aLXZy.window).location;
        const url = pathname + search + hash;
        await router(url, element, {}, {
            pushState: false,
            scrollToTop: false,
            level: 0,
            event: event
        });
    };
};
const $aa3c642730ef8d69$export$54b760094ac80b64 = (routerOptions)=>{
    if (routerOptions && routerOptions.injectRouterInLinkComponent) return (0, $jm0BQ.deepMerge)((0, $c758e9252127af0a$export$a6c7ac8248d6e38a), (0, $c758e9252127af0a$export$fce709ebdac448ed));
};


parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");

var $imR0C = parcelRequire("imR0C");
'use strict';
const { window: $166b57cae17eecc1$var$window, overwriteDeep: $166b57cae17eecc1$var$overwriteDeep, deepDestringify: $166b57cae17eecc1$var$deepDestringify } = $imR0C;
const $166b57cae17eecc1$var$IS_DEVELOPMENT = $166b57cae17eecc1$var$window && $166b57cae17eecc1$var$window.location ? $166b57cae17eecc1$var$window.location.host.includes('dev.') : $imR0C.isDevelopment();
const $166b57cae17eecc1$var$SERVER_URL = $166b57cae17eecc1$var$IS_DEVELOPMENT ? 'http://localhost:8080/get' : 'https://api.symbols.app/get';
const $166b57cae17eecc1$var$defaultOptions = {
    endpoint: $166b57cae17eecc1$var$SERVER_URL
};
const $166b57cae17eecc1$export$e7aa7bc5c1b3cfb3 = globalThis.fetch;
const $166b57cae17eecc1$export$db36d2f1649120da = async (key, options = $166b57cae17eecc1$var$defaultOptions)=>{
    const baseUrl = options.endpoint || $166b57cae17eecc1$var$SERVER_URL;
    const route = options.serviceRoute ? $imR0C.isArray(options.serviceRoute) ? options.serviceRoute.map((v)=>v.toLowerCase() + '=true').join('&') : options.serviceRoute : '';
    let response;
    try {
        response = await $166b57cae17eecc1$export$e7aa7bc5c1b3cfb3(baseUrl + '/' + '?' + route, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-AppKey': key,
                'X-Metadata': options.metadata
            }
        });
        return await response.json();
    } catch (e) {
        if ($imR0C.isFunction(options.onError)) return options.onError(e);
        else console.error(e);
    }
};
const $166b57cae17eecc1$export$525bc467aeb111d5 = async (key, options)=>{
    const { editor: editor } = options;
    if (editor && editor.remote) {
        const data = await $166b57cae17eecc1$export$db36d2f1649120da(key, editor);
        const evalData = $166b57cae17eecc1$var$IS_DEVELOPMENT || options.isDevelopment ? $166b57cae17eecc1$var$deepDestringify(data) : $166b57cae17eecc1$var$deepDestringify(data.releases[0]);
        if (editor.serviceRoute) {
            if ($imR0C.isArray(editor.serviceRoute)) editor.serviceRoute.forEach((route)=>{
                $166b57cae17eecc1$var$overwriteDeep(options[route], evalData[route.toLowerCase()]);
            });
            else $166b57cae17eecc1$var$overwriteDeep(options[editor.serviceRoute], evalData);
        } else [
            'state',
            'designSystem',
            'components',
            'snippets',
            'pages',
            'utils',
            'files',
            'packages',
            'functions'
        ].forEach((key)=>{
            $166b57cae17eecc1$var$overwriteDeep(options[key], evalData[key.toLowerCase()]);
        });
    }
    return options;
};
const $166b57cae17eecc1$export$571411efd7718583 = async (key, options, callback)=>{
    const { editor: editor } = options;
    if (editor && editor.remote) {
        const data = await $166b57cae17eecc1$export$db36d2f1649120da(key, editor);
        const evalData = $166b57cae17eecc1$var$IS_DEVELOPMENT || options.isDevelopment ? $166b57cae17eecc1$var$deepDestringify(data) : $166b57cae17eecc1$var$deepDestringify(data.releases[0]);
        callback(evalData);
    }
};


'use strict';
const $c6ba012f5985bf8f$export$8946d631417d8ced = async (key, options)=>{
    if (key && options.editor) try {
        if (!options.editor.async) await (0, $166b57cae17eecc1$export$525bc467aeb111d5)(key, options);
    } catch (e) {
        console.error(e);
    }
};
const $c6ba012f5985bf8f$export$beca342e15b450be = (app, key, options, callback)=>{
    if (key && options.editor) try {
        if (options.editor.async) (0, $166b57cae17eecc1$export$571411efd7718583)(key, options, callback || ((data)=>{
            if ((0, $amNJ8.isObject)(data.designSystem)) options.utils.init(data.designSystem);
            if ((0, $amNJ8.isObject)(data.state)) app.state.set(data.state);
        }));
    } catch (e) {
        console.error(e);
    }
};



'use strict';
const $276d53b8538ee77e$export$6588fc50c67b09a2 = {
    routes: (param)=>param,
    // deps: (param, el) => param || el.parent.deps,
    $router: (param, el)=>{
        if (!param) return;
        const obj = {
            tag: 'fragment',
            ...param
        };
        const set = ()=>{
            el.set(obj, {
                preventDefineUpdate: '$router'
            });
        };
        if (el.props && el.props.lazyLoad) window.requestAnimationFrame(set);
        else set();
        return obj;
    },
    $collection: (0, $bbb58e1b70381780$export$fb8073518f34e6ec).define.$collection,
    $setCollection: (0, $bbb58e1b70381780$export$fb8073518f34e6ec).define.$setCollection,
    $stateCollection: (0, $bbb58e1b70381780$export$fb8073518f34e6ec).define.$stateCollection,
    $propsCollection: (0, $bbb58e1b70381780$export$fb8073518f34e6ec).define.$propsCollection
};


'use strict';
const $4c0b77951ed68110$export$882cd4124a942c79 = {
    useReset: true,
    useVariable: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDocumentTheme: true,
    useDefaultIcons: true,
    useFontImport: true,
    useDefaultConfig: true
};
const $4c0b77951ed68110$export$7f202753e6a32b2b = {
    state: {},
    pages: {},
    components: {},
    router: {
        initRouter: true,
        popState: true,
        injectRouterInLinkComponent: true
    },
    define: (0, $276d53b8538ee77e$export$6588fc50c67b09a2)
};
var $4c0b77951ed68110$export$2e2bcd8739ae039 = $4c0b77951ed68110$export$7f202753e6a32b2b;




var $hmiUX = parcelRequire("hmiUX");

var $aWnFx = parcelRequire("aWnFx");

var $5iyU7 = parcelRequire("5iyU7");

var $7S1uT = parcelRequire("7S1uT");
parcelRequire("6cTIH");
var $6l4Vl = parcelRequire("6l4Vl");
'use strict';
var $69aaa4c78a267f17$export$2e2bcd8739ae039 = (params, options = {})=>{
    const { overwrite: overwrite } = options;
    for(const param in params)if ((0, $6l4Vl.REGISTRY)[param] && !overwrite) (0, $7S1uT.report)('OverwriteToBuiltin', param);
    else (0, $6l4Vl.REGISTRY)[param] = params[param];
};



var $63mfJ = parcelRequire("63mfJ");

var $48DOr = parcelRequire("48DOr");
'use strict';


var $aWnFx = parcelRequire("aWnFx");
var $hmiUX = parcelRequire("hmiUX");
'use strict';
const $a7124367ee222f55$var$create = async (element, parent, key, options)=>{
    const domqlElement = await ((0, $aWnFx.default).default || (0, $aWnFx.default))(element, parent, key, options);
    const complete = domqlElement.on?.complete;
    if (complete) await domqlElement.on.complete(element, element.state, element.context, options);
    const onComplete = domqlElement.props?.onComplete;
    if (onComplete) await domqlElement.props?.onComplete(element, element.state, element.context, options);
    const initInspect = domqlElement.on?.initInspect;
    if (initInspect) await domqlElement.on.initInspect(element, element.state, element.context, options);
    const initSync = domqlElement.on?.initSync;
    if (initSync) await domqlElement.on.initSync(element, element.state, element.context, options);
    return domqlElement;
};
var $a7124367ee222f55$export$2e2bcd8739ae039 = {
    TREE: $hmiUX.TREE,
    create: $a7124367ee222f55$var$create
};



parcelRequire("imR0C");
var $2Jg1F = parcelRequire("2Jg1F");
var $amNJ8 = parcelRequire("amNJ8");
parcelRequire("QRTe9");
var $bnF2s = parcelRequire("bnF2s");


parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
var $kitvZ = parcelRequire("kitvZ");



var $hXdei = parcelRequire("hXdei");
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $aLXZy = parcelRequire("aLXZy");
'use strict';
// const ANIMATION = {
//   fadeInUp: {
//     from: {
//       transform: 'translate3d(0, 12.5%, 1px)',
//       opacity: 0
//     },
//     to: {
//       transform: 'translate3d(0, 0, 1px)',
//       opacity: 1
//     }
//   },
//   fadeOutDown: {
//     from: {
//       transform: 'translate3d(0, 0, 1px)',
//       opacity: 1
//     },
//     to: {
//       transform: 'translate3d(0, 12.5%, 1px)',
//       opacity: 0
//     }
//   }
// }
// const COLOR = {
//   black: '#000000',
//   blue: '#3686F7'
// }
// set({
//   COLOR,
//   ANIMATION
// })
const $38e61ea0d044ec40$var$NOTIF_COLORS = {
    success: 'green',
    error: 'red',
    warning: 'yellow'
};
const $38e61ea0d044ec40$export$f34bb2007ac88e4d = (clients, element, state)=>{
    if (clients.symbols) {
        if (!state.connected) {
            state.notifications.connected = {
                title: 'Connected',
                message: 'to the Symbols live server'
            };
            state.update({
                connected: true
            });
            const t = setTimeout(()=>{
                delete state.notifications.connected;
                element.notifications.content.connected.setProps({
                    animation: 'fadeOutDown'
                });
                state.update({
                    connected: true
                });
                clearTimeout(t);
            }, 3000);
        }
    } else if (state.connected) {
        state.notifications.connected = {
            title: 'Disconnected',
            type: 'error'
        };
        state.update({
            connected: false
        });
        const t = setTimeout(()=>{
            delete state.notifications.connected;
            if (element.notifications.content.connected) element.notifications.content.connected.setProps({
                animation: 'fadeOutDown'
            });
            state.update({
                connected: true
            });
            clearTimeout(t);
        }, 3000);
    }
};
const $38e61ea0d044ec40$export$36ba2f559d49a8f6 = {
    state: {
        notifications: []
    },
    Notifications: {
        position: 'fixed',
        left: 'A2',
        bottom: 'Z2',
        zIndex: '999',
        childExtends: 'Notification',
        childProps: ({ state: state })=>({
                animationDuration: 'C',
                background: $38e61ea0d044ec40$var$NOTIF_COLORS[state.type || 'success'],
                icon: null,
                Flex: {
                    Title: {
                        text: '{{ title }}'
                    },
                    P: {
                        text: '{{ title }}'
                    }
                },
                onRender: (e, el, s)=>{
                    el.setProps({
                        animation: 'fadeInUp'
                    });
                },
                onClick: (e, el, s)=>{
                    delete s.notifications[el.key];
                    el.setProps({
                        animation: 'fadeOutDown'
                    });
                    if (s.onClose) s.onClose(e, el, s);
                }
            }),
        IconText: null,
        childrenAs: 'state',
        children: ({ state: state })=>state.notifications
    }
};



parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");

var $hXdei = parcelRequire("hXdei");
'use strict';
function $9e0ad4e5a083a9fe$var$returnStringExtend(extend) {
    return (0, $amNJ8.isString)(extend) ? extend : (0, $amNJ8.isArray)(extend) ? extend.find((extItem)=>(0, $amNJ8.isString)(extItem)) : '';
}
function $9e0ad4e5a083a9fe$var$getComponentKey(el) {
    if (!el) return;
    const __componentKey = el.__ref.__componentKey;
    const extendStr = el.extend && $9e0ad4e5a083a9fe$var$returnStringExtend(el.extend);
    const parentChildExtendStr = el.parent && el.parent.childExtend && $9e0ad4e5a083a9fe$var$returnStringExtend(el.parent.childExtend);
    return (__componentKey || extendStr || parentChildExtendStr || '').split('_')[0].split('.')[0].split('+')[0];
}
function $9e0ad4e5a083a9fe$var$findComponent(el) {
    if (!el || !el.__ref) return;
    const { components: components, pages: pages, editor: editor } = el.context;
    const componentKey = $9e0ad4e5a083a9fe$var$getComponentKey(el);
    if (editor && editor.onInitInspect) {
        const initInspectReturns = editor.onInitInspect(componentKey, el, el.state);
        if (!initInspectReturns) return $9e0ad4e5a083a9fe$var$findComponent(el.parent);
    }
    if (componentKey && (components[componentKey] || pages[componentKey])) return el;
    return $9e0ad4e5a083a9fe$var$findComponent(el.parent);
}
const $9e0ad4e5a083a9fe$var$onInspect = (app, state, ctx)=>{
    const windowOpts = ctx.window || window;
    windowOpts.onkeydown = (ev)=>{
        if (ev.altKey && ev.shiftKey) app.state.update({
            debugging: true,
            preventSelect: true
        }, {
            preventUpdate: true,
            preventContentUpdate: true,
            preventRecursive: true
        });
    };
    windowOpts.onkeyup = (ev)=>{
        if (app.state.preventSelect && (!ev.altKey || !ev.shiftKey)) {
            app.state.replace({
                debugging: false,
                preventSelect: false
            }, {
                preventUpdate: true,
                preventContentUpdate: true,
                preventRecursive: true
            });
            app.Inspector.state.update({
                area: false
            });
        }
    };
};
const $9e0ad4e5a083a9fe$export$d1a121333e17a5bb = {
    props: {
        '.preventSelect': {
            userSelect: 'none'
        },
        '!preventSelect': {
            userSelect: 'auto'
        },
        onInspect: $9e0ad4e5a083a9fe$var$onInspect,
        onMousemove: (ev, e, state)=>{
            const el = ev.target.ref;
            const component = $9e0ad4e5a083a9fe$var$findComponent(el);
            const focusState = e.Inspector.state;
            if (!component || !state.debugging || !component.__ref) return focusState.update({
                area: false
            });
            const componentKey = $9e0ad4e5a083a9fe$var$getComponentKey(component);
            const updateValue = (area)=>{
                focusState.update({
                    area: area,
                    focusKey: componentKey
                });
            };
            const update = ()=>{
                if (ev.altKey && ev.shiftKey) {
                    const { x: x, y: y, width: width, height: height } = component.node.getBoundingClientRect();
                    const area = {
                        x: x,
                        y: y,
                        width: width,
                        height: height
                    };
                    if (!focusState.area) return updateValue(area);
                    if (focusState.area.x !== area.x) updateValue(area);
                } else if (focusState.area) focusState.update({
                    area: false
                });
            };
            window.requestAnimationFrame(()=>{
                update();
                window.requestAnimationFrame(update);
            });
        },
        onMousedown: (ev, elem, state)=>{
            if (!state.debugging) return;
            const el = ev.target.ref;
            const component = $9e0ad4e5a083a9fe$var$findComponent(el);
            if (!component) return;
            const componentKey = $9e0ad4e5a083a9fe$var$getComponentKey(component);
            if (!componentKey) return;
            const editor = el.context.editor;
            if (editor && editor.onInspect) return editor.onInspect(componentKey, el, el.state, {
                allowRouterWhileInspect: true
            });
            const data = JSON.stringify({
                componentKey: `${componentKey}`
            });
            (0, $hXdei.send).call(el.context.socket, 'route', data);
            ev.preventDefault();
            ev.stopPropagation();
            return false;
        }
    },
    Inspector: {
        state: {},
        props: (el, s)=>({
                transition: 'all, defaultBezier, X',
                position: 'fixed',
                hide: !(s.area && s.parent.debugging),
                style: {
                    boxShadow: '0 0 10px #3686F733, 0 0 0 3px #3686F766, 0 0 100vmax 100vmax #000A',
                    zIndex: '9999999',
                    borderRadius: '10px',
                    pointerEvents: 'none'
                }
            }),
        span: {
            props: {
                position: 'absolute',
                margin: 'A2 0',
                fontSize: 'Z',
                color: 'text',
                // color: 'blue',
                zIndex: '99999999',
                transition: 'all, defaultBezier, X',
                textDecoration: 'underline',
                fontWeight: '500',
                top: '100%',
                style: {
                    boxShadow: '0 25px 10px 35px black',
                    textShadow: '0 0 10px black'
                },
                text: '{{ focusKey }}'
            }
        },
        on: {
            init: ({ context: context })=>{
                const { components: components } = context;
                if ((0, $amNJ8.isObject)(components)) {
                    const { Content: Content, ...rest } = components;
                    for(const key in rest){
                        if ($e6fd4882357b9f2d$exports[key]) continue;
                        if (!rest[key].__ref) rest[key].__ref = {};
                        if (!rest[key].__ref.__componentKey) rest[key].__ref.__componentKey = key;
                    }
                }
            },
            beforeUpdate: (ch, el, s)=>{
                const { area: area } = s;
                const isDebugging = s.area && s.parent.debugging;
                let style;
                if (!isDebugging) style = 'display: none !important';
                else if (area) {
                    const { x: x, y: y, width: width, height: height } = area;
                    // el.node.style = Object.stringify({
                    //   top: y - 6 + 'px',
                    //   left: x - 6 + 'px',
                    //   width: width + 12 + 'px',
                    //   height: height + 12 + 'px'
                    // })
                    style = `
            display: block !important;
            top: ${y - 6}px;
            left: ${x - 6}px;
            width: ${width + 12}px;
            height: ${height + 12}px;
          `;
                }
                el.node.style = style;
                el.span.node.innerText = s.focusKey;
                return false;
            }
        }
    }
};


'use strict';
const $d37da8baddd0cbae$var$isLocalhost = (0, $aLXZy.window) && (0, $aLXZy.window).location && (0, $aLXZy.window).location.host.includes('local');
const $d37da8baddd0cbae$var$onConnect = (element, state)=>{
    return (socketId, socket)=>{
    // send('components', { COMPONENTS: a(COMPONENTS) })
    };
};
const $d37da8baddd0cbae$var$onDisconnect = (element, state)=>{
    return ()=>{};
};
const $d37da8baddd0cbae$var$onChange = (el, s, ctx)=>{
    return (event, data)=>{
        if (event === 'change') {
            const obj = JSON.parse(data);
            if (!obj?.DATA) return;
            const { state: state, designSystem: designSystem, pages: pages, components: components, snippets: snippets, functions: functions } = obj.DATA;
            const { utils: utils } = ctx;
            if (pages) // overwriteShallow(ctx.pages, pages)
            (0, $jm0BQ.overwriteShallow)(ctx.pages, pages);
            if (components) (0, $jm0BQ.overwriteShallow)(ctx.components, components);
            if (functions) (0, $jm0BQ.overwriteShallow)(ctx.functions, functions);
            if (snippets) (0, $jm0BQ.overwriteShallow)(ctx.snippets, snippets);
            if (state) {
                const route = state.route;
                if (route) (utils.router || (0, $20758fd265e78843$export$5375cda95f0b0eb4))(route.replace('/state', '') || '/', el, {});
                else if (!(snippets && functions && components && pages)) s.update(state);
            }
            if (snippets || functions || components || pages) {
                const { pathname: pathname, search: search, hash: hash } = ctx.window.location;
                (utils.router || (0, $20758fd265e78843$export$5375cda95f0b0eb4))(pathname + search + hash, el, {});
            }
            if (designSystem) (0, $84f69156e3582aea$export$2cd8252107eb640b)(designSystem);
        }
        if (ctx.editor.verbose && event === 'clients') (0, $38e61ea0d044ec40$export$f34bb2007ac88e4d)(data, el, s);
    };
};
const $d37da8baddd0cbae$export$c57211ae658b2a31 = (el, s, ctx)=>{
    return (0, $hXdei.connect)(ctx.key, {
        source: $d37da8baddd0cbae$var$isLocalhost ? 'localhost' : 'client',
        socketUrl: $d37da8baddd0cbae$var$isLocalhost ? 'localhost:8080' : 'api.symbols.app',
        location: (0, $aLXZy.window).location.host,
        onConnect: $d37da8baddd0cbae$var$onConnect(el, s, ctx),
        onDisconnect: $d37da8baddd0cbae$var$onDisconnect(el, s, ctx),
        onChange: $d37da8baddd0cbae$var$onChange(el, s, ctx)
    });
};
const $d37da8baddd0cbae$export$a8792fa004fc1e59 = {
    on: {
        initSync: $d37da8baddd0cbae$export$c57211ae658b2a31
    }
};
const $d37da8baddd0cbae$export$d05f3dc416482df7 = {
    extend: [
        $d37da8baddd0cbae$export$a8792fa004fc1e59,
        (0, $9e0ad4e5a083a9fe$export$d1a121333e17a5bb),
        (0, $38e61ea0d044ec40$export$36ba2f559d49a8f6)
    ]
};


'use strict';
const $1fdc504dcadfb2d4$export$c8d1988b2aeaf8a9 = (app, ctx)=>{
    return (0, $amNJ8.isObjectLike)(app.extend) ? app.extend : [];
};
const $1fdc504dcadfb2d4$export$f04cca198b6322f4 = (app, ctx)=>{
    const { editor: editor } = ctx;
    if (!editor) return;
    const liveSync = (0, $amNJ8.isUndefined)(editor.liveSync) ? (0, $kitvZ.isDevelopment)() : editor.liveSync;
    if (liveSync) {
        if ((0, $amNJ8.isArray)(app.extend)) app.extend.push((0, $d37da8baddd0cbae$export$a8792fa004fc1e59));
        else if (app.extend) app.extend = [
            app.extend,
            (0, $d37da8baddd0cbae$export$a8792fa004fc1e59)
        ];
        else app.extend = [
            (0, $d37da8baddd0cbae$export$a8792fa004fc1e59)
        ];
    }
};
const $1fdc504dcadfb2d4$export$6919748479ac6c4f = (app, ctx)=>{
    const { editor: editor } = ctx;
    if (!editor) return;
    const inspect = (0, $amNJ8.isUndefined)(editor.inspect) ? (0, $kitvZ.isDevelopment)() : editor.inspect;
    if (inspect) {
        if ((0, $amNJ8.isArray)(app.extend)) app.extend.push((0, $9e0ad4e5a083a9fe$export$d1a121333e17a5bb));
        else if (app.extend) app.extend = [
            app.extend,
            (0, $9e0ad4e5a083a9fe$export$d1a121333e17a5bb)
        ];
        else app.extend = [
            (0, $9e0ad4e5a083a9fe$export$d1a121333e17a5bb)
        ];
    }
};
const $1fdc504dcadfb2d4$export$cf84b69175b2f78a = (app, ctx)=>{
    const { editor: editor } = ctx;
    if (!editor) return;
    const verbose = (0, $amNJ8.isUndefined)(editor.verbose) ? (0, $kitvZ.isDevelopment)() || ctx.verbose : editor.verbose;
    if (verbose) {
        if ((0, $amNJ8.isArray)(app.extend)) app.extend.push((0, $38e61ea0d044ec40$export$36ba2f559d49a8f6));
        else if (app.extend) app.extend = [
            app.extend,
            (0, $38e61ea0d044ec40$export$36ba2f559d49a8f6)
        ];
        else app.extend = [
            (0, $38e61ea0d044ec40$export$36ba2f559d49a8f6)
        ];
    }
};


parcelRequire("imR0C");
var $3Kzng = parcelRequire("3Kzng");
var $jm0BQ = parcelRequire("jm0BQ");
var $kitvZ = parcelRequire("kitvZ");
var $amNJ8 = parcelRequire("amNJ8");
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
var $kitvZ = parcelRequire("kitvZ");

parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $92e7440775b462ec$export$d559e9a3b71405f6 = (element)=>{
    const { key: key } = element;
    if (element.class === true) element.class = key;
    else if (!element.class && typeof key === 'string' && key.charAt(0) === '_' && key.charAt(1) !== '_') element.class = key.slice(1);
};
const $92e7440775b462ec$export$b04d9b8d414ba5e8 = (obj, element)=>{
    let className = '';
    for(const item in obj){
        const param = obj[item];
        if (typeof param === 'boolean' && param) className += ` ${item}`;
        else if (typeof param === 'string') className += ` ${param}`;
        else if (typeof param === 'function') className += ` ${(0, $jm0BQ.exec)(param, element)}`;
    }
    return className;
};
const $92e7440775b462ec$export$11c615ce16f87241 = (params, element)=>{
    if (!params) return;
    const { key: key } = element;
    if (params === true) params = element.class = {
        key: key
    };
    if ((0, $amNJ8.isString)(params)) params = element.class = {
        default: params
    };
    if ((0, $amNJ8.isObject)(params)) params = $92e7440775b462ec$export$b04d9b8d414ba5e8(params, element);
    // TODO: fails on string
    const className = params.replace(/\s+/g, ' ').trim();
    if (element.ref) element.ref.class = className // TODO: this check is NOT needed in new DOMQL
    ;
    return className;
};
const $92e7440775b462ec$export$e8f750c9f10c0a7b = (params, element, node)=>{
    const className = $92e7440775b462ec$export$11c615ce16f87241(params, element);
    node.classList = className;
    return className;
};
function $92e7440775b462ec$export$f1a8a7f322d4587c(params, element, node) {
    $92e7440775b462ec$export$e8f750c9f10c0a7b(params, element, node);
}
var $92e7440775b462ec$export$2e2bcd8739ae039 = $92e7440775b462ec$export$f1a8a7f322d4587c;


'use strict';
const $b241cf3d5b0dac94$export$c79b0dc85ccca679 = (emotion)=>{
    return (params, element, state)=>{
        const execParams = (0, $jm0BQ.exec)(params, element);
        if (params) {
            if ((0, $amNJ8.isObjectLike)(element.class)) element.class.elementStyle = execParams;
            else element.class = {
                elementStyle: execParams
            };
        }
        $b241cf3d5b0dac94$export$62b33bcc98e42249(emotion)(element.class, element, element.state, true);
    };
};
const $b241cf3d5b0dac94$export$62b33bcc98e42249 = (emotion)=>{
    return (params, element, state, flag)=>{
        if (element.style && !flag) return;
        const { __ref: __ref } = element;
        const { __class: __class, __classNames: __classNames } = __ref;
        if (!(0, $amNJ8.isObjectLike)(params)) return;
        if (element.props.class) __classNames.classProps = element.props.class;
        if (element.attr.class) __classNames.class = element.attr.class;
        for(const key in params){
            const prop = (0, $jm0BQ.exec)(params[key], element);
            if (!prop) {
                delete __class[key];
                delete __classNames[key];
                continue;
            }
            const isEqual = (0, $jm0BQ.isEqualDeep)(__class[key], prop);
            if (!isEqual) {
                if (!(0, $kitvZ.isProduction)() && (0, $amNJ8.isObject)(prop)) prop.label = key || element.key;
                let className;
                if ((0, $amNJ8.isString)(prop) || (0, $amNJ8.isNumber)(prop)) className = prop;
                else if ((0, $amNJ8.isBoolean)(prop)) className = element.key;
                else className = emotion.css(prop);
                __class[key] = prop;
                __classNames[key] = className;
            }
        }
        (0, $92e7440775b462ec$export$e8f750c9f10c0a7b)(__classNames, element, element.node);
    // return element.class
    };
};
const $b241cf3d5b0dac94$export$23627aa597d6e60c = (emotion, options)=>{
    if (!emotion) emotion = (0, $be0b73abefc1556e$export$2e2bcd8739ae039)(options || {
        key: 'smbls'
    });
    return {
        style: $b241cf3d5b0dac94$export$c79b0dc85ccca679(emotion),
        class: $b241cf3d5b0dac94$export$62b33bcc98e42249(emotion)
    };
};




parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");

var $6926b6904a40ba96$exports = {};

$parcel$defineInteropFlag($6926b6904a40ba96$exports);

$parcel$export($6926b6904a40ba96$exports, "DEFAULT_CONFIG", function () { return $6926b6904a40ba96$export$c2f8e0cc249a8d8f; });
$parcel$export($6926b6904a40ba96$exports, "default", function () { return $6926b6904a40ba96$export$2e2bcd8739ae039; });
'use strict';






































const $a362bb0fdcefc623$export$6be23892b3f5233 = {
    symbols: (parcelRequire("e0lzv")),
    logo: (parcelRequire("e0lzv")),
    arrowDownCircle: (parcelRequire("d3KIO")),
    arrowDownLeft: (parcelRequire("eUB2h")),
    arrowDownRight: (parcelRequire("hNfSb")),
    arrowDown: (parcelRequire("9Ap7e")),
    arrowLeftCircle: (parcelRequire("7JFDg")),
    arrowLeft: (parcelRequire("dHL6K")),
    arrowRight: (parcelRequire("7pjFq")),
    arrowRightCircle: (parcelRequire("e3aXB")),
    arrowUpCircle: (parcelRequire("8vbB0")),
    arrowUpLeft: (parcelRequire("yRj0w")),
    arrowUpRight: (parcelRequire("3EKvT")),
    arrowUp: (parcelRequire("kE4z0")),
    checkCircle: (parcelRequire("z0Skz")),
    check: (parcelRequire("dsqxM")),
    chevronDown: (parcelRequire("7OO2T")),
    chevronLeft: (parcelRequire("bMQZX")),
    chevronRight: (parcelRequire("6fPSc")),
    chevronUp: (parcelRequire("8ZAo9")),
    copy: (parcelRequire("AMokA")),
    eyeOff: (parcelRequire("5dUGz")),
    eye: (parcelRequire("g5qZ0")),
    info: (parcelRequire("76EwH")),
    lock: (parcelRequire("aVA6c")),
    minus: (parcelRequire("bqvPv")),
    sun: (parcelRequire("4pPjC")),
    moon: (parcelRequire("6gZUK")),
    moreHorizontal: (parcelRequire("kXKuk")),
    moreVertical: (parcelRequire("eTVvk")),
    send: (parcelRequire("79NoA")),
    smile: (parcelRequire("i7K7z")),
    star: (parcelRequire("j32f0")),
    search: (parcelRequire("hHkz5")),
    upload: (parcelRequire("gVrTn")),
    video: (parcelRequire("7iEp3")),
    x: (parcelRequire("h7gho")),
    plus: (parcelRequire("86RIu"))
};


'use strict';
const $0829f0b4676feadd$export$9b982809044276a6 = {
    blue: '#213eb0',
    green: '#389d34',
    red: '#e15c55',
    yellow: '#EDCB38',
    orange: '#e97c16',
    transparent: 'rgba(0, 0, 0, 0)',
    black: 'black',
    gray: '#4e4e50',
    white: 'white',
    title: [
        '--gray 1 -168',
        '--gray 1 +168'
    ],
    caption: [
        '--gray 1 -68',
        '--gray 1 +68'
    ],
    paragraph: [
        '--gray 1 -42',
        '--gray 1 +42'
    ],
    disabled: [
        '--gray 1 -26',
        '--gray 1 +26'
    ],
    line: [
        '--gray 1 -16',
        '--gray 1 +16'
    ]
};
const $0829f0b4676feadd$export$3d856cf049c09ba8 = {
    'gradient-blue-light': `linear-gradient(to right,
    rgba(4, 116, 242, 1),
    rgba(0, 48, 103, 1)
  )`,
    'gradient-blue-dark': `linear-gradient(to right,
    #0474F2,
    #003067
  )`,
    'gradient-dark': `linear-gradient(0deg,
    rgba(0,0,0,0.06) 0%,
    rgba(0,0,0,0.07) 100%
  )`,
    'gradient-dark-active': `linear-gradient(0deg,
    rgba(0,0,0,0.09) 0%,
    rgba(0,0,0,0.1) 100%
  )`,
    'gradient-light': `linear-gradient(
    0deg,
    rgba(255,255,255,0.05) 0%,
    rgba(255,255,255,0.06) 100%
  )`,
    'gradient-light-active': `linear-gradient(
    0deg,
    rgba(255,255,255,0.09) 0%,
    rgba(255,255,255,0.10) 100%
  )`,
    'gradient-colorful': `linear-gradient(60deg,
    #00A2E7 0%,
    #185DF3 31%,
    #1E54F0 36%,
    #8B4CCA 69%,
    #C66894 100%
  )`
};


'use strict';
const $06329112426876e0$var$PRIORITIES = {
    primary: {
        '@dark': {
            color: 'white',
            background: 'blue',
            '.color-only': {
                color: 'blue'
            },
            '.inactive': {
                background: 'gray 1 +16'
            },
            '.gradient': {
                color: 'white',
                background: 'gradient-blue'
            }
        },
        '@light': {
            color: 'white',
            background: 'gradient-blue',
            '.color-only': {
                color: 'blue'
            },
            '.gradient': {
                color: 'white',
                background: 'gradient-colorful'
            }
        }
    },
    secondary: {
        '@dark': {
            color: 'white',
            background: 'green',
            '.color-only': {
                color: 'green'
            }
        },
        '@light': {
            color: 'white',
            background: 'green',
            '.color-only': {
                color: 'green'
            }
        },
        '.child': '--primary'
    },
    tertiary: {
        '@dark': {
            color: 'white',
            background: 'gray .92 +8'
        },
        '@light': {
            background: 'gray .1'
        }
    },
    quaternary: {
        '@light': {
            color: 'white',
            background: 'gradient-light'
        },
        '@dark': {
            color: 'white',
            background: 'gradient-dark-active'
        }
    },
    quinary: {
        '@dark': {
            color: 'gray 1 90',
            background: 'gradient-light',
            ':hover': {
                color: 'gray 1 95',
                background: 'gradient-light-active'
            },
            ':focus': {
                color: 'gray 1 120',
                background: 'gradient-light-active'
            },
            ':active': {
                color: 'gray 1 120',
                background: 'gradient-light-active'
            },
            '.active': {
                color: 'gray 1 120',
                background: 'gradient-light-active'
            }
        },
        '@light': {
            color: 'gray3',
            background: 'gradient-dark',
            ':hover': {
                color: 'gray1',
                background: 'gradient-dark-active'
            },
            ':active': {
                color: 'gray1',
                background: 'gradient-dark-active'
            },
            '.active': {
                color: 'gray1',
                background: 'gradient-dark-active'
            }
        }
    }
};
const $06329112426876e0$var$STATES = {
    alert: {
        '@dark': {
            color: 'white',
            background: 'red'
        }
    },
    warning: {
        '@dark': {
            color: 'black',
            background: 'yellow'
        }
    },
    success: {
        '@dark': {
            color: 'black',
            background: 'green'
        }
    }
};
const $06329112426876e0$var$UI = {
    field: {
        '@light': {
            color: 'black',
            background: 'gray .975 +144',
            borderColor: 'gray .975 +144',
            '::placeholder': {
                color: 'gray 1 -68'
            }
        },
        '@dark': {
            color: 'white',
            background: 'gray .975 -52',
            borderColor: 'gray .975 -52',
            '::placeholder': {
                color: 'gray 1 +68'
            }
        }
    },
    label: {
        '@dark': {
            color: 'white',
            background: 'gray .92 +8'
        },
        '@light': {
            background: 'gray .1'
        },
        '.light': {
            color: 'white',
            background: 'gray3'
        },
        '.dark': {
            color: 'white',
            background: 'black .35'
        }
    },
    card: {
        '@light': {
            background: 'gray .975 +150'
        },
        '@dark': {
            color: 'white',
            background: 'gray .975 -56'
        },
        '.child': {
            color: 'white',
            background: 'gray3'
        },
        '.secondary': {
            color: 'white',
            background: 'gradient-blue-dark',
            '.child': {
                color: 'white',
                background: 'black .35'
            }
        }
    },
    dialog: {
        '@dark': {
            color: 'white',
            background: 'gray .92',
            '.helper': {
                color: 'white',
                background: 'black'
            }
        },
        '@light': {
            color: 'currentColor',
            background: 'gray .1'
        }
    }
};
const $06329112426876e0$export$5714e40777c1bcc2 = {
    document: {
        '@light': {
            color: 'black',
            background: 'white'
        },
        '@dark': {
            color: 'white',
            background: 'black'
        }
    },
    ...$06329112426876e0$var$PRIORITIES,
    ...$06329112426876e0$var$STATES,
    ...$06329112426876e0$var$UI,
    none: {
        color: 'none',
        background: 'none'
    },
    transparent: {
        color: 'currentColor',
        background: 'transparent'
    }
};


'use strict';
const $775f8294e4567df6$export$d36796ab73e728d9 = {
    base: 16,
    ratio: 1.25,
    subSequence: true,
    templates: {}
};


'use strict';
const $50dffb55ede71ac2$export$82ea42e772d49e5b = {
    ratio: 1.618,
    subSequence: true
};


'use strict';
const $a9299b4184137cb8$export$75d3998385cc196f = {
    SourceSans: [
        {
            url: ''
        }
    ]
};
const $a9299b4184137cb8$export$530097e879f93363 = {
    system: {
        value: [
            '"Helvetica Neue"',
            'Helvetica',
            'Arial'
        ],
        type: 'sans-serif'
    }
};


'use strict';
const $cb83797144c76b81$export$500415a86c544f73 = {
    tv: '(min-width: 2780px)',
    screenL: '(max-width: 1920px)',
    'screenL<': '(min-width: 1920px)',
    screenM: '(max-width: 1680px)',
    'screenM<': '(min-width: 1680px)',
    screenS: '(max-width: 1440px)',
    'screenS<': '(min-width: 1440px)',
    tabletL: '(max-width: 1366px)',
    'tabletL<': '(min-width: 1366px)',
    tabletM: '(max-width: 1280px)',
    'tabletM<': '(min-width: 1280px)',
    tabletS: '(max-width: 1024px)',
    'tabletS<': '(min-width: 1024px)',
    mobileL: '(max-width: 768px)',
    'mobileL<': '(min-width: 768px)',
    mobileM: '(max-width: 560px)',
    'mobileM<': '(min-width: 560px)',
    mobileS: '(max-width: 480px)',
    'mobileS<': '(min-width: 480px)',
    mobileXS: '(max-width: 375px)',
    'mobileXS<': '(min-width: 375px)',
    light: '(prefers-color-scheme: light)',
    dark: '(prefers-color-scheme: dark)',
    print: 'print'
};


'use strict';
const $f231ca5723ae9951$export$3c9e9dc0cdfaa753 = {
    base: 150,
    ratio: 1.333,
    unit: 'ms',
    subSequence: true
};


'use strict';
const $6926b6904a40ba96$export$c2f8e0cc249a8d8f = {
    version: '0.0.1',
    COLOR: $0829f0b4676feadd$export$9b982809044276a6,
    GRADIENT: $0829f0b4676feadd$export$3d856cf049c09ba8,
    THEME: $06329112426876e0$export$5714e40777c1bcc2,
    TYPOGRAPHY: $775f8294e4567df6$export$d36796ab73e728d9,
    SPACING: $50dffb55ede71ac2$export$82ea42e772d49e5b,
    FONT: $a9299b4184137cb8$export$75d3998385cc196f,
    FONT_FAMILY: $a9299b4184137cb8$export$530097e879f93363,
    TIMING: $f231ca5723ae9951$export$3c9e9dc0cdfaa753,
    ICONS: (0, $a362bb0fdcefc623$export$6be23892b3f5233),
    MEDIA: $cb83797144c76b81$export$500415a86c544f73,
    RESET: {
        html: {},
        body: {}
    },
    ANIMATION: {
        fadeIn: {
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            }
        }
    },
    DEVICES: {},
    CASES: {},
    CLASS: {},
    SVG: {} // TODO: Check with @nikoloza on this
};
var $6926b6904a40ba96$export$2e2bcd8739ae039 = $6926b6904a40ba96$export$c2f8e0cc249a8d8f;


'use strict';
const $324b1bd801777972$export$e567b959eb9cc2cc = (key, options = {})=>{
    const doc = options.parent || options.document || document;
    const initOptions = options.initOptions || {};
    const emotion = initOptions.emotion;
    if (!initOptions.emotion) initOptions.emotion = (0, $9119ccb14775b2d1$export$51d693b3d243fd90);
    const registry = options.registry || (0, $b241cf3d5b0dac94$export$23627aa597d6e60c)(initOptions.emotion, options);
    const designSystem = initOptions.useDefaultConfig || options.designSystem?.useDefaultConfig ? (0, $jm0BQ.deepMerge)(options.designSystem, (0, $jm0BQ.deepClone)((0, $6926b6904a40ba96$export$c2f8e0cc249a8d8f))) : options.designSystem || (0, $jm0BQ.deepClone)((0, $6926b6904a40ba96$export$c2f8e0cc249a8d8f));
    const scratchSystem = (0, $84f69156e3582aea$export$2cd8252107eb640b)(designSystem, {
        key: key,
        emotion: emotion,
        verbose: options.verbose,
        document: doc,
        ...(0, $4c0b77951ed68110$export$882cd4124a942c79),
        ...initOptions
    });
    return [
        scratchSystem,
        emotion,
        registry
    ];
};





'use strict';
const $b32e08d03b363954$export$c3727843bfb8bb3b = (context)=>{
    if (typeof window === 'undefined') window = globalThis || {}; // eslint-disable-line
    if (typeof document === 'undefined') {
        if (!window.document) window.document = globalThis.document || {
            body: {}
        };
        document = window.document; // eslint-disable-line
    }
    context.document = context.document || document;
    context.window = context.window || window;
    return context.window;
};
function $b32e08d03b363954$var$onlyDotsAndNumbers(str) {
    return /^[0-9.]+$/.test(str) && str !== '';
}
const $b32e08d03b363954$export$17aa062053a6ac51 = ()=>{
    const newObj = {};
    for(const key in $e6fd4882357b9f2d$exports)if (Object.prototype.hasOwnProperty.call($e6fd4882357b9f2d$exports, key)) {
        if ((0, $3Kzng.checkIfKeyIsComponent)(key)) newObj[`smbls.${key}`] = $e6fd4882357b9f2d$exports[key];
        else newObj[key] = $e6fd4882357b9f2d$exports[key];
    }
    return newObj;
};
const $b32e08d03b363954$export$4f2633f1ff10978c = (context)=>{
    return context.components ? {
        ...$b32e08d03b363954$export$17aa062053a6ac51(),
        ...context.components
    } : $b32e08d03b363954$export$17aa062053a6ac51();
};
const $b32e08d03b363954$export$348dc3ccba7d17b1 = (context)=>{
    return {
        ...$e5c9cce2d37812b2$exports,
        ...$20758fd265e78843$exports,
        ...$e5c9cce2d37812b2$exports.scratchUtils,
        ...context.utils,
        ...context.snippets,
        ...context.functions
    };
};
const $b32e08d03b363954$export$bb03004b651040c = (context)=>{
    return {
        ...context.methods || {},
        require: context.utils.require,
        requireOnDemand: context.utils.requireOnDemand
    };
};
const $b32e08d03b363954$var$cachedDeps = {};
const $b32e08d03b363954$export$c40391394e7726ed = async ({ dependencies: dependencies, dependenciesOnDemand: dependenciesOnDemand, document: document1, preventCaching: preventCaching = false })=>{
    if (!dependencies || Object.keys(dependencies).length === 0) return null;
    for (const [dependency, version] of Object.entries(dependencies)){
        if (version === 'loading' || version === 'error' || dependenciesOnDemand && dependenciesOnDemand[dependency]) continue;
        const random = (0, $kitvZ.isDevelopment)() && preventCaching ? `?${Math.random()}` : '';
        let url = `https://pkg.symbo.ls/${dependency}/${version}.js${random}`;
        if (dependency.split('/').length > 2 || !$b32e08d03b363954$var$onlyDotsAndNumbers(version)) url = `https://pkg.symbo.ls/${dependency}${random}`;
        try {
            if ($b32e08d03b363954$var$cachedDeps[dependency]) return;
            $b32e08d03b363954$var$cachedDeps[dependency] = true;
            await $e5c9cce2d37812b2$exports.loadRemoteScript(url, {
                document: document1
            });
        } catch (e) {
            console.error(`Failed to load ${dependency}:`, e);
        }
    }
    return dependencies;
};
const $b32e08d03b363954$export$52302ef84805a6f8 = async (packages, ctx)=>{
    const windowOpts = ctx.window || window;
    const initRequire = async (ctx)=>async (key)=>{
            const windowOpts = ctx.window || window;
            const pkg = windowOpts.packages[key];
            if (typeof pkg === 'function') return pkg();
            return pkg;
        };
    const initRequireOnDemand = async (ctx)=>async (key)=>{
            const { dependenciesOnDemand: dependenciesOnDemand } = ctx;
            const documentOpts = ctx.document || document;
            const windowOpts = ctx.window || window;
            if (!windowOpts.packages[key]) {
                const random = (0, $kitvZ.isDevelopment)() ? `?${Math.random()}` : '';
                if (dependenciesOnDemand && dependenciesOnDemand[key]) {
                    const version = dependenciesOnDemand[key];
                    const url = `https://pkg.symbo.ls/${key}/${version}.js${random}`;
                    await ctx.utils.loadRemoteScript(url, {
                        window: windowOpts,
                        document: documentOpts
                    });
                } else {
                    const url = `https://pkg.symbo.ls/${key}${random}`;
                    await ctx.utils.loadRemoteScript(url, {
                        window: windowOpts,
                        document: documentOpts
                    });
                    windowOpts.packages[key] = 'loadedOnDeman';
                }
            }
            return await windowOpts.require(key);
        };
    if (windowOpts.packages) windowOpts.packages = (0, $jm0BQ.merge)(windowOpts.packages, packages);
    else windowOpts.packages = packages;
    if (!windowOpts.require) {
        ctx.utils.require = await initRequire(ctx);
        windowOpts.require = ctx.utils.require;
    }
    if (!windowOpts.requireOnDemand) {
        ctx.utils.requireOnDemand = await initRequireOnDemand(ctx);
        windowOpts.requireOnDemand = ctx.utils.requireOnDemand;
    }
};
const $b32e08d03b363954$export$d54de307475be07a = (key, context)=>{
    const [scratcDesignhSystem, emotion, registry] = (0, $324b1bd801777972$export$e567b959eb9cc2cc)(key, context);
    return [
        scratcDesignhSystem,
        emotion,
        registry
    ];
};
const $b32e08d03b363954$export$beb986ec1c64324 = (app, context)=>{
    const state = {};
    if (context.state) $e5c9cce2d37812b2$exports.deepMerge(state, context.state);
    if (app && app.state) (0, $jm0BQ.deepMerge)(state, app.state);
    return (0, $jm0BQ.deepClone)(state);
};
const $b32e08d03b363954$export$b2f7e94520d001d1 = (app, context)=>{
    if ((0, $amNJ8.isObject)(app.routes) && (0, $amNJ8.isObject)(context.pages)) (0, $jm0BQ.merge)(app.routes, context.pages);
    const pages = app.routes || context.pages || {};
    return Object.keys(pages).filter((v)=>!v.startsWith('/')).reduce((pages, v)=>{
        const index = v === 'index' ? '' : v;
        pages['/' + index] = pages[v];
        delete pages[v];
        return pages;
    }, pages);
};


'use strict';
const $162e7e7de2321255$export$9c634076e0a91d1f = async (app, context = {})=>{
    // const rcFileKey = process?.env?.SYMBOLS_KEY
    const key = context.key = context.key || ((0, $amNJ8.isString)(app) ? app : 'smblsapp');
    context.define = context.define || (0, $276d53b8538ee77e$export$6588fc50c67b09a2);
    context.window = (0, $b32e08d03b363954$export$c3727843bfb8bb3b)(context);
    const [scratcDesignSystem, emotion, registry] = (0, $b32e08d03b363954$export$d54de307475be07a)(key, context);
    context.designSystem = scratcDesignSystem;
    context.registry = registry;
    context.emotion = emotion;
    const state = (0, $b32e08d03b363954$export$beb986ec1c64324)(app, context);
    context.state = state;
    context.pages = (0, $b32e08d03b363954$export$b2f7e94520d001d1)(app, context);
    context.components = (0, $b32e08d03b363954$export$4f2633f1ff10978c)(context);
    context.utils = (0, $b32e08d03b363954$export$348dc3ccba7d17b1)(context);
    context.dependencies = await (0, $b32e08d03b363954$export$c40391394e7726ed)(context);
    context.methods = (0, $b32e08d03b363954$export$bb03004b651040c)(context);
    context.routerOptions = (0, $aa3c642730ef8d69$export$cf7ee87ede64229c)(app, context);
    context.defaultExtends = [
        $dadb0cb046bc2284$export$e71c4d32a2263218
    ];
    return context;
};
const $162e7e7de2321255$export$b5b313bfdabf2fb4 = async (app, ctx)=>{
    if (!(0, $amNJ8.isObject)(ctx)) ctx = {};
    if ((0, $2Jg1F.isNode)(app)) {
        app = {};
        ctx.parent = app;
    }
    if ((0, $amNJ8.isString)(app)) {
        app = {};
        ctx.key = app;
    }
    if (!(0, $amNJ8.isObject)(app)) app = {};
    await $162e7e7de2321255$export$9c634076e0a91d1f(app, ctx);
    app.extend = (0, $1fdc504dcadfb2d4$export$c8d1988b2aeaf8a9)(app, ctx);
    app.routes = ctx.pages;
    app.state = ctx.state;
    app.context = ctx;
    app.data = app.data || {};
    app.data.frameListeners = (0, $bnF2s.initAnimationFrame)(ctx);
    await (0, $b32e08d03b363954$export$52302ef84805a6f8)({
        functions: ctx.functions,
        utils: ctx.utils,
        snippets: ctx.snippets,
        ...ctx.files
    }, ctx);
    (0, $1fdc504dcadfb2d4$export$f04cca198b6322f4)(app, ctx);
    (0, $1fdc504dcadfb2d4$export$6919748479ac6c4f)(app, ctx);
    (0, $1fdc504dcadfb2d4$export$cf84b69175b2f78a)(app, ctx);
    const parentNode = ctx.parent || ctx.document.body;
    const domqlCreate = (0, $a7124367ee222f55$export$2e2bcd8739ae039).default && (0, $a7124367ee222f55$export$2e2bcd8739ae039).default.create || (0, $a7124367ee222f55$export$2e2bcd8739ae039).create;
    const smblsApp = await domqlCreate(app, parentNode, ctx.key, {
        verbose: ctx.verbose,
        ...ctx.domqlOptions
    });
    return smblsApp;
};


'use strict';
const $25b5ce44de4d06e3$var$mergeWithLocalFile = (options, optionsExternalFile)=>(0, $jm0BQ.deepMerge)(options, (0, $amNJ8.isObject)(optionsExternalFile) ? optionsExternalFile : (0, (/*@__PURE__*/$parcel$interopDefault($edf97ce22d544a62$exports))) || {});
const $25b5ce44de4d06e3$export$185802fd694ee1f5 = (App, options = (0, $4c0b77951ed68110$export$2e2bcd8739ae039), optionsExternalFile)=>{
    const redefinedOptions = {
        ...(0, $4c0b77951ed68110$export$2e2bcd8739ae039),
        ...$25b5ce44de4d06e3$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    const domqlApp = (0, $162e7e7de2321255$export$b5b313bfdabf2fb4)(App, redefinedOptions);
    (0, $aa3c642730ef8d69$export$423945072aa2156)(domqlApp, redefinedOptions);
    if (redefinedOptions.on && redefinedOptions.on.create) redefinedOptions.on.create(domqlApp, domqlApp.state, domqlApp.context, redefinedOptions);
    return domqlApp;
};
const $25b5ce44de4d06e3$export$fa0abf86dcc47d66 = (App, options = (0, $4c0b77951ed68110$export$2e2bcd8739ae039), optionsExternalFile)=>{
    const domqlApp = $25b5ce44de4d06e3$export$185802fd694ee1f5(App, options, optionsExternalFile);
    const redefinedOptions = {
        ...(0, $4c0b77951ed68110$export$2e2bcd8739ae039),
        ...$25b5ce44de4d06e3$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    // const SYMBOLS_KEY = process.env.SYMBOLS_KEY
    const key = redefinedOptions.key;
    (0, $c6ba012f5985bf8f$export$beca342e15b450be)(domqlApp, key, {
        utils: $e5c9cce2d37812b2$exports,
        ...redefinedOptions
    });
    return domqlApp;
};
const $25b5ce44de4d06e3$export$df2a74307fafca3b = async (App, options = (0, $4c0b77951ed68110$export$2e2bcd8739ae039), optionsExternalFile)=>{
    const redefinedOptions = {
        ...(0, $4c0b77951ed68110$export$2e2bcd8739ae039),
        ...$25b5ce44de4d06e3$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    // const SYMBOLS_KEY = process.env.SYMBOLS_KEY
    const key = options.key;
    await (0, $c6ba012f5985bf8f$export$8946d631417d8ced)(key, redefinedOptions);
    const domqlApp = await (0, $162e7e7de2321255$export$b5b313bfdabf2fb4)(App, redefinedOptions);
    (0, $aa3c642730ef8d69$export$423945072aa2156)(domqlApp, redefinedOptions);
    if (redefinedOptions.on && redefinedOptions.on.create) await redefinedOptions.on.create(domqlApp, domqlApp.state, domqlApp.context, redefinedOptions);
    return domqlApp;
};
const $25b5ce44de4d06e3$export$9cb2e3fca5d0556e = (App = {}, options = (0, $4c0b77951ed68110$export$2e2bcd8739ae039), optionsExternalFile)=>{
    return $25b5ce44de4d06e3$export$185802fd694ee1f5({
        deps: {
            isUndefined: $amNJ8.isUndefined
        },
        ...App
    }, (0, $jm0BQ.deepMerge)({
        domqlOptions: {
            onlyResolveExtends: true
        }
    }, options), optionsExternalFile);
};
var $25b5ce44de4d06e3$export$2e2bcd8739ae039 = $25b5ce44de4d06e3$export$185802fd694ee1f5;


var $7d99557d9b959b1d$exports = {};

$parcel$export($7d99557d9b959b1d$exports, "exetuteClassPerComponent", function () { return $7d99557d9b959b1d$export$2d3867789701917d; });
var $b6a1bff7e7921a33$exports = {};

$parcel$export($b6a1bff7e7921a33$exports, "transformClassname", function () { return $b6a1bff7e7921a33$export$2b5b252eb866c647; });
$parcel$export($b6a1bff7e7921a33$exports, "extractCSSfromProps", function () { return $b6a1bff7e7921a33$export$70a74cfeffe570f4; });
parcelRequire("imR0C");
var $jm0BQ = parcelRequire("jm0BQ");
var $amNJ8 = parcelRequire("amNJ8");

var $e1bf7a72fe80923c$exports = {};

$parcel$export($e1bf7a72fe80923c$exports, "CSS_PROPS_REGISTRY", function () { return $e1bf7a72fe80923c$export$b474245a861fc144; });
$parcel$export($e1bf7a72fe80923c$exports, "CSS_PREPROCS_DEFAULTS", function () { return $e1bf7a72fe80923c$export$c6537d1a7d8e90af; });
parcelRequire("imR0C");
var $1cJu7 = parcelRequire("1cJu7");
var $eb52d8a8504dc7f2$exports = {};
var $ac75ac59fdf3152e$exports = {};

$parcel$export($ac75ac59fdf3152e$exports, "ANIMATION_PROPS", function () { return $ac75ac59fdf3152e$export$29173f57c6f2005; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");


'use strict';
const $ac75ac59fdf3152e$var$applyAnimationProps = (animation, element)=>{
    const { emotion: ctxEmotion } = element.context;
    const { keyframes: keyframes } = ctxEmotion || (0, $9119ccb14775b2d1$export$51d693b3d243fd90);
    if ((0, $amNJ8.isObject)(animation)) return {
        animationName: keyframes(animation)
    };
    const { ANIMATION: ANIMATION } = element.context && element.context.designSystem;
    const record = ANIMATION[animation];
    return keyframes(record);
};
const $ac75ac59fdf3152e$export$29173f57c6f2005 = {
    animation: (el)=>({
            animationName: $ac75ac59fdf3152e$var$applyAnimationProps(el.props.animation, el),
            animationDuration: (0, $9779037853e3fa59$export$3fa311edc5edd22f)(el.props.animationDuration || 'A').timing,
            animationDelay: (0, $9779037853e3fa59$export$3fa311edc5edd22f)(el.props.animationDelay || '0s').timing,
            animationTimingFunction: (0, $9779037853e3fa59$export$23ba66c7c3e2e613)(el.props.animationTimingFunction || 'ease'),
            animationFillMode: el.props.animationFillMode || 'both',
            animationPlayState: el.props.animationPlayState,
            animationDirection: el.props.animationDirection
        }),
    animationName: (el)=>({
            animationName: $ac75ac59fdf3152e$var$applyAnimationProps(el.props.animationName, el)
        }),
    animationDuration: ({ props: props, deps: deps })=>({
            animationDuration: deps.getTimingByKey(props.animationDuration).timing
        }),
    animationDelay: ({ props: props, deps: deps })=>({
            animationDelay: deps.getTimingByKey(props.animationDelay).timing
        }),
    animationTimingFunction: ({ props: props, deps: deps })=>({
            animationTimingFunction: deps.getTimingFunction(props.animationTimingFunction)
        })
};


var $8e3d31fd37905fc6$exports = {};

$parcel$export($8e3d31fd37905fc6$exports, "BLOCK_PROPS", function () { return $8e3d31fd37905fc6$export$d8a4821b5338da9d; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");

'use strict';
const $8e3d31fd37905fc6$export$d8a4821b5338da9d = {
    show: (el, s, ctx)=>!!(ctx.utils.exec(el.props.show, el, s) === false) && {
            display: 'none !important'
        },
    hide: (el, s, ctx)=>!!ctx.utils.exec(el.props.hide, el, s) && {
            display: 'none !important'
        },
    height: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('height', props),
    width: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('width', props),
    boxSizing: ({ props: props })=>!(0, $amNJ8.isUndefined)(props.boxSizing) ? {
            boxSizing: props.boxSizing
        } : {
            boxSizing: 'border-box'
        },
    boxSize: ({ props: props })=>{
        if (!(0, $amNJ8.isString)(props.boxSize)) return;
        const [height, width] = props.boxSize.split(' ');
        return {
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('height', height),
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('width', width || height)
        };
    },
    inlineSize: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('inlineSize', props),
    blockSize: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('blockSize', props),
    minWidth: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('minWidth', props),
    maxWidth: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('maxWidth', props),
    widthRange: ({ props: props })=>{
        if (!(0, $amNJ8.isString)(props.widthRange)) return;
        const [minWidth, maxWidth] = props.widthRange.split(' ');
        return {
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('minWidth', minWidth),
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('maxWidth', maxWidth || minWidth)
        };
    },
    minHeight: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('minHeight', props),
    maxHeight: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('maxHeight', props),
    heightRange: ({ props: props })=>{
        if (!(0, $amNJ8.isString)(props.heightRange)) return;
        const [minHeight, maxHeight] = props.heightRange.split(' ');
        return {
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('minHeight', minHeight),
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('maxHeight', maxHeight || minHeight)
        };
    },
    size: ({ props: props })=>{
        if (!(0, $amNJ8.isString)(props.size)) return;
        const [inlineSize, blockSize] = props.size.split(' ');
        return {
            ...(0, $260ce182974bc204$export$b6e34d20a288a08c)('inlineSize', inlineSize),
            ...(0, $260ce182974bc204$export$b6e34d20a288a08c)('blockSize', blockSize || inlineSize)
        };
    },
    minBlockSize: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('minBlockSize', props),
    minInlineSize: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('minInlineSize', props),
    maxBlockSize: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('maxBlockSize', props),
    maxInlineSize: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('maxInlineSize', props),
    minSize: ({ props: props })=>{
        if (!(0, $amNJ8.isString)(props.minSize)) return;
        const [minInlineSize, minBlockSize] = props.minSize.split(' ');
        return {
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('minInlineSize', minInlineSize),
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('minBlockSize', minBlockSize || minInlineSize)
        };
    },
    maxSize: ({ props: props })=>{
        if (!(0, $amNJ8.isString)(props.maxSize)) return;
        const [maxInlineSize, maxBlockSize] = props.maxSize.split(' ');
        return {
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('maxInlineSize', maxInlineSize),
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('maxBlockSize', maxBlockSize || maxInlineSize)
        };
    },
    borderWidth: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('borderWidth', props),
    padding: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('padding', props),
    scrollPadding: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('scrollPadding', props),
    paddingInline: ({ props: props })=>{
        if (!(0, $amNJ8.isString)(props.paddingInline)) return;
        const [paddingInlineStart, paddingInlineEnd] = props.paddingInline.split(' ');
        return {
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('paddingInlineStart', paddingInlineStart),
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('paddingInlineEnd', paddingInlineEnd || paddingInlineStart)
        };
    },
    paddingBlock: ({ props: props })=>{
        if (!(0, $amNJ8.isString)(props.paddingBlock)) return;
        const [paddingBlockStart, paddingBlockEnd] = props.paddingBlock.split(' ');
        return {
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('paddingBlockStart', paddingBlockStart),
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('paddingBlockEnd', paddingBlockEnd || paddingBlockStart)
        };
    },
    paddingInlineStart: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('paddingInlineStart', props),
    paddingInlineEnd: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('paddingInlineEnd', props),
    paddingBlockStart: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('paddingBlockStart', props),
    paddingBlockEnd: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('paddingBlockEnd', props),
    margin: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('margin', props),
    marginInline: ({ props: props })=>{
        if (!(0, $amNJ8.isString)(props.marginInline)) return;
        const [marginInlineStart, marginInlineEnd] = props.marginInline.split(' ');
        return {
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('marginInlineStart', marginInlineStart),
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('marginInlineEnd', marginInlineEnd || marginInlineStart)
        };
    },
    marginBlock: ({ props: props })=>{
        if (!(0, $amNJ8.isString)(props.marginBlock)) return;
        const [marginBlockStart, marginBlockEnd] = props.marginBlock.split(' ');
        return {
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('marginBlockStart', marginBlockStart),
            ...(0, $260ce182974bc204$export$f09d9444954afeda)('marginBlockEnd', marginBlockEnd || marginBlockStart)
        };
    },
    marginInlineStart: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('marginInlineStart', props),
    marginInlineEnd: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('marginInlineEnd', props),
    marginBlockStart: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('marginBlockStart', props),
    marginBlockEnd: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('marginBlockEnd', props),
    gap: ({ props: props })=>({
            gap: (0, $260ce182974bc204$export$1e420ad2d0d06436)(props.gap)
        }),
    columnGap: ({ props: props })=>(0, $8d2bd189328d3a32$export$94679ba49f16fc2e)(props, 'columnGap'),
    rowGap: ({ props: props })=>(0, $8d2bd189328d3a32$export$94679ba49f16fc2e)(props, 'rowGap'),
    flexWrap: ({ props: props })=>({
            display: 'flex',
            flexFlow: (props.flexFlow || 'row').split(' ')[0] + ' ' + props.flexWrap
        }),
    flexFlow: ({ props: props })=>{
        const { flexFlow: flexFlow, reverse: reverse } = props;
        if (!(0, $amNJ8.isString)(flexFlow)) return;
        let [direction, wrap] = (flexFlow || 'row').split(' ');
        if (flexFlow.startsWith('x') || flexFlow === 'row') direction = 'row';
        if (flexFlow.startsWith('y') || flexFlow === 'column') direction = 'column';
        return {
            display: 'flex',
            flexFlow: (direction || '') + (!direction.includes('-reverse') && reverse ? '-reverse' : '') + ' ' + (wrap || '')
        };
    },
    flexAlign: ({ props: props })=>{
        if (!(0, $amNJ8.isString)(props.flexAlign)) return;
        const [alignItems, justifyContent] = props.flexAlign.split(' ');
        return {
            display: 'flex',
            alignItems: alignItems,
            justifyContent: justifyContent
        };
    }
};


var $00d029eb68924850$exports = {};

$parcel$export($00d029eb68924850$exports, "FONT_PROPS", function () { return $00d029eb68924850$export$e6c8c930b1cd765; });

'use strict';
const $00d029eb68924850$export$e6c8c930b1cd765 = {
    fontSize: (el)=>{
        const { props: props } = el;
        return props.fontSize ? (0, $2cd01d71c583d41c$export$ea9b2cd64205746b)(props.fontSize) : null;
    },
    fontFamily: ({ props: props })=>({
            fontFamily: (0, $4474b96e1a761f26$export$c4930fc256cef44f)(props.fontFamily) || props.fontFamily
        }),
    fontWeight: ({ props: props })=>({
            fontWeight: props.fontWeight,
            fontVariationSettings: '"wght" ' + props.fontWeight
        })
};


var $b74d0a089f4f356c$exports = {};

$parcel$export($b74d0a089f4f356c$exports, "MISC_PROPS", function () { return $b74d0a089f4f356c$export$24dfac4a0da20903; });
'use strict';
const $b74d0a089f4f356c$export$24dfac4a0da20903 = {
    overflow: ({ props: props, deps: deps })=>!deps.isUndefined(props.overflow) && {
            overflow: props.overflow,
            scrollBehavior: 'smooth'
        },
    cursor: (el, s, ctx)=>{
        let val = el.props.cursor;
        if (!val) return;
        const file = ctx.files && ctx.files[val];
        if (file && file.content) val = `url(${file.content.src})`;
        return {
            cursor: val
        };
    }
};


var $9830d40182751b2c$exports = {};

$parcel$export($9830d40182751b2c$exports, "POSITION_PROPS", function () { return $9830d40182751b2c$export$c0036cbb5416e2bc; });

'use strict';
const $9830d40182751b2c$export$c0036cbb5416e2bc = {
    inset: ({ props: props, context: context })=>{
        const { inset: inset } = props;
        if (context.utils.isNumber(inset)) return {
            inset: inset
        };
        if (!context.utils.isString(inset)) return;
        return {
            inset: inset.split(' ').map((v)=>(0, $8d2bd189328d3a32$export$4f949d23b5dbefe6)(v, 'k').k).join(' ')
        };
    },
    left: ({ props: props })=>(0, $8d2bd189328d3a32$export$4f949d23b5dbefe6)(props.left, 'left'),
    top: ({ props: props })=>(0, $8d2bd189328d3a32$export$4f949d23b5dbefe6)(props.top, 'top'),
    right: ({ props: props })=>(0, $8d2bd189328d3a32$export$4f949d23b5dbefe6)(props.right, 'right'),
    bottom: ({ props: props })=>(0, $8d2bd189328d3a32$export$4f949d23b5dbefe6)(props.bottom, 'bottom'),
    verticalInset: ({ props: props })=>{
        const { verticalInset: verticalInset } = props;
        if (typeof verticalInset !== 'string') return;
        const vi = verticalInset.split(' ').map((v)=>(0, $8d2bd189328d3a32$export$4f949d23b5dbefe6)(v, 'k').k);
        return {
            top: vi[0],
            bottom: vi[1] || vi[0]
        };
    },
    horizontalInset: ({ props: props })=>{
        const { horizontalInset: horizontalInset } = props;
        if (typeof horizontalInset !== 'string') return;
        const vi = horizontalInset.split(' ').map((v)=>(0, $8d2bd189328d3a32$export$4f949d23b5dbefe6)(v, 'k').k);
        return {
            left: vi[0],
            right: vi[1] || vi[0]
        };
    }
};


var $64d04c47897171c1$exports = {};

$parcel$export($64d04c47897171c1$exports, "getSystemGlobalTheme", function () { return $64d04c47897171c1$export$f12bbb197a836138; });
$parcel$export($64d04c47897171c1$exports, "THEME_PROPS", function () { return $64d04c47897171c1$export$11ce017e3ee09814; });

parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");
'use strict';
const $64d04c47897171c1$export$f12bbb197a836138 = ({ context: context, state: state })=>{
    const rootState = state && state.root;
    return rootState && rootState.globalTheme ? rootState.globalTheme : context.designSystem && context.designSystem.globalTheme;
};
const $64d04c47897171c1$export$11ce017e3ee09814 = {
    theme: (element)=>{
        const { props: props } = element;
        const globalTheme = $64d04c47897171c1$export$f12bbb197a836138(element);
        if (!props.theme) return;
        const hasSubtheme = props.theme.includes(' ') && !props.theme.includes('@');
        const globalThemeForced = `@${props.themeModifier || globalTheme}`;
        if (hasSubtheme) {
            const themeAppliedInVal = props.theme.split(' ');
            themeAppliedInVal.splice(1, 0, globalThemeForced);
            return (0, $50d2ff83e590f376$export$b3cf7317de2f2233)(themeAppliedInVal);
        } else if (props.theme.includes('@{globalTheme}')) props.theme.replace('@{globalTheme}', globalThemeForced);
        return (0, $50d2ff83e590f376$export$b3cf7317de2f2233)(props.theme, `@${props.themeModifier || globalTheme}`);
    },
    color: (element)=>{
        const { props: props } = element;
        const globalTheme = $64d04c47897171c1$export$f12bbb197a836138(element);
        if (!props.color) return;
        return {
            color: (0, $31bb7c46f86719dd$export$dd72f6d9deea7207)(props.color, globalTheme)
        };
    },
    background: (element)=>{
        const { props: props } = element;
        const globalTheme = $64d04c47897171c1$export$f12bbb197a836138(element);
        if (!props.background) return;
        return {
            background: (0, $31bb7c46f86719dd$export$dd72f6d9deea7207)(props.background, globalTheme)
        };
    },
    backgroundColor: (element)=>{
        const { props: props } = element;
        const globalTheme = $64d04c47897171c1$export$f12bbb197a836138(element);
        if (!props.backgroundColor) return;
        return {
            backgroundColor: (0, $31bb7c46f86719dd$export$dd72f6d9deea7207)(props.backgroundColor, globalTheme)
        };
    },
    backgroundImage: (element, s, ctx)=>{
        const { props: props } = element;
        const globalTheme = $64d04c47897171c1$export$f12bbb197a836138(element);
        let val = props.backgroundImage;
        if (!val) return;
        const file = ctx.files && ctx.files[val];
        if (file && file.content) val = file.content.src;
        return {
            backgroundImage: (0, $260ce182974bc204$export$15f2b9b64835b137)(val, globalTheme)
        };
    },
    backgroundSize: ({ props: props })=>({
            backgroundSize: props.backgroundSize
        }),
    backgroundPosition: ({ props: props })=>({
            backgroundPosition: props.backgroundPosition
        }),
    backgroundRepeat: ({ props: props })=>({
            backgroundRepeat: props.backgroundRepeat
        }),
    textStroke: ({ props: props })=>({
            WebkitTextStroke: (0, $260ce182974bc204$export$8bcd50b221b13db)(props.textStroke)
        }),
    outline: ({ props: props })=>({
            outline: (0, $260ce182974bc204$export$ca4ef6ca6dc743f2)(props.outline)
        }),
    outlineOffset: ({ props: props })=>(0, $260ce182974bc204$export$b6e34d20a288a08c)('outlineOffset', props),
    border: ({ props: props })=>({
            border: (0, $260ce182974bc204$export$ca4ef6ca6dc743f2)(props.border)
        }),
    borderColor: (element)=>{
        const { props: props } = element;
        const globalTheme = $64d04c47897171c1$export$f12bbb197a836138(element);
        if (!props.borderColor) return;
        return {
            borderColor: (0, $31bb7c46f86719dd$export$dd72f6d9deea7207)(props.borderColor, globalTheme)
        };
    },
    borderLeft: ({ props: props })=>({
            borderLeft: (0, $260ce182974bc204$export$ca4ef6ca6dc743f2)(props.borderLeft)
        }),
    borderTop: ({ props: props })=>({
            borderTop: (0, $260ce182974bc204$export$ca4ef6ca6dc743f2)(props.borderTop)
        }),
    borderRight: ({ props: props })=>({
            borderRight: (0, $260ce182974bc204$export$ca4ef6ca6dc743f2)(props.borderRight)
        }),
    borderBottom: ({ props: props })=>({
            borderBottom: (0, $260ce182974bc204$export$ca4ef6ca6dc743f2)(props.borderBottom)
        }),
    shadow: (element)=>{
        const { props: props } = element;
        const globalTheme = $64d04c47897171c1$export$f12bbb197a836138(element);
        if (!props.backgroundImage) return;
        return {
            boxShadow: (0, $260ce182974bc204$export$837e4beeff9ff924)(props.shadow, globalTheme)
        };
    },
    boxShadow: (element, state, context)=>{
        const { props: props } = element;
        if (!(0, $amNJ8.isString)(props.boxShadow)) return;
        const [val, hasImportant] = props.boxShadow.split('!importan');
        const globalTheme = $64d04c47897171c1$export$f12bbb197a836138(element);
        const important = hasImportant ? ' !important' : '';
        return {
            boxShadow: (0, $260ce182974bc204$export$9c296746f296a70)(val.trim(), globalTheme) + important
        };
    },
    textShadow: ({ props: props, context: context })=>({
            textShadow: (0, $260ce182974bc204$export$9c296746f296a70)(props.textShadow, context.designSystem.globalTheme)
        }),
    columnRule: ({ props: props })=>({
            columnRule: (0, $260ce182974bc204$export$ca4ef6ca6dc743f2)(props.columnRule)
        })
};


var $802b34715c008ca4$exports = {};

$parcel$export($802b34715c008ca4$exports, "TIMING_PROPS", function () { return $802b34715c008ca4$export$801d104720a35e80; });

'use strict';
const $802b34715c008ca4$export$801d104720a35e80 = {
    transition: ({ props: props })=>({
            transition: (0, $260ce182974bc204$export$d9f7ff0c2b32d4b5)(props.transition)
        }),
    transitionDuration: ({ props: props })=>({
            transitionDuration: (0, $260ce182974bc204$export$d87c1c5f4a8ec3d9)(props.transitionDuration)
        }),
    transitionDelay: ({ props: props })=>({
            transitionDelay: (0, $260ce182974bc204$export$d87c1c5f4a8ec3d9)(props.transitionDelay)
        }),
    transitionTimingFunction: ({ props: props })=>({
            transitionTimingFunction: (0, $9779037853e3fa59$export$23ba66c7c3e2e613)(props.transitionTimingFunction)
        }),
    transitionProperty: ({ props: props })=>({
            transitionProperty: props.transitionProperty,
            willChange: props.transitionProperty
        })
};


'use strict';
$parcel$exportWildcard($eb52d8a8504dc7f2$exports, $ac75ac59fdf3152e$exports);
$parcel$exportWildcard($eb52d8a8504dc7f2$exports, $8e3d31fd37905fc6$exports);
$parcel$exportWildcard($eb52d8a8504dc7f2$exports, $00d029eb68924850$exports);
$parcel$exportWildcard($eb52d8a8504dc7f2$exports, $b74d0a089f4f356c$exports);
$parcel$exportWildcard($eb52d8a8504dc7f2$exports, $9830d40182751b2c$exports);
$parcel$exportWildcard($eb52d8a8504dc7f2$exports, $64d04c47897171c1$exports);
$parcel$exportWildcard($eb52d8a8504dc7f2$exports, $802b34715c008ca4$exports);



'use strict';
const $e1bf7a72fe80923c$export$b474245a861fc144 = (0, $1cJu7.mergeArray)([
    (0, $092e29b554101b61$export$6428a7f2611ef1fa),
    (0, $871c31bc83970b54$export$13807d9ee5a34a42),
    (0, $3f3bd33101f88eb8$export$14faa19a0f3bbeb2),
    (0, $2340ecba3950811a$export$d96a8827a60d6b69),
    (0, $dadcc042eebbf1ae$export$5f1af8db9871e1d6),
    (0, $16f068d5dcc1a960$export$25d20c189d4a23b8),
    (0, $836338cbaed52506$export$ef1e5872612852d1),
    (0, $a4ea0dc306f2bb25$export$563a914cafbdc389),
    (0, $8bf0bee715543d08$export$7fc53215244aec38),
    (0, $dac5daea1dcbcf9a$export$a13296960cae0384),
    (0, $4cb9b2e3a5a60a57$export$36b810b8b2e73231),
    (0, $2ab55593ea7c1829$export$c35d437ae5945fcd)
]).class;
const $e1bf7a72fe80923c$export$c6537d1a7d8e90af = (0, $1cJu7.mergeArray)(Object.values($eb52d8a8504dc7f2$exports));


var $f57fd6659c7caf91$exports = {};

$parcel$export($f57fd6659c7caf91$exports, "DEFAULT_CSS_PROPERTIES_LIST", function () { return $f57fd6659c7caf91$export$33f20e95f48422c; });
const $f57fd6659c7caf91$export$33f20e95f48422c = [
    'accentColor',
    'alignContent',
    'alignItems',
    'alignSelf',
    'alignmentBaseline',
    'all',
    'animation',
    'animationDelay',
    'animationDirection',
    'animationDuration',
    'animationFillMode',
    'animationIterationCount',
    'animationName',
    'animationPlayState',
    'animationTimingFunction',
    'appearance',
    'aspectRatio',
    'backdropFilter',
    'backfaceVisibility',
    'background',
    'backgroundAttachment',
    'backgroundBlendMode',
    'backgroundClip',
    'backgroundColor',
    'backgroundImage',
    'backgroundOrigin',
    'backgroundPosition',
    'backgroundPositionX',
    'backgroundPositionY',
    'backgroundRepeat',
    'backgroundRepeatX',
    'backgroundRepeatY',
    'backgroundSize',
    'baselineShift',
    'blockSize',
    'border',
    'borderBlock',
    'borderBlockColor',
    'borderBlockEnd',
    'borderBlockEndColor',
    'borderBlockEndStyle',
    'borderBlockEndWidth',
    'borderBlockStart',
    'borderBlockStartColor',
    'borderBlockStartStyle',
    'borderBlockStartWidth',
    'borderBlockStyle',
    'borderBlockWidth',
    'borderBottom',
    'borderBottomColor',
    'borderBottomLeftRadius',
    'borderBottomRightRadius',
    'borderBottomStyle',
    'borderBottomWidth',
    'borderCollapse',
    'borderColor',
    'borderImage',
    'borderImageOutset',
    'borderImageRepeat',
    'borderImageSlice',
    'borderImageSource',
    'borderImageWidth',
    'borderLeft',
    'borderLeftColor',
    'borderLeftStyle',
    'borderLeftWidth',
    'borderRadius',
    'borderRight',
    'borderRightColor',
    'borderRightStyle',
    'borderRightWidth',
    'borderSpacing',
    'borderStyle',
    'borderTop',
    'borderTopColor',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderTopStyle',
    'borderTopWidth',
    'borderWidth',
    'bottom',
    'boxDecorationBreak',
    'boxShadow',
    'boxSizing',
    'breakAfter',
    'breakBefore',
    'breakInside',
    'captionSide',
    'caretColor',
    'clear',
    'clip',
    'clipPath',
    'color',
    'colorAdjust',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorRendering',
    'columnCount',
    'columnFill',
    'columnGap',
    'columnRule',
    'columnRuleColor',
    'columnRuleStyle',
    'columnRuleWidth',
    'columnSpan',
    'columnWidth',
    'columns',
    'contain',
    'content',
    'counterIncrement',
    'counterReset',
    'cursor',
    'direction',
    'display',
    'emptyCells',
    'filter',
    'flex',
    'flexBasis',
    'flexDirection',
    'flexFlow',
    'flexGrow',
    'flexShrink',
    'flexWrap',
    'float',
    'font',
    'fontFamily',
    'fontFeatureSettings',
    'fontKerning',
    'fontLanguageOverride',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontVariantAlternates',
    'fontVariantCaps',
    'fontVariantEastAsian',
    'fontVariantNumeric',
    'fontVariantPosition',
    'fontWeight',
    'fontVariationSettings',
    'fontSynthesis',
    'forcedColorAdjust',
    'gap',
    'grid',
    'gridArea',
    'gridAutoColumns',
    'gridAutoFlow',
    'gridAutoRows',
    'gridColumn',
    'gridColumnEnd',
    'gridColumnGap',
    'gridColumnStart',
    'gridGap',
    'gridRow',
    'gridRowEnd',
    'gridRowGap',
    'gridRowStart',
    'gridTemplate',
    'gridTemplateAreas',
    'gridTemplateColumns',
    'gridTemplateRows',
    'height',
    'hyphens',
    'imageOrientation',
    'imageRendering',
    'imeMode',
    'inset',
    'insetBlock',
    'insetBlockEnd',
    'insetBlockStart',
    'insetInline',
    'insetInlineEnd',
    'insetInlineStart',
    'initialLetter',
    'isolation',
    'justifyContent',
    'justifyItems',
    'justifySelf',
    'left',
    'letterSpacing',
    'lineBreak',
    'lineClamp',
    'lineHeight',
    'listStyle',
    'listStyleImage',
    'listStylePosition',
    'listStyleType',
    'margin',
    'marginBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBlock',
    'marginBlockEnd',
    'marginBlockStart',
    'marginInline',
    'marginInlineEnd',
    'marginInlineStart',
    'mask',
    'maskBorder',
    'maskBorderImage',
    'maskBorderOutset',
    'maskBorderRepeat',
    'maskBorderSlice',
    'maskBorderSource',
    'maskBorderWidth',
    'maskClip',
    'maskComposite',
    'maskImage',
    'maskOrigin',
    'maskPosition',
    'maskRepeat',
    'maskSize',
    'maskType',
    'maxBlockSize',
    'maxHeight',
    'maxInlineSize',
    'maxWidth',
    'minBlockSize',
    'minHeight',
    'minInlineSize',
    'minWidth',
    'mixBlendMode',
    'objectFit',
    'objectPosition',
    'objectViewBox',
    'offset',
    'offsetDistance',
    'offsetPath',
    'offsetRotate',
    'opacity',
    'order',
    'orientation',
    'outline',
    'outlineColor',
    'outlineOffset',
    'outlineStyle',
    'outlineWidth',
    'overflow',
    'overflowAnchor',
    'overflowClip',
    'overflowScrolling',
    'overflowWrap',
    'overflowX',
    'overflowY',
    'padding',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'pageBreakAfter',
    'pageBreakBefore',
    'pageBreakInside',
    'paintOrder',
    'perspective',
    'perspectiveOrigin',
    'placeContent',
    'placeItems',
    'placeSelf',
    'pointerEvents',
    'position',
    'resize',
    'right',
    'rotate',
    'rowGap',
    'scrollBehavior',
    'scrollPadding',
    'scrollSnapAlign',
    'scrollSnapType',
    'scrollbarColor',
    'scrollbarWidth',
    'shapeImageThreshold',
    'shapeMargin',
    'shapeOutside',
    'tabSize',
    'tableLayout',
    'textAlign',
    'textAlignLast',
    'textDecoration',
    'textDecorationColor',
    'textDecorationLine',
    'textDecorationSkipInk',
    'textDecorationStyle',
    'textDecorationThickness',
    'textIndent',
    'textOverflow',
    'textShadow',
    'textTransform',
    'textUnderlineOffset',
    'top',
    'transform',
    'transformOrigin',
    'transformStyle',
    'transition',
    'transitionDelay',
    'transitionDuration',
    'transitionProperty',
    'transitionTimingFunction',
    'translate',
    'translateX',
    'translateY',
    'translateZ',
    'unicodeBidi',
    'userSelect',
    'verticalAlign',
    'visibility',
    'whiteSpace',
    'widows',
    'width',
    'willChange',
    'wordBreak',
    'wordSpacing',
    'wordWrap',
    'writingMode',
    'zIndex'
];


'use strict';
const $b6a1bff7e7921a33$export$2b5b252eb866c647 = (element, restProps = {})=>{
    const classCss = {};
    const { props: props, class: elementClass } = element;
    if (!(0, $amNJ8.isObject)(props)) return;
    // merge(elementClass, registry)
    // if (registry && Object.keys(registry)[0] !== Object.keys(CSS_PROPS_REGISTRY)[0]) {
    //   merge(elementClass, CSS_PROPS_REGISTRY)
    // }
    for(const key in props){
        const setter = (0, $8bf0bee715543d08$export$5c168558fab3755c)[key.slice(0, 1)];
        const hasCSS = elementClass[key];
        if (setter) setter(key, props[key], classCss, element, true);
        else if ((0, $amNJ8.isFunction)(hasCSS)) {
            // const stack = hasCSS(element)
            const stack = hasCSS(element, element.state, element.context);
            const exec = (0, $amNJ8.isArray)(stack) ? stack.reduce((a, c)=>{
                return (0, $jm0BQ.merge)(a, c);
            }, {}) : stack;
            (0, $jm0BQ.deepMerge)(classCss, exec);
        } else if (key === 'style') (0, $jm0BQ.deepMerge)(classCss, props[key]);
        else restProps[key] = props[key];
    }
    return classCss;
};
const $b6a1bff7e7921a33$export$70a74cfeffe570f4 = (element)=>{
    const { props: defProps } = element;
    const css = {};
    const props = {};
    for(const key in defProps){
        const val = defProps[key];
        const mediaProp = (0, $8bf0bee715543d08$export$5c168558fab3755c)[key.slice(0, 1)];
        if (mediaProp) {
            mediaProp(key, defProps[key], css, element, true);
            continue;
        }
        const preprop = (0, $e1bf7a72fe80923c$export$c6537d1a7d8e90af)[key];
        if (preprop) {
            // const stack = hasCSS(element)
            const stack = preprop(element, element.state, element.context);
            const exec = (0, $amNJ8.isArray)(stack) ? stack.reduce((a, c)=>{
                return (0, $jm0BQ.merge)(a, c);
            }, {}) : stack;
            (0, $jm0BQ.deepMerge)(css, exec);
            continue;
        }
        if (key === 'style') {
            (0, $jm0BQ.deepMerge)(css, defProps[key]);
            continue;
        }
        if ((0, $f57fd6659c7caf91$export$33f20e95f48422c).includes(key)) {
            css[key] = val;
            continue;
        }
        props[key] = val;
    }
    return {
        css: css,
        props: props
    };
};


var $4c3ae4a83fbb1a23$exports = {};

$parcel$export($4c3ae4a83fbb1a23$exports, "setClassname", function () { return $4c3ae4a83fbb1a23$export$6241622f59b2c037; });

var $971f9a5a1b34cf3a$exports = {};

$parcel$export($971f9a5a1b34cf3a$exports, "transformEmotion", function () { return $971f9a5a1b34cf3a$export$a66cdfca4dd68910; });
parcelRequire("imR0C");
var $amNJ8 = parcelRequire("amNJ8");

'use strict';
const { css: $971f9a5a1b34cf3a$var$css } = (0, $9119ccb14775b2d1$export$51d693b3d243fd90);
const $971f9a5a1b34cf3a$export$a66cdfca4dd68910 = (props, callback)=>{
    return (0, $amNJ8.isFunction)(callback) ? callback(props) : $971f9a5a1b34cf3a$var$css(props);
};


'use strict';
const $4c3ae4a83fbb1a23$export$6241622f59b2c037 = (props, emotionCss)=>{
    const transform = (0, $b6a1bff7e7921a33$export$2b5b252eb866c647)(props);
    return (0, $971f9a5a1b34cf3a$export$a66cdfca4dd68910)(transform, emotionCss);
};





'use strict';
const $7d99557d9b959b1d$export$2d3867789701917d = (component, element)=>{
    const classObj = {};
    if (component.class) for(const classProp in component.class)classObj[classProp] = component.class[classProp](element);
    return classObj;
};
$parcel$exportWildcard($7d99557d9b959b1d$exports, $b6a1bff7e7921a33$exports);
$parcel$exportWildcard($7d99557d9b959b1d$exports, $4c3ae4a83fbb1a23$exports);
$parcel$exportWildcard($7d99557d9b959b1d$exports, $971f9a5a1b34cf3a$exports);
$parcel$exportWildcard($7d99557d9b959b1d$exports, $e1bf7a72fe80923c$exports);
$parcel$exportWildcard($7d99557d9b959b1d$exports, $f57fd6659c7caf91$exports);








'use strict';
 // export * from '@symbo.ls/socket/client' // TODO: Check with @nikoloza
 // export * from '@symbo.ls/sync' // TODO: add it soon
$parcel$exportWildcard($15823c83ee6e64a1$exports, $imR0C);
$parcel$exportWildcard($15823c83ee6e64a1$exports, $97f45980f9c117e0$exports);
$parcel$exportWildcard($15823c83ee6e64a1$exports, $25b5ce44de4d06e3$exports);
$parcel$exportWildcard($15823c83ee6e64a1$exports, $7d99557d9b959b1d$exports);
$parcel$exportWildcard($15823c83ee6e64a1$exports, $6926b6904a40ba96$exports);
$parcel$exportWildcard($15823c83ee6e64a1$exports, $9119ccb14775b2d1$exports);
$parcel$exportWildcard($15823c83ee6e64a1$exports, $84f69156e3582aea$exports);
$parcel$exportWildcard($15823c83ee6e64a1$exports, $9ab4e20a7cba0748$exports);
$parcel$exportWildcard($15823c83ee6e64a1$exports, $e6fd4882357b9f2d$exports);
$parcel$exportWildcard($15823c83ee6e64a1$exports, $9eb7ca543617066e$exports);


'use strict';
if (window.packages) window.packages.smbls = ()=>$15823c83ee6e64a1$exports;
else window.packages = {
    smbls: ()=>$15823c83ee6e64a1$exports
};
window.require = (key)=>{
    const pkg = window.packages[key];
    if (typeof pkg === 'function') return pkg();
    else return pkg;
}; // import init, { js_domql_string_to_react_string, initSync } from './dompiler'
 // export async function convertDomqlToReact (domqlString) {
 //   await init() // Ensure the WASM module is initialized
 //   try {
 //     const reactString = js_domql_string_to_react_string(domqlString)
 //     console.log(reactString) // Output the converted React string
 //   } catch (error) {
 //     console.error('Error converting DOMQL to React:', error)
 //   }
 // }
 // // Example DOMQL string
 // const domqlString = `export const IconText = {
 //   extend: "Flex",
 //   props: {
 //     align: "center center",
 //     lineHeight: 1,
 //   },
 //   Icon: {
 //     props: ({ parent }) => ({ icon: parent.props.icon }),
 //     if: ({ parent, props }) => {
 //       const doesExist =
 //         parent.props.icon || parent.props.Icon || props.name || props.icon;
 //       return doesExist;
 //     },
 //   },
 //   text: ({ props }) => props.text,
 // };`
 // convertDomqlToReact(domqlString)


//# sourceMappingURL=example.c998a74a.js.map
